export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  JSON: any;
  Upload: any;
  Url: any;
};

export type AbTest = {
  __typename: 'ABTest';
  id: Scalars['ID'];
  variation: Scalars['String'];
};

export enum AbTestAudienceType {
  ADULT = 'ADULT',
  ALL = 'ALL',
  KID = 'KID'
}

export type AbTestConfig = {
  __typename: 'ABTestConfig';
  audience: AbTestAudienceType;
  defaultVariation?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isHardCoded: Scalars['Boolean'];
  isNewAudienceOnly: Scalars['Boolean'];
  startDate: Scalars['Date'];
  status: AbTestStatus;
  type: AbTestType;
  /** @deprecated use variationsWithPercentage */
  variations: Array<Scalars['String']>;
  variationsWithPercentage: Array<AbTestVariation>;
  winnerVariation?: Maybe<Scalars['String']>;
};

export enum AbTestStatus {
  ARCHIVED = 'ARCHIVED',
  TESTING = 'TESTING',
  WINNER = 'WINNER'
}

export enum AbTestType {
  APP_INSTALL = 'APP_INSTALL',
  SERVER = 'SERVER',
  USER = 'USER'
}

export type AbTestVariation = {
  __typename: 'ABTestVariation';
  name: Scalars['String'];
  percentage: Scalars['Int'];
};

export type AbTestVariationInput = {
  name: Scalars['String'];
  percentage: Scalars['Int'];
};

export type AcceptFriendRequestInput = {
  userId: Scalars['ID'];
};

export type AcceptTeamMemberInviteInput = {
  inviteId: Scalars['ID'];
};

export type AcceptTeamQuizLiveGameRequestInput = {
  liveGameRequestId: Scalars['ID'];
  teamId: Scalars['ID'];
};

export type AcceptTeamQuizLiveGameRequestPayload = {
  __typename: 'AcceptTeamQuizLiveGameRequestPayload';
  userToUser: UserToUser;
};

export type AcceptUserToUserQuizLiveGameRequestInput = {
  userToUserId: Scalars['ID'];
};

export type AcceptUserToUserQuizTurnGameRequestInput = {
  requestId: Scalars['ID'];
};

export type AcceptUserToUserQuizTurnGameRequestPayload = {
  __typename: 'AcceptUserToUserQuizTurnGameRequestPayload';
  userToUser?: Maybe<UserToUser>;
};

export type ActivateBoostsInLiveGameInput = {
  isArtistOnlyBoostActivated?: InputMaybe<Scalars['Boolean']>;
  isNinjaBoostActivated?: InputMaybe<Scalars['Boolean']>;
  isSpeedsterBoostActivated?: InputMaybe<Scalars['Boolean']>;
  userToUserQuizLiveRoundId: Scalars['ID'];
};

export type ActivateBoostsInTournamentRoundInput = {
  isSpeedsterBoostActivated?: InputMaybe<Scalars['Boolean']>;
  tournamentId: Scalars['ID'];
  tournamentRoundId: Scalars['ID'];
};

export type ActivateBoostsInTournamentRoundPayload = {
  __typename: 'ActivateBoostsInTournamentRoundPayload';
  tournament: Tournament;
  user: User;
};

export type ActivateBoostsInTurnGameInput = {
  isArtistOnlyBoostActivated?: InputMaybe<Scalars['Boolean']>;
  isSpeedsterBoostActivated?: InputMaybe<Scalars['Boolean']>;
  userToUserQuizTurnRoundId: Scalars['ID'];
};

export type ActivateBoostsInTurnGamePayload = {
  __typename: 'ActivateBoostsInTurnGamePayload';
  user?: Maybe<User>;
  userToUserQuizTurnRound?: Maybe<UserToUserQuizTurnRound>;
};

export type ActivateInternalFreeTrialInput = {
  /**
   * Not required, by default it will used the connected user
   * It will be potentially used by the admin to activate free trial for other users later
   */
  userId?: InputMaybe<Scalars['ID']>;
};

export type ActivateInternalFreeTrialPayload = {
  __typename: 'ActivateInternalFreeTrialPayload';
  user?: Maybe<User>;
};

export type ActivateUnlimitedBoostInput = {
  boostType: CurrencyUnlimitedBoostType;
};

export type ActivateUnlimitedBoostPayload = {
  __typename: 'ActivateUnlimitedBoostPayload';
  user: User;
};

export type ActiveUserSubscriptionUpdateLogsInput = {
  userId: Scalars['String'];
};

export type ActiveUserSubscriptionUpdateLogsPayload = {
  __typename: 'ActiveUserSubscriptionUpdateLogsPayload';
  logs: Array<UserSubscriptionUpdateLog>;
};

export type AddDdexSongToCurationContentPackInput = {
  ddexSongIds?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
};

export type AddFriendByInviteCodeInput = {
  inviteCode: Scalars['String'];
};

export type AddFriendByInviteCodePayload = {
  __typename: 'AddFriendByInviteCodePayload';
  userToUser: UserToUser;
};

export type AddItunesSongToCurationContentPackInput = {
  id: Scalars['ID'];
  itunesIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type AddLiveEventContentPackInput = {
  contentPackId: Scalars['ID'];
  liveEventId: Scalars['ID'];
};

export type AddLiveEventContentPackPayload = {
  __typename: 'AddLiveEventContentPackPayload';
  contentPack: ContentPack;
  liveEvent: LiveEvent;
};

export type AddSpecialEventContentPackInput = {
  contentPackId: Scalars['ID'];
  specialEventId: Scalars['ID'];
};

export type AddSpecialEventContentPackPayload = {
  __typename: 'AddSpecialEventContentPackPayload';
  contentPack: ContentPack;
  specialEvent: SpecialEvent;
};

export type AddSpecialEventQuizLiveShowInput = {
  quizLiveShowId: Scalars['ID'];
  specialEventId: Scalars['ID'];
};

export type AddSpecialEventQuizLiveShowPayload = {
  __typename: 'AddSpecialEventQuizLiveShowPayload';
  quizLiveShow: QuizLiveShow;
  specialEvent: SpecialEvent;
};

export type AddSpecialEventTournamentInput = {
  shouldUpdateTournamentRankGroups?: InputMaybe<Scalars['Boolean']>;
  specialEventId: Scalars['ID'];
  tournamentId: Scalars['ID'];
};

export type AddSpecialEventTournamentPayload = {
  __typename: 'AddSpecialEventTournamentPayload';
  specialEvent: SpecialEvent;
  tournament: Tournament;
};

export type AddTeamLeaderInput = {
  teamId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type AddUserEmojiPackInput = {
  packId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type AdminCredentialSummary = {
  __typename: 'AdminCredentialSummary';
  created?: Maybe<Scalars['Date']>;
  credentialId: Scalars['String'];
  type: Scalars['String'];
};

export type AdminGiftPayload = {
  __typename: 'AdminGiftPayload';
  count: Scalars['Int'];
  metadataList: Array<Scalars['String']>;
};

export type AdminLinkEmailCredentialInput = {
  newEmail: Scalars['String'];
  userId: Scalars['ID'];
};

export type AdminLinkEmailCredentialPayload = {
  __typename: 'AdminLinkEmailCredentialPayload';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  user?: Maybe<AdminUserSummary>;
};

export type AdminModerateContentItemInput = {
  id: Scalars['ID'];
  state: ModeratedContentItemState;
};

export type AdminSearchUsersInput = {
  query: Scalars['String'];
};

export type AdminSearchUsersPayload = {
  __typename: 'AdminSearchUsersPayload';
  users: Array<AdminUserSummary>;
};

export type AdminSendSignInLinkInput = {
  userId: Scalars['ID'];
};

export type AdminSendSignInLinkPayload = {
  __typename: 'AdminSendSignInLinkPayload';
  message?: Maybe<Scalars['String']>;
  sentToEmail?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type AdminUserSummary = {
  __typename: 'AdminUserSummary';
  created: Scalars['Date'];
  displayName: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  firebaseDisabled?: Maybe<Scalars['Boolean']>;
  firebaseEmail?: Maybe<Scalars['String']>;
  firebaseEmailVerified?: Maybe<Scalars['Boolean']>;
  firebaseProviders?: Maybe<Array<Scalars['String']>>;
  firebaseUid?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
  providers: Array<AdminCredentialSummary>;
  role: UserRole;
  userId: Scalars['ID'];
};

export type AdsReward = {
  __typename: 'AdsReward';
  coinClaimed: Scalars['Int'];
  coinLimit: Scalars['Int'];
  coinReward: Scalars['Int'];
  diamondClaimed: Scalars['Int'];
  diamondLimit: Scalars['Int'];
  diamondReward: Scalars['Int'];
  id: Scalars['ID'];
  nextCoinClaimableDate: Scalars['Date'];
  nextDiamondClaimableDate: Scalars['Date'];
  useAds: Scalars['Boolean'];
};

export enum AdsRewardCurrencyType {
  COIN = 'COIN',
  DIAMOND = 'DIAMOND'
}

export type AdvanceBadgeInput = {
  id: Scalars['ID'];
};

export type AdvanceBadgePayload = {
  __typename: 'AdvanceBadgePayload';
  badge: Badge;
  user: User;
};

/**
 * An Agent is someone/something that can communicate with the user, without being a real app User.
 * Can be ChatAgent, SupportAgent, etc
 */
export type Agent = {
  __typename: 'Agent';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  picture?: Maybe<Scalars['String']>;
};

/** A replica of UserToUser, but one of the "User" is actually an Agent */
export type AgentToUser = {
  __typename: 'AgentToUser';
  /** @deprecated use conversation instead */
  a41conversation?: Maybe<Conversation>;
  agent: Agent;
  conversation?: Maybe<Conversation>;
  created: Scalars['Date'];
  id: Scalars['ID'];
  readOnly: Scalars['Boolean'];
};

export type Analytics = {
  __typename: 'Analytics';
  appLogsBySession: AnalyticsSessionResult;
  appSessions: AnalyticsBigQueryPayload;
  backendLogsByRuntime: AnalyticsBigQueryPayload;
  /** @deprecated use dashboardQueries instead */
  bqQueries: Array<AnalyticsBigQueryPayload>;
  dashboardQueries: Array<AnalyticsDashboardQueriesPayload>;
  ddexJobLogs: DdexJobLogsPaginated;
  id: Scalars['ID'];
  liveShowLogs: LiveShowLogsPaginated;
  userLastSession?: Maybe<AnalyticsUserLastSession>;
  userTransactions: Array<Scalars['JSON']>;
};


export type AnalyticsAppLogsBySessionArgs = {
  sessionDate: Scalars['Date'];
  sessionId: Scalars['ID'];
};


export type AnalyticsAppSessionsArgs = {
  installId?: InputMaybe<Scalars['ID']>;
  startDate: Scalars['Date'];
  userId?: InputMaybe<Scalars['ID']>;
};


export type AnalyticsBackendLogsByRuntimeArgs = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  runtimeId: Scalars['ID'];
  startDate?: InputMaybe<Scalars['Date']>;
};


export type AnalyticsBqQueriesArgs = {
  queries: Array<BigQueryInput>;
};


export type AnalyticsDashboardQueriesArgs = {
  queries: Array<AnalyticsDashboardQueriesInput>;
};


export type AnalyticsDdexJobLogsArgs = {
  jobId: Scalars['ID'];
  pagination?: InputMaybe<PaginationParams>;
};


export type AnalyticsLiveShowLogsArgs = {
  pagination?: InputMaybe<PaginationParams>;
  showId: Scalars['ID'];
};


export type AnalyticsUserLastSessionArgs = {
  id: Scalars['ID'];
};


export type AnalyticsUserTransactionsArgs = {
  endDate: Scalars['String'];
  startDate: Scalars['String'];
  userId: Scalars['ID'];
};

export type AnalyticsBigQueryPayload = {
  __typename: 'AnalyticsBigQueryPayload';
  data?: Maybe<Array<Scalars['String']>>;
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  metadata?: Maybe<Scalars['String']>;
};

export type AnalyticsDashboardQueriesInput = {
  id: Scalars['ID'];
  query: Scalars['String'];
  type?: InputMaybe<DashboardQueryType>;
};

export type AnalyticsDashboardQueriesPayload = {
  __typename: 'AnalyticsDashboardQueriesPayload';
  data?: Maybe<Array<Scalars['String']>>;
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  metadata?: Maybe<Scalars['String']>;
  type?: Maybe<DashboardQueryType>;
};

export type AnalyticsSessionResult = {
  __typename: 'AnalyticsSessionResult';
  backendLogs?: Maybe<AnalyticsBigQueryPayload>;
  crashLogs?: Maybe<AnalyticsBigQueryPayload>;
  frontendLogs?: Maybe<AnalyticsBigQueryPayload>;
};

export type AnalyticsUserLastSession = {
  __typename: 'AnalyticsUserLastSession';
  date: Scalars['Date'];
  id: Scalars['ID'];
};

export type AnswerHurdleQuizInput = {
  id: Scalars['ID'];
  itemId?: InputMaybe<Scalars['ID']>;
  listenCount: Scalars['Int'];
  mode: HurdleMode;
  skipped: Scalars['Boolean'];
};

export type AnswerHurdleQuizPayload = {
  __typename: 'AnswerHurdleQuizPayload';
  hurdleQuiz: HurdleQuiz;
};

export type AnswerLiveShowData = {
  answerIndex: Scalars['Int'];
  answerTime: Scalars['Int'];
  quizQuestionId: Scalars['ID'];
};

export type AnswerLiveShowInput = {
  answerIndex: Scalars['Int'];
  answerTime: Scalars['Int'];
  quizLiveRoundId: Scalars['ID'];
  quizLiveShowId: Scalars['ID'];
  quizQuestionId: Scalars['ID'];
};

export type AnswerLiveShowPayload = {
  __typename: 'AnswerLiveShowPayload';
  userQuizAnswer?: Maybe<UserQuizAnswer>;
};

export type AnswerMultiQuizLiveShowInput = {
  answers: Array<AnswerLiveShowData>;
  quizLiveRoundId: Scalars['ID'];
  quizLiveShowId: Scalars['ID'];
};

export type AnswerTournamentRoundInput = {
  answers: Array<UserAnswerInput>;
  rank: Scalars['Int'];
  tournamentId: Scalars['ID'];
  tournamentRoundId: Scalars['ID'];
};

export type AnswerTournamentRoundPayload = {
  __typename: 'AnswerTournamentRoundPayload';
  tournament: Tournament;
  user: User;
};

export type AnswerUserToUserQuizLiveRoundInput = {
  answerIndex: Scalars['Int'];
  answerTime: Scalars['Int'];
  /** isBombBoostActivated = false by default (value not mandatory for retro-compatibility purpose) */
  isBombBoostActivated?: InputMaybe<Scalars['Boolean']>;
  quizQuestionId: Scalars['ID'];
  userToUserQuizLiveRoundId: Scalars['ID'];
};

/**
 * Gather data related to a specific app (no user data).
 * Can be viewed by any user (even no users)
 */
export type App = {
  __typename: 'App';
  /** Returns list of active ab tests and their variations for a given app install */
  appInstallABTests: Array<AbTest>;
  appleMusicToken: Scalars['String'];
  artistContentPackLevels: Array<LevelConfigContentPack>;
  autoRenewReminderPopupEnabled: Scalars['Boolean'];
  /** @deprecated use User.energySystems.coin.caps.basic */
  basicCoinCap: RewardCap;
  /** @deprecated use User.energySystems.tournamentTicket.caps.basic */
  basicTournamentTicketCap: RewardCap;
  /** @deprecated use User.energySystems.xp.caps.basic */
  basicXPCap: RewardCap;
  boostsSales: Array<CurrencyBoostPack>;
  coinsSales: Array<CurrencyCoinPack>;
  contentCategories: Array<ContentCategory>;
  contentPackLevels: Array<LevelConfigContentPack>;
  craftableItems: Array<Item>;
  currentMonthlyPass: MonthlyPass;
  emojiFontData: EmojiFontData;
  emojiFontInspectData: Array<EmojiFontInspectData>;
  emojiSales: Array<CurrencyEmojiPack>;
  getUserMonthIdList: GetUserMonthIdListPayload;
  getUserMonthlyPass: GetUserMonthlyPassPayload;
  id: Scalars['ID'];
  /** Items details for the app (all possible items) */
  itemDetails: ItemDetails;
  /** @deprecated Use User.loyaltyCardTrades instead */
  loyaltyCardTrades: Array<LoyaltyCardTrade>;
  piggyBankPacks: Array<PiggyBankPack>;
  podId: Scalars['ID'];
  /** @deprecated use User.energySystems.coin.caps.premium */
  premiumCoinCap: RewardCap;
  /** @deprecated use User.energySystems.tournamentTicket.caps.premium */
  premiumTournamentTicketCap: RewardCap;
  /** @deprecated use User.energySystems.xp.caps.premium */
  premiumXPCap: RewardCap;
  sandboxSubscriptionSkuCheatAllowed: Scalars['Boolean'];
  sandboxSubscriptionSkuCheatEnabled: Scalars['Boolean'];
  sandboxSubscriptionSkuCheatUserIds: Array<Scalars['String']>;
  scoreConfig: ScoreConfig;
  shopBoosts: Array<CurrencyBoostPack>;
  shopChainedOffers: Array<Maybe<ShopChainedOfferPack>>;
  shopCoins: Array<CurrencyCoinPack>;
  shopDailyEmojis: Array<Emoji>;
  shopDailyFragments: Array<CurrencyCategoryFragmentPack>;
  shopDailyItems: Array<Item>;
  shopDiamonds: Array<CurrencyDiamondPack>;
  shopDiamondsSales: Array<CurrencyDiamondPack>;
  shopMetaFragments: Array<CurrencyMetaFragmentPack>;
  shopNextRefresh: Scalars['Date'];
  shopStarterPacks: Array<StarterPack>;
  shouldAddDelay?: Maybe<Scalars['Boolean']>;
  shouldUseNewLiveShow?: Maybe<Scalars['Boolean']>;
  userLevels: Array<LevelConfigUser>;
  /** @deprecated use User.energySystems.coin.caps.vip */
  vipCoinCap: RewardCap;
  /** @deprecated use User.energySystems.tournamentTicket.caps.vip */
  vipTournamentTicketCap: RewardCap;
  /** @deprecated use User.energySystems.xp.caps.vip */
  vipXPCap: RewardCap;
};


/**
 * Gather data related to a specific app (no user data).
 * Can be viewed by any user (even no users)
 */
export type AppGetUserMonthIdListArgs = {
  input: GetUserMonthIdListInput;
};


/**
 * Gather data related to a specific app (no user data).
 * Can be viewed by any user (even no users)
 */
export type AppGetUserMonthlyPassArgs = {
  input: GetUserMonthlyPassInput;
};

export type AppFeatureToggles = {
  __typename: 'AppFeatureToggles';
  autoRenewReminderPopupEnabled: Scalars['Boolean'];
  sandboxSubscriptionSkuCheatEnabled: Scalars['Boolean'];
  sandboxSubscriptionSkuCheatUserIds: Array<Scalars['String']>;
};

/** Represents the app theme, for user customization */
export type AppSkin = Item & {
  __typename: 'AppSkin';
  allLevelItems: Array<Item>;
  asset: Scalars['String'];
  availability: ItemAvailability;
  cost?: Maybe<Currency>;
  iconAsset?: Maybe<Scalars['String']>;
  iconBackgroundColor?: Maybe<Scalars['String']>;
  iconPrimaryColor?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  level: Scalars['Int'];
  liveOpsAvailability: ItemAvailability;
  name: Scalars['String'];
  nextLevelItem?: Maybe<Item>;
  nextLevelItems: Array<Item>;
};

export type AppSkinPaginated = {
  __typename: 'AppSkinPaginated';
  hasMore: Scalars['Boolean'];
  list: Array<AppSkin>;
  totalCount: Scalars['Int'];
};

export type AppVersionConfig = {
  __typename: 'AppVersionConfig';
  forceUpdateType: Scalars['String'];
  numericVersion: Scalars['Int'];
  platform: Scalars['String'];
  version: Scalars['String'];
};

export type ApplyUserSubscriptionUpdateLogInput = {
  logId: Scalars['String'];
  userId: Scalars['String'];
};

export type ApplyUserSubscriptionUpdateLogPayload = {
  __typename: 'ApplyUserSubscriptionUpdateLogPayload';
  user: User;
};

export type ArchiveUserToUserQuizTurnGameInput = {
  userToUserId: Scalars['ID'];
};

export type ArchiveUserToUserQuizTurnPayload = {
  __typename: 'ArchiveUserToUserQuizTurnPayload';
  user?: Maybe<User>;
  userToUser?: Maybe<UserToUser>;
};

export type AuthenticateGoogleSheetInput = {
  code: Scalars['String'];
};

export type AvailableTeamHeatMilestonePayload = {
  __typename: 'AvailableTeamHeatMilestonePayload';
  user: User;
  userMonthlyPass: UserMonthlyPass;
};

export type Badge = {
  __typename: 'Badge';
  createdAt?: Maybe<Scalars['Date']>;
  currentLevel?: Maybe<Scalars['Int']>;
  details: Scalars['String'];
  id: Scalars['ID'];
  isSP2: Scalars['Boolean'];
  levelUpReq: Scalars['String'];
  name: Scalars['String'];
  owned: Scalars['Boolean'];
  type: BadgeType;
  unlockReq: Scalars['String'];
  updatedAt?: Maybe<Scalars['Date']>;
};

export type BadgeConfig = {
  __typename: 'BadgeConfig';
  details: Scalars['String'];
  id: Scalars['ID'];
  levelUpReq?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: BadgeType;
  unlockReq?: Maybe<Scalars['String']>;
};

export type BadgeConfigPaginated = {
  __typename: 'BadgeConfigPaginated';
  hasMore: Scalars['Boolean'];
  list: Array<BadgeConfig>;
  totalCount: Scalars['Int'];
};

export type BadgeCraftDetails = {
  __typename: 'BadgeCraftDetails';
  craftableBadgesCount: Scalars['Int'];
  upgradableBadgesCount: Scalars['Int'];
};

export type BadgePaginated = {
  __typename: 'BadgePaginated';
  hasMore: Scalars['Boolean'];
  list: Array<Badge>;
  totalCount: Scalars['Int'];
};

export enum BadgeProgressTaskType {
  LEVEL = 'LEVEL',
  PLUS = 'PLUS'
}

export enum BadgeType {
  CATEGORY = 'CATEGORY',
  LIVE_EVENT = 'LIVE_EVENT',
  PROGRESS = 'PROGRESS',
  RARE = 'RARE',
  SHOP = 'SHOP'
}

export type BanPlayedPayload = {
  __typename: 'BanPlayedPayload';
  user: User;
};

export type BanUserInput = {
  userId: Scalars['ID'];
};

export type BatchCommitCurationContentPackInput = {
  ids: Array<Scalars['ID']>;
};

export type BatchContentModeration = {
  __typename: 'BatchContentModeration';
  curationContentPacks: Array<CurationContentPack>;
  errorReportedContentItems: ModeratedContentItemPaginated;
  id: Scalars['ID'];
  moderatedContentItems: ModeratedContentItemPaginated;
  moderators: Array<BatchContentModerator>;
  name: Scalars['String'];
  packs: Array<BatchContentModerationPack>;
  state: BatchContentModerationState;
  stats: Array<BatchContentModerationStats>;
};


export type BatchContentModerationErrorReportedContentItemsArgs = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type BatchContentModerationModeratedContentItemsArgs = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

export type BatchContentModerationPack = {
  __typename: 'BatchContentModerationPack';
  curationContentPack: CurationContentPack;
  id: Scalars['ID'];
  moderator?: Maybe<User>;
};

export type BatchContentModerationPaginated = {
  __typename: 'BatchContentModerationPaginated';
  hasMore: Scalars['Boolean'];
  list: Array<BatchContentModeration>;
  totalCount: Scalars['Int'];
};

export enum BatchContentModerationState {
  CREATING = 'CREATING',
  DONE = 'DONE',
  IN_PROGRESS = 'IN_PROGRESS'
}

export type BatchContentModerationStats = {
  __typename: 'BatchContentModerationStats';
  id: Scalars['ID'];
  locale: Scalars['String'];
  totalCount: Scalars['Int'];
  totalDone: Scalars['Int'];
  totalError: Scalars['Int'];
};

export type BatchContentModerator = {
  __typename: 'BatchContentModerator';
  id: Scalars['ID'];
  totalDone: Scalars['Int'];
  user: User;
};

export type BetweenAggregatedMetricsInput = {
  end: Scalars['String'];
  env?: InputMaybe<ServerEnv>;
  filterOutSubscriptions?: InputMaybe<Scalars['Boolean']>;
  maxNumberOfRequests?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<ServerMode>;
  orderQuery?: InputMaybe<MetricOrderBy>;
  start: Scalars['String'];
  timestamp: MetricTimestamp;
  type: MetricType;
};

export type BigQueryInput = {
  id: Scalars['ID'];
  query: Scalars['String'];
};

export type BlockUserInput = {
  userId: Scalars['ID'];
};

export type BlockUserPayload = {
  __typename: 'BlockUserPayload';
  me?: Maybe<User>;
  userToUser?: Maybe<UserToUser>;
};

export type BundleItem = {
  __typename: 'BundleItem';
  amount?: Maybe<Scalars['Int']>;
  itemId?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
};

export type BundlePack = {
  cost: Scalars['Float'];
  id: Scalars['String'];
  rewards: Array<LevelReward>;
  sku: Scalars['String'];
};

export enum BundlePackName {
  LARGE = 'LARGE',
  LARGE_2 = 'LARGE_2',
  MEDIUM = 'MEDIUM',
  MEDIUM_2 = 'MEDIUM_2',
  SMALL = 'SMALL',
  SMALL_2 = 'SMALL_2'
}

export enum BundlePackTag {
  BEST_VALUE = 'BEST_VALUE',
  BIG_DEAL = 'BIG_DEAL',
  BONUS = 'BONUS',
  DEAL = 'DEAL',
  NEW = 'NEW',
  SALE = 'SALE',
  SPECIAL = 'SPECIAL'
}

export type BuyTeamShopItemPayload = {
  __typename: 'BuyTeamShopItemPayload';
  item: UserTeamShopItem;
  user: User;
};

export type CalendarPayload = {
  __typename: 'CalendarPayload';
  calendar: UserPaidCalendar;
  user: User;
};

export type CalendarsInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CancelLiveEventMatchmakingPayload = {
  __typename: 'CancelLiveEventMatchmakingPayload';
  liveEvent: LiveEvent;
};

export type CancelLiveEventRoundPayload = {
  __typename: 'CancelLiveEventRoundPayload';
  userToUser: UserToUser;
};

export type CancelTeamQuizLiveGameRequestInput = {
  teamId: Scalars['ID'];
};

export type CancelTeamQuizLiveGameRequestPayload = {
  __typename: 'CancelTeamQuizLiveGameRequestPayload';
  team: Team;
};

export enum CapType {
  COIN = 'COIN',
  LIVE_EVENT_TICKET = 'LIVE_EVENT_TICKET',
  TOURNAMENT_TICKET = 'TOURNAMENT_TICKET',
  XP = 'XP'
}

export enum ChainedOfferClaimType {
  AD = 'AD',
  BUY = 'BUY',
  FREE = 'FREE',
  PLUS = 'PLUS',
  PLUS_BUY = 'PLUS_BUY'
}

export type ChainedOfferEvent = {
  __typename: 'ChainedOfferEvent';
  activePack: Scalars['Int'];
  backgroundImage?: Maybe<Scalars['String']>;
  claimedPacks: Array<Scalars['Int']>;
  id: Scalars['ID'];
  isParticipating: Scalars['Boolean'];
  name: Scalars['String'];
  packs: Array<ChainedOfferPack>;
  startDate: Scalars['Date'];
  stopDate: Scalars['Date'];
};

export type ChainedOfferEventConfig = {
  __typename: 'ChainedOfferEventConfig';
  backgroundImage?: Maybe<Scalars['String']>;
  filterAppVersion?: Maybe<Scalars['String']>;
  filterSubscriptionTier?: Maybe<UserSubscriptionTier>;
  filterUserIds?: Maybe<Array<Scalars['String']>>;
  filterUserLevel?: Maybe<Scalars['Int']>;
  filterUserMaxCreationDate?: Maybe<Scalars['String']>;
  filterUserMinCreationDate?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  packs: Array<ChainedOfferPackConfig>;
  startDate: Scalars['Date'];
  status: ChainedOfferEventStatus;
  stopDate: Scalars['Date'];
};

export enum ChainedOfferEventStatus {
  ACTIVE = 'ACTIVE',
  DRAFT = 'DRAFT'
}

export type ChainedOfferPack = BundlePack & {
  __typename: 'ChainedOfferPack';
  claimType: ChainedOfferClaimType;
  cost: Scalars['Float'];
  id: Scalars['String'];
  rewards: Array<LevelReward>;
  sku: Scalars['String'];
};

export type ChainedOfferPackConfig = {
  __typename: 'ChainedOfferPackConfig';
  claimType: ChainedOfferClaimType;
  cost?: Maybe<Scalars['Float']>;
  rewards: Array<ChainedOfferPackRewardConfig>;
  sku?: Maybe<Scalars['String']>;
};

export type ChainedOfferPackConfigInput = {
  claimType: ChainedOfferClaimType;
  cost?: InputMaybe<Scalars['Float']>;
  rewards: Array<LevelRewardInput>;
  sku?: InputMaybe<Scalars['String']>;
};

export type ChainedOfferPackRewardConfig = {
  __typename: 'ChainedOfferPackRewardConfig';
  amount: Scalars['Int'];
  itemId: Scalars['ID'];
  type: Scalars['String'];
};

export type ChallengeSp2OpponentInput = {
  link: Scalars['String'];
  opponentSP2Id: Scalars['ID'];
};

export type ChallengeSp2OpponentPayload = {
  __typename: 'ChallengeSP2OpponentPayload';
  opponent: Sp2Opponent;
};

export type ChangeAvailableDateYirInput = {
  date: Scalars['Date'];
  userId: Scalars['ID'];
  year: Scalars['Int'];
};

export type ChatSender = Agent | User;

export type CheckMusicReportStatusPayload = {
  __typename: 'CheckMusicReportStatusPayload';
  exportPostProcess?: Maybe<Scalars['String']>;
  exportStatusAll?: Maybe<Scalars['String']>;
  exportStatusSP?: Maybe<Scalars['String']>;
  exportStatusSPPJP?: Maybe<Scalars['String']>;
};

export type ClaimChainedOfferPackInput = {
  id: Scalars['ID'];
  packIndex: Scalars['Int'];
  priceAmount?: InputMaybe<Scalars['Float']>;
  priceCurrency?: InputMaybe<Scalars['String']>;
  receipt?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['ID']>;
  store?: InputMaybe<StoreType>;
};

export type ClaimChainedOfferPackPayload = {
  __typename: 'ClaimChainedOfferPackPayload';
  user: User;
};

export type ClaimCollectionRewardPayload = {
  __typename: 'ClaimCollectionRewardPayload';
  collection: UserCollection;
  user: User;
};

export type ClaimCurrentAdsRewardPayload = {
  __typename: 'ClaimCurrentAdsRewardPayload';
  adsRewardClaimed: AdsReward;
  user: User;
};

export type ClaimCurrentDailyBonusPayload = {
  __typename: 'ClaimCurrentDailyBonusPayload';
  user: User;
};

export type ClaimHurdleRewardsInput = {
  adWatched: Scalars['Boolean'];
  id: Scalars['ID'];
  /**
   * If the reward claimed is an unlimited boost, it can be automatically activated
   * (like calling activateUnlimitedBoost mutation on behalf of the user)
   * default: true
   */
  isUnlimitedBoostActiveOnClaim?: InputMaybe<Scalars['Boolean']>;
};

export type ClaimHurdleRewardsPayload = {
  __typename: 'ClaimHurdleRewardsPayload';
  hurdleQuiz: HurdleQuiz;
  user: User;
};

export type ClaimLevelUserRewardInput = {
  level: Scalars['Int'];
  subscriptionTier: UserSubscriptionTier;
};

export type ClaimLevelUserRewardPayload = {
  __typename: 'ClaimLevelUserRewardPayload';
  user: User;
};

/** Optional input for backward compatibility reason. Once alpha 4.1 is there, will make it required */
export type ClaimLevelUserRewardsInput = {
  /** Optional list of levels to claim. If not present, all unclaimed levels at the subscription tier will be claimed */
  levels?: InputMaybe<Array<Scalars['Int']>>;
  subscriptionTier: UserSubscriptionTier;
};

export type ClaimLevelUserRewardsPayload = {
  __typename: 'ClaimLevelUserRewardsPayload';
  user: User;
};

export type ClaimLiveEventShopItemPayload = {
  __typename: 'ClaimLiveEventShopItemPayload';
  user: User;
  userLiveEvent: UserLiveEvent;
};

export type ClaimLoyaltyCampaignCardPayload = {
  __typename: 'ClaimLoyaltyCampaignCardPayload';
  user: User;
};

export type ClaimLoyaltyCardDayInput = {
  /**
   * Reward amount can be multiplied by a factor based on user action (eg. watch ad = amount x 2).
   * We trust the client and we only check BE side if amountMultiplier is between 1 and 4
   */
  amountMultiplier: Scalars['Float'];
  id: Scalars['ID'];
};

export type ClaimLoyaltyCardDayPayload = {
  __typename: 'ClaimLoyaltyCardDayPayload';
  user: User;
};

export type ClaimMarathonMilestoneInput = {
  eventId: Scalars['ID'];
  /** Boolean which tells if user want to claim all available milestones. */
  isAll: Scalars['Boolean'];
  isPlus: Scalars['Boolean'];
  milestoneIndex: Scalars['Int'];
};

export type ClaimMarathonMilestonePayload = {
  __typename: 'ClaimMarathonMilestonePayload';
  user: User;
  userMarathonEvent: UserMarathonEvent;
};

export type ClaimMissionInput = {
  missionId: Scalars['ID'];
  xpMultiplier: Scalars['Float'];
};

export type ClaimMissionPayload = {
  __typename: 'ClaimMissionPayload';
  user: User;
};

export type ClaimMonthlyPassLeaderboardRewardsPayload = {
  __typename: 'ClaimMonthlyPassLeaderboardRewardsPayload';
  user: User;
};

export type ClaimPromotionInput = {
  promotionId: Scalars['ID'];
};

export type ClaimPromotionPayload = {
  __typename: 'ClaimPromotionPayload';
  user: User;
};

export type ClaimQuizLiveShowUserRoundRewardInput = {
  correctAliveQuestions: Scalars['Int'];
  correctGhostQuestions: Scalars['Int'];
  quizLiveRoundId: Scalars['ID'];
  quizLiveShowId: Scalars['ID'];
};

export type ClaimQuizLiveShowUserRoundRewardPayload = {
  __typename: 'ClaimQuizLiveShowUserRoundRewardPayload';
  rewards: Array<LevelReward>;
  songs: Array<Song>;
  specialReward?: Maybe<LevelReward>;
  user: User;
  userContentPack: UserContentPack;
  userLikedContent: Array<UserContentItem>;
  userNewContent: Array<UserContentItem>;
};

export type ClaimReferralRewardInput = {
  referralRewardId: Scalars['String'];
};

export type ClaimReturningGiftPayload = {
  __typename: 'ClaimReturningGiftPayload';
  user: User;
};

export type ClaimSpecialEventMilestoneRewardInput = {
  specialEventId: Scalars['ID'];
  specialEventMilestoneId: Scalars['ID'];
};

export type ClaimSpecialEventMilestoneRewardPayload = {
  __typename: 'ClaimSpecialEventMilestoneRewardPayload';
  specialEvent: SpecialEvent;
  user: User;
};

export type ClaimSpecialEventRankGroupRewardInput = {
  specialEventId: Scalars['ID'];
};

export type ClaimSpecialEventRankGroupRewardPayload = {
  __typename: 'ClaimSpecialEventRankGroupRewardPayload';
  specialEvent: SpecialEvent;
  user: User;
};

export type ClaimStarterPackFragmentsInput = {
  categoryId: Scalars['ID'];
  starterPackId: Scalars['ID'];
};

export type ClaimStarterPackFragmentsPayload = {
  __typename: 'ClaimStarterPackFragmentsPayload';
  starterPack: StarterPack;
  user: User;
};

export type ClaimTeamMonthlyPassInput = {
  monthIds: Array<Scalars['ID']>;
  teamId: Scalars['ID'];
};

export type ClaimTeamMonthlyPassRewardPayload = {
  __typename: 'ClaimTeamMonthlyPassRewardPayload';
  user: User;
};

export type ClaimTournamentMilestoneRewardInput = {
  tournamentId: Scalars['ID'];
  tournamentMilestoneId: Scalars['ID'];
};

export type ClaimTournamentMilestoneRewardPayload = {
  __typename: 'ClaimTournamentMilestoneRewardPayload';
  tournament: Tournament;
  user: User;
};

export type ClaimTournamentRankGroupRewardInput = {
  tournamentId: Scalars['ID'];
};

export type ClaimTournamentRankGroupRewardPayload = {
  __typename: 'ClaimTournamentRankGroupRewardPayload';
  tournament: Tournament;
  user: User;
};

export type ClaimUpdateGiftPayload = {
  __typename: 'ClaimUpdateGiftPayload';
  user: User;
};

export type ClaimUserMonthlyPassRewardInput = {
  level: Scalars['Int'];
  subscriptionTier: UserSubscriptionTier;
};

export type ClaimUserMonthlyPassRewardPayload = {
  __typename: 'ClaimUserMonthlyPassRewardPayload';
  rewardClaimed: LevelReward;
  user: User;
  userMonthlyPass: UserMonthlyPass;
};

export type ClaimUserMonthlyPassRewardsInput = {
  /** levels is optional, if it's not present, all the levels for this tier will be claimed */
  levels?: InputMaybe<Array<Scalars['Int']>>;
  subscriptionTier: UserSubscriptionTier;
};

export type ClaimUserMonthlyPassRewardsPayload = {
  __typename: 'ClaimUserMonthlyPassRewardsPayload';
  rewards: Array<LevelReward>;
  user: User;
  userMonthlyPass: UserMonthlyPass;
};

export type ClaimUserToUserQuizTurnRoundInput = {
  userToUserQuizTurnRoundId: Scalars['ID'];
};

export type ClaimUserToUserQuizTurnRoundPayload = {
  __typename: 'ClaimUserToUserQuizTurnRoundPayload';
  user?: Maybe<User>;
  userToUserQuizTurnRound?: Maybe<UserToUserQuizTurnRound>;
};

export type ClaimingReferralRewardsInput = {
  userId: Scalars['String'];
};

export type Collection = {
  __typename: 'Collection';
  asset?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDraft: Scalars['Boolean'];
  levels: Array<CollectionLevel>;
  name: Scalars['String'];
  type: CollectionType;
};

export enum CollectionItemType {
  BADGE = 'BADGE',
  FRAME = 'FRAME',
  PLAYLIST = 'PLAYLIST',
  STICKER = 'STICKER',
  VINYL = 'VINYL'
}

export type CollectionLevel = {
  __typename: 'CollectionLevel';
  items?: Maybe<Array<CollectionLevelItem>>;
  rewards?: Maybe<Array<CollectionReward>>;
};

export type CollectionLevelInput = {
  items?: InputMaybe<Array<CollectionLevelItemInput>>;
  rewards?: InputMaybe<Array<LevelRewardInput>>;
};

export type CollectionLevelItem = {
  __typename: 'CollectionLevelItem';
  itemId: Scalars['ID'];
  itemLevel: Scalars['Int'];
  type: CollectionItemType;
};

export type CollectionLevelItemInput = {
  itemId: Scalars['ID'];
  itemLevel: Scalars['Int'];
  type: CollectionItemType;
};

export type CollectionPaginated = {
  __typename: 'CollectionPaginated';
  hasMore: Scalars['Boolean'];
  list: Array<Collection>;
  totalCount: Scalars['Int'];
};

export type CollectionReward = {
  __typename: 'CollectionReward';
  amount?: Maybe<Scalars['Int']>;
  itemId?: Maybe<Scalars['ID']>;
  type: Scalars['String'];
};

export enum CollectionType {
  MUSIC = 'MUSIC',
  SPECIAL = 'SPECIAL',
  VANITY = 'VANITY'
}

export type CommitCurationContentPackInput = {
  availabilityDate?: InputMaybe<Scalars['Date']>;
  availabilityType?: InputMaybe<ContentPackAvailabilityType>;
  id: Scalars['ID'];
};

export type CommitSp2CurationPlaylistInput = {
  sp2CurationPlaylistId: Scalars['ID'];
  useV2?: InputMaybe<Scalars['Boolean']>;
};

export type CompleteFtueStepInput = {
  step: Scalars['String'];
};

export type CompleteFtueStepPayload = {
  __typename: 'CompleteFTUEStepPayload';
  user: User;
};

export type CompleteUserHurdleQuizInput = {
  id: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
};

export type CompleteUserHurdleQuizPayload = {
  __typename: 'CompleteUserHurdleQuizPayload';
  hurdleQuiz: HurdleQuiz;
};

export type CompleteUserToUserQuizTurnRoundInput = {
  answers: Array<UserAnswerInput>;
  userToUserQuizTurnRoundId: Scalars['ID'];
};

export type CompleteUserToUserQuizTurnRoundPayload = {
  __typename: 'CompleteUserToUserQuizTurnRoundPayload';
  user?: Maybe<User>;
  userToUser?: Maybe<UserToUser>;
};

/**
 * Represents content pack category.
 * For SP3, music genres/decades
 * FOR TVP, trivia categories
 */
export type ContentCategory = {
  __typename: 'ContentCategory';
  icon: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  type: ContentCategoryType;
};

export enum ContentCategoryType {
  MUSIC_DECADE = 'MUSIC_DECADE',
  MUSIC_GENRE = 'MUSIC_GENRE',
  MUSIC_SPECIAL = 'MUSIC_SPECIAL',
  TRIVIA = 'TRIVIA'
}

/**
 * Represents a question content the user can play on.
 * For SP3, song sample
 * For TVP, a trivia question
 */
export type ContentItem = QuizQuestion | SongSample;

/**
 * Represents a collection of ContentItem with added metadata.
 * Used to generate quiz rounds.
 * For SP3, music playlist
 * FOR TVP, trivia "playlist"
 */
export type ContentPack = {
  __typename: 'ContentPack';
  adminSpecialEvents: Array<SpecialEvent>;
  availabilityDate: Scalars['Date'];
  availabilityType: ContentPackAvailabilityType;
  categories: Array<ContentCategory>;
  contentItems: Array<ContentItem>;
  contentItemsCount: Scalars['Int'];
  explicitContentStatus?: Maybe<ContentPackExplicitContentStatus>;
  featuredArtists: Array<Scalars['String']>;
  id: Scalars['ID'];
  isArtistOnlyBoostActivable: Scalars['Boolean'];
  isNew: Scalars['Boolean'];
  isReplacing: Scalars['Boolean'];
  lastUpdateDate: Scalars['Date'];
  levelConfigs: Array<LevelConfigContentPack>;
  localeCountryCode: Scalars['String'];
  monthlyLeaderboard: Leaderboard;
  name: Scalars['String'];
  picture?: Maybe<Scalars['String']>;
  popularity: Scalars['Int'];
  specialEvent?: Maybe<SpecialEvent>;
  type: ContentPackType;
};


/**
 * Represents a collection of ContentItem with added metadata.
 * Used to generate quiz rounds.
 * For SP3, music playlist
 * FOR TVP, trivia "playlist"
 */
export type ContentPackContentItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export enum ContentPackAvailabilityType {
  ALL = 'ALL',
  EARN = 'EARN',
  UNAVAILABLE = 'UNAVAILABLE'
}

export enum ContentPackExplicitContentStatus {
  CAN_BE_FILTERED = 'CAN_BE_FILTERED',
  CLEAN = 'CLEAN',
  EXPLICIT = 'EXPLICIT'
}

export type ContentPackList = {
  __typename: 'ContentPackList';
  contentPackListId: Scalars['ID'];
  contentPacks: Array<ContentPack>;
  description: Scalars['String'];
  name: Scalars['String'];
};

export type ContentPackListPaginated = {
  __typename: 'ContentPackListPaginated';
  hasMore: Scalars['Boolean'];
  list: Array<ContentPackList>;
  totalCount: Scalars['Int'];
};

export type ContentPackPaginated = {
  __typename: 'ContentPackPaginated';
  hasMore: Scalars['Boolean'];
  id: Scalars['ID'];
  list: Array<ContentPack>;
  totalCount: Scalars['Int'];
};

export type ContentPackPayload = {
  __typename: 'ContentPackPayload';
  contentPack: ContentPack;
};

export type ContentPackReward = {
  __typename: 'ContentPackReward';
  contentPack: ContentPack;
  id: Scalars['ID'];
  type: Scalars['String'];
};

export type ContentPackSearchPayload = {
  __typename: 'ContentPackSearchPayload';
  allContentPacks: UserContentPackPaginated;
  artistContentPacks: UserContentPackPaginated;
  categories: Array<ContentCategory>;
  topContentPacks: UserContentPackPaginated;
};


export type ContentPackSearchPayloadAllContentPacksArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ContentPackSearchPayloadArtistContentPacksArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ContentPackSearchPayloadCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ContentPackSearchPayloadTopContentPacksArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export enum ContentPackType {
  ARTIST = 'ARTIST',
  PLAYLIST = 'PLAYLIST',
  TRIVIA = 'TRIVIA'
}

export enum ContentSearchType {
  BY_AVAILABILITY_TYPE = 'BY_AVAILABILITY_TYPE',
  BY_CATEGORY = 'BY_CATEGORY',
  BY_NAME = 'BY_NAME'
}

export type Conversation = {
  __typename: 'Conversation';
  id: Scalars['ID'];
  messages: MessagesPaginated;
  unreadCount: Scalars['Int'];
};


export type ConversationMessagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type ConversationPayload = {
  __typename: 'ConversationPayload';
  conversation: Conversation;
  user: User;
};

export type ConvertSamplesInput = {
  contentPackId: Scalars['ID'];
  format: Scalars['String'];
};

export type ConvertToSp2SamplesInput = {
  contentPackId: Scalars['ID'];
};

export type CopyQuizLiveShowInput = {
  showId: Scalars['ID'];
  startDate: Scalars['Date'];
};

export type CopyTournamentInput = {
  id: Scalars['ID'];
  startDate: Scalars['Date'];
};

export type CraftItemInput = {
  itemId: Scalars['ID'];
};

export type CreateAbTestInput = {
  id: Scalars['ID'];
};

export type CreateAbTestPayload = {
  __typename: 'CreateABTestPayload';
  abTest: AbTestConfig;
};

export type CreateBackendDeploymentImportantEventInput = {
  datetime: Scalars['Date'];
  important?: InputMaybe<Scalars['Boolean']>;
  major: Scalars['Int'];
  minor: Scalars['Int'];
  notes?: InputMaybe<Scalars['String']>;
  patch: Scalars['Int'];
};

export type CreateBadgeInput = {
  name: Scalars['String'];
  type: BadgeType;
};

export type CreateBadgePayload = {
  __typename: 'CreateBadgePayload';
  badge: BadgeConfig;
};

export type CreateBatchContentModerationInput = {
  name: Scalars['String'];
  packIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type CreateChainedOfferEventInput = {
  name: Scalars['String'];
};

export type CreateChainedOfferEventPayload = {
  __typename: 'CreateChainedOfferEventPayload';
  chainedOfferEvent: ChainedOfferEventConfig;
};

export type CreateCollectionInput = {
  name: Scalars['String'];
  type: CollectionType;
};

export type CreateContentPackListInput = {
  contentPackIds?: Array<Scalars['ID']>;
  description?: Scalars['String'];
  name: Scalars['String'];
};

export type CreateCurationContentPackByArtistsInput = {
  artistIds: Array<Scalars['String']>;
  includeExtras?: InputMaybe<Scalars['Boolean']>;
};

export type CreateCurationContentPackByCsvInput = {
  file: Scalars['Upload'];
};

export type CreateCurationContentPackByUrlInput = {
  spotifyURI: Scalars['String'];
};

export type CreateCurationContentPackFromSp2Input = {
  sp2PlaylistId: Scalars['String'];
};

export type CreateCurationContentPackFromSp2MultiInput = {
  sp2PlaylistIds?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateCurationContentPackFromSp2MultiPayload = {
  __typename: 'CreateCurationContentPackFromSp2MultiPayload';
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateCurationContentPackListInput = {
  appId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CreateCurationContentPackNewDraftInput = {
  file?: InputMaybe<Scalars['Upload']>;
  id: Scalars['ID'];
  includeExtras?: InputMaybe<Scalars['Boolean']>;
  sp2PlaylistId?: InputMaybe<Scalars['String']>;
  spotifyArtistsIds?: InputMaybe<Array<Scalars['String']>>;
  spotifyURI?: InputMaybe<Scalars['String']>;
};

export type CreateEmojiPackInput = {
  name: Scalars['String'];
};

export type CreateEmojiPackPayload = {
  __typename: 'CreateEmojiPackPayload';
  emojiPack: EmojiPack;
};

export type CreateExportRequestInput = {
  userId: Scalars['String'];
};

export type CreateExportRequestPayload = {
  __typename: 'CreateExportRequestPayload';
  userExport: UserExport;
};

export type CreateFrontendDeploymentImportantEventInput = {
  datetime: Scalars['Date'];
  important?: InputMaybe<Scalars['Boolean']>;
  major: Scalars['Int'];
  minor: Scalars['Int'];
  notes?: InputMaybe<Scalars['String']>;
  patch: Scalars['Int'];
  platform: Scalars['String'];
};

export type CreateHurdleCatalogItemInput = {
  categoryId?: InputMaybe<Scalars['String']>;
  contentItemId: Scalars['ID'];
  excludeFromAutogeneration: Scalars['Boolean'];
  sourceContentPackId: Scalars['ID'];
  type: HurdleType;
};

export type CreateHurdleCatalogItemPayload = {
  __typename: 'CreateHurdleCatalogItemPayload';
  catalogItem: HurdleCatalogItem;
  hasBeenRestored: Scalars['Boolean'];
};

export type CreateHurdleQuizInput = {
  catalogItemId: Scalars['ID'];
  categoryId: Scalars['String'];
  endDate: Scalars['Date'];
  namespace: HurdleNamespace;
  startDate: Scalars['Date'];
  type: HurdleType;
};

export type CreateHurdleQuizPayload = {
  __typename: 'CreateHurdleQuizPayload';
  hurdleQuiz: HurdleQuiz;
};

export type CreateImportantEventInput = {
  datetime: Scalars['Date'];
  description: Scalars['String'];
  important?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
};

export type CreateItemInput = {
  asset: Scalars['String'];
  cost?: InputMaybe<CurrencyInput>;
  name: Scalars['String'];
  type: CreateItemInputType;
};

export enum CreateItemInputType {
  APP_SKIN = 'APP_SKIN',
  PROFILE_FRAME = 'PROFILE_FRAME',
  STICKER = 'STICKER'
}

export type CreateItemPayload = {
  __typename: 'CreateItemPayload';
  item: Item;
};

export type CreateLiveEventInput = {
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
};

export type CreateMmTemplateInput = {
  milestones: Array<MMilestonesInput>;
  name: Scalars['String'];
};

export type CreateMmTemplatePayload = {
  __typename: 'CreateMMTemplatePayload';
  template: MarathonMilestoneTemplate;
};

export type CreateMarathonEventInput = {
  name: Scalars['String'];
};

export type CreateMarathonEventPayload = {
  __typename: 'CreateMarathonEventPayload';
  event: MarathonEventConfig;
};

export type CreatePosterInput = {
  name: Scalars['String'];
  type: PosterType;
};

export type CreatePracticeQuizInput = {
  contentPackId: Scalars['ID'];
};

export type CreatePracticeQuizInputPayload = {
  __typename: 'CreatePracticeQuizInputPayload';
  quiz: PracticeQuiz;
};

export type CreateSaleEventInput = {
  name: Scalars['String'];
};

export type CreateSaleEventPayload = {
  __typename: 'CreateSaleEventPayload';
  saleEvent: SaleEventConfig;
};

export type CreateSpecialEventInput = {
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
};

export type CreateSpecialEventSampleInput = {
  categoryId?: InputMaybe<Scalars['String']>;
  contentPackIds?: InputMaybe<Array<Scalars['String']>>;
  specialEventIsDraft?: InputMaybe<Scalars['Boolean']>;
};

export type CreateTeamInput = {
  banner: Scalars['String'];
  description: Scalars['String'];
  name: Scalars['String'];
  type: TeamType;
};

export type CreateTournamentInput = {
  categoryId: Scalars['ID'];
  startDate: Scalars['Date'];
};

export type CreateUpdateTeamShopItemInput = {
  buyLimit?: InputMaybe<Scalars['Int']>;
  buyLimitType?: InputMaybe<TeamShopBuyLimitEnum>;
  cost: Scalars['Int'];
  discount?: InputMaybe<Scalars['Int']>;
  endDate?: InputMaybe<Scalars['Date']>;
  reward: LevelRewardInput;
  startDate: Scalars['Date'];
};

export type CreateUserToUserQuizTurnRoundForInfluencerInput = {
  influencerId: Scalars['ID'];
};

export type CreateUserToUserQuizTurnRoundForInfluencerPayload = {
  __typename: 'CreateUserToUserQuizTurnRoundForInfluencerPayload';
  userToUser?: Maybe<UserToUser>;
};

export type CreateUserToUserQuizTurnRoundForInviteInput = {
  contentPackId: Scalars['ID'];
};

export type CreateUserToUserQuizTurnRoundForInvitePayload = {
  __typename: 'CreateUserToUserQuizTurnRoundForInvitePayload';
  user?: Maybe<User>;
  userToUserQuizTurnRound?: Maybe<UserToUserQuizTurnRound>;
};

export type CreateUserToUserQuizTurnRoundForRandomInput = {
  contentPackId: Scalars['ID'];
};

export type CreateUserToUserQuizTurnRoundForRandomPayload = {
  __typename: 'CreateUserToUserQuizTurnRoundForRandomPayload';
  user?: Maybe<User>;
  userToUser?: Maybe<UserToUser>;
};

export type CreateUserToUserQuizTurnRoundForUserInput = {
  contentPackId: Scalars['ID'];
  opponentId: Scalars['ID'];
};

export type CreateUserToUserQuizTurnRoundForUserPayload = {
  __typename: 'CreateUserToUserQuizTurnRoundForUserPayload';
  user?: Maybe<User>;
  userToUser?: Maybe<UserToUser>;
};

export type CreateUserToUserQuizTurnRoundInput = {
  contentPackId: Scalars['ID'];
  userToUserId: Scalars['ID'];
};

export type CreateUserToUserQuizTurnRoundPayload = {
  __typename: 'CreateUserToUserQuizTurnRoundPayload';
  user?: Maybe<User>;
  userToUser?: Maybe<UserToUser>;
};

export type CreateWfEventInput = {
  name: Scalars['String'];
};

export type CreateWfEventPayload = {
  __typename: 'CreateWFEventPayload';
  event: WheelFortuneEventConfig;
};

export type CreateWfrTemplateInput = {
  name: Scalars['String'];
  rewards: Array<WfRewardInput>;
};

export type CreateWfrTemplatePayload = {
  __typename: 'CreateWFRTemplatePayload';
  template: WheelFortuneRewardTemplate;
};

export enum CredentialSignUpType {
  APPLE = 'APPLE',
  FACEBOOK = 'FACEBOOK',
  FIREBASE = 'FIREBASE',
  GOOGLE = 'GOOGLE',
  KID = 'KID',
  TEST = 'TEST'
}

export type CrupdateSp2ReleaseInput = {
  id?: InputMaybe<Scalars['ID']>;
  playlistIds: Array<Scalars['String']>;
  releaseTime: Scalars['Int'];
  type: Scalars['String'];
};

export type CrupdateSp2ReleasePayload = {
  __typename: 'CrupdateSP2ReleasePayload';
  sp2Release?: Maybe<Sp2ReleaseStatusRelease>;
};

/** This object contains the basic data about curation, to populate the admin website. */
export type Curation = {
  __typename: 'Curation';
  /** SP3 catalog export status */
  catalogExport?: Maybe<CurationTask>;
  /** Used to generate a CSV file with all the playlists' metadata */
  contentPackCsvExport: CurationCsvExport;
  /** Paginated list of curation content packs to be displayed on the playlist screen */
  contentPacks: CurationContentPacksPaginated;
  id: Scalars['ID'];
  /** iTunes database ingestion status */
  ingestStatus?: Maybe<CurationTask>;
  legalConfig: CurationLegalConfig;
};


/** This object contains the basic data about curation, to populate the admin website. */
export type CurationContentPacksArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type CurationBlacklistedTitle = {
  __typename: 'CurationBlacklistedTitle';
  artist: Scalars['String'];
  title: Scalars['String'];
};

export type CurationContentItem = CurationQuizQuestion | CurationSong | CurationSongInput;

export type CurationContentPack = {
  __typename: 'CurationContentPack';
  /** manual tag by curator to restrict a content pack to adult (bypassing explicitContentStatus) */
  adultOnly: Scalars['Boolean'];
  categories: Array<ContentCategory>;
  /** Date when the playlist was committed (if it is committed, otherwise null) */
  committed?: Maybe<Scalars['Date']>;
  /**
   * Content of the CCP. If the type is TRIVIA, it is an array of CurationQuizQuestion. Otherwise, it is an array
   * of CurationSong and CurationSongInput for unmatched songs
   */
  contentItems: Array<CurationContentItem>;
  /** If the CCP is committed, link to the corresponding ContentPack */
  contentPack?: Maybe<ContentPack>;
  /** Date of playlist creation */
  created: Scalars['Date'];
  /** Date when the playlist was deleted (if it is deleted, otherwise null) */
  deleted?: Maybe<Scalars['Date']>;
  description: Scalars['String'];
  /** playlist explicit status based on label information */
  explicitContentStatus: ContentPackExplicitContentStatus;
  /**
   * String describing where the playlist comes from.
   * If imported from Spotify -> spotify:playlist:<Playlist ID>
   * If imported from SP2 -> sp2:<SP2 Production ID>
   * If generated from Spotify artists: artists:<Spotify artist ID 1>,<Spotify artist ID 2>,...
   */
  externalURI?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** ISO 639 locale, default is en-US */
  locale?: Maybe<Scalars['String']>;
  localeReplacements?: Maybe<Array<CurationContentPack>>;
  name: Scalars['String'];
  /**
   * ID of the first version of the CCP. It remains the same when we create a new version and therefore lets us know which CCPs are different
   * versions of the same playlist
   */
  originId: Scalars['ID'];
  /** Date when the playlist was outdated, i.e. a new version was created (if it is outdated, otherwise null) */
  outdated?: Maybe<Scalars['Date']>;
  picture: Scalars['String'];
  /** If the CCP is localized, the replacing content pack is the US-based CCP that is replaced */
  replacingContentPack?: Maybe<CurationContentPack>;
  /** Array of custom fields. Changes the way quizzes a created based on the CCP */
  selectedCustomFields: Array<CurationContentPackCustomField>;
  /**
   * If the CCP was exported to SP2, it is the ID of the corresponding SP2 playlist. If the CCP was imported from SP2,
   * it also points to the SP2 playlist: like this, if we make changes to the CCP in SP3 admin website and want to transfer
   * those changes to SP2, the SP3 CCP will be exported to the right SP2 playlist.
   */
  sp2ExportId?: Maybe<Scalars['String']>;
  /** Last SP2 export date */
  sp2LastExportDate?: Maybe<Scalars['Date']>;
  /** last exported version to SP2 */
  sp2LastExportedVersion?: Maybe<Scalars['Int']>;
  /** If the CCP is available only on SP2 (legacy playlist, never to appear in SP3/SPP) */
  sp2Only?: Maybe<Scalars['Boolean']>;
  state?: Maybe<CurationContentPackState>;
  type: ContentPackType;
  version: Scalars['Int'];
};


export type CurationContentPackContentItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** Changes the way songs are displayed when quizzes are created from the curation content pack */
export enum CurationContentPackCustomField {
  ARTIST = 'ARTIST',
  COMPOSER = 'COMPOSER',
  CUSTOM = 'CUSTOM',
  CUSTOM_SAMPLE = 'CUSTOM_SAMPLE',
  FULL_CUSTOM = 'FULL_CUSTOM',
  INTRO_SAMPLE = 'INTRO_SAMPLE',
  /** @deprecated use CUSTOM */
  JESTER_TITLE = 'JESTER_TITLE',
  LEAD_SINGER = 'LEAD_SINGER',
  /** @deprecated use CUSTOM */
  MOVIE_TITLE = 'MOVIE_TITLE',
  TITLE = 'TITLE'
}

export type CurationContentPackList = {
  __typename: 'CurationContentPackList';
  curationContentPacks: Array<CurationContentPack>;
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CurationContentPackListPaginated = {
  __typename: 'CurationContentPackListPaginated';
  hasMore: Scalars['Boolean'];
  list: Array<CurationContentPackList>;
  totalCount: Scalars['Int'];
};

export type CurationContentPackPayload = {
  __typename: 'CurationContentPackPayload';
  curationContentPack: CurationContentPack;
};

export enum CurationContentPackState {
  COMMITTED = 'COMMITTED',
  CREATED = 'CREATED',
  DELETED = 'DELETED',
  OUTDATED = 'OUTDATED',
  PROCESSING = 'PROCESSING',
  VALIDATING = 'VALIDATING'
}

export type CurationContentPacksPaginated = {
  __typename: 'CurationContentPacksPaginated';
  hasMore: Scalars['Boolean'];
  list: Array<CurationContentPack>;
  totalCount: Scalars['Int'];
};

export type CurationCsvExport = {
  __typename: 'CurationCsvExport';
  content: Scalars['String'];
};

/** Contains all the legal config data to populate the corresponding page on the admin website */
export type CurationLegalConfig = {
  __typename: 'CurationLegalConfig';
  blacklistedArtists: Array<Scalars['String']>;
  blacklistedLabels: Array<CurationLegalConfigBlacklistedLabel>;
  blacklistedTitles: Array<CurationBlacklistedTitle>;
  id: Scalars['ID'];
  whitelistedLabels: Array<CurationLegalConfigLabel>;
  whitelistedTitles: Array<CurationBlacklistedTitle>;
};

export type CurationLegalConfigBlacklistedLabel = {
  __typename: 'CurationLegalConfigBlacklistedLabel';
  id: Scalars['ID'];
  whitelistedSubLabels: Array<Scalars['String']>;
};

export type CurationLegalConfigLabel = {
  __typename: 'CurationLegalConfigLabel';
  blacklistedArtists: Array<Scalars['String']>;
  blacklistedSubLabels: Array<Scalars['String']>;
  id: Scalars['ID'];
};

export type CurationQuizQuestion = {
  __typename: 'CurationQuizQuestion';
  asset?: Maybe<Scalars['String']>;
  correctChoice: Scalars['String'];
  difficulty?: Maybe<CurationQuizQuestionDifficulty>;
  id: Scalars['ID'];
  incorrectChoices: Array<Scalars['String']>;
  title: Scalars['String'];
};

export enum CurationQuizQuestionDifficulty {
  EASY = 'EASY',
  HARD = 'HARD',
  MEDIUM = 'MEDIUM'
}

/** Same type as Song, but with added fields for curators */
export type CurationSong = {
  __typename: 'CurationSong';
  album: Scalars['String'];
  albumYear: Scalars['Int'];
  /** alternatives ddex songs linked to a specific song, used to know if a song is WW or not */
  alternativeDDEXSongs: Array<DdexSong>;
  artist: Scalars['String'];
  /**
   * Composer of the song, to be used for CCPs having COMPOSER as a custom field.
   * Can be customized through the admin website, it is not in the iTunes DB
   */
  composer?: Maybe<Scalars['String']>;
  /** the song doesn't contains the full ddex sample, which can be usefull for specific uses (customSample etc) */
  ddexFullSample?: Maybe<Scalars['String']>;
  /** ddex song linked to a specific song, used for the comparison with the itunes results */
  ddexSong?: Maybe<DdexSong>;
  /** Sample of the song. Can be customized through the admin website by uploading an audio file longer than 30 sec */
  defaultSample: Scalars['String'];
  /** User-friendly artist, customizable by the curator */
  displayArtist: Scalars['String'];
  /** User-friendly title, customizable by the curator */
  displayTitle: Scalars['String'];
  /** Links to the song's page on Spotify and Apple Music (not the same DB as the iTunes Store) */
  externalLinks: CurationSongExternalLinks;
  id: Scalars['ID'];
  /** Optional intro sample, to be used in playlists that have INTRO_SAMPLE as a custom field */
  introSample?: Maybe<Scalars['String']>;
  /** the source that have been selected for the song informations */
  isDDEXSong: Scalars['Boolean'];
  isExplicit: Scalars['Boolean'];
  /**
   * Whether the song is invalid for the CCP specified by the query argument. For example, if the CCP has LEAD_SINGER as a
   * custom field and the value of leadSinger is undefined, the song is invalid for that CCP.
   */
  isInvalid: Scalars['Boolean'];
  isItunesSong: Scalars['Boolean'];
  isrc: Scalars['String'];
  itunesId?: Maybe<Scalars['Int']>;
  /** since the ddexSong can be use instead of the itunes, we need to be able to retreive the itunesResult */
  itunesSong?: Maybe<ItunesSong>;
  /**
   * Customizable jester title, i.e. a joke title. Used to create quizzes when the playlist has
   * JESTER_TITLE as a custom field. Will be progressively deprecated in favor of the playlist custom display.
   */
  jesterTitle?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  /**
   * Optional lead singer of the song, to be used for CCPs having LEAD_SINGER as a custom field.
   * Can be customized through the admin website, it is not in the iTunes DB
   */
  leadSinger?: Maybe<Scalars['String']>;
  /**
   * Customizable movie title, i.e. the movie where this song is used. Used to create quizzes when the playlist has
   * MOVIE_TITLE as a custom field. Will be progressively deprecated in favor of the playlist custom display.
   */
  movieTitle?: Maybe<Scalars['String']>;
  picture: Scalars['String'];
  /**
   * Custom value to display during quizzes for CCPs having CUSTOM as a custom field. Differently from movieTitle, leadSinger,
   * jesterTitle and composer, it can be different based on the CCP.
   * The optional songInputId query argument avoid errors when multiple SongInputs point to the same song in the same CCP.
   * The playlistCustomDisplay is stored in Spanner as a dictionary with the SongInput ID as key. If all the SongInputs of
   * the CCP are pointing to different songs, we can find the correct SongInput ID based on the CCP ID and the song ID. If
   * there are duplicates, we need the SongInput ID.
   */
  playlistCustomDisplay?: Maybe<Scalars['String']>;
  /** Custom sample url to use when the contentPack has a CUSTOM_SAMPLE custom field. */
  playlistCustomSample?: Maybe<Scalars['String']>;
  questionableStatus?: Maybe<SongQuestionableStatus>;
  songInput: CurationSongInput;
  state: CurationSongState;
  stateDetail?: Maybe<CurationSongStateDetail>;
  subLabel?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};


/** Same type as Song, but with added fields for curators */
export type CurationSongIsInvalidArgs = {
  contentPackId: Scalars['ID'];
  songInputId?: InputMaybe<Scalars['ID']>;
};


/** Same type as Song, but with added fields for curators */
export type CurationSongPlaylistCustomDisplayArgs = {
  contentPackId?: InputMaybe<Scalars['ID']>;
  songInputId?: InputMaybe<Scalars['ID']>;
};


/** Same type as Song, but with added fields for curators */
export type CurationSongPlaylistCustomSampleArgs = {
  contentPackId?: InputMaybe<Scalars['ID']>;
  songInputId?: InputMaybe<Scalars['ID']>;
};


/** Same type as Song, but with added fields for curators */
export type CurationSongSongInputArgs = {
  contentPackId?: InputMaybe<Scalars['ID']>;
  songInputId?: InputMaybe<Scalars['ID']>;
};

export type CurationSongExternalLinks = {
  __typename: 'CurationSongExternalLinks';
  itunes: CurationSongExternalLinksByStore;
  spotify: CurationSongExternalLinksByStore;
};

export type CurationSongExternalLinksByStore = {
  __typename: 'CurationSongExternalLinksByStore';
  br?: Maybe<Scalars['String']>;
  de?: Maybe<Scalars['String']>;
  es?: Maybe<Scalars['String']>;
  fr?: Maybe<Scalars['String']>;
  gb?: Maybe<Scalars['String']>;
  us?: Maybe<Scalars['String']>;
};

export type CurationSongInput = {
  __typename: 'CurationSongInput';
  album: Scalars['String'];
  artist: Scalars['String'];
  /** List committed ContentPacks the song is in */
  contentPacks: Array<ContentPack>;
  /** List CurationContentPacks the song input is in */
  curationContentPacks: Array<CurationContentPack>;
  curationSong?: Maybe<CurationSong>;
  id: Scalars['ID'];
  isrc?: Maybe<Scalars['String']>;
  matchType?: Maybe<SongInputMatchType>;
  title: Scalars['String'];
};

export type CurationSongPayload = {
  __typename: 'CurationSongPayload';
  curationSong?: Maybe<CurationSong>;
};

export type CurationSongSearchTerm = {
  album?: InputMaybe<Scalars['String']>;
  artist?: InputMaybe<Scalars['String']>;
  endYear?: InputMaybe<Scalars['Int']>;
  fuzzySearch?: InputMaybe<Scalars['Boolean']>;
  isrc?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  startYear?: InputMaybe<Scalars['Int']>;
  subLabel?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export enum CurationSongState {
  BLACKLISTED = 'BLACKLISTED',
  DELETED = 'DELETED',
  WHITELISTED = 'WHITELISTED'
}

export enum CurationSongStateDetail {
  ARTIST_BLACKLISTED = 'ARTIST_BLACKLISTED',
  DDEX_MISSING = 'DDEX_MISSING',
  DELETED = 'DELETED',
  NO_WW_DEALS = 'NO_WW_DEALS'
}

export type CurationTask = {
  __typename: 'CurationTask';
  available?: Maybe<Scalars['Date']>;
  completed?: Maybe<Scalars['Date']>;
  created: Scalars['Date'];
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  resultUrl?: Maybe<Scalars['String']>;
  started?: Maybe<Scalars['Date']>;
  status: CurationTaskStatus;
};

export enum CurationTaskStatus {
  COMPLETED = 'COMPLETED',
  CREATED = 'CREATED',
  FAILED = 'FAILED',
  PROCESSING = 'PROCESSING'
}

export type Currency = {
  amount: Scalars['Int'];
  id: Scalars['ID'];
};

export type CurrencyAccolade = Currency & {
  __typename: 'CurrencyAccolade';
  amount: Scalars['Int'];
  id: Scalars['ID'];
};

/**
 * Currency for Quiz Gameplay
 * Can be bought with coins
 */
export type CurrencyBoost = Currency & {
  __typename: 'CurrencyBoost';
  amount: Scalars['Int'];
  boostType: CurrencyBoostType;
  id: Scalars['ID'];
};

export type CurrencyBoostPack = CurrencyPack & {
  __typename: 'CurrencyBoostPack';
  /** @deprecated For amount of boosts per pack, refer to 'min' and 'max' fields */
  amount: Scalars['Int'];
  asset: Scalars['String'];
  boostType: CurrencyBoostType;
  cost: CurrencyCoin;
  id: Scalars['ID'];
  max: Scalars['Int'];
  min: Scalars['Int'];
};

export enum CurrencyBoostType {
  ARTIST_ONLY = 'ARTIST_ONLY',
  BOMB = 'BOMB',
  HURDLE_HINT = 'HURDLE_HINT',
  NINJA = 'NINJA',
  REMOVE2 = 'REMOVE2',
  REVIVE = 'REVIVE',
  SPEEDSTER = 'SPEEDSTER',
  TEAM_SPIRIT = 'TEAM_SPIRIT'
}

export type CurrencyBundlePack = {
  __typename: 'CurrencyBundlePack';
  cost: Scalars['Float'];
  id: Scalars['ID'];
  name: Scalars['String'];
  sku: Scalars['String'];
};

/**
 * Currency for Customization
 * Can be bought with diamonds
 */
export type CurrencyCategoryFragment = Currency & {
  __typename: 'CurrencyCategoryFragment';
  amount: Scalars['Int'];
  category: ContentCategory;
  id: Scalars['ID'];
};

export type CurrencyCategoryFragmentPack = CurrencyPack & {
  __typename: 'CurrencyCategoryFragmentPack';
  amount: Scalars['Int'];
  asset: Scalars['String'];
  category: ContentCategory;
  cost: CurrencyDiamond;
  id: Scalars['ID'];
  purchased: Scalars['Boolean'];
};

/**
 * Same as CurrencyCategoryFragment, except we don't reveal the category until it's claimed
 * The FE can still request the category to be able to make an animation when claiming without having to wait for the BE response
 */
export type CurrencyCategoryRandom = Currency & {
  __typename: 'CurrencyCategoryRandom';
  amount: Scalars['Int'];
  category: ContentCategory;
  id: Scalars['ID'];
};

/**
 * Main currency.
 * Can be bought with diamonds
 */
export type CurrencyCoin = Currency & {
  __typename: 'CurrencyCoin';
  amount: Scalars['Int'];
  id: Scalars['ID'];
};

export type CurrencyCoinPack = CurrencyPack & {
  __typename: 'CurrencyCoinPack';
  amount: Scalars['Int'];
  asset: Scalars['String'];
  cost: CurrencyDiamond;
  id: Scalars['ID'];
};

/**
 * Hard currency.
 * Can be bought with IAP
 */
export type CurrencyDiamond = Currency & {
  __typename: 'CurrencyDiamond';
  amount: Scalars['Int'];
  id: Scalars['ID'];
};

export type CurrencyDiamondPack = CurrencyPack & {
  __typename: 'CurrencyDiamondPack';
  amount: Scalars['Int'];
  asset: Scalars['String'];
  id: Scalars['ID'];
  /** sku for the IAP in the device store (AppStore/GooglePlay) */
  sku: Scalars['String'];
};

export type CurrencyEmojiPack = CurrencyPack & {
  __typename: 'CurrencyEmojiPack';
  amount: Scalars['Int'];
  asset: Scalars['String'];
  cost: CurrencyDiamond;
  id: Scalars['ID'];
};

/** Wheel fortune currency. */
export type CurrencyFreeSpin = Currency & {
  __typename: 'CurrencyFreeSpin';
  amount: Scalars['Int'];
  id: Scalars['ID'];
};

export type CurrencyInput = {
  amount: Scalars['Int'];
  category?: InputMaybe<Scalars['ID']>;
  type: CurrencyTypeInput;
};

/** Live matchmaking currency. */
export type CurrencyLiveEvent = Currency & {
  __typename: 'CurrencyLiveEvent';
  amount: Scalars['Int'];
  id: Scalars['ID'];
};

export type CurrencyLoyaltyPoints = Currency & {
  __typename: 'CurrencyLoyaltyPoints';
  amount: Scalars['Int'];
  id: Scalars['ID'];
};

export type CurrencyMetaFragmentBronze = Currency & {
  __typename: 'CurrencyMetaFragmentBronze';
  amount: Scalars['Int'];
  id: Scalars['ID'];
};

export type CurrencyMetaFragmentGold = Currency & {
  __typename: 'CurrencyMetaFragmentGold';
  amount: Scalars['Int'];
  id: Scalars['ID'];
};

export type CurrencyMetaFragmentPack = CurrencyPack & {
  __typename: 'CurrencyMetaFragmentPack';
  amount: Scalars['Int'];
  asset: Scalars['String'];
  cost: CurrencyDiamond;
  id: Scalars['ID'];
  metaFragmentType: MetaFragmentType;
  purchased: Scalars['Boolean'];
};

export type CurrencyMetaFragmentSilver = Currency & {
  __typename: 'CurrencyMetaFragmentSilver';
  amount: Scalars['Int'];
  id: Scalars['ID'];
};

export type CurrencyPack = {
  amount: Scalars['Int'];
  asset: Scalars['String'];
  id: Scalars['ID'];
};

export type CurrencyShardBronze = Currency & {
  __typename: 'CurrencyShardBronze';
  amount: Scalars['Int'];
  id: Scalars['ID'];
};

export type CurrencyShardGold = Currency & {
  __typename: 'CurrencyShardGold';
  amount: Scalars['Int'];
  id: Scalars['ID'];
};

export type CurrencyShardSilver = Currency & {
  __typename: 'CurrencyShardSilver';
  amount: Scalars['Int'];
  id: Scalars['ID'];
};

/**
 * CurrencySpecialEvent is like currencyXP dedicated to the current special event
 * They are accumulated during the special event and used to calculate the player progress for SpecialEventMilestone and his final SpecialEventRankGroup
 */
export type CurrencySpecialEvent = Currency & {
  __typename: 'CurrencySpecialEvent';
  amount: Scalars['Int'];
  id: Scalars['ID'];
};

/** Hurdle currency. */
export type CurrencyStampCard = Currency & {
  __typename: 'CurrencyStampCard';
  amount: Scalars['Int'];
  id: Scalars['ID'];
};

export type CurrencySubscriptionDay = Currency & {
  __typename: 'CurrencySubscriptionDay';
  amount: Scalars['Int'];
  id: Scalars['ID'];
};

/** Tournament currency. */
export type CurrencyTournamentTicket = Currency & {
  __typename: 'CurrencyTournamentTicket';
  amount: Scalars['Int'];
  id: Scalars['ID'];
};

export enum CurrencyTypeInput {
  CURRENCY_CATEGORY_FRAGMENT = 'CURRENCY_CATEGORY_FRAGMENT',
  CURRENCY_COIN = 'CURRENCY_COIN',
  CURRENCY_DIAMOND = 'CURRENCY_DIAMOND'
}

export type CurrencyUnlimitedBoost = Currency & {
  __typename: 'CurrencyUnlimitedBoost';
  amount: Scalars['Int'];
  id: Scalars['ID'];
  unlimitedBoostType: CurrencyUnlimitedBoostType;
};

export enum CurrencyUnlimitedBoostType {
  AD_FREE = 'AD_FREE',
  COINS_AND_XP = 'COINS_AND_XP',
  REMOVE2 = 'REMOVE2',
  SPEEDSTER = 'SPEEDSTER',
  TOURNAMENT_TICKET = 'TOURNAMENT_TICKET'
}

/**
 * Very similar to currency, but not exactly one.
 * Given when upgrading contentPacks
 */
export type CurrencyXp = Currency & {
  __typename: 'CurrencyXP';
  amount: Scalars['Int'];
  id: Scalars['ID'];
};

export type CurrentHurdleQuizzesInput = {
  pagination?: InputMaybe<PaginationParams>;
  type?: InputMaybe<HurdleType>;
};

export type DdexJob = {
  __typename: 'DDEXJob';
  created: Scalars['Date'];
  jobId: Scalars['ID'];
  label: Scalars['String'];
  nbExecutions: Scalars['Int'];
  path: Scalars['String'];
  state: JobState;
};

export type DdexJobLog = {
  __typename: 'DDEXJobLog';
  extraData?: Maybe<Scalars['JSON']>;
  jobId?: Maybe<Scalars['ID']>;
  label: Scalars['String'];
  level: Scalars['String'];
  message: Scalars['String'];
  taskId?: Maybe<Scalars['ID']>;
  timestamp: Scalars['Date'];
};

export type DdexJobLogsPaginated = {
  __typename: 'DDEXJobLogsPaginated';
  list: Array<DdexJobLog>;
  totalCount: Scalars['Int'];
};

export type DdexJobsPaginated = {
  __typename: 'DDEXJobsPaginated';
  hasMore: Scalars['Boolean'];
  id: Scalars['ID'];
  list: Array<DdexJob>;
  totalCount: Scalars['Int'];
};

export type DdexSong = {
  __typename: 'DDEXSong';
  album: Scalars['String'];
  albumId: Scalars['ID'];
  albumReleaseType: Scalars['String'];
  alternativeSongs: Array<DdexSong>;
  artist: Scalars['String'];
  artwork: Scalars['String'];
  artworkHeic?: Maybe<Scalars['String']>;
  fullSample?: Maybe<Scalars['String']>;
  heavySanitizedArtist: Scalars['String'];
  heavySanitizedId: Scalars['String'];
  icpn: Scalars['ID'];
  id: Scalars['ID'];
  isExplicit: Scalars['Boolean'];
  isWhitelisted: Scalars['Boolean'];
  isrc: Scalars['String'];
  label: Scalars['String'];
  previewStartPoint?: Maybe<Scalars['Int']>;
  releaseDate: Scalars['Date'];
  sample: Scalars['String'];
  sanitizedId: Scalars['String'];
  sanitizedTitle: Scalars['String'];
  subLabel: Scalars['String'];
  territoryCodes: Array<Scalars['String']>;
  title: Scalars['String'];
};

export type DdexTask = {
  __typename: 'DDEXTask';
  jobId: Scalars['ID'];
  nbExecutions: Scalars['Int'];
  newAssetUrl?: Maybe<Scalars['String']>;
  originalAssetUrl?: Maybe<Scalars['String']>;
  state: TaskState;
  taskId: Scalars['ID'];
  type: Scalars['String'];
};

export type DailyBonus = {
  __typename: 'DailyBonus';
  ends: Scalars['Date'];
  id: Scalars['ID'];
  reward: LevelReward;
  starts: Scalars['Date'];
  status: DailyBonusStatus;
};

export enum DailyBonusStatus {
  CLAIMED = 'CLAIMED',
  READY = 'READY',
  UPCOMING = 'UPCOMING'
}

export enum DashboardQueryType {
  ATHENA = 'ATHENA',
  BIGQUERY = 'BIGQUERY'
}

export type DeclineFriendRequestInput = {
  userId: Scalars['ID'];
};

export type DeclineTeamMemberInviteInput = {
  inviteId: Scalars['ID'];
};

export type DeclineTeamMemberInvitePayload = {
  __typename: 'DeclineTeamMemberInvitePayload';
  user: User;
};

export type DeclineUserToUserQuizLiveGameRequestInput = {
  userToUserId: Scalars['ID'];
};

export type DeleteAbTestInput = {
  id: Scalars['ID'];
};

export type DeleteAbTestPayload = {
  __typename: 'DeleteABTestPayload';
  testIdDeleted: Scalars['ID'];
};

export type DeleteChainedOfferEventInput = {
  id: Scalars['ID'];
};

export type DeleteChainedOfferEventPayload = {
  __typename: 'DeleteChainedOfferEventPayload';
  deletedEventId: Scalars['ID'];
};

export type DeleteCurationContentPackInput = {
  id: Scalars['ID'];
  sp2ExportId?: InputMaybe<Scalars['String']>;
};

export type DeleteHurdleCatalogItemInput = {
  catalogItemId: Scalars['ID'];
};

export type DeleteHurdleCatalogItemPayload = {
  __typename: 'DeleteHurdleCatalogItemPayload';
  deleted: Scalars['Boolean'];
};

export type DeleteImportantEventInput = {
  eventKey: Scalars['String'];
  type: ImportantEventType;
};

export type DeleteImportantEventPayload = {
  __typename: 'DeleteImportantEventPayload';
  deletedEventKey: Scalars['String'];
  deletedEventType: ImportantEventType;
};

export type DeleteSp2ReleaseInput = {
  id: Scalars['ID'];
};

export type DeleteSaleEventInput = {
  id: Scalars['ID'];
};

export type DeleteSaleEventPayload = {
  __typename: 'DeleteSaleEventPayload';
  saleEventIdDeleted: Scalars['ID'];
};

export type DeleteUserEmojiPackInput = {
  packId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type DeleteUserPayload = {
  __typename: 'DeleteUserPayload';
  success?: Maybe<Scalars['Boolean']>;
};

export type DemoteTeamLeaderInput = {
  teamId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type Emoji = {
  __typename: 'Emoji';
  asset: Scalars['String'];
  cost: CurrencyDiamond;
  id: Scalars['ID'];
  name: Scalars['String'];
  utfCode: Scalars['String'];
};

export type EmojiAvailabilityInfo = {
  __typename: 'EmojiAvailabilityInfo';
  isAvailable: Scalars['Boolean'];
  type: EmojiAvailabilityType;
};

export enum EmojiAvailabilityType {
  DD = 'DD',
  EARN = 'EARN',
  FREE = 'FREE',
  SUB = 'SUB'
}

export type EmojiConfig = {
  __typename: 'EmojiConfig';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type EmojiConfigPaginated = {
  __typename: 'EmojiConfigPaginated';
  hasMore: Scalars['Boolean'];
  list: Array<EmojiConfig>;
  totalCount: Scalars['Int'];
};

export type EmojiFontData = {
  __typename: 'EmojiFontData';
  url: Scalars['String'];
  version: Scalars['String'];
};

export type EmojiFontInspectData = {
  __typename: 'EmojiFontInspectData';
  updated: Scalars['Date'];
  url: Scalars['String'];
  version: Scalars['String'];
  versionInCache: Scalars['String'];
};

export type EmojiPack = {
  __typename: 'EmojiPack';
  asset: Scalars['String'];
  emojis: Array<Emoji>;
  id: Scalars['ID'];
  isDraft: Scalars['Boolean'];
  layout: EmojiPackLayout;
  name: Scalars['String'];
};

export enum EmojiPackLayout {
  FREE = 'FREE',
  IAP = 'IAP',
  TUTOR = 'TUTOR'
}

export type EmojiPackLayoutInfo = {
  __typename: 'EmojiPackLayoutInfo';
  availability: Array<EmojiAvailabilityType>;
  type: EmojiPackLayout;
};

export type EmojiPackPaginated = {
  __typename: 'EmojiPackPaginated';
  hasMore: Scalars['Boolean'];
  list: Array<EmojiPack>;
  totalCount: Scalars['Int'];
};

export type EmojiPacksByIdInput = {
  ids: Array<Scalars['ID']>;
};

export type EmojiPacksByIdPayload = {
  __typename: 'EmojiPacksByIdPayload';
  emojiPacks: Array<EmojiPack>;
};

export type EndBatchContentModerationInput = {
  id: Scalars['ID'];
};

export type EndUserToUserQuizLiveGameInput = {
  userToUserId: Scalars['ID'];
};

export type EnergySystem = {
  __typename: 'EnergySystem';
  /** RewardCap for each subscription tier */
  caps: EnergySystemCap;
  /** Last time the energy cap supply has been auto-refilled. Used with RewardCap.period to display useful information to the user (like how long he has to wait before getting a new supply) */
  currentCapLastUpdate?: Maybe<Scalars['Date']>;
  /**
   * Current amount of energy you can use from the automatically renewed balance.
   * Starts at RewardCap.maxStorage and get lowered everytime you use this energy type.
   */
  currentCapSupply: Scalars['Int'];
  /**
   * This balance is for extra energy supply bough by the user - to get the total balance that are automatically renewed,
   * use User.energySystems.x.currentCapSupply + User.energySystems.x.extraBalance
   * Can be null if the energy type doesn't support extraBalance
   */
  extraBalance?: Maybe<Scalars['Int']>;
  /** Has the user already used his free energy refill */
  isCapFreeRefillUsed: Scalars['Boolean'];
};

export type EnergySystemCap = {
  __typename: 'EnergySystemCap';
  ad_free: RewardCap;
  basic: RewardCap;
  plus: RewardCap;
  premium: RewardCap;
  vip: RewardCap;
};

export type EnergySystems = {
  __typename: 'EnergySystems';
  coin: EnergySystem;
  liveEventTicket: EnergySystem;
  tournamentTicket: EnergySystem;
  xp: EnergySystem;
};

export type ExportCurationContentPackToSp2Input = {
  id: Scalars['ID'];
};

export type ExportMusicCatalogPayload = {
  __typename: 'ExportMusicCatalogPayload';
  id?: Maybe<Scalars['ID']>;
  success: Scalars['Boolean'];
};

export type ExportUserPayload = {
  __typename: 'ExportUserPayload';
  export?: Maybe<UserExport>;
};

export type ExtraConfig = {
  __typename: 'ExtraConfig';
  buttonColor?: Maybe<Scalars['String']>;
  characterImage?: Maybe<Scalars['String']>;
  contrastGradient1?: Maybe<Scalars['String']>;
  contrastGradient2?: Maybe<Scalars['String']>;
  headerImage?: Maybe<Scalars['String']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  secondaryDarkColor?: Maybe<Scalars['String']>;
};

export type ExtraConfigInput = {
  buttonColor?: InputMaybe<Scalars['String']>;
  characterImage?: InputMaybe<Scalars['String']>;
  contrastGradient1?: InputMaybe<Scalars['String']>;
  contrastGradient2?: InputMaybe<Scalars['String']>;
  headerImage?: InputMaybe<Scalars['String']>;
  primaryColor?: InputMaybe<Scalars['String']>;
  secondaryColor?: InputMaybe<Scalars['String']>;
  secondaryDarkColor?: InputMaybe<Scalars['String']>;
};

export type FtueContentPackCatalogPayload = {
  __typename: 'FTUEContentPackCatalogPayload';
  category1: Array<ContentPack>;
  category2: Array<ContentPack>;
  category3: Array<ContentPack>;
  recommended: Array<ContentPack>;
};

export type FinishMarathonPayload = {
  __typename: 'FinishMarathonPayload';
  round: UserMarathonRound;
  userMarathonEvent: UserMarathonEvent;
};

export type FinishMarathonRoundInput = {
  answers: Array<UserAnswerInput>;
  eventId: Scalars['ID'];
  roundId: Scalars['ID'];
};

export type FlushHurdleCacheInput = {
  type?: InputMaybe<HurdleType>;
};

export type FlushHurdleCachePayload = {
  __typename: 'FlushHurdleCachePayload';
  flushed: Scalars['Boolean'];
};

export type FlushRedisCacheForOneUserInput = {
  model: UserRelatedRedisModel;
  userId: Scalars['ID'];
};

export type FlushRedisCacheForOneUserPayload = {
  __typename: 'FlushRedisCacheForOneUserPayload';
  user: User;
};

export type FlushRedisCacheInput = {
  model: RedisCacheModel;
};

export type FlushRedisCachePayload = {
  __typename: 'FlushRedisCachePayload';
  flushedEntities: Scalars['Int'];
};

export type ForceGrantMplRewardsInput = {
  monthId: Scalars['String'];
  userId: Scalars['ID'];
};

export type ForceMissionProgressInput = {
  missionProgressId: Scalars['ID'];
  progress: Scalars['Int'];
};

export type ForceMissionProgressPayload = {
  __typename: 'ForceMissionProgressPayload';
  missionProgress: MissionProgress;
};

export type ForceSongInputMatchingInput = {
  ddexSongId?: InputMaybe<Scalars['ID']>;
  itunesId?: InputMaybe<Scalars['Int']>;
  songId?: InputMaybe<Scalars['ID']>;
  songInputId: Scalars['ID'];
};

export type ForceSongInputMatchingPayload = {
  __typename: 'ForceSongInputMatchingPayload';
  curationSong?: Maybe<CurationSong>;
  suggestedSong?: Maybe<CurationSong>;
};

export type ForceUpdateUserInput = {
  accoladeBalance: Scalars['Int'];
  appSkins: Array<UserItemInput>;
  basicTierContentPack: UserPlaylistInput;
  boostArtistOnlyBalance: Scalars['Int'];
  boostBombBalance: Scalars['Int'];
  boostHurdleHintBalance: Scalars['Int'];
  boostNinjaBalance: Scalars['Int'];
  boostRemove2Balance: Scalars['Int'];
  boostReviveBalance: Scalars['Int'];
  boostSpeedsterBalance: Scalars['Int'];
  boostTeamSpiritBalance: Scalars['Int'];
  calendars: Array<CalendarsInput>;
  claimedUpdateGiftId?: InputMaybe<Scalars['String']>;
  coinBalance: Scalars['Int'];
  currentUserMonthlyPass?: InputMaybe<UserMonthlyPassInput>;
  diamondBalance: Scalars['Int'];
  earnedContentPackIds?: InputMaybe<Array<Scalars['String']>>;
  energyCoinSupply?: InputMaybe<Scalars['Int']>;
  energyLiveEventTicketSupply?: InputMaybe<Scalars['Int']>;
  energyTournamentTicketSupply?: InputMaybe<Scalars['Int']>;
  energyXPSupply?: InputMaybe<Scalars['Int']>;
  fragmentBalance?: InputMaybe<Array<InputMaybe<FragmentBalanceInput>>>;
  freeSpins: Scalars['Int'];
  id: Scalars['ID'];
  liveEventCurrency?: InputMaybe<Scalars['Int']>;
  metaFragments: MetaFragmentsInput;
  piggyBank: PiggyBankInput;
  premiumDays: Scalars['Int'];
  profileFrames: Array<UserItemInput>;
  savedContentPacks: Array<UserPlaylistInput>;
  shards: ShardsInput;
  stampCards: Scalars['Int'];
  stickers: Array<UserItemInput>;
  totalStampCardsEarned: Scalars['Int'];
  tournamentTicketBalance: Scalars['Int'];
  unlimitedBoosts?: InputMaybe<UnlimitedBoostsInput>;
  userLevel: Scalars['Int'];
  userProgressToNextLevel: Scalars['Float'];
  vipDays: Scalars['Int'];
};

export type ForceUpdateUserPayload = {
  __typename: 'ForceUpdateUserPayload';
  user: User;
};

export type ForceUserAbTestInput = {
  testId: Scalars['ID'];
  userId: Scalars['ID'];
  variation?: InputMaybe<Scalars['String']>;
};

export type ForceUserAbTestPayload = {
  __typename: 'ForceUserABTestPayload';
  user: User;
};

export type ForcedTemplateData = {
  categoryIds?: InputMaybe<Scalars['String']>;
  contentPackId?: InputMaybe<Scalars['String']>;
  contentPacksPlayedByUser?: InputMaybe<Scalars['String']>;
  earnedContentPackIds?: InputMaybe<Scalars['String']>;
  favoriteOpponentCount?: InputMaybe<Scalars['String']>;
  favoriteOpponentId?: InputMaybe<Scalars['String']>;
  favoritePlaylistCount?: InputMaybe<Scalars['String']>;
  favoritePlaylistId?: InputMaybe<Scalars['String']>;
  numberOfPendingTurns?: InputMaybe<Scalars['String']>;
  numberSongs?: InputMaybe<Scalars['String']>;
  opponentId?: InputMaybe<Scalars['String']>;
  opponentNumber?: InputMaybe<Scalars['String']>;
  opponentsNumber?: InputMaybe<Scalars['String']>;
  playerLevel?: InputMaybe<Scalars['String']>;
  songsGuessed?: InputMaybe<Scalars['String']>;
  streakNumber?: InputMaybe<Scalars['String']>;
  unlockedFeatures?: InputMaybe<Scalars['String']>;
  userToUserId?: InputMaybe<Scalars['String']>;
};

export type FragmentBalanceInput = {
  amount: Scalars['Int'];
  id: Scalars['ID'];
};

export type FriendHurdleQuiz = {
  __typename: 'FriendHurdleQuiz';
  answers: Array<UserHurdleAnswer>;
  currentStreak: Scalars['Int'];
  guessedIn?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isCorrectlyGuessed: Scalars['Boolean'];
  mode: HurdleMode;
  user: User;
};

export type FriendRequestPayload = {
  __typename: 'FriendRequestPayload';
  userToUser: UserToUser;
};

export type FriendsLeaderboard = {
  __typename: 'FriendsLeaderboard';
  id: Scalars['ID'];
  /** Return the rank the current user - can be null because the player may not have played in this leaderboard */
  meRank?: Maybe<Scalars['Int']>;
  /** Return the score the current user - return 0 by default (even if the user have not played in this leaderboard) */
  meScore: Scalars['Int'];
  /**
   * Rank = cursor, before and after are how many ranks before and after to retreive
   * Defaults values: rank = 1, before = 5, after = 5
   * If rank = -1, we will try to find the current user rank and use it, or it will fall back on rank = 1
   */
  nearValueRankings: Array<LeaderboardEntry>;
  /** Return the top 10 */
  topRankings: Array<LeaderboardEntry>;
  totalRanks: Scalars['Int'];
};


export type FriendsLeaderboardNearValueRankingsArgs = {
  after?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['Int']>;
  rank?: InputMaybe<Scalars['Int']>;
};

export enum GameNamespace {
  BETA = 'BETA',
  PROD = 'PROD',
  TEST = 'TEST'
}

export type GenPromotionInput = {
  teamId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type GenPromotionPayload = {
  __typename: 'GenPromotionPayload';
  promotion: TeamPromotion;
};

export type GenerateHurdleQuizzesInput = {
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
  type: HurdleType;
};

export type GenerateHurdleQuizzesPayload = {
  __typename: 'GenerateHurdleQuizzesPayload';
  hurdleQuizzes: Array<HurdleQuiz>;
};

export type GenerateMarathonQuestionsInput = {
  category: Scalars['String'];
  eventId: Scalars['ID'];
  offset: Scalars['Int'];
  roundId: Scalars['ID'];
};

export type GenerateMarathonQuestionsPayload = {
  __typename: 'GenerateMarathonQuestionsPayload';
  questions: Array<QuizQuestion>;
};

export type GenerateReportInput = {
  appId?: InputMaybe<Scalars['ID']>;
  country?: InputMaybe<Scalars['String']>;
  fromDay?: InputMaybe<Scalars['Int']>;
  month: Scalars['Int'];
  reportId?: InputMaybe<Scalars['ID']>;
  toDay?: InputMaybe<Scalars['Int']>;
  year: Scalars['Int'];
};

export type GenerateReportPayload = {
  __typename: 'GenerateReportPayload';
  success: Scalars['Boolean'];
};

export type GenerateSubscriptionPromoSignatureInput = {
  applicationUsername: Scalars['String'];
  offer: Scalars['ID'];
  sku: Scalars['String'];
};

export type GenericLevelReward = {
  __typename: 'GenericLevelReward';
  amount: Scalars['Int'];
  itemId?: Maybe<Scalars['String']>;
  type: LevelRewardInputType;
};

export type GetImportantEventsInput = {
  end: Scalars['Date'];
  namespace?: InputMaybe<ServerEnv>;
  start: Scalars['Date'];
};

export type GetSignedDownloadUrlInput = {
  requestId: Scalars['String'];
};

export type GetSignedDownloadUrlPayload = {
  __typename: 'GetSignedDownloadUrlPayload';
  url: Scalars['String'];
};

export type GetSpecialEventInput = {
  specialEventId: Scalars['ID'];
};

export type GetSpecialEventPayload = {
  __typename: 'GetSpecialEventPayload';
  specialEvent: SpecialEvent;
};

export type GetUserMonthIdListInput = {
  sortOrder?: InputMaybe<SortOrder>;
  userId: Scalars['ID'];
};

export type GetUserMonthIdListPayload = {
  __typename: 'GetUserMonthIdListPayload';
  list: Array<Scalars['String']>;
};

export type GetUserMonthlyPassInput = {
  monthId: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
};

export type GetUserMonthlyPassPayload = {
  __typename: 'GetUserMonthlyPassPayload';
  userMonthlyPass: UserMonthlyPass;
};

export type GhostQuizLiveShowInput = {
  questionNumber: Scalars['Int'];
  roundNumber: Scalars['Int'];
  showId: Scalars['ID'];
};

export type GhostQuizLiveShowPayload = {
  __typename: 'GhostQuizLiveShowPayload';
  showId: Scalars['ID'];
};

export type GiftFilters = {
  __typename: 'GiftFilters';
  age?: Maybe<Scalars['Int']>;
  appVersion?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  daysSinceInstall?: Maybe<Scalars['Int']>;
  daysSinceLastOnline?: Maybe<Scalars['Int']>;
  gender?: Maybe<Scalars['String']>;
  isSpender?: Maybe<Scalars['Int']>;
  namespace?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  specificUsers?: Maybe<Array<Scalars['ID']>>;
  subTier?: Maybe<UserSubscriptionTier>;
};

export type GiftFiltersInput = {
  age?: InputMaybe<Scalars['Int']>;
  appVersion?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  daysSinceInstall?: InputMaybe<Scalars['Int']>;
  daysSinceLastOnline?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<Scalars['String']>;
  isSpender?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  specificUsers?: InputMaybe<Array<Scalars['ID']>>;
  subTier?: InputMaybe<UserSubscriptionTier>;
};

export type GiftInfo = {
  __typename: 'GiftInfo';
  gift: IapGift;
  isFriend: Scalars['Boolean'];
  isSystem: Scalars['Boolean'];
  sender: GiftSender;
};

export type GiftSender = Agent | User;

export type GiftTutorialBadgesPayload = {
  __typename: 'GiftTutorialBadgesPayload';
  badges: Array<Badge>;
  totalCount: Scalars['Int'];
};

export type GrantTutorialEmojiPackPayload = {
  __typename: 'GrantTutorialEmojiPackPayload';
  user: User;
};

export type GrantUserBadgeAdminInput = {
  badgeId: Scalars['ID'];
  level?: InputMaybe<Scalars['Int']>;
  userId: Scalars['ID'];
};

export type GuessTheSongQuiz = {
  __typename: 'GuessTheSongQuiz';
  category: ContentCategory;
  questions: Array<QuizQuestion>;
  userContentPack: UserContentPack;
};

export type HurdleAssetsConfig = {
  __typename: 'HurdleAssetsConfig';
  buttonColor?: Maybe<Scalars['String']>;
  characterImage?: Maybe<Scalars['String']>;
  contrast?: Maybe<Scalars['String']>;
  contrastGradient1?: Maybe<Scalars['String']>;
  contrastGradient2?: Maybe<Scalars['String']>;
  headerImage?: Maybe<Scalars['String']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  secondaryDarkColor?: Maybe<Scalars['String']>;
};

export type HurdleAutoCompleteInput = {
  limit: Scalars['Int'];
  search: Scalars['String'];
  type?: InputMaybe<HurdleType>;
};

export type HurdleAutoCompletePayload = {
  __typename: 'HurdleAutoCompletePayload';
  items: Array<HurdleItemSuggestion>;
};

export type HurdleCalendarInput = {
  endDate: Scalars['Date'];
  maxPerDay?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['Date'];
  type?: InputMaybe<HurdleType>;
};

export type HurdleCalendarPayload = {
  __typename: 'HurdleCalendarPayload';
  hurdleQuizzes: Array<HurdleQuiz>;
};

export type HurdleCatalogItem = {
  __typename: 'HurdleCatalogItem';
  addedAt: Scalars['Date'];
  categoryId?: Maybe<Scalars['String']>;
  excludeFromAutogeneration?: Maybe<Scalars['Boolean']>;
  excludeFromCheck?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  item: HurdleItem;
  offset: Scalars['Float'];
  removed?: Maybe<Scalars['Boolean']>;
};

export type HurdleCatalogItemInput = {
  catalogItemId: Scalars['ID'];
};

export type HurdleCatalogItemListInput = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  type: HurdleType;
};

export type HurdleCatalogItemListPayload = {
  __typename: 'HurdleCatalogItemListPayload';
  hasMore: Scalars['Boolean'];
  list: Array<HurdleCatalogItem>;
  totalCount: Scalars['Int'];
};

export type HurdleCatalogItemPayload = {
  __typename: 'HurdleCatalogItemPayload';
  catalogItem: HurdleCatalogItem;
};

export type HurdleItem = HurdleSongItem;

export type HurdleItemSuggestion = SongItemSuggestion;

export enum HurdleMode {
  HARD = 'Hard',
  NORMAL = 'Normal'
}

export enum HurdleNamespace {
  BETA = 'Beta',
  PROD = 'Prod',
  TEST = 'Test'
}

export type HurdleQuestion = {
  __typename: 'HurdleQuestion';
  asset: Scalars['String'];
  id: Scalars['ID'];
  offset: Scalars['Float'];
  song?: Maybe<Song>;
  userLikedContent: UserContentItem;
};

export type HurdleQuiz = {
  __typename: 'HurdleQuiz';
  allTimeStreakLeaderboard?: Maybe<Leaderboard>;
  assetsConfig: HurdleAssetsConfig;
  catalogItemId: Scalars['ID'];
  categoryId: Scalars['ID'];
  currentStreakLeaderboard?: Maybe<Leaderboard>;
  endDate: Scalars['Date'];
  id: Scalars['ID'];
  namespace: HurdleNamespace;
  number: Scalars['Int'];
  question?: Maybe<HurdleQuestion>;
  rewards: Array<LevelReward>;
  startDate: Scalars['Date'];
  type: HurdleType;
  userHurdleQuiz: UserHurdleQuiz;
};

export type HurdleQuizInput = {
  id: Scalars['ID'];
};

export type HurdleQuizPayload = {
  __typename: 'HurdleQuizPayload';
  hurdleQuiz?: Maybe<HurdleQuiz>;
};

export type HurdleQuizzesPaginated = {
  __typename: 'HurdleQuizzesPaginated';
  hasMore: Scalars['Boolean'];
  id: Scalars['ID'];
  list: Array<HurdleQuiz>;
  totalCount: Scalars['Int'];
};

export type HurdleSongItem = {
  __typename: 'HurdleSongItem';
  asset: Scalars['String'];
  id: Scalars['ID'];
  song?: Maybe<Song>;
};

export enum HurdleType {
  DEFAULTSONG = 'DefaultSong'
}

export type IosSubscriptionPromoSignature = {
  __typename: 'IOSSubscriptionPromoSignature';
  id: Scalars['ID'];
  keyId: Scalars['String'];
  nonce: Scalars['String'];
  signature: Scalars['String'];
  timestamp: Scalars['Date'];
};

export type IapGift = {
  __typename: 'IapGift';
  bundleName?: Maybe<Scalars['String']>;
  claimed?: Maybe<Scalars['Date']>;
  created: Scalars['Date'];
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  rewards: Array<LevelReward>;
};

export type IapGiftBanner = {
  __typename: 'IapGiftBanner';
  id: Scalars['ID'];
};

export enum IapGiftBannerType {
  FROM_SYSTEM = 'FROM_SYSTEM',
  FROM_USER = 'FROM_USER'
}

export type IapGiftDraft = {
  __typename: 'IapGiftDraft';
  completedBatches: Scalars['Int'];
  created: Scalars['Date'];
  deliveryStatus: Scalars['String'];
  failedBatches: Scalars['Int'];
  filters: GiftFilters;
  id: Scalars['String'];
  messageId?: Maybe<Scalars['String']>;
  pendingBatches: Scalars['Int'];
  recipientsCount?: Maybe<Scalars['Int']>;
  rewards: Array<IapGiftDraftReward>;
  runningBatches: Scalars['Int'];
  sendDate?: Maybe<Scalars['Date']>;
  sentRecipientsCount: Scalars['Int'];
  sku: Scalars['String'];
  totalBatches: Scalars['Int'];
};

export type IapGiftDraftReward = {
  __typename: 'IapGiftDraftReward';
  amount: Scalars['Int'];
  itemId: Scalars['ID'];
  type: Scalars['String'];
};

export type ImportItunesDatabasePayload = {
  __typename: 'ImportItunesDatabasePayload';
  ingestStatus?: Maybe<CurationTask>;
  success: Scalars['Boolean'];
};

export type ImportSongsFromContentPackListToHurdleCatalogInput = {
  contentPackIds: Array<Scalars['ID']>;
  excludeContentPackIdsFromAutogeneration: Array<Scalars['ID']>;
  type: HurdleType;
};

export type ImportSongsFromContentPackListToHurdleCatalogPayload = {
  __typename: 'ImportSongsFromContentPackListToHurdleCatalogPayload';
  alreadyInCatalogNumber: Scalars['Int'];
  excludedBannedItemsNumber: Scalars['Int'];
  excludedExplicitItemsNumber: Scalars['Int'];
  excludedQuestionableItemsNumber: Scalars['Int'];
  inSeveralNewContentPacksNumber: Scalars['Int'];
  newSongsImported: Scalars['Int'];
};

export type ImportantEvent = {
  __typename: 'ImportantEvent';
  datetime: Scalars['Date'];
  description: Scalars['String'];
  eventKey: Scalars['String'];
  important: Scalars['Boolean'];
  notes: Scalars['String'];
  type: ImportantEventType;
};

export enum ImportantEventType {
  BACKENDDEPLOYMENT = 'BackendDeployment',
  CUSTOM = 'Custom',
  FRONTENDDEPLOYMENT = 'FrontendDeployment'
}

export type InitMonthlyPassMissionsInput = {
  forceReset?: Scalars['Boolean'];
  monthId: Scalars['ID'];
};

export type InitSpecialEventMissionsInput = {
  forceReset?: Scalars['Boolean'];
  specialEventId: Scalars['ID'];
};

export type InviteSp2OpponentInput = {
  link: Scalars['String'];
  opponentSP2Id: Scalars['ID'];
};

export type InviteSp2OpponentPayload = {
  __typename: 'InviteSP2OpponentPayload';
  opponent: Sp2Opponent;
};

export type Item = {
  allLevelItems: Array<Item>;
  asset: Scalars['String'];
  availability: ItemAvailability;
  cost?: Maybe<Currency>;
  id: Scalars['ID'];
  level: Scalars['Int'];
  name: Scalars['String'];
  nextLevelItem?: Maybe<Item>;
  nextLevelItems: Array<Item>;
};

export enum ItemAvailability {
  CRAFT = 'CRAFT',
  EARN = 'EARN',
  EARN_EACH_LEVEL = 'EARN_EACH_LEVEL',
  OWNED = 'OWNED',
  SHOP = 'SHOP',
  UNAVAILABLE = 'UNAVAILABLE',
  UPGRADE = 'UPGRADE'
}

export type ItemCraftDetails = {
  __typename: 'ItemCraftDetails';
  craftableFramesCount: Scalars['Int'];
  craftableStickersCount: Scalars['Int'];
  upgradableFramesCount: Scalars['Int'];
  upgradableVinylsCount: Scalars['Int'];
};

export type ItemDetails = {
  __typename: 'ItemDetails';
  totalProfileFrames: Scalars['Int'];
  totalStickers: Scalars['Int'];
  totalVinyls: Scalars['Int'];
};

export type ItemPayload = {
  __typename: 'ItemPayload';
  item?: Maybe<Item>;
  user?: Maybe<User>;
};

export enum ItunesParentalAdvisory {
  CLEAN = 'CLEAN',
  EXPLICIT = 'EXPLICIT',
  NON_EXPLICIT = 'NON_EXPLICIT'
}

export type ItunesSong = {
  __typename: 'ItunesSong';
  album: Scalars['String'];
  albumArtwork?: Maybe<Scalars['String']>;
  albumId: Scalars['ID'];
  albumYear: Scalars['Int'];
  artist: Scalars['String'];
  id: Scalars['ID'];
  isWhitelisted: Scalars['Boolean'];
  isrc: Scalars['String'];
  label: Scalars['String'];
  parentalAdvisory: ItunesParentalAdvisory;
  sample: Scalars['String'];
  subLabel?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export enum JobState {
  ARCHIVED = 'ARCHIVED',
  COPY_XML = 'COPY_XML',
  DB_INGESTION = 'DB_INGESTION',
  DONE = 'DONE',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  MISSING_ASSETS = 'MISSING_ASSETS',
  MISSING_INITIAL = 'MISSING_INITIAL',
  MISSING_XML = 'MISSING_XML',
  PARSING_XML = 'PARSING_XML',
  PAUSED = 'PAUSED',
  PENDING = 'PENDING',
  TASKS_CREATED = 'TASKS_CREATED',
  TASKS_FAILED = 'TASKS_FAILED',
  XML_PARSED = 'XML_PARSED'
}

export type JoinQuizLiveShowInput = {
  showId: Scalars['ID'];
  skipCost?: InputMaybe<Scalars['Boolean']>;
};

export type JoinQuizLiveShowPayload = {
  __typename: 'JoinQuizLiveShowPayload';
  podId: Scalars['ID'];
  team?: Maybe<Team>;
  user: User;
};

export type JoinTeamInput = {
  teamId: Scalars['ID'];
};

export type KickTeamMemberInput = {
  teamId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type LbRankGroup = {
  __typename: 'LBRankGroup';
  id: Scalars['ID'];
  maxRank: Scalars['Int'];
  minRank: Scalars['Int'];
  rewards: Array<LevelReward>;
};

export type LatestUpdateGift = {
  __typename: 'LatestUpdateGift';
  betaAndroidVersions: Array<Scalars['Int']>;
  betaIosVersions: Array<Scalars['Int']>;
  eligibleAndroidVersions: Array<Scalars['Int']>;
  eligibleIosVersions: Array<Scalars['Int']>;
  gift1Amount: Scalars['Int'];
  gift1Type: Scalars['String'];
  gift2Amount: Scalars['Int'];
  gift2Type: Scalars['String'];
  updatedAt: Scalars['Date'];
};

export type Leaderboard = {
  __typename: 'Leaderboard';
  /** Similar endpoints but the data is filtered for the user and they friends only */
  friends: FriendsLeaderboard;
  id: Scalars['ID'];
  /** Return the rank the current user - can be null because the player may not have played in this leaderboard */
  meRank?: Maybe<Scalars['Int']>;
  /** Return the score the current user - return 0 by default (even if the user have not played in this leaderboard) */
  meScore: Scalars['Int'];
  /**
   * Rank = cursor, before and after are how many ranks before and after to retreive
   * Defaults values: rank = 1, before = 5, after = 5
   * If rank = -1, we will try to find the current user rank and use it, or it will fall back on rank = 1
   */
  nearValueRankings: Array<LeaderboardEntry>;
  /** Return the top 10 */
  topRankings: Array<LeaderboardEntry>;
  totalRanks: Scalars['Int'];
};


export type LeaderboardNearValueRankingsArgs = {
  after?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['Int']>;
  rank?: InputMaybe<Scalars['Int']>;
};

export type LeaderboardEntry = {
  __typename: 'LeaderboardEntry';
  /**
   * If the current leaderboard is a subset of another leaderboard (eg. FriendsLeaderboard),
   * we try to find the rank of this entry in the parent leaderboard.
   * Else globalRank = rank
   */
  globalRank: Scalars['Int'];
  id: Scalars['ID'];
  rank: Scalars['Int'];
  score: Scalars['Int'];
  user: User;
};

export type LeaveTeamInput = {
  teamId: Scalars['ID'];
};

/** Config and rewards when reaching a content pack level. */
export type LevelConfigContentPack = {
  __typename: 'LevelConfigContentPack';
  /** How many content items are available at this level */
  contentItemReward: Scalars['Int'];
  /** Diamonds player will get as reward when upgrading to this level */
  diamondReward?: Maybe<Scalars['Int']>;
  /** Fragments player will get as reward when upgrading to this level */
  fragmentReward?: Maybe<CurrencyCategoryFragment>;
  level: Scalars['Int'];
  /** specialEvent points a player will get as reward when upgrading to this level */
  specialEventReward: Scalars['Int'];
  /** Amount of coins needed to upgrade to the next level (level+1) */
  upgradeCoinCost: Scalars['Int'];
  /** xp player will get as reward (user xp) when upgrading to this level */
  xpReward: Scalars['Int'];
  /** Amount of xp needed to upgrade to the next level (level+1) */
  xpToNextLevel: Scalars['Int'];
};

/** Config and rewards when reaching a monthly pass level. */
export type LevelConfigMonthlyPass = {
  __typename: 'LevelConfigMonthlyPass';
  basicReward: LevelReward;
  level: Scalars['Int'];
  plusReward?: Maybe<LevelReward>;
  premiumReward?: Maybe<LevelReward>;
  /**
   * monthly pass levels are not time locked anymore, starts is now deprecated
   * @deprecated there is no more gate on monthly pass levels - user can levelup to the max level day 1 if he wants
   */
  starts: Scalars['Date'];
  vipReward?: Maybe<LevelReward>;
  xpToNextLevel: Scalars['Int'];
};

export type LevelConfigMonthlyPassInput = {
  basicReward: LevelRewardInput;
  level: Scalars['Int'];
  plusReward?: InputMaybe<LevelRewardInput>;
  premiumReward?: InputMaybe<LevelRewardInput>;
  starts: Scalars['Date'];
  vipReward?: InputMaybe<LevelRewardInput>;
  xpToNextLevel: Scalars['Int'];
};

/** Config and rewards when reaching a user level. */
export type LevelConfigUser = {
  __typename: 'LevelConfigUser';
  basicReward: LevelReward;
  /** @deprecated use featuresUnlocked instead */
  featureUnlocked?: Maybe<LevelConfigUserFeatureUnlocked>;
  featuresUnlocked: Array<LevelConfigUserFeatureUnlocked>;
  level: Scalars['Int'];
  plusReward?: Maybe<LevelReward>;
  premiumReward?: Maybe<LevelReward>;
  vipReward?: Maybe<LevelReward>;
  xpToNextLevel: Scalars['Int'];
};

export enum LevelConfigUserFeatureUnlocked {
  ARTIST_SELECTION = 'ARTIST_SELECTION',
  BADGES = 'BADGES',
  COLLECTIONS = 'COLLECTIONS',
  DAILY_BONUS = 'DAILY_BONUS',
  EMOJI_PACK = 'EMOJI_PACK',
  FRAME = 'FRAME',
  FRAME_UPGRADE_LEVEL_2 = 'FRAME_UPGRADE_LEVEL_2',
  FRAME_UPGRADE_LEVEL_3 = 'FRAME_UPGRADE_LEVEL_3',
  HURDLE_HINT = 'HURDLE_HINT',
  IMAGE_CHAT_MESSAGE = 'IMAGE_CHAT_MESSAGE',
  LIKE_SONGS = 'LIKE_SONGS',
  LISTEN = 'LISTEN',
  LIVE_MULTIPLAYER = 'LIVE_MULTIPLAYER',
  LIVE_SHOW = 'LIVE_SHOW',
  MAX_PLAYLIST_LEVEL_2 = 'MAX_PLAYLIST_LEVEL_2',
  MAX_PLAYLIST_LEVEL_3 = 'MAX_PLAYLIST_LEVEL_3',
  MAX_PLAYLIST_LEVEL_4 = 'MAX_PLAYLIST_LEVEL_4',
  MAX_PLAYLIST_LEVEL_5 = 'MAX_PLAYLIST_LEVEL_5',
  MAX_PLAYLIST_LEVEL_6 = 'MAX_PLAYLIST_LEVEL_6',
  MAX_PLAYLIST_LEVEL_7 = 'MAX_PLAYLIST_LEVEL_7',
  MAX_PLAYLIST_LEVEL_8 = 'MAX_PLAYLIST_LEVEL_8',
  MAX_PLAYLIST_LEVEL_9 = 'MAX_PLAYLIST_LEVEL_9',
  MAX_PLAYLIST_LEVEL_10 = 'MAX_PLAYLIST_LEVEL_10',
  MAX_PLAYLIST_LEVEL_11 = 'MAX_PLAYLIST_LEVEL_11',
  MAX_PLAYLIST_LEVEL_12 = 'MAX_PLAYLIST_LEVEL_12',
  MAX_PLAYLIST_LEVEL_13 = 'MAX_PLAYLIST_LEVEL_13',
  MAX_PLAYLIST_LEVEL_14 = 'MAX_PLAYLIST_LEVEL_14',
  MAX_PLAYLIST_LEVEL_15 = 'MAX_PLAYLIST_LEVEL_15',
  MAX_PLAYLIST_LEVEL_16 = 'MAX_PLAYLIST_LEVEL_16',
  MAX_PLAYLIST_LEVEL_17 = 'MAX_PLAYLIST_LEVEL_17',
  MAX_PLAYLIST_LEVEL_18 = 'MAX_PLAYLIST_LEVEL_18',
  MAX_PLAYLIST_LEVEL_19 = 'MAX_PLAYLIST_LEVEL_19',
  MAX_PLAYLIST_LEVEL_20 = 'MAX_PLAYLIST_LEVEL_20',
  MAX_PLAYLIST_LEVEL_21 = 'MAX_PLAYLIST_LEVEL_21',
  MAX_PLAYLIST_LEVEL_22 = 'MAX_PLAYLIST_LEVEL_22',
  MAX_PLAYLIST_LEVEL_23 = 'MAX_PLAYLIST_LEVEL_23',
  MAX_PLAYLIST_LEVEL_24 = 'MAX_PLAYLIST_LEVEL_24',
  MAX_PLAYLIST_LEVEL_25 = 'MAX_PLAYLIST_LEVEL_25',
  MAX_PLAYLIST_LEVEL_26 = 'MAX_PLAYLIST_LEVEL_26',
  MAX_PLAYLIST_LEVEL_27 = 'MAX_PLAYLIST_LEVEL_27',
  MAX_PLAYLIST_LEVEL_28 = 'MAX_PLAYLIST_LEVEL_28',
  MAX_PLAYLIST_LEVEL_29 = 'MAX_PLAYLIST_LEVEL_29',
  MAX_PLAYLIST_LEVEL_30 = 'MAX_PLAYLIST_LEVEL_30',
  MONTHLY_PASS = 'MONTHLY_PASS',
  MULTIPLAYER = 'MULTIPLAYER',
  PLAYLIST_LEADERBOARD = 'PLAYLIST_LEADERBOARD',
  PLAYLIST_SELECTION = 'PLAYLIST_SELECTION',
  PLAYLIST_STATS = 'PLAYLIST_STATS',
  PLAYLIST_SUGGESTION = 'PLAYLIST_SUGGESTION',
  PRACTICE = 'PRACTICE',
  PREMIUM = 'PREMIUM',
  PROFILE_PIC_UPLOAD = 'PROFILE_PIC_UPLOAD',
  REMOVE2 = 'REMOVE2',
  REVIVE = 'REVIVE',
  SONG_CHAT_MESSAGE = 'SONG_CHAT_MESSAGE',
  STICKER_AND_WORD = 'STICKER_AND_WORD',
  TEAM = 'TEAM',
  TEAM_SPIRIT = 'TEAM_SPIRIT',
  TEXT_CHAT = 'TEXT_CHAT',
  TOURNAMENT = 'TOURNAMENT',
  UNLOCK_ARTIST_ONLY = 'UNLOCK_ARTIST_ONLY',
  UNLOCK_BOMB_BOOST = 'UNLOCK_BOMB_BOOST',
  UNLOCK_NINJA_BOOST = 'UNLOCK_NINJA_BOOST',
  UNLOCK_POWER_OFF = 'UNLOCK_POWER_OFF',
  UNLOCK_SAMPLER = 'UNLOCK_SAMPLER',
  UNLOCK_SPEEDSTER = 'UNLOCK_SPEEDSTER',
  UNLOCK_VINYL = 'UNLOCK_VINYL',
  VINYL_UPGRADE_LEVEL_2 = 'VINYL_UPGRADE_LEVEL_2',
  VINYL_UPGRADE_LEVEL_3 = 'VINYL_UPGRADE_LEVEL_3',
  VIP = 'VIP'
}

export type LevelItemInput = {
  asset: Scalars['String'];
  cost: CurrencyInput;
};

export type LevelReward = AppSkin | Badge | ContentPackReward | CurrencyAccolade | CurrencyBoost | CurrencyCategoryFragment | CurrencyCategoryRandom | CurrencyCoin | CurrencyDiamond | CurrencyFreeSpin | CurrencyLiveEvent | CurrencyLoyaltyPoints | CurrencyMetaFragmentBronze | CurrencyMetaFragmentGold | CurrencyMetaFragmentSilver | CurrencyShardBronze | CurrencyShardGold | CurrencyShardSilver | CurrencySpecialEvent | CurrencyStampCard | CurrencySubscriptionDay | CurrencyTournamentTicket | CurrencyUnlimitedBoost | CurrencyXp | Emoji | EmojiPack | MonthlyBuff | Poster | ProfileFrame | Sticker;

export type LevelRewardInput = {
  amount: Scalars['Int'];
  itemId?: InputMaybe<Scalars['String']>;
  type: LevelRewardInputType;
};

export enum LevelRewardInputType {
  APP_SKIN = 'APP_SKIN',
  BADGE = 'BADGE',
  CONTENT_PACK_REWARD = 'CONTENT_PACK_REWARD',
  CURRENCY_ACCOLADE = 'CURRENCY_ACCOLADE',
  CURRENCY_BOOST = 'CURRENCY_BOOST',
  CURRENCY_CATEGORY_FRAGMENT = 'CURRENCY_CATEGORY_FRAGMENT',
  CURRENCY_COIN = 'CURRENCY_COIN',
  CURRENCY_DIAMOND = 'CURRENCY_DIAMOND',
  CURRENCY_FREE_SPIN = 'CURRENCY_FREE_SPIN',
  CURRENCY_LOYALTY_POINT = 'CURRENCY_LOYALTY_POINT',
  CURRENCY_META_FRAGMENT_BRONZE = 'CURRENCY_META_FRAGMENT_BRONZE',
  CURRENCY_META_FRAGMENT_GOLD = 'CURRENCY_META_FRAGMENT_GOLD',
  CURRENCY_META_FRAGMENT_SILVER = 'CURRENCY_META_FRAGMENT_SILVER',
  CURRENCY_SHARD_BRONZE = 'CURRENCY_SHARD_BRONZE',
  CURRENCY_SHARD_GOLD = 'CURRENCY_SHARD_GOLD',
  CURRENCY_SHARD_SILVER = 'CURRENCY_SHARD_SILVER',
  CURRENCY_SPECIAL_EVENT = 'CURRENCY_SPECIAL_EVENT',
  CURRENCY_SUBSCRIPTION_DAY = 'CURRENCY_SUBSCRIPTION_DAY',
  CURRENCY_TOURNAMENT_TICKET = 'CURRENCY_TOURNAMENT_TICKET',
  EMOJI = 'EMOJI',
  EMOJI_PACK = 'EMOJI_PACK',
  MONTHLY_BUFF = 'MONTHLY_BUFF',
  POSTER = 'POSTER',
  PROFILE_FRAME = 'PROFILE_FRAME',
  STICKER = 'STICKER'
}

export type LevelTieredRewardClaimed = {
  __typename: 'LevelTieredRewardClaimed';
  bestTierClaimed?: Maybe<UserSubscriptionTier>;
  level: Scalars['Int'];
  tiersClaimed: Array<UserSubscriptionTier>;
};

export type LinkCredentialPayload = {
  __typename: 'LinkCredentialPayload';
  user?: Maybe<User>;
};

export type LinkInfoPayload = {
  __typename: 'LinkInfoPayload';
  sp2Info?: Maybe<Sp2Info>;
  sp2id?: Maybe<Scalars['ID']>;
  sp3id?: Maybe<Scalars['ID']>;
  state: Sp2LinkState;
};

export type LinkTokenInput = {
  linkToken: Scalars['String'];
};

export type ListenCountInput = {
  count: Scalars['Int'];
  songId: Scalars['ID'];
};

export type LiveEvent = {
  __typename: 'LiveEvent';
  contentPacks: Array<ContentPack>;
  endDate: Scalars['Date'];
  filterOnlyAdmin: Scalars['Boolean'];
  filterUserIds: Array<Scalars['ID']>;
  filterVersion: Scalars['Int'];
  id: Scalars['ID'];
  isDraft: Scalars['Boolean'];
  name: Scalars['String'];
  shop: Array<LiveEventShopItemConfig>;
  startDate: Scalars['Date'];
};

export type LiveEventOpponentFoundPayload = {
  __typename: 'LiveEventOpponentFoundPayload';
  isBot: Scalars['Boolean'];
  userToUser: UserToUser;
};

export type LiveEventPaginated = {
  __typename: 'LiveEventPaginated';
  hasMore: Scalars['Boolean'];
  id: Scalars['ID'];
  list: Array<LiveEvent>;
  totalCount: Scalars['Int'];
};

export type LiveEventPayload = {
  __typename: 'LiveEventPayload';
  liveEvent: LiveEvent;
};

export type LiveEventShopItem = {
  __typename: 'LiveEventShopItem';
  cost: Currency;
  id: Scalars['ID'];
  item: LevelReward;
};

export type LiveEventShopItemConfig = {
  __typename: 'LiveEventShopItemConfig';
  amount: Scalars['Int'];
  buyLimit: Scalars['Int'];
  cost: Scalars['Int'];
  itemId: Scalars['ID'];
  type: Scalars['String'];
};

export type LiveEventShopItemInput = {
  buyLimit: Scalars['Int'];
  cost: Scalars['Int'];
  item: LevelRewardInput;
};

export type LiveEventStatesUpdatedPayload = {
  __typename: 'LiveEventStatesUpdatedPayload';
  currentStates: UserToUserLiveEvent;
  userToUser: UserToUser;
};

/**
 * For admin live ops.
 * Helps create content for daily live ops in game
 */
export type LiveOps = {
  __typename: 'LiveOps';
  /** List of all ABTests without filter, order by startDate DESC */
  ABTestConfigs: Array<AbTestConfig>;
  appskins: AppSkinPaginated;
  badgeConfigs: BadgeConfigPaginated;
  badgeLevelUpReqConfig: Array<Scalars['String']>;
  badgeUnlockReqConfig: Array<Scalars['String']>;
  bundleNames: Array<BundlePackName>;
  bundleSales: Array<CurrencyBundlePack>;
  bundleTags: Array<BundlePackTag>;
  chainedOfferEvent?: Maybe<ChainedOfferEventConfig>;
  chainedOfferEvents: Array<ChainedOfferEventConfig>;
  collections: CollectionPaginated;
  /** @deprecated use Query.searchContentPacks instead */
  contentPacksByCategory?: Maybe<Array<ContentPack>>;
  emojiPacks: EmojiPackPaginated;
  emojiPacksLayoutAvailabilities: Array<EmojiPackLayoutInfo>;
  emojisConfig: EmojiConfigPaginated;
  getAllCategoriesForMarathon: Array<MarathonCategoryData>;
  getAllMarathonEvents: Array<MarathonEventConfig>;
  getAllMarathonMilestoneConfigs: Array<MarathonMilestoneTemplate>;
  getAllWheelFortuneEvents: Array<WheelFortuneEventConfig>;
  getAllWheelFortuneRewardConfigs: Array<WheelFortuneRewardTemplate>;
  getMarathonEvent: MarathonEventConfig;
  getWheelFortuneEvent: WheelFortuneEventConfig;
  id: Scalars['ID'];
  initialSubscriptionOffers: Array<SubscriptionSaleConfig>;
  liveEvents: LiveEventPaginated;
  loyaltyCampaignCards: Array<LoyaltyCampaignCard>;
  loyaltyCampaignConfigs: Array<LoyaltyCampaignConfig>;
  loyaltyCampaignOfferOptions: Array<LoyaltyCampaignOfferOption>;
  loyaltyCampaignSkuOptions: Array<Scalars['String']>;
  loyaltyCampaignSkuPrices: Array<LoyaltyCampaignSkuPrice>;
  missionTasks: Array<MissionTask>;
  monthlyPasses: MonthlyPassPaginated;
  posters: Array<Poster>;
  profileFrames: ProfileFramePaginated;
  quizLiveShowPresets: Array<QuizLiveShowPreset>;
  quizLiveShows: QuizLiveShowsPaginated;
  /** List of all SaleEvents without filter, order by startDate DESC */
  saleEventConfig?: Maybe<SaleEventConfig>;
  saleEventConfigs: Array<SaleEventConfig>;
  specialEvents: SpecialEventPaginated;
  stickers: StickerPaginated;
  tournaments: TournamentPaginated;
  unsupportedPopupConfigs: Array<UnsupportedPopupConfig>;
  usersWithRoles: Array<User>;
};


/**
 * For admin live ops.
 * Helps create content for daily live ops in game
 */
export type LiveOpsAppskinsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * For admin live ops.
 * Helps create content for daily live ops in game
 */
export type LiveOpsBadgeConfigsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * For admin live ops.
 * Helps create content for daily live ops in game
 */
export type LiveOpsChainedOfferEventArgs = {
  id: Scalars['ID'];
};


/**
 * For admin live ops.
 * Helps create content for daily live ops in game
 */
export type LiveOpsCollectionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * For admin live ops.
 * Helps create content for daily live ops in game
 */
export type LiveOpsContentPacksByCategoryArgs = {
  category: Scalars['ID'];
  excludeExplicit: Scalars['Boolean'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * For admin live ops.
 * Helps create content for daily live ops in game
 */
export type LiveOpsEmojiPacksArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * For admin live ops.
 * Helps create content for daily live ops in game
 */
export type LiveOpsEmojisConfigArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * For admin live ops.
 * Helps create content for daily live ops in game
 */
export type LiveOpsGetMarathonEventArgs = {
  id: Scalars['ID'];
};


/**
 * For admin live ops.
 * Helps create content for daily live ops in game
 */
export type LiveOpsGetWheelFortuneEventArgs = {
  id: Scalars['ID'];
};


/**
 * For admin live ops.
 * Helps create content for daily live ops in game
 */
export type LiveOpsLiveEventsArgs = {
  pagination?: InputMaybe<PaginationParams>;
};


/**
 * For admin live ops.
 * Helps create content for daily live ops in game
 */
export type LiveOpsMonthlyPassesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * For admin live ops.
 * Helps create content for daily live ops in game
 */
export type LiveOpsProfileFramesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * For admin live ops.
 * Helps create content for daily live ops in game
 */
export type LiveOpsQuizLiveShowsArgs = {
  pagination?: InputMaybe<PaginationParams>;
};


/**
 * For admin live ops.
 * Helps create content for daily live ops in game
 */
export type LiveOpsSaleEventConfigArgs = {
  saleEventId: Scalars['ID'];
};


/**
 * For admin live ops.
 * Helps create content for daily live ops in game
 */
export type LiveOpsSpecialEventsArgs = {
  pagination?: InputMaybe<PaginationParams>;
};


/**
 * For admin live ops.
 * Helps create content for daily live ops in game
 */
export type LiveOpsStickersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * For admin live ops.
 * Helps create content for daily live ops in game
 */
export type LiveOpsTournamentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * For admin live ops.
 * Helps create content for daily live ops in game
 */
export type LiveOpsUnsupportedPopupConfigsArgs = {
  place?: InputMaybe<PopupPlacement>;
};


/**
 * For admin live ops.
 * Helps create content for daily live ops in game
 */
export type LiveOpsUsersWithRolesArgs = {
  role: UserRole;
};

export type LiveShowLastSchedulePayload = {
  __typename: 'LiveShowLastSchedulePayload';
  isCurrentlyScheduled: Scalars['Boolean'];
  lastScheduleDate?: Maybe<Scalars['Date']>;
};

export type LiveShowLog = {
  __typename: 'LiveShowLog';
  extraData: Scalars['JSON'];
  level: Scalars['String'];
  message: Scalars['String'];
  namespace: Scalars['String'];
  source: Scalars['String'];
  timestamp: Scalars['Date'];
};

export type LiveShowLogsPaginated = {
  __typename: 'LiveShowLogsPaginated';
  list: Array<LiveShowLog>;
  totalCount: Scalars['Int'];
};

export type Loyalty = {
  __typename: 'Loyalty';
  cardStreak: Scalars['Int'];
  /**
   * User's current loyalty card
   * Null if the user has never started one
   */
  currentCard?: Maybe<LoyaltyCard>;
  dayStreak: Scalars['Int'];
  /**
   * Next loyalty card after the current one
   * After the user completes a card and starts a new one, there will be a period
   * where the current card is still active and the next has not started yet
   */
  futureCard?: Maybe<LoyaltyCard>;
  previousCard?: Maybe<LoyaltyCard>;
  previousCardStreak?: Maybe<Scalars['Int']>;
  tradeableCardCount: Scalars['Int'];
};

export type LoyaltyCampaignCard = {
  __typename: 'LoyaltyCampaignCard';
  claimType: LoyaltyCampaignCardType;
  cost: Scalars['Int'];
  created: Scalars['Date'];
  displayOrder: Scalars['Int'];
  groupDisplayOrder?: Maybe<Scalars['Int']>;
  groupEndDate?: Maybe<Scalars['Date']>;
  groupId?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
  groupStartDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  itemBonusLoyaltyPoints?: Maybe<Scalars['Int']>;
  itemDisplayOrder?: Maybe<Scalars['Int']>;
  kind: LoyaltyCampaignCardKind;
  maxClaims: Scalars['Int'];
  name: Scalars['String'];
  rewards: Array<LevelReward>;
  subgroupDisplayOrder?: Maybe<Scalars['Int']>;
  subgroupEndDate?: Maybe<Scalars['Date']>;
  subgroupId?: Maybe<Scalars['String']>;
  subgroupName?: Maybe<Scalars['String']>;
  subgroupStartDate?: Maybe<Scalars['Date']>;
};

export type LoyaltyCampaignCardClaimCount = {
  __typename: 'LoyaltyCampaignCardClaimCount';
  cardId: Scalars['ID'];
  count: Scalars['Int'];
};

export enum LoyaltyCampaignCardKind {
  BUNDLE = 'BUNDLE',
  ITEM = 'ITEM'
}

export enum LoyaltyCampaignCardType {
  INFINITE = 'INFINITE',
  ONE_TIME = 'ONE_TIME'
}

export type LoyaltyCampaignConfig = {
  __typename: 'LoyaltyCampaignConfig';
  amount: Scalars['Int'];
  id: Scalars['ID'];
  updatedAt: Scalars['Date'];
};

export type LoyaltyCampaignOfferOption = {
  __typename: 'LoyaltyCampaignOfferOption';
  id: Scalars['ID'];
  label: Scalars['String'];
  priceUsd?: Maybe<Scalars['Float']>;
  skus: Array<Scalars['String']>;
};

export type LoyaltyCampaignSkuPrice = {
  __typename: 'LoyaltyCampaignSkuPrice';
  priceUsd: Scalars['Float'];
  sku: Scalars['String'];
};

export type LoyaltyCard = {
  __typename: 'LoyaltyCard';
  cardIndex: Scalars['Int'];
  /**
   * The current day index (starting from 0) - to use with the "days" array.
   * This corresponds to the day for which start <= now <= end, based on current
   * server time.
   * Null if the card is expired, has not started yet, or is in the past.
   */
  currentDayIndex?: Maybe<Scalars['Int']>;
  days: Array<LoyaltyCardDay>;
  id: Scalars['ID'];
  isCompleted: Scalars['Boolean'];
  /**
   * True if the current day has not been claimed before its end date
   * Need to call reviveLoyaltyCardDay or startLoyaltyCard
   * VIP players can call claimLoyaltyCardDay even if isExpired === true
   */
  isExpired: Scalars['Boolean'];
  /**
   * The next claimable day index (starting from 0) - to use with the "days" array.
   * This corresponds to the first day which has not been claimed yet.
   * Null if all days have been claimed (the card is completed).
   */
  nextClaimableDayIndex?: Maybe<Scalars['Int']>;
  reviveCost: LoyaltyCardReviveCost;
};

export type LoyaltyCardDay = {
  __typename: 'LoyaltyCardDay';
  claimedDate?: Maybe<Scalars['Date']>;
  claimedMultiplier?: Maybe<Scalars['Float']>;
  end: Scalars['Date'];
  id: Scalars['ID'];
  isClaimed: Scalars['Boolean'];
  /**
   * If day is a Guess the Song Day, the player can play a quiz to get a reward multiplier
   * If quiz = null, it is not a Guess the Song Day
   */
  quiz?: Maybe<GuessTheSongQuiz>;
  rewards: Array<LevelReward>;
  start: Scalars['Date'];
};

export type LoyaltyCardReviveCost = {
  __typename: 'LoyaltyCardReviveCost';
  cost: Scalars['Float'];
  type: LoyaltyCardReviveCostType;
};

export enum LoyaltyCardReviveCostType {
  AD = 'AD',
  DIAMOND = 'DIAMOND',
  FREE = 'FREE',
  STORE = 'STORE'
}

export type LoyaltyCardTrade = {
  __typename: 'LoyaltyCardTrade';
  cardCost: Scalars['Int'];
  id: Scalars['ID'];
  isAvailable: Scalars['Boolean'];
  /** @deprecated Use LoyaltyCardTrade.reward instead */
  item: LoyaltyTradeableItem;
  itemAmount: Scalars['Int'];
  reward: LevelReward;
};

export enum LoyaltyTradeableItem {
  APP_SKIN = 'APP_SKIN',
  DIAMONDS = 'DIAMONDS',
  REMOVE2_BOOST = 'REMOVE2_BOOST',
  SPEEDSTER_BOOST = 'SPEEDSTER_BOOST'
}

export type LyricsData = {
  __typename: 'LyricsData';
  artist: Scalars['String'];
  embedScriptUrl: Scalars['String'];
  id: Scalars['ID'];
  songImageUrl?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  url: Scalars['String'];
};

export type LyricsResult = {
  __typename: 'LyricsResult';
  id: Scalars['ID'];
  lyricsData?: Maybe<LyricsData>;
};

export type MMilestonesInput = {
  basicReward: LevelRewardInput;
  numberOfGuesses: Scalars['Int'];
  plusReward: LevelRewardInput;
  /** Optional; the server defaults to REGULAR. */
  type?: InputMaybe<MarathonMilestoneType>;
};

export type MakeMusicCatalogAvailablePayload = {
  __typename: 'MakeMusicCatalogAvailablePayload';
  catalogExport?: Maybe<CurationTask>;
};

export type MarathonCategoryData = {
  __typename: 'MarathonCategoryData';
  contentPacks: Scalars['Int'];
  id: Scalars['String'];
  name: Scalars['String'];
  songs: Scalars['Int'];
};

export type MarathonEconomyConfig = {
  __typename: 'MarathonEconomyConfig';
  freeRevivesBasic: Scalars['Int'];
  freeRevivesPlus: Scalars['Int'];
  freeStartsBasic: Scalars['Int'];
  freeStartsPlus: Scalars['Int'];
  revivePrice: Scalars['Int'];
  startPrice: Scalars['Int'];
};

export type MarathonEconomyConfigInput = {
  freeRevivesBasic: Scalars['Int'];
  freeRevivesPlus: Scalars['Int'];
  freeStartsBasic: Scalars['Int'];
  freeStartsPlus: Scalars['Int'];
  revivePrice: Scalars['Int'];
  startPrice: Scalars['Int'];
};

export type MarathonEvent = {
  __typename: 'MarathonEvent';
  category: Scalars['String'];
  economy: MarathonEconomyConfig;
  id: Scalars['ID'];
  milestoneGroups: Array<MarathonMilestoneGroup>;
  milestones: Array<MarathonMilestone>;
  startDate: Scalars['Date'];
  stopDate: Scalars['Date'];
};

export type MarathonEventConfig = {
  __typename: 'MarathonEventConfig';
  category?: Maybe<Scalars['String']>;
  economy: MarathonEconomyConfig;
  filterAppVersion?: Maybe<Scalars['String']>;
  filterSubscriptionTier?: Maybe<UserSubscriptionTier>;
  filterUserIds?: Maybe<Array<Scalars['String']>>;
  filterUserLevel?: Maybe<Scalars['Int']>;
  filterUserMaxCreationDate?: Maybe<Scalars['Date']>;
  filterUserMinCreationDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  /** Read-only: flat concat of all groups' milestones (back-compat convenience). */
  milestones: Array<MarathonMilestoneConfig>;
  milestoneGroups: Array<MarathonMilestoneGroupConfig>;
  name: Scalars['String'];
  /** Read-only: derived from the first group's unlockDate. */
  startDate: Scalars['Date'];
  status: ChainedOfferEventStatus;
  /** Read-only: derived from the last group's stopDate. */
  stopDate: Scalars['Date'];
};

export type MarathonMilestone = {
  __typename: 'MarathonMilestone';
  basicReward: LevelReward;
  numberOfGuesses: Scalars['Int'];
  plusReward: LevelReward;
  type: MarathonMilestoneType;
};

export type MarathonMilestoneConfig = {
  __typename: 'MarathonMilestoneConfig';
  basicReward: GenericLevelReward;
  numberOfGuesses: Scalars['Int'];
  plusReward: GenericLevelReward;
  type: MarathonMilestoneType;
};

export type MarathonMilestoneGroup = {
  __typename: 'MarathonMilestoneGroup';
  milestones: Array<MarathonMilestone>;
  stopDate: Scalars['Date'];
  unlockDate: Scalars['Date'];
};

export type MarathonMilestoneGroupConfig = {
  __typename: 'MarathonMilestoneGroupConfig';
  milestones: Array<MarathonMilestoneConfig>;
  stopDate: Scalars['Date'];
  unlockDate: Scalars['Date'];
};

export type MarathonMilestoneGroupInput = {
  milestones: Array<MMilestonesInput>;
  stopDate: Scalars['Date'];
  unlockDate: Scalars['Date'];
};

export type MarathonMilestoneTemplate = {
  __typename: 'MarathonMilestoneTemplate';
  id: Scalars['ID'];
  milestones: Array<MarathonMilestoneConfig>;
  name: Scalars['String'];
};

export enum MarathonMilestoneType {
  CHECKPOINT = 'CHECKPOINT',
  COMBINED = 'COMBINED',
  REGULAR = 'REGULAR',
  REST_POINT = 'REST_POINT'
}

export type MarkMessagesAsReadInput = {
  conversationId: Scalars['ID'];
};

export type MarkRoundAsStartedInput = {
  quizId: Scalars['ID'];
  roundId: Scalars['ID'];
};

export type MarkRoundAsStartedPayload = {
  __typename: 'MarkRoundAsStartedPayload';
  success?: Maybe<Scalars['Boolean']>;
};

export type MarkSongInputsAsOutdatedInput = {
  songInputIds: Array<Scalars['ID']>;
};

export type MarkSongInputsAsOutdatedPayload = {
  __typename: 'MarkSongInputsAsOutdatedPayload';
  songInputs?: Maybe<Array<CurationSongInput>>;
};

export type MasterfilePlaylist = {
  categories: Scalars['String'];
  description: Scalars['String'];
  forcedFields: Scalars['String'];
  isArtist: Scalars['String'];
  name: Scalars['String'];
  playlistId: Scalars['String'];
  popularity: Scalars['String'];
  toBeImported: Scalars['String'];
};

export type Message = {
  __typename: 'Message';
  attachment?: Maybe<MessageAttachement>;
  content: Scalars['String'];
  id: Scalars['ID'];
  sender: ChatSender;
  sent: Scalars['Date'];
  type: MessageType;
};

export type MessageAttachement = IapGiftBanner | QuizLiveShow | SpecialEvent | TeamMonthlyPass | TeamVoteResult | Tournament | UserContentItem | UserLiveEvent | UserMonthlyPass | UserToUserQuizLiveRound | UserToUserQuizTurnRound | YearInReview;

export type MessagePayload = {
  __typename: 'MessagePayload';
  message: Message;
};

export type MessageTemplate = {
  __typename: 'MessageTemplate';
  id: Scalars['ID'];
  message: Scalars['String'];
};

export enum MessageType {
  CONTENT_ITEM = 'CONTENT_ITEM',
  IAP_GIFT = 'IAP_GIFT',
  IMAGE = 'IMAGE',
  LIVE_EVENT = 'LIVE_EVENT',
  LIVE_SHOW_SAFE_TEXT = 'LIVE_SHOW_SAFE_TEXT',
  LIVE_SHOW_STICKER = 'LIVE_SHOW_STICKER',
  MONTHLY_PASS = 'MONTHLY_PASS',
  QUIZ = 'QUIZ',
  REFERRAL_PROGRAM = 'REFERRAL_PROGRAM',
  SAFE_TEXT = 'SAFE_TEXT',
  SPECIAL_EVENT = 'SPECIAL_EVENT',
  STICKER = 'STICKER',
  TEAM = 'TEAM',
  TEAM_HEAT_STARTED = 'TEAM_HEAT_STARTED',
  TEAM_MONTHLY_PASS = 'TEAM_MONTHLY_PASS',
  TEAM_VOTE_RESULT = 'TEAM_VOTE_RESULT',
  TEXT = 'TEXT',
  TOURNAMENT = 'TOURNAMENT',
  YEAR_IN_REVIEW = 'YEAR_IN_REVIEW'
}

export type MessagesPaginated = {
  __typename: 'MessagesPaginated';
  hasMore: Scalars['Boolean'];
  id: Scalars['ID'];
  list: Array<Message>;
  /** @deprecated No longer supported */
  totalCount: Scalars['Int'];
};

export type MetaFragmentAmount = {
  __typename: 'MetaFragmentAmount';
  amount?: Maybe<Scalars['Int']>;
};

export enum MetaFragmentType {
  BRONZE = 'BRONZE',
  GOLD = 'GOLD',
  SILVER = 'SILVER'
}

export type MetaFragments = {
  __typename: 'MetaFragments';
  BRONZE?: Maybe<MetaFragmentAmount>;
  GOLD?: Maybe<MetaFragmentAmount>;
  SILVER?: Maybe<MetaFragmentAmount>;
};

export type MetaFragmentsInput = {
  BRONZE?: InputMaybe<Scalars['Int']>;
  GOLD?: InputMaybe<Scalars['Int']>;
  SILVER?: InputMaybe<Scalars['Int']>;
};

export enum MetricOrderBy {
  MOST_POPULAR_SORT = 'MOST_POPULAR_SORT',
  WORST_AVERAGE_TIME_SORT = 'WORST_AVERAGE_TIME_SORT',
  WORST_CACHE_MISS_RATIO = 'WORST_CACHE_MISS_RATIO',
  WORST_CUMULATED_BY_PERIOD_SORT = 'WORST_CUMULATED_BY_PERIOD_SORT',
  WORST_CUMULATED_TIME_SORT = 'WORST_CUMULATED_TIME_SORT',
  WORST_TIMEOUT_RATIO = 'WORST_TIMEOUT_RATIO'
}

export enum MetricTimestamp {
  DAILY = 'Daily',
  HOURLY = 'Hourly',
  MINUTELY = 'Minutely',
  MONTHLY = 'Monthly',
  QUARTERLY = 'Quarterly',
  WEEKLY = 'Weekly',
  YEARLY = 'Yearly'
}

export enum MetricType {
  GQLREQUEST = 'GqlRequest',
  REDISREQUEST = 'RedisRequest',
  REDISREQUESTCOUNT = 'RedisRequestCount',
  SPANNERREQUEST = 'SpannerRequest',
  SPANNERRESPONSESIZE = 'SpannerResponseSize'
}

export type MetricsSerie = NumericAggregatedMetricsSerie | NumericAggregatedRedisCountMetricsSerie;

export type MigrateSp2PlaylistsInput = {
  playlists?: InputMaybe<Array<MasterfilePlaylist>>;
};

export type MigrateSp2PlaylistsPayload = {
  __typename: 'MigrateSP2PlaylistsPayload';
  curationContentPacks: Array<CurationContentPack>;
  errors?: Maybe<Array<Scalars['String']>>;
};

export type Mission = {
  __typename: 'Mission';
  end: Scalars['Date'];
  id: Scalars['ID'];
  requiredTier: UserSubscriptionTier;
  reward?: Maybe<LevelReward>;
  rewardAccolades?: Maybe<Scalars['Int']>;
  rewardCoins?: Maybe<Scalars['Int']>;
  rewardDiamonds?: Maybe<Scalars['Int']>;
  /**
   * XP / Points received when claimed
   * MonthlyPass XP if the mission is linked to a MonthlyPass
   * SpecialEventPoint if the mission is linked to a MonthlyPass
   */
  rewardXp: Scalars['Int'];
  start: Scalars['Date'];
  /**
   * Tasks that need to be completed to claim the mission
   * (Only 1 for now)
   */
  tasks: Array<MissionTask>;
};

export type MissionInput = {
  requiredTier: UserSubscriptionTier;
  reward?: InputMaybe<LevelRewardInput>;
  rewardAccolades?: InputMaybe<Scalars['Int']>;
  rewardXp: Scalars['Int'];
  tasks: Array<MissionTaskInput>;
};

export type MissionParam = MissionParamContentCategory | MissionParamContentPack | MissionParamFloat | MissionParamHour24 | MissionParamInt | MissionParamSong | MissionParamString | MissionParamType;

export type MissionParamContentCategory = {
  __typename: 'MissionParamContentCategory';
  category: ContentCategory;
};

export type MissionParamContentPack = {
  __typename: 'MissionParamContentPack';
  contentPack: ContentPack;
};

export type MissionParamFloat = {
  __typename: 'MissionParamFloat';
  value: Scalars['Float'];
};

export type MissionParamHour24 = {
  __typename: 'MissionParamHour24';
  value: Scalars['Int'];
};

export type MissionParamInt = {
  __typename: 'MissionParamInt';
  value: Scalars['Int'];
};

export type MissionParamSong = {
  __typename: 'MissionParamSong';
  playlists?: Maybe<Array<UserContentPack>>;
  song: Song;
  variantIds: Array<Scalars['ID']>;
};

export type MissionParamString = {
  __typename: 'MissionParamString';
  value: Scalars['String'];
};

export type MissionParamType = {
  __typename: 'MissionParamType';
  typeName: Scalars['String'];
};

export type MissionProgress = {
  __typename: 'MissionProgress';
  /**
   * Date when mission was claimed
   * (Null if not claimed yet)
   */
  claimedDate?: Maybe<Scalars['Date']>;
  /**
   * XP multiplier with which reward was claimed
   * (Null if not claimed yet)
   */
  claimedMultiplier?: Maybe<Scalars['Float']>;
  /**
   * Date when mission was completed (progress = 100%)
   * (Null if not completed yet)
   */
  completedDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  mission: Mission;
  progress: Scalars['Int'];
  progressGoal: Scalars['Int'];
  requiredLevel: Scalars['Int'];
};

export type MissionProgressSource = {
  __typename: 'MissionProgressSource';
  /**
   * Possible values:
   * - acceptUserToUserQuizTurnGameRequest
   * - answerTournamentRound:{roundId}
   * - answerUserToUserQuizLiveRound:{roundId}
   * - claimQuizLiveShowUserRoundReward:{roundId}
   * - claimUserToUserQuizTurnRound:{roundId}
   * - completeUserToUserQuizTurnRound:{roundId}
   * - createUserToUserQuizTurnRound
   * - createUserToUserQuizTurnRoundForRandom
   * - createUserToUserQuizTurnRoundForUser
   * - updateUserContentItemStatus:{contentItemId}
   * - upgradeUserContentPack:{contentPackId}
   * - sendTextMessage
   * - sendSafeTextMessage
   * - sendLiveShowSafeTextMessage
   * - sendStickerMessage
   * - sendImageMessage
   * - sendContentItemMessage
   * - upgradeItem
   */
  sourceId: Scalars['ID'];
};

export type MissionTask = {
  __typename: 'MissionTask';
  description?: Maybe<Scalars['String']>;
  /**
   * Parameters of mission task
   * Eg. if type is "Guess song X by artist Y", the parameters are X (a song) and Y (a pack)
   */
  params: Array<MissionParam>;
  paramsDescriptions: Array<Scalars['String']>;
  type: MissionTaskType;
};

export type MissionTaskInput = {
  params: Array<Scalars['String']>;
  type: MissionTaskType;
};

export enum MissionTaskParameterType {
  MISSIONPARAMCONTENTCATEGORY = 'MissionParamContentCategory',
  MISSIONPARAMCONTENTPACK = 'MissionParamContentPack',
  MISSIONPARAMFLOAT = 'MissionParamFloat',
  MISSIONPARAMHOUR24 = 'MissionParamHour24',
  MISSIONPARAMINT = 'MissionParamInt',
  MISSIONPARAMSONG = 'MissionParamSong',
  MISSIONPARAMSTRING = 'MissionParamString'
}

export type MissionTaskPayload = {
  __typename: 'MissionTaskPayload';
  description?: Maybe<Scalars['String']>;
  featureRequirements?: Maybe<Array<Maybe<LevelConfigUserFeatureUnlocked>>>;
  parameterDescriptions: Array<Maybe<Scalars['String']>>;
  parameterTypes?: Maybe<Array<Maybe<MissionTaskParameterType>>>;
};

export type MissionTaskTuple = {
  __typename: 'MissionTaskTuple';
  task: MissionTaskPayload;
  type: MissionTaskType;
};

export enum MissionTaskType {
  CHALLENGES_FRIEND = 'CHALLENGES_FRIEND',
  CHALLENGES_RANDOM = 'CHALLENGES_RANDOM',
  COMPLETE_COLLECTION_CUSTOM = 'COMPLETE_COLLECTION_CUSTOM',
  COMPLETE_COLLECTION_MP = 'COMPLETE_COLLECTION_MP',
  COMPLETE_COLLECTION_MUSIC = 'COMPLETE_COLLECTION_MUSIC',
  COMPLETE_COLLECTION_SPECIAL = 'COMPLETE_COLLECTION_SPECIAL',
  COMPLETE_FTUE = 'COMPLETE_FTUE',
  COMPLETE_MARATHON = 'COMPLETE_MARATHON',
  COMPLETE_MARATHON_24H = 'COMPLETE_MARATHON_24H',
  COMPLETE_MONTHLY_MISSIONS = 'COMPLETE_MONTHLY_MISSIONS',
  EARN_ACCOLADES = 'EARN_ACCOLADES',
  EARN_FESTIVAL_POINTS = 'EARN_FESTIVAL_POINTS',
  EARN_FRAGMENTS = 'EARN_FRAGMENTS',
  EARN_METAFRAGMENTS = 'EARN_METAFRAGMENTS',
  EARN_SHARDS = 'EARN_SHARDS',
  GET_BOOSTER_WHEEL_OF_FORTUNE = 'GET_BOOSTER_WHEEL_OF_FORTUNE',
  GET_CARDS = 'GET_CARDS',
  GET_COINS = 'GET_COINS',
  GET_COINS_WHEEL_OF_FORTUNE = 'GET_COINS_WHEEL_OF_FORTUNE',
  GET_FRIENDS = 'GET_FRIENDS',
  GET_OPPONENTS = 'GET_OPPONENTS',
  GET_STREAK_LIVE_GAME = 'GET_STREAK_LIVE_GAME',
  GET_STREAK_LIVE_SHOW = 'GET_STREAK_LIVE_SHOW',
  GET_STREAK_TOURNAMENT = 'GET_STREAK_TOURNAMENT',
  GET_STREAK_TURN_GAME = 'GET_STREAK_TURN_GAME',
  GET_TICKETS_WHEEL_OF_FORTUNE = 'GET_TICKETS_WHEEL_OF_FORTUNE',
  GUESS_ALL_SONGS_WRONG = 'GUESS_ALL_SONGS_WRONG',
  GUESS_ARTIST = 'GUESS_ARTIST',
  GUESS_SONG = 'GUESS_SONG',
  GUESS_SONGS = 'GUESS_SONGS',
  GUESS_SONGS_FAST = 'GUESS_SONGS_FAST',
  GUESS_SONGS_MARATHON = 'GUESS_SONGS_MARATHON',
  GUESS_SONGS_STARTING_WITH = 'GUESS_SONGS_STARTING_WITH',
  GUESS_TUNEOLOGY_SECONDS = 'GUESS_TUNEOLOGY_SECONDS',
  GUESS_TUNEOLOGY_TRIES = 'GUESS_TUNEOLOGY_TRIES',
  LEVEL_APP_SKINS = 'LEVEL_APP_SKINS',
  LEVEL_ARTIST_CONTENT_PACKS_TO_LEVEL = 'LEVEL_ARTIST_CONTENT_PACKS_TO_LEVEL',
  LEVEL_CONTENT_PACK = 'LEVEL_CONTENT_PACK',
  LEVEL_CONTENT_PACKS = 'LEVEL_CONTENT_PACKS',
  LEVEL_CONTENT_PACKS_TO_LEVEL = 'LEVEL_CONTENT_PACKS_TO_LEVEL',
  LEVEL_FRAMES = 'LEVEL_FRAMES',
  LEVEL_USER = 'LEVEL_USER',
  LOSE_GAMES_IN_A_ROW = 'LOSE_GAMES_IN_A_ROW',
  PLAY_ALL_CATEGORIES = 'PLAY_ALL_CATEGORIES',
  PLAY_ALL_DECADES = 'PLAY_ALL_DECADES',
  PLAY_BETWEEN_HOURS = 'PLAY_BETWEEN_HOURS',
  PLAY_CATEGORY = 'PLAY_CATEGORY',
  PLAY_DIFFERENT_CATEGORIES_TOURNAMENTS = 'PLAY_DIFFERENT_CATEGORIES_TOURNAMENTS',
  PLAY_DIFFERENT_CONTENT_PACKS = 'PLAY_DIFFERENT_CONTENT_PACKS',
  PLAY_DIFFERENT_LOCALES_CONTENT_PACK = 'PLAY_DIFFERENT_LOCALES_CONTENT_PACK',
  PLAY_LIVE_GAMES = 'PLAY_LIVE_GAMES',
  PLAY_LIVE_MM = 'PLAY_LIVE_MM',
  PLAY_LIVE_SHOW = 'PLAY_LIVE_SHOW',
  PLAY_TOURNAMENTS = 'PLAY_TOURNAMENTS',
  PLAY_TURN_GAMES = 'PLAY_TURN_GAMES',
  REACH_MARATHON_MILESTONE5 = 'REACH_MARATHON_MILESTONE5',
  SCORE_TOTAL_TOURNAMENT = 'SCORE_TOTAL_TOURNAMENT',
  SCORE_TOTAL_TURN_GAME = 'SCORE_TOTAL_TURN_GAME',
  SCORE_TOURNAMENT = 'SCORE_TOURNAMENT',
  SCORE_TURN_GAME = 'SCORE_TURN_GAME',
  SEND_EMOJI_FRIEND = 'SEND_EMOJI_FRIEND',
  SEND_EMOJI_TEAM = 'SEND_EMOJI_TEAM',
  SEND_EXTERNAL_CHALLENGES = 'SEND_EXTERNAL_CHALLENGES',
  SEND_GIFT = 'SEND_GIFT',
  SEND_GIFTS = 'SEND_GIFTS',
  SPEND_ACCOLADES = 'SPEND_ACCOLADES',
  SPEND_COINS = 'SPEND_COINS',
  SPEND_DIAMONDS = 'SPEND_DIAMONDS',
  SPEND_LIVE_MM_BEATS = 'SPEND_LIVE_MM_BEATS',
  SPEND_LIVE_MM_TICKETS = 'SPEND_LIVE_MM_TICKETS',
  SPIN_WHEEL_OF_FORTUNE = 'SPIN_WHEEL_OF_FORTUNE',
  TEAM_HEAT_BONUS = 'TEAM_HEAT_BONUS',
  TEAM_HEAT_STREAK = 'TEAM_HEAT_STREAK',
  TUNEOLOGY_STREAK = 'TUNEOLOGY_STREAK',
  UPGRADE_BADGE_BRONZE = 'UPGRADE_BADGE_BRONZE',
  UPGRADE_BADGE_GOLD = 'UPGRADE_BADGE_GOLD',
  UPGRADE_BADGE_SILVER = 'UPGRADE_BADGE_SILVER',
  UPGRADE_POSTER_LVL2 = 'UPGRADE_POSTER_LVL2',
  UPGRADE_POSTER_LVL3 = 'UPGRADE_POSTER_LVL3',
  USE_APP_SKIN = 'USE_APP_SKIN',
  USE_ARTIST_ONLYS = 'USE_ARTIST_ONLYS',
  USE_BOMBS = 'USE_BOMBS',
  USE_DIFFERENT_FRAMES = 'USE_DIFFERENT_FRAMES',
  USE_DIFFERENT_STICKERS = 'USE_DIFFERENT_STICKERS',
  USE_FRAME = 'USE_FRAME',
  USE_FRIEND = 'USE_FRIEND',
  USE_HURDLE_HINT = 'USE_HURDLE_HINT',
  USE_HURDLE_HINT_TEAM = 'USE_HURDLE_HINT_TEAM',
  USE_LIKES = 'USE_LIKES',
  USE_NINJAS = 'USE_NINJAS',
  USE_REMOVE2 = 'USE_REMOVE2',
  USE_REMOVE2_MARATHON = 'USE_REMOVE2_MARATHON',
  USE_SAVES = 'USE_SAVES',
  USE_SPEEDSTERS = 'USE_SPEEDSTERS',
  USE_STICKER = 'USE_STICKER',
  USE_TEAM_MESSAGE = 'USE_TEAM_MESSAGE',
  WIN_LIVE_GAMES = 'WIN_LIVE_GAMES',
  WIN_LIVE_MM = 'WIN_LIVE_MM',
  WIN_TOURNAMENT = 'WIN_TOURNAMENT',
  WIN_TURN_GAMES = 'WIN_TURN_GAMES',
  WIN_TURN_GAMES_IN_A_ROW = 'WIN_TURN_GAMES_IN_A_ROW'
}

export type ModerateContentItemInput = {
  id: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  noteType?: InputMaybe<ModeratedContentItemNoteType>;
  state: ModeratedContentItemState;
};

export type ModeratedContentItem = {
  __typename: 'ModeratedContentItem';
  admin?: Maybe<User>;
  adminState?: Maybe<ModeratedContentItemState>;
  contentItem: CurationContentItem;
  curationContentPack?: Maybe<CurationContentPack>;
  id: Scalars['ID'];
  locale: Scalars['String'];
  moderator?: Maybe<User>;
  note?: Maybe<Scalars['String']>;
  noteType?: Maybe<ModeratedContentItemNoteType>;
  state: ModeratedContentItemState;
  stateUpdated?: Maybe<Scalars['Date']>;
};

export enum ModeratedContentItemNoteType {
  ALBUM = 'ALBUM',
  ARTIST = 'ARTIST',
  ERROR = 'ERROR',
  EXPLICIT = 'EXPLICIT',
  LYRICS = 'LYRICS',
  TITLE = 'TITLE'
}

export type ModeratedContentItemPaginated = {
  __typename: 'ModeratedContentItemPaginated';
  hasMore: Scalars['Boolean'];
  list: Array<ModeratedContentItem>;
  totalCount: Scalars['Int'];
};

export enum ModeratedContentItemState {
  CLEAN = 'CLEAN',
  ERROR = 'ERROR',
  EXPLICIT = 'EXPLICIT',
  QUESTIONABLE = 'QUESTIONABLE',
  TO_BE_REVIEWED = 'TO_BE_REVIEWED'
}

export type MonitoringRequestNamesInput = {
  type: MetricType;
};

/**
 * Positive modifier the user can earn.
 * Is valid until the month ends
 */
export type MonthlyBuff = {
  __typename: 'MonthlyBuff';
  buffType?: Maybe<MonthlyBuffType>;
  /** multiplier is a buff increase factor which is cumulative, it is added to the value of the current buff. */
  multiplier: Scalars['Int'];
};

export enum MonthlyBuffType {
  COIN = 'COIN',
  XP = 'XP'
}

export type MonthlyPass = {
  __typename: 'MonthlyPass';
  /**
   * The assetConfig are retreived through multiple source:
   * - the last level json file from the current monthlyPass vinyl reward
   * eg (january 2022): https://storage.googleapis.com/songpop3-assets/sp3/vinyls/1b43a93b-a16d-405b-951a-83befdb8e91f/musicFestivalThemeLvl3.json
   * - the last level frame / sticker rewards
   */
  assetsConfig: MonthlyPassAssetsConfig;
  ends: Scalars['Date'];
  id: Scalars['ID'];
  leaderboard?: Maybe<Leaderboard>;
  leaderboardRankGroups: Array<LbRankGroup>;
  levels: Array<LevelConfigMonthlyPass>;
  /**
   * This endpoint is used to view the global mission config for a monthly pass.
   * The FE should use UserMonthlyPass.missions instead, which also includes the user's progress on each mission.
   */
  missions?: Maybe<MonthlyPassMissions>;
  month: Scalars['Int'];
  monthId: Scalars['ID'];
  starts: Scalars['Date'];
  teamHeatIterations: Array<Maybe<TeamHeatIteration>>;
  teamMonthlyPassLeaderboard: TeamLeaderboardEntriesPayload;
  teamRankGroups: Array<LbRankGroup>;
  year: Scalars['Int'];
};


export type MonthlyPassTeamMonthlyPassLeaderboardArgs = {
  after?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['Int']>;
  rank?: InputMaybe<Scalars['Int']>;
};

export type MonthlyPassAssetsConfig = {
  __typename: 'MonthlyPassAssetsConfig';
  animatedOverlay?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
  character?: Maybe<Scalars['String']>;
  emoji?: Maybe<Scalars['String']>;
  frame?: Maybe<Scalars['String']>;
  palette?: Maybe<Scalars['String']>;
  sticker?: Maybe<Scalars['String']>;
  vinyl?: Maybe<Scalars['String']>;
};

export type MonthlyPassMissions = {
  __typename: 'MonthlyPassMissions';
  dailyMissions: Array<Mission>;
  extraMissions: Array<Mission>;
  id: Scalars['ID'];
  monthlyMissions: Array<Mission>;
  teamMissions: Array<Mission>;
};

export type MonthlyPassMissionsPayload = {
  __typename: 'MonthlyPassMissionsPayload';
  missions: MonthlyPassMissions;
};

export type MonthlyPassPaginated = {
  __typename: 'MonthlyPassPaginated';
  hasMore: Scalars['Boolean'];
  list: Array<MonthlyPass>;
  totalCount: Scalars['Int'];
};

export type MonthlyPassRankGroupInput = {
  maxRank: Scalars['Int'];
  minRank: Scalars['Int'];
  rewards: Array<LevelRewardInput>;
};

export type MusicReport = {
  __typename: 'MusicReport';
  completed?: Maybe<Scalars['Date']>;
  created: Scalars['Date'];
  formattedDate: Scalars['String'];
  id: Scalars['ID'];
  jobIdStep2?: Maybe<Scalars['String']>;
  jobIdStep3?: Maybe<Scalars['String']>;
  lastSuccessStep: Scalars['String'];
  sp2StatusDone: Scalars['Boolean'];
  sp3StatusDone: Scalars['Boolean'];
  step6StatusDone: Scalars['Boolean'];
};

export type MusicReportPaginated = {
  __typename: 'MusicReportPaginated';
  hasMore: Scalars['Boolean'];
  list: Array<MusicReport>;
  totalCount: Scalars['Int'];
};

export type MusicReportPayload = {
  __typename: 'MusicReportPayload';
  report?: Maybe<MusicReport>;
};

export type Mutation = {
  __typename: 'Mutation';
  acceptFriendRequest: FriendRequestPayload;
  acceptTeamMemberInvite: TeamPayload;
  acceptTeamQuizLiveGameRequest: AcceptTeamQuizLiveGameRequestPayload;
  acceptUserToUserQuizLiveGameRequest: UserToUserQuizLiveGamePayload;
  acceptUserToUserQuizTurnGameRequest: AcceptUserToUserQuizTurnGameRequestPayload;
  activateBoostsInLiveGame: UserToUserQuizLiveRoundPayload;
  activateBoostsInTournamentRound: ActivateBoostsInTournamentRoundPayload;
  activateBoostsInTurnGame: ActivateBoostsInTurnGamePayload;
  /** @deprecated abtest lost */
  activateInternalFreeTrial: ActivateInternalFreeTrialPayload;
  activateTeamHeatBoost: TeamBoostMutationPayload;
  activateUnlimitedBoost: ActivateUnlimitedBoostPayload;
  addCandidate: GenPromotionPayload;
  /** Add a song or a list of songs to a CCP */
  addDDEXSongToCurationContentPack: CurationContentPackPayload;
  addFriendByInviteCode: FriendRequestPayload;
  /**
   * Add a song or a list of songs to a CCP
   * @deprecated No longer supported
   */
  addItunesSongToCurationContentPack: CurationContentPackPayload;
  addLiveEventContentPack: AddLiveEventContentPackPayload;
  addSpecialEventContentPack: AddSpecialEventContentPackPayload;
  addSpecialEventQuizLiveShow: AddSpecialEventQuizLiveShowPayload;
  addSpecialEventTournament: AddSpecialEventTournamentPayload;
  addTeamLeader: TeamPayload;
  addUserEmojiPack: UserEmojiPackCommonPayload;
  adminLinkEmailCredential: AdminLinkEmailCredentialPayload;
  /** Admin has reviewed the content item (and overwrite the state from the contentModerator) */
  adminModerateContentItem: ModeratedContentItem;
  adminSendSignInLinkToUser: AdminSendSignInLinkPayload;
  advanceBadge: AdvanceBadgePayload;
  /** Save results of user and return the updated user results */
  answerHurdleQuiz: AnswerHurdleQuizPayload;
  answerMultiQuizLiveShow: AnswerLiveShowPayload;
  answerQuizLiveShow: AnswerLiveShowPayload;
  /**
   * If the answer is sent after the tournament end, player answers will not be saved (no coin / xp etc...)
   * A tournament ticket will be refunded, speedsterboost too if used, and this last tournamentRound.state will be TournamentRoundState.TOO_LATE
   */
  answerTournamentRound: AnswerTournamentRoundPayload;
  answerUserToUserQuizLiveRound: UserToUserQuizLiveRoundPayload;
  /** Only used for AppCenter Test. This endpoint does nothing for beta/production */
  applyUserSubscriptionUpdateLog: ApplyUserSubscriptionUpdateLogPayload;
  archiveUserToUserQuizTurnGame: ArchiveUserToUserQuizTurnPayload;
  /**
   * Authenticates the backend with the Google Sheets API, in order to retrieve the data to refresh SPP configuration files
   * @deprecated No longer needed by the admin
   */
  authenticateGoogleSheet: NoReturnMutationPayload;
  /** Ban user (can be done from the admin interface for example) */
  banUser: BanPlayedPayload;
  /**
   * Used to commit multiple CCPs at the same time.
   * Not used by the admin website, only by the Python script scripts/sp2_playlist_migration
   * @deprecated No longer supported
   */
  batchCommitCurationContentPack: MigrateSp2PlaylistsPayload;
  /** Blocking a user will make them unable to send you a challenge (turn or live), a friend request or any chat message */
  blockUser: BlockUserPayload;
  buyTeamShopItem: BuyTeamShopItemPayload;
  cancelLiveEventMatchmaking: CancelLiveEventMatchmakingPayload;
  cancelLiveEventRound: CancelLiveEventRoundPayload;
  cancelTeamQuizLiveGameRequest: CancelTeamQuizLiveGameRequestPayload;
  castVote: GenPromotionPayload;
  challengeSP2Opponent: ChallengeSp2OpponentPayload;
  changeAvailableDateYearInReview?: Maybe<YearInReview>;
  claimAvailableTeamHeatMilestones: AvailableTeamHeatMilestonePayload;
  claimCalendarReward: CalendarPayload;
  /**
   * @throw INVALID_CHAINED_OFFER_EVENT_ID
   * @throw ALREADY_CLAIMED_ALL_STEPS
   * @throw WRONG_INPUT # no sku for claimType == BUY
   */
  claimChainedOfferPack: ClaimChainedOfferPackPayload;
  claimCollectionReward: ClaimCollectionRewardPayload;
  claimCurrentAdsReward: ClaimCurrentAdsRewardPayload;
  claimCurrentDailyBonus: ClaimCurrentDailyBonusPayload;
  claimGift: User;
  /** Claim the rewards for the quiz, returning the updated user results */
  claimHurdleRewards: ClaimHurdleRewardsPayload;
  /**
   * This new mutation will let the FE claim one reward no matter the level and the tier.
   * If some rewards (below the current reward in terms of level/tier) are not claimed yet, they will stay unclaimed.
   */
  claimLevelUserReward: ClaimLevelUserRewardPayload;
  /**
   * The FE is now responsible of claiming which levels and for which subscriptionTier it wants to claim the rewards
   * If some rewards (below the current reward in terms of level/tier) are not claimed yet, they will be claimed at the same time.
   * @deprecated Replaced by claimLevelUserReward
   */
  claimLevelUserRewards: ClaimLevelUserRewardsPayload;
  claimLiveEventShopItem: ClaimLiveEventShopItemPayload;
  claimLoyaltyCampaignCard: ClaimLoyaltyCampaignCardPayload;
  claimLoyaltyCardDay: ClaimLoyaltyCardDayPayload;
  claimMarathonMilestone: ClaimMarathonMilestonePayload;
  claimMission: ClaimMissionPayload;
  claimMonthlyPassLeaderboardRewards: ClaimMonthlyPassLeaderboardRewardsPayload;
  claimPromotion: ClaimPromotionPayload;
  /** Calculate the round rewards for user, but does not update in db. Used only to show information on the user screen */
  claimQuizLiveShowUserRoundReward: ClaimQuizLiveShowUserRoundRewardPayload;
  claimReferralReward: ReferralRewardPayload;
  claimReturningGift: ClaimReturningGiftPayload;
  claimSpecialEventMilestoneReward: ClaimSpecialEventMilestoneRewardPayload;
  claimSpecialEventRankGroupReward: ClaimSpecialEventRankGroupRewardPayload;
  /**
   * @throw NO_FRAGMENTS_TO_CLAIM
   * @throw INVALID_STARTER_PACK_ID
   * @throw STARTER_PACK_NOT_AVAILABLE
   * @throw STARTER_PACK_ALREADY_CLAIMED
   */
  claimStarterPackFragments: ClaimStarterPackFragmentsPayload;
  claimTeamMonthlyPassRewards: ClaimTeamMonthlyPassRewardPayload;
  claimTournamentMilestoneReward: ClaimTournamentMilestoneRewardPayload;
  claimTournamentRankGroupReward: ClaimTournamentRankGroupRewardPayload;
  claimUpdateGift: ClaimUpdateGiftPayload;
  /**
   * This new mutation will let the FE claim one reward no matter the level and the tier.
   * If some rewards (below the current reward in terms of level/tier) are not claimed yet, they will stay unclaimed.
   */
  claimUserMonthlyPassReward: ClaimUserMonthlyPassRewardPayload;
  /**
   * The FE is now responsible of claiming which levels and for which subscriptionTier it wants to claim the rewards
   * If some rewards (below the current reward in terms of level/tier) are not claimed yet, they will be claimed at the same time.
   * @deprecated Replaced by claimUserMonthlyPassReward
   */
  claimUserMonthlyPassRewards: ClaimUserMonthlyPassRewardsPayload;
  claimUserToUserQuizTurnRound: ClaimUserToUserQuizTurnRoundPayload;
  clearAllLoyaltyCampaignConfigs: Scalars['Boolean'];
  /**
   * Commits a CCP. Performs checks on the songs, and if there are more than a certain number of valid songs, creates
   * the ContentPack object and makes it available in the game.
   */
  commitCurationContentPack: CurationContentPackPayload;
  commitSP2CurationPlaylist: Sp2CurationContentPackPayload;
  completeFTUEStep: CompleteFtueStepPayload;
  /** Complete the UserHurdleQuiz */
  completeUserHurdleQuiz: CompleteUserHurdleQuizPayload;
  completeUserToUserQuizTurnRound: CompleteUserToUserQuizTurnRoundPayload;
  /** Converts all the samples of a CCP to a given format */
  convertSamples: NoReturnMutationPayload;
  /** Converts all the samples of a CCP to a given format */
  convertToSp2Samples: NoReturnMutationPayload;
  copyQuizLiveShow: QuizLiveShow;
  copyTournament: TournamentPayload;
  craftItem: ItemPayload;
  createABTest: CreateAbTestPayload;
  createAppVersionConfig: Array<AppVersionConfig>;
  createBackendDeploymentImportantEvent: ImportantEvent;
  createBadge: CreateBadgePayload;
  /**
   * Create the batch. Will look at all the curationContentPack not yet reviewed and create an entry for them.
   * You cannot create a new batch if there's one still in progress
   */
  createBatchContentModeration: BatchContentModeration;
  createCalendarAdmin: PaidCalendar;
  createChainedOfferEvent?: Maybe<CreateChainedOfferEventPayload>;
  createCollection: Collection;
  createContentPackList: ContentPackList;
  /** Creates a CCP from a list of Spotify artist IDs */
  createCurationContentPackByArtists: CurationContentPackPayload;
  /** Creates a CCP from a CSV file upload */
  createCurationContentPackByCSV: CurationContentPackPayload;
  /** Creates a CCP from a Spotify URI */
  createCurationContentPackByUrl: CurationContentPackPayload;
  /** Creates a CCP from a SP2 production playlist ID */
  createCurationContentPackFromSp2: CurationContentPackPayload;
  /**
   * Creates CCPs from list of SP2 production playlist IDs
   * Won't output anything, it just schedules a task
   */
  createCurationContentPackFromSp2Multi?: Maybe<CreateCurationContentPackFromSp2MultiPayload>;
  createCurationContentPackList: CurationContentPackList;
  /** Creates a new version of a CCP */
  createCurationContentPackNewDraft: CurationContentPackPayload;
  createCustomImportantEvent: ImportantEvent;
  createEmojiPack: CreateEmojiPackPayload;
  createExportRequest: CreateExportRequestPayload;
  createFrontendDeploymentImportantEvent: ImportantEvent;
  createGiftAdmin: IapGiftDraft;
  /** Create */
  createHurdleCatalogItem: CreateHurdleCatalogItemPayload;
  /** Plan an unplaned hurdle */
  createHurdleQuiz: CreateHurdleQuizPayload;
  createItem: CreateItemPayload;
  createLiveEvent: LiveEventPayload;
  createLoyaltyCampaignCard: LoyaltyCampaignCard;
  createMMilestonesTemplate?: Maybe<CreateMmTemplatePayload>;
  createMarathonEvent: CreateMarathonEventPayload;
  createMessageTemplate: Array<MessageTemplate>;
  createMonthlyPass: UpdatedMonthlyPassPayload;
  createPoster: Poster;
  createPracticeQuiz: CreatePracticeQuizInputPayload;
  createSaleEvent: CreateSaleEventPayload;
  createSpecialEvent: SpecialEventPayload;
  /**
   * For internal dev only - to use by the frontend to create a 30 min special event with:
   * - 1 tournament starting with the special event but end 5 min before
   * - 1 liveshow (preset: dev) that will start 5 minutes after the liveEvent startDate
   * - 1 random contentPack
   */
  createSpecialEventSample: SpecialEventPayload;
  createTeam: TeamPayload;
  createTeamShopItem: TeamShopPaginated;
  createTournament: TournamentPayload;
  createUnsupportedPopupConfig: UnsupportedPopupConfig;
  createUserToUserQuizTurnRound: CreateUserToUserQuizTurnRoundPayload;
  createUserToUserQuizTurnRoundForInfluencer: CreateUserToUserQuizTurnRoundForInfluencerPayload;
  createUserToUserQuizTurnRoundForInvite: CreateUserToUserQuizTurnRoundForInvitePayload;
  createUserToUserQuizTurnRoundForRandom: CreateUserToUserQuizTurnRoundForRandomPayload;
  createUserToUserQuizTurnRoundForUser: CreateUserToUserQuizTurnRoundForUserPayload;
  createWFRewardTemplate?: Maybe<CreateWfrTemplatePayload>;
  createWheelFortuneEvent: CreateWfEventPayload;
  /** Schedule SP2 release (i.e will appear in SP2 shop) */
  crupdateSP2Release: CrupdateSp2ReleasePayload;
  declineFriendRequest: FriendRequestPayload;
  declineTeamMemberInvite: DeclineTeamMemberInvitePayload;
  declineUserToUserQuizLiveGameRequest: UserToUserQuizLiveGamePayload;
  /** Can only be used on test ENV, use updateABTest status = ABTestStatus.ARCHIVED on beta/prod ENV */
  deleteABTest: DeleteAbTestPayload;
  deleteAppVersionConfig: Array<AppVersionConfig>;
  deleteChainedOfferEvent?: Maybe<DeleteChainedOfferEventPayload>;
  /** Returns whether the specified ContentPackList existed beforehand. */
  deleteContentPackList: Scalars['Boolean'];
  /** Deletes a CCP */
  deleteCurationContentPack: CurationContentPackPayload;
  /** Returns whether the specified ContentPackList existed beforehand. */
  deleteCurationContentPackList: Scalars['Boolean'];
  deleteEmoji: Scalars['ID'];
  deleteEmojiPack: Scalars['ID'];
  /** Delete */
  deleteHurdleCatalogItem: DeleteHurdleCatalogItemPayload;
  deleteImportantEvent: DeleteImportantEventPayload;
  deleteLoyaltyCampaignCard: Scalars['Boolean'];
  deleteLoyaltyCampaignConfig: Scalars['Boolean'];
  deleteLoyaltyCampaignGroup: Scalars['Boolean'];
  deleteLoyaltyCampaignSubgroup: Scalars['Boolean'];
  deleteMMilestonesTemplate: Scalars['Boolean'];
  deleteMarathonEvent: Scalars['Boolean'];
  deleteMessageTemplate: Array<MessageTemplate>;
  /** Delete scheduled SP2 release */
  deleteSP2Release: CrupdateSp2ReleasePayload;
  /** Can't be used on Sale.isHardCoded = true */
  deleteSaleEvent: DeleteSaleEventPayload;
  deleteTeamShopItem: TeamShopPaginated;
  deleteUnsupportedPopupConfig: Scalars['ID'];
  deleteUpdateGiftHistory: Scalars['Boolean'];
  deleteUser: DeleteUserPayload;
  deleteUserCalendar: User;
  deleteUserEmojiPack: UserEmojiPackCommonPayload;
  deleteWFRewardTemplate: Scalars['Boolean'];
  deleteWheelFortuneEvent: Scalars['Boolean'];
  demoteTeamLeader: TeamPayload;
  editMessageTemplate: Array<MessageTemplate>;
  /** Apply the content moderation to the songs */
  endBatchContentModeration: BatchContentModeration;
  endUserToUserQuizLiveGame: UserToUserQuizLiveGamePayload;
  /** Exports the CCP to SP2 */
  exportCurationContentPackToSp2: CurationContentPackPayload;
  /** Starts a music catalog export */
  exportMusicCatalog: ExportMusicCatalogPayload;
  exportUser: ExportUserPayload;
  finishMarathonRound: FinishMarathonPayload;
  /** Notify servers to refresh the in-memory cache */
  flushHurdleCache: FlushHurdleCachePayload;
  flushMarathonContentPacksCache: Scalars['Boolean'];
  flushRedisCache: FlushRedisCachePayload;
  flushRedisCacheForOneUser: FlushRedisCacheForOneUserPayload;
  forceGrantMPLeaderboardRewards: Scalars['Boolean'];
  forceMissionProgress: ForceMissionProgressPayload;
  /** Forces the matching of a SongInput to a manual input */
  forceSongInputMatching: ForceSongInputMatchingPayload;
  forceUpdateUser: ForceUpdateUserPayload;
  forceUserABTest: ForceUserAbTestPayload;
  generateCombinedMusicReport: MusicReportPayload;
  /** Generate hurdle quizzes */
  generateHurdleQuizzes: GenerateHurdleQuizzesPayload;
  generateMarathonQuestions: GenerateMarathonQuestionsPayload;
  generateReport: GenerateReportPayload;
  generateSP2ReportingTable: GenerateReportPayload;
  ghostQuizLiveShow: GhostQuizLiveShowPayload;
  giftTutorialBadges: GiftTutorialBadgesPayload;
  grantTutorialEmojiPack: GrantTutorialEmojiPackPayload;
  grantUserBadgeAdmin: UserBadgeAdminPayload;
  /** Starts an iTunes database ingestion */
  importItunesDatabase: ImportItunesDatabasePayload;
  /** Batch import some songs from a content pack list, returning status of the import */
  importSongsFromContentPackListToHurdleCatalog: ImportSongsFromContentPackListToHurdleCatalogPayload;
  initMonthlyPassMissions: MonthlyPassMissionsPayload;
  initSpecialEventMissions: SpecialEventMissionsPayload;
  inviteSP2Opponent: InviteSp2OpponentPayload;
  joinQuizLiveShow: JoinQuizLiveShowPayload;
  joinTeam: TeamPayload;
  kickTeamMember: TeamPayload;
  leaveTeam: TeamPayload;
  likeContentItemUserToUserQuizLiveRound: UserToUserQuizLiveRoundPayload;
  linkCredential: LinkCredentialPayload;
  linkToSp2: Sp2LinkResult;
  linkToSp2Admin: Sp2LinkResult;
  linkToSp2WithToken: Sp2LinkResult;
  /** Starts a music catalog export */
  makeMusicCatalogAvailable: MakeMusicCatalogAvailablePayload;
  markMessagesAsRead: ConversationPayload;
  markRoundAsStarted: MarkRoundAsStartedPayload;
  /** Mark a song input as outdated, meaning the matching algorithm will try to update it next time it operates */
  markSongInputsAsOutdated: MarkSongInputsAsOutdatedPayload;
  markYearInReviewAsSeen?: Maybe<YearInReview>;
  /**
   * Migrates playlists from SP2 to SP3 based on the Masterfile. The process still works, but we don't use it anymore.
   * It might be useful if we want to reset the Test DB. Works with the Python script scripts/sp2_playlist_migration
   * @deprecated No longer supported
   */
  migrateSP2Playlists: MigrateSp2PlaylistsPayload;
  /** Content Moderator has reviewed the content item (and leave a note if it's marked as questionable) */
  moderateContentItem: ModeratedContentItem;
  pickUserToUserQuizLiveRoundContentPack: UserToUserQuizLiveRoundPayload;
  /** Trigger the onUserToUserPing subscription for the opponent if he is online */
  pingUserToUser: PingUserToUserPayload;
  processExportRequest: ProcessExportRequestPayload;
  /**
   * @throw INVALID_BOOSTPACK_ID
   * @throw NOT_ENOUGH_CURRENCY
   */
  purchaseBoostPack: PurchaseBoostPackPayload;
  purchaseCalendar: CalendarPayload;
  /**
   * On IOS, if purchasing with a Sandbox receipt, the user has to have the role ADMIN.
   * @throw INVALID_SKU
   * @throw PURCHASE_VALIDATION_FAILED
   * @throw WRONG_RECEIPT_FOR_SKU
   * @throw PURCHASE_ACKNOWLEDGEMENT_FAILED
   *
   * @throw ALREADY_PURCHASED
   * @throw INVALID_SKU
   */
  purchaseCurrencyPack: PurchaseCurrencyPackPayload;
  purchaseEmoji: PurchaseEmojiPayload;
  purchaseItem: ItemPayload;
  /** @throw INVALID_SKU */
  purchasePiggyBank: PurchasePiggyBankPayload;
  purchaseSaleBundlePack: PurchaseSaleBundlePackPayload;
  /**
   * @throw INVALID_STARTERPACK_ID
   * @throw NOT_ENOUGH_CURRENCY
   * @throw STARTER_PACK_NOT_YET_AVAILABLE
   */
  purchaseStarterPack: PurchaseStarterPackPayload;
  purchaseSubscription: PurchaseSubscriptionPayload;
  /** @throw INVALID_SKU */
  purchaseSubscriptionDays: PurchaseSubscriptionDaysPayload;
  refillEmptyCap: RefillEmptyCapPayload;
  /**
   * Refreshes the SongPop Party content configuration files based on a Google spreadsheet
   * @deprecated No longer needed by the admin
   */
  refreshSppContent: NoReturnMutationPayload;
  refreshUserRedisCache: RefreshUserRedisCachePayload;
  refundLiveShowUserBoosts: RefundLiveShowUserBoostsPayload;
  /** @deprecated No longer used */
  registerAppsFlyerId: RegisterAppsFlyerIdPayload;
  /** @deprecated No longer used */
  registerSingularDeviceId: RegisterSingularDeviceIdPayload;
  removeBadge: RemoveBadgePayload;
  removeCalendarAdmin: RemoveCalendarAdminPayload;
  removeCollection: RemoveCollectionPayload;
  removeDraftGiftAdmin: RemoveDraftGiftAdminPayload;
  /**
   * Development purpose to avoid to create multiple user for each front-end tests
   * Will remove the corresponding SP3Frienship and SP3UserToUser records in DB
   */
  removeFriend: RemoveFriendPayload;
  removeLiveEvent: RemoveLiveEventPayload;
  removeLiveEventContentPack: RemoveLiveEventContentPackPayload;
  removeLiveShow: RemoveLiveShowPayload;
  removePoster: RemovePosterPayload;
  /** Removes a song or a list of songs from a CCP */
  removeSongFromCurationContentPack: CurationContentPackPayload;
  removeSpecialEvent: RemoveSpecialEventPayload;
  removeSpecialEventContentPack: RemoveSpecialEventContentPackPayload;
  removeSpecialEventQuizLiveShow: RemoveSpecialEventQuizLiveShowPayload;
  removeSpecialEventTournament: RemoveSpecialEventTournamentPayload;
  /** Remove a tournament */
  removeTournament: RemoveTournamentPayload;
  /** Reorder songs from a CCP */
  reorderSongsFromCurationContentPack: CurationContentPackPayload;
  /** Replace the ddex result from the matching */
  replaceDDEXSongMatch: ReplaceDdexSongMatchPayload;
  reportSongListenCount: ReportSongListenCountPayload;
  reportSongSample: ReportSongSamplePayload;
  /**
   * If 3 different people report the same user, its user role is BANNED.
   * This action doesn't have any effect for bot users.
   * Banned users can still play the game, but:
   * - user name replaced by a safe name (same as for kids),
   * - profile picture replaced by default avatar,
   * - no user generated content (custom chat message and photo are disabled).
   * Note: Comments must be fewer than 500 bytes (in UTF-8).
   */
  reportUser: ReportUserPayload;
  requestSp2LinkToken: Sp2LinkTokenPayload;
  rescheduleQuizLiveShow: QuizLiveShow;
  /** QA/debug helper to clear the saved age-gate completion marker for current user. */
  resetAgeGateShownForCurrentUser: Scalars['Boolean'];
  resetClaimedTeamHeatMilestones: ResetTeamHeatClaimedMilestonesPayload;
  resetDailyEmojis: Scalars['Int'];
  resetEmojiPackTutorial: UserEmojiPackCommonPayload;
  /** Reset the UserHurdleQuiz */
  resetHurdleQuiz: ResetHurdleQuizPayload;
  resetLiveGameMemory: ResetLiveGameMemoryPayload;
  resetLoyaltyCard: ResetLoyaltyCardPayload;
  resetMissionProgress: ResetMissionProgressPayload;
  /** For dev purpose only (deactivated on beta/prod) */
  resetPromotion: ResetPromotionPayload;
  resetQuizLiveShowRoundQuestions: QuizLiveShow;
  /** Only available on test / beta */
  resetSpecialOfferRewards: ResetSpecialOfferRewardsPayload;
  resetUserLoyaltyCampaignProgress: User;
  resetUserMarathonEvent: ResetUserMarathonEventPayload;
  resetUserSubscriptions: ResetUserSubscriptionsPayload;
  resumeMarathonRound: ResumeMarathonPayload;
  /** Retries to generate all the song external links. Used only by scripts. */
  retryCurationExternalLinks: RetryCurationExternalLinksPayload;
  /**
   * Retries to match songs based on a list of SongInput IDs or Song IDs.
   * Used by the script scripts/curation/rematchSongs/index.ts
   */
  retryCurationMatching: RetryCurationMatchingPayload;
  retryGiftAdmin: IapGiftDraft;
  reviveLoyaltyCard: ReviveLoyaltyCardPayload;
  reviveLoyaltyCardDay: ReviveLoyaltyCardDayPayload;
  revokeUserBadgeAdmin: RevokeUserBadgeAdminPayload;
  /**
   * Saves user's device country code once for legal checks.
   * If already saved, existing value is kept.
   */
  saveAgeGateCountryCode: Scalars['String'];
  saveMarathonRound: SaveMarathonPayload;
  saveUserContentPack: UserContentPackPayload;
  scheduleQuizLiveShowRoundEncryption: QuizLiveShow;
  selectAppSkin: UserPayload;
  selectBadge: SelectBadgePayload;
  /** Send the itemId: "default" to empty the profile frame */
  selectProfileFrame: UserPayload;
  sendContentItemMessage: MessagePayload;
  sendFriendRequest: FriendRequestPayload;
  sendGift: User;
  sendImageMessage: MessagePayload;
  sendLiveShowSafeTextMessage: MessagePayload;
  sendLiveShowStickerMessage: MessagePayload;
  sendMessageUserToUserQuizLiveRound: UserToUserQuizLiveRoundPayload;
  sendNotification?: Maybe<Scalars['String']>;
  sendQuizLiveShowWinnerSticker: SendWinnerStickerPayload;
  sendRetentionReminder?: Maybe<Scalars['String']>;
  sendSafeTextMessage: MessagePayload;
  sendStickerMessage: MessagePayload;
  sendTeamMemberInvite: SendTeamMemberInvitePayload;
  sendTeamQuizLiveGameRequest: SendTeamQuizLiveGameRequestPayload;
  sendTextMessage: MessagePayload;
  sendUserToUserQuizLiveGameRequest: UserToUserQuizLiveGamePayload;
  setActiveEmojiPack: SetActiveEmojiPackPayload;
  setLatestUpdateGift: LatestUpdateGift;
  setModeratorToContentPack?: Maybe<BatchContentModerationPack>;
  setStickerPosition: SetStickerPositionPayload;
  /** Admin mutation to set subscription expires date for a user or a transaction. */
  setSubscriptionExpires: SetSubscriptionExpiresPayload;
  setSubscriptionTier: UpdateSubscriptionTierPayload;
  setUserBadgeLevelAdmin: UserBadgeAdminPayload;
  setUserContentItemPosition: SetUserContentItemPositionPayload;
  setUserContentPackPosition: SetUserContentPackPositionPayload;
  setUserLoyaltyCampaignProgress: User;
  shiftLoyaltyCard: ShiftLoyaltyCardPayload;
  /** @throw Account not found */
  signIn: SignInPayload;
  signOut: SignOutPayload;
  signUp: SignInPayload;
  spinWheelFortune: SpinWheelFortunePayload;
  startBatchContentModeration: BatchContentModeration;
  startExportJob: StartExportJobPayload;
  startLiveEventGameRound: StartLiveEventGameRoundPayload;
  startLiveEventMatchmaking: StartLiveEventMatchmakingPayload;
  startLiveEventSession: StartLiveEventSessionPayload;
  /**
   * If User.loyalty.currentCard = null, you can init the first card with this mutation.
   * After that, should only be called if the card is expired, and the user doesn't want to revive.
   */
  startLoyaltyCard: StartLoyaltyCardPayload;
  startMarathonRound: StartMarathonPayload;
  startTournamentRound: StartTournamentRoundPayload;
  stopCurrentLiveShow: StopCurrentLiveShowPayload;
  /** Stores age-gate input for current user and returns updated legal status. */
  submitAgeGate: UserLegalSetup;
  syncBadgeProgress: Array<Badge>;
  syncBadgesFromSP2: SyncSp2Badges;
  syncFriendsFromFacebook: SyncFriendsFromFacebookPayload;
  syncFriendsFromGameCenter: SyncFriendsFromGameCenterPayload;
  toggleCurationContentPackAdultOnlyTag: CurationContentPackPayload;
  /** Tag/Untag a CPP as SP2 only (SP2 only = legacy playlist, only used for backward compatibility with SP2) */
  toggleSP2OnlyTag: CurationContentPackPayload;
  tradeLoyaltyCards: TradeLoyaltyCardsPayload;
  /** Unban user (restores USER status, but not profile or ADMIN/CURATOR status) */
  unbanUser: UnbanUserPayload;
  /** Unblock a userToUser relation and set its state to NEUTRAL - temporary version for dev purpose */
  unblockUser: UnblockUserPayload;
  unlikeContentItemUserToUserQuizLiveRound: UserToUserQuizLiveRoundPayload;
  unlinkCredential: LinkCredentialPayload;
  unlinkIdPair: Sp2LinkResult;
  unlinkSp3Id: Sp2LinkResult;
  unlockMonthlyPassLevel: UnlockMonthlyPassLevelPayload;
  unlockTeamHeatBoostSlot: TeamBoostMutationPayload;
  unsaveUserContentPack: UserContentPackPayload;
  /** Can't be used on ABTest.isHardCoded = true */
  updateABTest: UpdateAbTestPayload;
  /** Enables or disables frontend subscription QA and renewal reminder features. */
  updateAppFeatureToggles: AppFeatureToggles;
  updateAppVersionConfig: Array<AppVersionConfig>;
  updateBadge: UpdateBadgePayload;
  /** Update the batch */
  updateBatchContentModeration: BatchContentModeration;
  updateCalendarAdmin: PaidCalendar;
  updateChainedOfferEvent?: Maybe<UpdateChainedOfferEventPayload>;
  updateCollection: Collection;
  updateContentPackAvailabilityDate: ContentPackPayload;
  updateContentPackAvailabilityType: ContentPackPayload;
  updateContentPackLastUpdateDate: ContentPackPayload;
  /**
   * Attributes set to null (the default value) will not be updated.
   * Returns null if there is no list with the specified ID.
   */
  updateContentPackList?: Maybe<ContentPackList>;
  /** Update Badges of SP2 CCP */
  updateCurationContentPackBadgesToSp2: Sp2CurationContentPackPayload;
  /** Updates the categories of a CCP */
  updateCurationContentPackCategories: CurationContentPackPayload;
  /** Updates the custom fields of a CCP */
  updateCurationContentPackCustomFields: CurationContentPackPayload;
  /** Updates the description of a CCP */
  updateCurationContentPackDescription: CurationContentPackPayload;
  /**
   * Attributes set to null (the default value) will not be updated.
   * Returns null if there is no list with the specified ID.
   */
  updateCurationContentPackList?: Maybe<CurationContentPackList>;
  /** Updates the locale of a CCP */
  updateCurationContentPackLocale: CurationContentPackPayload;
  /** Updates the name of a CCP */
  updateCurationContentPackName: CurationContentPackPayload;
  /** Updates the picture of a CCP (needs to upload a file) */
  updateCurationContentPackPicture: CurationContentPackPayload;
  /** Update SP2 playlist picture (can be different than SP3 playlist picture) */
  updateCurationContentPackPictureToSp2: Sp2CurationContentPackPayload;
  /** Update Price of SP2 CCP */
  updateCurationContentPackPriceToSp2: Sp2CurationContentPackPayload;
  /** Update ContentPackType */
  updateCurationContentPackType: CurationContentPackPayload;
  /** Updates a song. Only customizable fields are available for updates: displayTitle, displayArtist, etc. */
  updateCurationSong: CurationSongPayload;
  /** Updates a song sample, either the default one or the intro one. */
  updateCurationSongSample?: Maybe<CurationSongPayload>;
  updateEmoji: UpdateEmojiPayload;
  updateEmojiPack: UpdateEmojiPackPayload;
  updateGameCenterId: UpdateUserPayload;
  updateGiftAdmin: IapGiftDraft;
  /** Update */
  updateHurdleCatalogItem: UpdateHurdleCatalogItemPayload;
  /** Update an already planned hurdle quiz */
  updateHurdleQuiz: UpdateHurdleQuizPayload;
  updateImportantEvent: ImportantEvent;
  updateItem: UpdateItemPayload;
  updateLiveEvent: LiveEventPayload;
  updateLiveEventContentPacks: LiveEventPayload;
  updateLiveEventShop: LiveEventPayload;
  /** Content Moderator has reviewed the content item (and leave a note if it's marked as questionable) */
  updateLocaleForModerationContentItem: ModeratedContentItem;
  updateLoyaltyCampaignCard: LoyaltyCampaignCard;
  updateLoyaltyCampaignGroup: Scalars['Boolean'];
  updateLoyaltyCampaignSubgroup: Scalars['Boolean'];
  updateLoyaltyCard: UpdateLoyaltyCardPayload;
  updateMMilestonesTemplate?: Maybe<UpdateMmTemplatePayload>;
  updateMarathonEvent: UpdateMarathonEventPayload;
  updateMonthlyPass: UpdatedMonthlyPassPayload;
  updateMonthlyPassMissions: MonthlyPassMissionsPayload;
  updatePingUserToUserConfig: UpdatePingUserToUserConfigPayload;
  updatePoster: Poster;
  updatePushToken: UpdateUserPayload;
  updateQuizLiveShowContentPacks: QuizLiveShow;
  /** @deprecated Use updateQuizLiveShowContentPacks instead */
  updateQuizLiveShowRound: QuizLiveShow;
  updateReferralRewardStatusToPending: Array<ReferralReward>;
  /** Updates the replacing content pack of a localized CCP */
  updateReplacingCurationContentPack: CurationContentPackPayload;
  /** Can't be used on Sale.isHardCoded = true */
  updateSaleEvent: UpdateSaleEventPayload;
  updateSongQuestionableStatus: CurationSongPayload;
  updateSpecialEvent: SpecialEventPayload;
  updateSpecialEventContentPacks: SpecialEventPayload;
  updateSpecialEventMilestones: SpecialEventPayload;
  updateSpecialEventMissions: SpecialEventMissionsPayload;
  updateSpecialEventPlusMilestones: SpecialEventPayload;
  updateSpecialEventRankGroups: SpecialEventPayload;
  /** Only used for AppCenter Test. This endpoint does nothing for beta/production */
  updateSubscriptionTier: UpdateSubscriptionTierPayload;
  updateTeam: TeamPayload;
  updateTeamBoosts: UpdateTeamBoostsPayload;
  updateTeamHeat: TeamHeatUpdatePayload;
  updateTeamHeatIterationMilestones: UpdateTeamHeatIterationMilestonesPayload;
  updateTeamShopItem: TeamShopPaginated;
  /** Update general tournament data - see updateTournamentMilestones & updateTournamentRankGroups */
  updateTournament: TournamentPayload;
  /** Update tournament content pack data only */
  updateTournamentContentPacks: TournamentPayload;
  /** Update tournament milestones data only */
  updateTournamentMilestones: TournamentPayload;
  /** Update tournament rankGroups data only */
  updateTournamentRankGroups: TournamentPayload;
  updateUnsupportedPopupConfig: UnsupportedPopupConfig;
  updateUpdateGiftHistory: UpdateGiftHistory;
  updateUserBasicTierContentPack: UpdateUserBasicTierContentPackPayload;
  updateUserContentItemStatus: UpdateUserContentItemStatusPayload;
  updateUserDisplayName: UpdateUserPayload;
  updateUserEmojiPack: UserEmojiPackCommonPayload;
  /** Update the UserHurdleQuiz */
  updateUserHurdleQuiz: UpdateUserHurdleQuizPayload;
  updateUserInfluencer: UpdateUserInfluencerPayload;
  updateUserMarathonAchievementProgress: Scalars['Int'];
  updateUserMarathonEvent: UpdateUserMarathonEventPayload;
  updateUserPicture: UpdateUserPayload;
  updateUserRole: UpdateUserRolePayload;
  updateUserSelectedCategories: UpdateUserSelectedCategoriesPayload;
  updateUserSettings: UpdateUserSettingsPayload;
  /** Let the admin update how many specialEvent points a user have */
  updateUserSpecialEventPoints: UpdateUserSpecialEventPointsPayload;
  updateUserToUserQuizLiveRoundState: UpdateUserToUserQuizLiveRoundStatePayload;
  updateWFRewardTemplate?: Maybe<UpdateWfrTemplatePayload>;
  updateWheelFortuneEvent: UpdateWfEventPayload;
  upgradeItem: ItemPayload;
  upgradeUserContentPack: UpgradeUserContentPackPayload;
  uploadAsset: UploadAssetPayload;
  uploadBadgeAssets: UploadBadgeAssetPayload;
  uploadBatchEmojiAsset: UploadBatchEmojiAssetPayload;
  uploadChainedOfferEventAsset: ChainedOfferEventConfig;
  uploadCollectionAssets: Collection;
  uploadEmojiAsset: UploadEmojiAssetPayload;
  uploadEmojiPackAsset: UploadEmojiPackAssetPayload;
  uploadEmojisFont: UploadEmojisFontPayload;
  uploadIconAsset: UploadAssetPayload;
  uploadLiveShowCharacterAsset: QuizLiveShow;
  uploadLiveShowHeaderAsset: QuizLiveShow;
  uploadPosterAssets: Poster;
  /** A uniq mutation endpoint for all assets type */
  uploadSaleEventAsset: SaleEventPayload;
  uploadSheet: UploadSheetPayload;
  /** A uniq mutation endpoint for all assets type */
  uploadSpecialEventAsset: SpecialEventPayload;
  uploadTournamentCharacterAsset: TournamentPayload;
  uploadTournamentHeaderAsset: TournamentPayload;
  uploadUserGeneratedPicture: UploadUserGeneratedPicturePayload;
  upsertLoyaltyCampaignConfig: LoyaltyCampaignConfig;
  upsertQuizLiveShow: QuizLiveShow;
  useFreeReviveInMarathon: UserMarathonRound;
  useHurdleHintBoost: UseHurdleHintBoostPayload;
  /** Deprecated: Call useBoost from GRPC instead */
  useQuizLiveShowBoost: UseQuizLiveShowBoostPayload;
  /** @throw REMOVE2_AMOUNT_EMPTY */
  useRemove2Boost: UseRemove2BoostPayload;
  useReviveInMarathon: UseReviveInMarathonPayload;
};


export type MutationAcceptFriendRequestArgs = {
  input: AcceptFriendRequestInput;
};


export type MutationAcceptTeamMemberInviteArgs = {
  input: AcceptTeamMemberInviteInput;
};


export type MutationAcceptTeamQuizLiveGameRequestArgs = {
  input: AcceptTeamQuizLiveGameRequestInput;
};


export type MutationAcceptUserToUserQuizLiveGameRequestArgs = {
  input: AcceptUserToUserQuizLiveGameRequestInput;
};


export type MutationAcceptUserToUserQuizTurnGameRequestArgs = {
  input: AcceptUserToUserQuizTurnGameRequestInput;
};


export type MutationActivateBoostsInLiveGameArgs = {
  input: ActivateBoostsInLiveGameInput;
};


export type MutationActivateBoostsInTournamentRoundArgs = {
  input: ActivateBoostsInTournamentRoundInput;
};


export type MutationActivateBoostsInTurnGameArgs = {
  input: ActivateBoostsInTurnGameInput;
};


export type MutationActivateInternalFreeTrialArgs = {
  input: ActivateInternalFreeTrialInput;
};


export type MutationActivateTeamHeatBoostArgs = {
  input: TeamHeatActivateBoostInput;
};


export type MutationActivateUnlimitedBoostArgs = {
  input: ActivateUnlimitedBoostInput;
};


export type MutationAddCandidateArgs = {
  input: GenPromotionInput;
};


export type MutationAddDdexSongToCurationContentPackArgs = {
  input: AddDdexSongToCurationContentPackInput;
};


export type MutationAddFriendByInviteCodeArgs = {
  input: AddFriendByInviteCodeInput;
};


export type MutationAddItunesSongToCurationContentPackArgs = {
  input: AddItunesSongToCurationContentPackInput;
};


export type MutationAddLiveEventContentPackArgs = {
  input: AddLiveEventContentPackInput;
};


export type MutationAddSpecialEventContentPackArgs = {
  input: AddSpecialEventContentPackInput;
};


export type MutationAddSpecialEventQuizLiveShowArgs = {
  input: AddSpecialEventQuizLiveShowInput;
};


export type MutationAddSpecialEventTournamentArgs = {
  input: AddSpecialEventTournamentInput;
};


export type MutationAddTeamLeaderArgs = {
  input: AddTeamLeaderInput;
};


export type MutationAddUserEmojiPackArgs = {
  input: AddUserEmojiPackInput;
};


export type MutationAdminLinkEmailCredentialArgs = {
  input: AdminLinkEmailCredentialInput;
};


export type MutationAdminModerateContentItemArgs = {
  input: AdminModerateContentItemInput;
};


export type MutationAdminSendSignInLinkToUserArgs = {
  input: AdminSendSignInLinkInput;
};


export type MutationAdvanceBadgeArgs = {
  input: AdvanceBadgeInput;
};


export type MutationAnswerHurdleQuizArgs = {
  input: AnswerHurdleQuizInput;
};


export type MutationAnswerMultiQuizLiveShowArgs = {
  input: AnswerMultiQuizLiveShowInput;
};


export type MutationAnswerQuizLiveShowArgs = {
  input: AnswerLiveShowInput;
};


export type MutationAnswerTournamentRoundArgs = {
  input: AnswerTournamentRoundInput;
};


export type MutationAnswerUserToUserQuizLiveRoundArgs = {
  input: AnswerUserToUserQuizLiveRoundInput;
};


export type MutationApplyUserSubscriptionUpdateLogArgs = {
  input: ApplyUserSubscriptionUpdateLogInput;
};


export type MutationArchiveUserToUserQuizTurnGameArgs = {
  input: ArchiveUserToUserQuizTurnGameInput;
};


export type MutationAuthenticateGoogleSheetArgs = {
  input: AuthenticateGoogleSheetInput;
};


export type MutationBanUserArgs = {
  input: BanUserInput;
};


export type MutationBatchCommitCurationContentPackArgs = {
  input: BatchCommitCurationContentPackInput;
};


export type MutationBlockUserArgs = {
  input: BlockUserInput;
};


export type MutationBuyTeamShopItemArgs = {
  itemId: Scalars['ID'];
};


export type MutationCancelLiveEventMatchmakingArgs = {
  eventId: Scalars['ID'];
};


export type MutationCancelLiveEventRoundArgs = {
  eventId: Scalars['ID'];
  userToUserId: Scalars['ID'];
};


export type MutationCancelTeamQuizLiveGameRequestArgs = {
  input: CancelTeamQuizLiveGameRequestInput;
};


export type MutationCastVoteArgs = {
  input: GenPromotionInput;
};


export type MutationChallengeSp2OpponentArgs = {
  input: ChallengeSp2OpponentInput;
};


export type MutationChangeAvailableDateYearInReviewArgs = {
  input?: InputMaybe<ChangeAvailableDateYirInput>;
};


export type MutationClaimAvailableTeamHeatMilestonesArgs = {
  teamId: Scalars['ID'];
};


export type MutationClaimCalendarRewardArgs = {
  id: Scalars['ID'];
};


export type MutationClaimChainedOfferPackArgs = {
  input: ClaimChainedOfferPackInput;
};


export type MutationClaimCollectionRewardArgs = {
  collectionId: Scalars['String'];
};


export type MutationClaimCurrentAdsRewardArgs = {
  type?: InputMaybe<AdsRewardCurrencyType>;
};


export type MutationClaimGiftArgs = {
  id: Scalars['ID'];
};


export type MutationClaimHurdleRewardsArgs = {
  input: ClaimHurdleRewardsInput;
};


export type MutationClaimLevelUserRewardArgs = {
  input?: InputMaybe<ClaimLevelUserRewardInput>;
};


export type MutationClaimLevelUserRewardsArgs = {
  input?: InputMaybe<ClaimLevelUserRewardsInput>;
};


export type MutationClaimLiveEventShopItemArgs = {
  eventId: Scalars['ID'];
  itemId: Scalars['ID'];
};


export type MutationClaimLoyaltyCampaignCardArgs = {
  id: Scalars['ID'];
  quantity?: InputMaybe<Scalars['Int']>;
};


export type MutationClaimLoyaltyCardDayArgs = {
  input?: InputMaybe<ClaimLoyaltyCardDayInput>;
};


export type MutationClaimMarathonMilestoneArgs = {
  input: ClaimMarathonMilestoneInput;
};


export type MutationClaimMissionArgs = {
  input: ClaimMissionInput;
};


export type MutationClaimPromotionArgs = {
  input?: InputMaybe<ClaimPromotionInput>;
};


export type MutationClaimQuizLiveShowUserRoundRewardArgs = {
  input: ClaimQuizLiveShowUserRoundRewardInput;
};


export type MutationClaimReferralRewardArgs = {
  input?: InputMaybe<ClaimReferralRewardInput>;
};


export type MutationClaimSpecialEventMilestoneRewardArgs = {
  input: ClaimSpecialEventMilestoneRewardInput;
};


export type MutationClaimSpecialEventRankGroupRewardArgs = {
  input: ClaimSpecialEventRankGroupRewardInput;
};


export type MutationClaimStarterPackFragmentsArgs = {
  input: ClaimStarterPackFragmentsInput;
};


export type MutationClaimTeamMonthlyPassRewardsArgs = {
  input: ClaimTeamMonthlyPassInput;
};


export type MutationClaimTournamentMilestoneRewardArgs = {
  input: ClaimTournamentMilestoneRewardInput;
};


export type MutationClaimTournamentRankGroupRewardArgs = {
  input: ClaimTournamentRankGroupRewardInput;
};


export type MutationClaimUserMonthlyPassRewardArgs = {
  input: ClaimUserMonthlyPassRewardInput;
};


export type MutationClaimUserMonthlyPassRewardsArgs = {
  input: ClaimUserMonthlyPassRewardsInput;
};


export type MutationClaimUserToUserQuizTurnRoundArgs = {
  input: ClaimUserToUserQuizTurnRoundInput;
};


export type MutationCommitCurationContentPackArgs = {
  input: CommitCurationContentPackInput;
};


export type MutationCommitSp2CurationPlaylistArgs = {
  input: CommitSp2CurationPlaylistInput;
};


export type MutationCompleteFtueStepArgs = {
  input: CompleteFtueStepInput;
};


export type MutationCompleteUserHurdleQuizArgs = {
  input: CompleteUserHurdleQuizInput;
};


export type MutationCompleteUserToUserQuizTurnRoundArgs = {
  input: CompleteUserToUserQuizTurnRoundInput;
};


export type MutationConvertSamplesArgs = {
  input: ConvertSamplesInput;
};


export type MutationConvertToSp2SamplesArgs = {
  input: ConvertToSp2SamplesInput;
};


export type MutationCopyQuizLiveShowArgs = {
  input: CopyQuizLiveShowInput;
};


export type MutationCopyTournamentArgs = {
  input: CopyTournamentInput;
};


export type MutationCraftItemArgs = {
  input: CraftItemInput;
};


export type MutationCreateAbTestArgs = {
  input: CreateAbTestInput;
};


export type MutationCreateAppVersionConfigArgs = {
  forceUpdateType: Scalars['String'];
  platform: Scalars['String'];
  version: Scalars['String'];
};


export type MutationCreateBackendDeploymentImportantEventArgs = {
  input: CreateBackendDeploymentImportantEventInput;
};


export type MutationCreateBadgeArgs = {
  input: CreateBadgeInput;
};


export type MutationCreateBatchContentModerationArgs = {
  input: CreateBatchContentModerationInput;
};


export type MutationCreateCalendarAdminArgs = {
  endDate: Scalars['Date'];
  name: Scalars['String'];
  startDate: Scalars['Date'];
};


export type MutationCreateChainedOfferEventArgs = {
  input?: InputMaybe<CreateChainedOfferEventInput>;
};


export type MutationCreateCollectionArgs = {
  input: CreateCollectionInput;
};


export type MutationCreateContentPackListArgs = {
  input: CreateContentPackListInput;
};


export type MutationCreateCurationContentPackByArtistsArgs = {
  input: CreateCurationContentPackByArtistsInput;
};


export type MutationCreateCurationContentPackByCsvArgs = {
  input: CreateCurationContentPackByCsvInput;
};


export type MutationCreateCurationContentPackByUrlArgs = {
  input: CreateCurationContentPackByUrlInput;
};


export type MutationCreateCurationContentPackFromSp2Args = {
  input: CreateCurationContentPackFromSp2Input;
};


export type MutationCreateCurationContentPackFromSp2MultiArgs = {
  input: CreateCurationContentPackFromSp2MultiInput;
};


export type MutationCreateCurationContentPackListArgs = {
  input: CreateCurationContentPackListInput;
};


export type MutationCreateCurationContentPackNewDraftArgs = {
  input: CreateCurationContentPackNewDraftInput;
};


export type MutationCreateCustomImportantEventArgs = {
  input: CreateImportantEventInput;
};


export type MutationCreateEmojiPackArgs = {
  input: CreateEmojiPackInput;
};


export type MutationCreateExportRequestArgs = {
  input: CreateExportRequestInput;
};


export type MutationCreateFrontendDeploymentImportantEventArgs = {
  input: CreateFrontendDeploymentImportantEventInput;
};


export type MutationCreateGiftAdminArgs = {
  filters: GiftFiltersInput;
  gifts: Array<LevelRewardInput>;
  messageId?: InputMaybe<Scalars['String']>;
  recipientsCount?: InputMaybe<Scalars['Int']>;
  sendDate?: InputMaybe<Scalars['Date']>;
};


export type MutationCreateHurdleCatalogItemArgs = {
  input: CreateHurdleCatalogItemInput;
};


export type MutationCreateHurdleQuizArgs = {
  input: CreateHurdleQuizInput;
};


export type MutationCreateItemArgs = {
  input: CreateItemInput;
};


export type MutationCreateLiveEventArgs = {
  input: CreateLiveEventInput;
};


export type MutationCreateLoyaltyCampaignCardArgs = {
  cost: Scalars['Int'];
  groupDisplayOrder?: InputMaybe<Scalars['Int']>;
  groupEndDate?: InputMaybe<Scalars['Date']>;
  groupId?: InputMaybe<Scalars['String']>;
  groupName?: InputMaybe<Scalars['String']>;
  groupStartDate?: InputMaybe<Scalars['Date']>;
  itemBonusLoyaltyPoints?: InputMaybe<Scalars['Int']>;
  itemDisplayOrder?: InputMaybe<Scalars['Int']>;
  kind: LoyaltyCampaignCardKind;
  maxClaims: Scalars['Int'];
  name: Scalars['String'];
  rewards: Array<LevelRewardInput>;
  subgroupDisplayOrder?: InputMaybe<Scalars['Int']>;
  subgroupEndDate?: InputMaybe<Scalars['Date']>;
  subgroupId?: InputMaybe<Scalars['String']>;
  subgroupName?: InputMaybe<Scalars['String']>;
  subgroupStartDate?: InputMaybe<Scalars['Date']>;
};


export type MutationCreateMMilestonesTemplateArgs = {
  input: CreateMmTemplateInput;
};


export type MutationCreateMarathonEventArgs = {
  input: CreateMarathonEventInput;
};


export type MutationCreateMessageTemplateArgs = {
  msg: Scalars['String'];
};


export type MutationCreatePosterArgs = {
  input: CreatePosterInput;
};


export type MutationCreatePracticeQuizArgs = {
  input: CreatePracticeQuizInput;
};


export type MutationCreateSaleEventArgs = {
  input: CreateSaleEventInput;
};


export type MutationCreateSpecialEventArgs = {
  input: CreateSpecialEventInput;
};


export type MutationCreateSpecialEventSampleArgs = {
  input?: InputMaybe<CreateSpecialEventSampleInput>;
};


export type MutationCreateTeamArgs = {
  input: CreateTeamInput;
};


export type MutationCreateTeamShopItemArgs = {
  item: CreateUpdateTeamShopItemInput;
};


export type MutationCreateTournamentArgs = {
  input: CreateTournamentInput;
};


export type MutationCreateUnsupportedPopupConfigArgs = {
  input: UnsupportedPopupConfigInput;
};


export type MutationCreateUserToUserQuizTurnRoundArgs = {
  input: CreateUserToUserQuizTurnRoundInput;
};


export type MutationCreateUserToUserQuizTurnRoundForInfluencerArgs = {
  input: CreateUserToUserQuizTurnRoundForInfluencerInput;
};


export type MutationCreateUserToUserQuizTurnRoundForInviteArgs = {
  input: CreateUserToUserQuizTurnRoundForInviteInput;
};


export type MutationCreateUserToUserQuizTurnRoundForRandomArgs = {
  input: CreateUserToUserQuizTurnRoundForRandomInput;
};


export type MutationCreateUserToUserQuizTurnRoundForUserArgs = {
  input: CreateUserToUserQuizTurnRoundForUserInput;
};


export type MutationCreateWfRewardTemplateArgs = {
  input: CreateWfrTemplateInput;
};


export type MutationCreateWheelFortuneEventArgs = {
  input: CreateWfEventInput;
};


export type MutationCrupdateSp2ReleaseArgs = {
  input: CrupdateSp2ReleaseInput;
};


export type MutationDeclineFriendRequestArgs = {
  input: DeclineFriendRequestInput;
};


export type MutationDeclineTeamMemberInviteArgs = {
  input: DeclineTeamMemberInviteInput;
};


export type MutationDeclineUserToUserQuizLiveGameRequestArgs = {
  input: DeclineUserToUserQuizLiveGameRequestInput;
};


export type MutationDeleteAbTestArgs = {
  input: DeleteAbTestInput;
};


export type MutationDeleteAppVersionConfigArgs = {
  platform: Scalars['String'];
  version: Scalars['String'];
};


export type MutationDeleteChainedOfferEventArgs = {
  input?: InputMaybe<DeleteChainedOfferEventInput>;
};


export type MutationDeleteContentPackListArgs = {
  contentPackListId: Scalars['ID'];
};


export type MutationDeleteCurationContentPackArgs = {
  input: DeleteCurationContentPackInput;
};


export type MutationDeleteCurationContentPackListArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteEmojiArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteEmojiPackArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteHurdleCatalogItemArgs = {
  input: DeleteHurdleCatalogItemInput;
};


export type MutationDeleteImportantEventArgs = {
  input: DeleteImportantEventInput;
};


export type MutationDeleteLoyaltyCampaignCardArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteLoyaltyCampaignConfigArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteLoyaltyCampaignGroupArgs = {
  groupId: Scalars['String'];
};


export type MutationDeleteLoyaltyCampaignSubgroupArgs = {
  groupId: Scalars['String'];
  subgroupId: Scalars['String'];
};


export type MutationDeleteMMilestonesTemplateArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteMarathonEventArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteMessageTemplateArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSp2ReleaseArgs = {
  input: DeleteSp2ReleaseInput;
};


export type MutationDeleteSaleEventArgs = {
  input: DeleteSaleEventInput;
};


export type MutationDeleteTeamShopItemArgs = {
  itemId: Scalars['ID'];
};


export type MutationDeleteUnsupportedPopupConfigArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUpdateGiftHistoryArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserCalendarArgs = {
  calendarId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationDeleteUserEmojiPackArgs = {
  input: DeleteUserEmojiPackInput;
};


export type MutationDeleteWfRewardTemplateArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteWheelFortuneEventArgs = {
  id: Scalars['ID'];
};


export type MutationDemoteTeamLeaderArgs = {
  input: DemoteTeamLeaderInput;
};


export type MutationEditMessageTemplateArgs = {
  id: Scalars['ID'];
  msg: Scalars['String'];
};


export type MutationEndBatchContentModerationArgs = {
  input: EndBatchContentModerationInput;
};


export type MutationEndUserToUserQuizLiveGameArgs = {
  input?: InputMaybe<EndUserToUserQuizLiveGameInput>;
};


export type MutationExportCurationContentPackToSp2Args = {
  input: ExportCurationContentPackToSp2Input;
};


export type MutationFinishMarathonRoundArgs = {
  input: FinishMarathonRoundInput;
};


export type MutationFlushHurdleCacheArgs = {
  input?: InputMaybe<FlushHurdleCacheInput>;
};


export type MutationFlushRedisCacheArgs = {
  input: FlushRedisCacheInput;
};


export type MutationFlushRedisCacheForOneUserArgs = {
  input: FlushRedisCacheForOneUserInput;
};


export type MutationForceGrantMpLeaderboardRewardsArgs = {
  input: ForceGrantMplRewardsInput;
};


export type MutationForceMissionProgressArgs = {
  input: ForceMissionProgressInput;
};


export type MutationForceSongInputMatchingArgs = {
  input: ForceSongInputMatchingInput;
};


export type MutationForceUpdateUserArgs = {
  input: ForceUpdateUserInput;
};


export type MutationForceUserAbTestArgs = {
  input: ForceUserAbTestInput;
};


export type MutationGenerateCombinedMusicReportArgs = {
  input: GenerateReportInput;
};


export type MutationGenerateHurdleQuizzesArgs = {
  input: GenerateHurdleQuizzesInput;
};


export type MutationGenerateMarathonQuestionsArgs = {
  input: GenerateMarathonQuestionsInput;
};


export type MutationGenerateReportArgs = {
  input: GenerateReportInput;
};


export type MutationGenerateSp2ReportingTableArgs = {
  input: GenerateReportInput;
};


export type MutationGhostQuizLiveShowArgs = {
  input: GhostQuizLiveShowInput;
};


export type MutationGrantUserBadgeAdminArgs = {
  input: GrantUserBadgeAdminInput;
};


export type MutationImportSongsFromContentPackListToHurdleCatalogArgs = {
  input: ImportSongsFromContentPackListToHurdleCatalogInput;
};


export type MutationInitMonthlyPassMissionsArgs = {
  input: InitMonthlyPassMissionsInput;
};


export type MutationInitSpecialEventMissionsArgs = {
  input: InitSpecialEventMissionsInput;
};


export type MutationInviteSp2OpponentArgs = {
  input: InviteSp2OpponentInput;
};


export type MutationJoinQuizLiveShowArgs = {
  input: JoinQuizLiveShowInput;
};


export type MutationJoinTeamArgs = {
  input: JoinTeamInput;
};


export type MutationKickTeamMemberArgs = {
  input: KickTeamMemberInput;
};


export type MutationLeaveTeamArgs = {
  input: LeaveTeamInput;
};


export type MutationLikeContentItemUserToUserQuizLiveRoundArgs = {
  input: UpdateContentItemStatusUserToUserQuizLiveRoundInput;
};


export type MutationLinkCredentialArgs = {
  input: SignInInput;
};


export type MutationLinkToSp2Args = {
  input: LinkTokenInput;
};


export type MutationLinkToSp2AdminArgs = {
  input: Sp2LinkIdPairInput;
};


export type MutationLinkToSp2WithTokenArgs = {
  input: Sp2LinkTokenInput;
};


export type MutationMarkMessagesAsReadArgs = {
  input: MarkMessagesAsReadInput;
};


export type MutationMarkRoundAsStartedArgs = {
  input?: InputMaybe<MarkRoundAsStartedInput>;
};


export type MutationMarkSongInputsAsOutdatedArgs = {
  input: MarkSongInputsAsOutdatedInput;
};


export type MutationMarkYearInReviewAsSeenArgs = {
  year: Scalars['Int'];
};


export type MutationMigrateSp2PlaylistsArgs = {
  input: MigrateSp2PlaylistsInput;
};


export type MutationModerateContentItemArgs = {
  input: ModerateContentItemInput;
};


export type MutationPickUserToUserQuizLiveRoundContentPackArgs = {
  input: PickUserToUserQuizLiveRoundContentPackInput;
};


export type MutationPingUserToUserArgs = {
  input: PingUserToUserInput;
};


export type MutationProcessExportRequestArgs = {
  input: ProcessExportRequestInput;
};


export type MutationPurchaseBoostPackArgs = {
  input: PurchaseBoostPackInput;
};


export type MutationPurchaseCalendarArgs = {
  input: PurchaseCalendarInput;
};


export type MutationPurchaseCurrencyPackArgs = {
  input: PurchaseCurrencyPackInput;
};


export type MutationPurchaseEmojiArgs = {
  input: PurchaseEmojiInput;
};


export type MutationPurchaseItemArgs = {
  input: PurchaseItemInput;
};


export type MutationPurchasePiggyBankArgs = {
  input: PurchasePiggyBankInput;
};


export type MutationPurchaseSaleBundlePackArgs = {
  input: PurchaseSaleBundlePackInput;
};


export type MutationPurchaseStarterPackArgs = {
  input: PurchaseStarterPackInput;
};


export type MutationPurchaseSubscriptionArgs = {
  input: PurchaseSubscriptionInput;
};


export type MutationPurchaseSubscriptionDaysArgs = {
  input: PurchaseSubscriptionDaysInput;
};


export type MutationRefillEmptyCapArgs = {
  input: RefillEmptyCapInput;
};


export type MutationRefreshSppContentArgs = {
  input: RefreshSppContentInput;
};


export type MutationRefreshUserRedisCacheArgs = {
  input: RefreshUserRedisCacheInput;
};


export type MutationRefundLiveShowUserBoostsArgs = {
  input: RefundLiveShowUserBoostsInput;
};


export type MutationRegisterAppsFlyerIdArgs = {
  input: RegisterAppsFlyerIdInput;
};


export type MutationRegisterSingularDeviceIdArgs = {
  input: RegisterSingularDeviceId;
};


export type MutationRemoveBadgeArgs = {
  input: RemoveBadgeInput;
};


export type MutationRemoveCalendarAdminArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveCollectionArgs = {
  collectionId: Scalars['ID'];
};


export type MutationRemoveDraftGiftAdminArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveFriendArgs = {
  input: RemoveFriendInput;
};


export type MutationRemoveLiveEventArgs = {
  input: RemoveLiveEventInput;
};


export type MutationRemoveLiveEventContentPackArgs = {
  input: RemoveLiveEventContentPackInput;
};


export type MutationRemoveLiveShowArgs = {
  input: RemoveLiveShowInput;
};


export type MutationRemovePosterArgs = {
  posterId: Scalars['ID'];
};


export type MutationRemoveSongFromCurationContentPackArgs = {
  input: RemoveSongFromCurationContentPackInput;
};


export type MutationRemoveSpecialEventArgs = {
  input: RemoveSpecialEventInput;
};


export type MutationRemoveSpecialEventContentPackArgs = {
  input: RemoveSpecialEventContentPackInput;
};


export type MutationRemoveSpecialEventQuizLiveShowArgs = {
  input: RemoveSpecialEventQuizLiveShowInput;
};


export type MutationRemoveSpecialEventTournamentArgs = {
  input: RemoveSpecialEventTournamentInput;
};


export type MutationRemoveTournamentArgs = {
  input: RemoveTournamentInput;
};


export type MutationReorderSongsFromCurationContentPackArgs = {
  input: ReorderSongsFromCurationContentPackInput;
};


export type MutationReplaceDdexSongMatchArgs = {
  input: ReplaceDdexSongMatchInput;
};


export type MutationReportSongListenCountArgs = {
  input: ReportSongListenCountInput;
};


export type MutationReportSongSampleArgs = {
  input: ReportSongSampleInput;
};


export type MutationReportUserArgs = {
  input: ReportUserInput;
};


export type MutationRequestSp2LinkTokenArgs = {
  input: Sp2IdInput;
};


export type MutationRescheduleQuizLiveShowArgs = {
  input: RescheduleQuizLiveShowInput;
};


export type MutationResetClaimedTeamHeatMilestonesArgs = {
  input: ResetTeamHeatClaimedMilestonesInput;
};


export type MutationResetDailyEmojisArgs = {
  userId?: InputMaybe<Scalars['ID']>;
};


export type MutationResetEmojiPackTutorialArgs = {
  userId: Scalars['ID'];
};


export type MutationResetHurdleQuizArgs = {
  input: ResetHurdleQuizInput;
};


export type MutationResetLoyaltyCardArgs = {
  input: ResetLoyaltyCardInput;
};


export type MutationResetMissionProgressArgs = {
  input: ResetMissionProgressInput;
};


export type MutationResetPromotionArgs = {
  input?: InputMaybe<ResetPromotionInput>;
};


export type MutationResetQuizLiveShowRoundQuestionsArgs = {
  input: ResetQuizLiveShowRoundQuestionsInput;
};


export type MutationResetSpecialOfferRewardsArgs = {
  input: ResetSpecialOfferRewardsInput;
};


export type MutationResetUserLoyaltyCampaignProgressArgs = {
  userId: Scalars['ID'];
};


export type MutationResetUserMarathonEventArgs = {
  input: ResetUserMarathonEventInput;
};


export type MutationResetUserSubscriptionsArgs = {
  input: ResetUserSubscriptionsInput;
};


export type MutationResumeMarathonRoundArgs = {
  input: ResumeMarathonRoundInput;
};


export type MutationRetryCurationExternalLinksArgs = {
  input: RetryCurationExternalLinksInput;
};


export type MutationRetryCurationMatchingArgs = {
  input?: InputMaybe<RetryCurationMatchingInput>;
};


export type MutationRetryGiftAdminArgs = {
  id: Scalars['ID'];
};


export type MutationReviveLoyaltyCardArgs = {
  input: ReviveLoyaltyCardInput;
};


export type MutationReviveLoyaltyCardDayArgs = {
  input?: InputMaybe<ReviveLoyaltyCardDayInput>;
};


export type MutationRevokeUserBadgeAdminArgs = {
  input: RevokeUserBadgeAdminInput;
};


export type MutationSaveAgeGateCountryCodeArgs = {
  countryCode: Scalars['String'];
};


export type MutationSaveMarathonRoundArgs = {
  input: SaveMarathonRoundInput;
};


export type MutationSaveUserContentPackArgs = {
  input: SaveUserContentPackInput;
};


export type MutationScheduleQuizLiveShowRoundEncryptionArgs = {
  input: ScheduleQuizLiveShowRoundEncryptionInput;
};


export type MutationSelectAppSkinArgs = {
  input: SelectAppSkinInput;
};


export type MutationSelectBadgeArgs = {
  input: SelectBadgeInput;
};


export type MutationSelectProfileFrameArgs = {
  input: SelectProfileFrameInput;
};


export type MutationSendContentItemMessageArgs = {
  input: SendContentItemMessageInput;
};


export type MutationSendFriendRequestArgs = {
  input: SendFriendRequestInput;
};


export type MutationSendGiftArgs = {
  input: SendGiftInput;
};


export type MutationSendImageMessageArgs = {
  input: SendMessageInput;
};


export type MutationSendLiveShowSafeTextMessageArgs = {
  input: SendQuizMessageInput;
};


export type MutationSendLiveShowStickerMessageArgs = {
  input: SendQuizMessageInput;
};


export type MutationSendMessageUserToUserQuizLiveRoundArgs = {
  input: SendMessageUserToUserQuizLiveRoundInput;
};


export type MutationSendNotificationArgs = {
  input: SendNotificationInput;
};


export type MutationSendQuizLiveShowWinnerStickerArgs = {
  input: SendWinnerStickerInput;
};


export type MutationSendRetentionReminderArgs = {
  input?: InputMaybe<SendRetentionReminderInput>;
};


export type MutationSendSafeTextMessageArgs = {
  input: SendQuizMessageInput;
};


export type MutationSendStickerMessageArgs = {
  input: SendQuizMessageInput;
};


export type MutationSendTeamMemberInviteArgs = {
  input: SendTeamMemberInviteInput;
};


export type MutationSendTeamQuizLiveGameRequestArgs = {
  input: SendTeamQuizLiveGameRequestInput;
};


export type MutationSendTextMessageArgs = {
  input: SendMessageInput;
};


export type MutationSendUserToUserQuizLiveGameRequestArgs = {
  input: SendUserToUserQuizLiveGameRequestInput;
};


export type MutationSetActiveEmojiPackArgs = {
  input: SetActiveEmojiPackInput;
};


export type MutationSetLatestUpdateGiftArgs = {
  betaAndroidVersions?: InputMaybe<Array<Scalars['Int']>>;
  betaIosVersions?: InputMaybe<Array<Scalars['Int']>>;
  eligibleAndroidVersions: Array<Scalars['Int']>;
  eligibleIosVersions: Array<Scalars['Int']>;
  gift1Amount: Scalars['Int'];
  gift1Type: Scalars['String'];
  gift2Amount: Scalars['Int'];
  gift2Type: Scalars['String'];
};


export type MutationSetModeratorToContentPackArgs = {
  input?: InputMaybe<SetModeratorToContentPack>;
};


export type MutationSetStickerPositionArgs = {
  input: SetStickerPositionInput;
};


export type MutationSetSubscriptionExpiresArgs = {
  input: SetSubscriptionExpiresInput;
};


export type MutationSetSubscriptionTierArgs = {
  input: SetSubscriptionTierInput;
};


export type MutationSetUserBadgeLevelAdminArgs = {
  input: SetUserBadgeLevelAdminInput;
};


export type MutationSetUserContentItemPositionArgs = {
  input: SetUserContentItemPositionInput;
};


export type MutationSetUserContentPackPositionArgs = {
  input: SetUserContentPackPositionInput;
};


export type MutationSetUserLoyaltyCampaignProgressArgs = {
  claimedLoyaltyCardIds: Array<Scalars['ID']>;
  loyaltyPoints: Scalars['Int'];
  userId: Scalars['ID'];
};


export type MutationShiftLoyaltyCardArgs = {
  input: ShiftLoyaltyCardInput;
};


export type MutationSignInArgs = {
  input: SignUpInput;
};


export type MutationSignUpArgs = {
  input: SignUpInput;
};


export type MutationSpinWheelFortuneArgs = {
  input: SpinWheelFortuneInput;
};


export type MutationStartBatchContentModerationArgs = {
  input: StartBatchContentModerationInput;
};


export type MutationStartExportJobArgs = {
  input: StartExportJobInput;
};


export type MutationStartLiveEventGameRoundArgs = {
  boosts: Array<CurrencyBoostType>;
  contentPackId: Scalars['ID'];
  eventId: Scalars['ID'];
  roundId: Scalars['ID'];
  userToUserId: Scalars['ID'];
};


export type MutationStartLiveEventMatchmakingArgs = {
  eventId: Scalars['ID'];
};


export type MutationStartLiveEventSessionArgs = {
  eventId: Scalars['ID'];
  userToUserId: Scalars['ID'];
};


export type MutationStartMarathonRoundArgs = {
  input: StartMarathonRoundInput;
};


export type MutationStartTournamentRoundArgs = {
  input: StartTournamentRoundInput;
};


export type MutationSubmitAgeGateArgs = {
  input: SubmitAgeGateInput;
};


export type MutationSyncFriendsFromFacebookArgs = {
  input: SyncFriendsFromFacebookInput;
};


export type MutationSyncFriendsFromGameCenterArgs = {
  input: SyncFriendsFromGameCenterInput;
};


export type MutationToggleCurationContentPackAdultOnlyTagArgs = {
  input: ToggleCurationContentPackAdultOnlyTagInput;
};


export type MutationToggleSp2OnlyTagArgs = {
  input: ToggleSp2OnlyTagInput;
};


export type MutationTradeLoyaltyCardsArgs = {
  input?: InputMaybe<TradeLoyaltyCardsInput>;
};


export type MutationUnbanUserArgs = {
  input: UnbanUserInput;
};


export type MutationUnblockUserArgs = {
  input: UnblockUserInput;
};


export type MutationUnlikeContentItemUserToUserQuizLiveRoundArgs = {
  input: UpdateContentItemStatusUserToUserQuizLiveRoundInput;
};


export type MutationUnlinkCredentialArgs = {
  input: SignInInput;
};


export type MutationUnlinkIdPairArgs = {
  input?: InputMaybe<Sp2LinkIdPairInput>;
};


export type MutationUnlinkSp3IdArgs = {
  input?: InputMaybe<Sp3IdInput>;
};


export type MutationUnlockTeamHeatBoostSlotArgs = {
  teamId: Scalars['ID'];
};


export type MutationUnsaveUserContentPackArgs = {
  input: UnsaveUserContentPackInput;
};


export type MutationUpdateAbTestArgs = {
  input: UpdateAbTestInput;
};


export type MutationUpdateAppFeatureTogglesArgs = {
  input: UpdateAppFeatureTogglesInput;
};


export type MutationUpdateAppVersionConfigArgs = {
  forceUpdateType: Scalars['String'];
  platform: Scalars['String'];
  version: Scalars['String'];
};


export type MutationUpdateBadgeArgs = {
  input: UpdateBadgeInput;
};


export type MutationUpdateBatchContentModerationArgs = {
  input: UpdateBatchContentModerationInput;
};


export type MutationUpdateCalendarAdminArgs = {
  calendarItems: Array<LevelRewardInput>;
  endDate: Scalars['Date'];
  filterUserIds: Array<Scalars['ID']>;
  filterVersion?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  purchaseReward?: InputMaybe<LevelRewardInput>;
  skuId: Scalars['String'];
  startDate: Scalars['Date'];
};


export type MutationUpdateChainedOfferEventArgs = {
  input?: InputMaybe<UpdateChainedOfferEventInput>;
};


export type MutationUpdateCollectionArgs = {
  input: UpdateCollectionInput;
};


export type MutationUpdateContentPackAvailabilityDateArgs = {
  input: UpdateContentPackAvailabilityDateInput;
};


export type MutationUpdateContentPackAvailabilityTypeArgs = {
  input: UpdateContentPackAvailabilityTypeInput;
};


export type MutationUpdateContentPackLastUpdateDateArgs = {
  input: UpdateContentPackLastUpdateDateInput;
};


export type MutationUpdateContentPackListArgs = {
  input: UpdateContentPackListInput;
};


export type MutationUpdateCurationContentPackBadgesToSp2Args = {
  input: UpdateCurationContentPackBadgesToSp2Input;
};


export type MutationUpdateCurationContentPackCategoriesArgs = {
  input: UpdateCurationContentPackCategoriesInput;
};


export type MutationUpdateCurationContentPackCustomFieldsArgs = {
  input: UpdateCurationContentPackCustomFieldsInput;
};


export type MutationUpdateCurationContentPackDescriptionArgs = {
  input: UpdateCurationContentPackDescriptionInput;
};


export type MutationUpdateCurationContentPackListArgs = {
  input: UpdateCurationContentPackListInput;
};


export type MutationUpdateCurationContentPackLocaleArgs = {
  input: UpdateCurationContentPackLocaleInput;
};


export type MutationUpdateCurationContentPackNameArgs = {
  input: UpdateCurationContentPackNameInput;
};


export type MutationUpdateCurationContentPackPictureArgs = {
  input: UpdateCurationContentPackPictureInput;
};


export type MutationUpdateCurationContentPackPictureToSp2Args = {
  input: UpdateCurationContentPackPictureToSp2Input;
};


export type MutationUpdateCurationContentPackPriceToSp2Args = {
  input: UpdateCurationContentPackPriceToSp2Input;
};


export type MutationUpdateCurationContentPackTypeArgs = {
  input: UpdateCurationContentPackTypeInput;
};


export type MutationUpdateCurationSongArgs = {
  input: UpdateCurationSongInput;
};


export type MutationUpdateCurationSongSampleArgs = {
  input: UpdateCurationSongSampleInput;
};


export type MutationUpdateEmojiArgs = {
  input: UpdateEmojiInput;
};


export type MutationUpdateEmojiPackArgs = {
  input: UpdateEmojiPackInput;
};


export type MutationUpdateGameCenterIdArgs = {
  input: UpdateGameCenterIdInput;
};


export type MutationUpdateGiftAdminArgs = {
  filters: GiftFiltersInput;
  gifts: Array<LevelRewardInput>;
  id: Scalars['ID'];
  messageId?: InputMaybe<Scalars['String']>;
  recipientsCount?: InputMaybe<Scalars['Int']>;
  sendDate?: InputMaybe<Scalars['Date']>;
};


export type MutationUpdateHurdleCatalogItemArgs = {
  input: UpdateHurdleCatalogItemInput;
};


export type MutationUpdateHurdleQuizArgs = {
  input: UpdateHurdleQuizInput;
};


export type MutationUpdateImportantEventArgs = {
  input: UpdateImportantEventInput;
};


export type MutationUpdateItemArgs = {
  input: UpdateItemInput;
};


export type MutationUpdateLiveEventArgs = {
  input: UpdateLiveEventInput;
};


export type MutationUpdateLiveEventContentPacksArgs = {
  input: UpdateLiveEventContentPacksInput;
};


export type MutationUpdateLiveEventShopArgs = {
  input: UpdateLiveEventShopInput;
};


export type MutationUpdateLocaleForModerationContentItemArgs = {
  input: UpdateLocaleForModerationContentItemInput;
};


export type MutationUpdateLoyaltyCampaignCardArgs = {
  cost?: InputMaybe<Scalars['Int']>;
  displayOrder?: InputMaybe<Scalars['Int']>;
  groupDisplayOrder?: InputMaybe<Scalars['Int']>;
  groupEndDate?: InputMaybe<Scalars['Date']>;
  groupId?: InputMaybe<Scalars['String']>;
  groupName?: InputMaybe<Scalars['String']>;
  groupStartDate?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
  itemBonusLoyaltyPoints?: InputMaybe<Scalars['Int']>;
  itemDisplayOrder?: InputMaybe<Scalars['Int']>;
  kind?: InputMaybe<LoyaltyCampaignCardKind>;
  maxClaims?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  rewards?: InputMaybe<Array<LevelRewardInput>>;
  subgroupDisplayOrder?: InputMaybe<Scalars['Int']>;
  subgroupEndDate?: InputMaybe<Scalars['Date']>;
  subgroupId?: InputMaybe<Scalars['String']>;
  subgroupName?: InputMaybe<Scalars['String']>;
  subgroupStartDate?: InputMaybe<Scalars['Date']>;
};


export type MutationUpdateLoyaltyCampaignGroupArgs = {
  endDate?: InputMaybe<Scalars['Date']>;
  groupDisplayOrder?: InputMaybe<Scalars['Int']>;
  groupId: Scalars['String'];
  groupName: Scalars['String'];
  startDate?: InputMaybe<Scalars['Date']>;
};


export type MutationUpdateLoyaltyCampaignSubgroupArgs = {
  groupId: Scalars['String'];
  subgroupDisplayOrder?: InputMaybe<Scalars['Int']>;
  subgroupEndDate?: InputMaybe<Scalars['Date']>;
  subgroupId: Scalars['String'];
  subgroupName: Scalars['String'];
  subgroupStartDate?: InputMaybe<Scalars['Date']>;
};


export type MutationUpdateLoyaltyCardArgs = {
  input: UpdateLoyaltyCardInput;
};


export type MutationUpdateMMilestonesTemplateArgs = {
  input: UpdateMmTemplateInput;
};


export type MutationUpdateMarathonEventArgs = {
  input: UpdateMarathonEventInput;
};


export type MutationUpdateMonthlyPassArgs = {
  input: UpdateMonthlyPassInput;
};


export type MutationUpdateMonthlyPassMissionsArgs = {
  input: UpdateMonthlyPassMissionsInput;
};


export type MutationUpdatePingUserToUserConfigArgs = {
  input: UpdatePingUserToUserConfigInput;
};


export type MutationUpdatePosterArgs = {
  input: UpdatePosterInput;
};


export type MutationUpdatePushTokenArgs = {
  input: UpdatePushTokenInput;
};


export type MutationUpdateQuizLiveShowContentPacksArgs = {
  input: UpdateQuizLiveShowContentPacksInput;
};


export type MutationUpdateQuizLiveShowRoundArgs = {
  input: UpdateQuizLiveShowRoundInput;
};


export type MutationUpdateReferralRewardStatusToPendingArgs = {
  input?: InputMaybe<UpdateReferralRewardStatusToPendingInput>;
};


export type MutationUpdateReplacingCurationContentPackArgs = {
  input: UpdateReplacingCurationContentPackInput;
};


export type MutationUpdateSaleEventArgs = {
  input: UpdateSaleEventInput;
};


export type MutationUpdateSongQuestionableStatusArgs = {
  input?: InputMaybe<UpdateSongQuestionableStatusInput>;
};


export type MutationUpdateSpecialEventArgs = {
  input: UpdateSpecialEventInput;
};


export type MutationUpdateSpecialEventContentPacksArgs = {
  input: UpdateSpecialEventContentPacksInput;
};


export type MutationUpdateSpecialEventMilestonesArgs = {
  input: UpdateSpecialEventMilestonesInput;
};


export type MutationUpdateSpecialEventMissionsArgs = {
  input: UpdateSpecialEventMissionsInput;
};


export type MutationUpdateSpecialEventPlusMilestonesArgs = {
  input: UpdateSpecialEventPlusMilestonesInput;
};


export type MutationUpdateSpecialEventRankGroupsArgs = {
  input: UpdateSpecialEventRankGroupsInput;
};


export type MutationUpdateSubscriptionTierArgs = {
  input: UpdateSubscriptionTierInput;
};


export type MutationUpdateTeamArgs = {
  input: UpdateTeamInput;
};


export type MutationUpdateTeamBoostsArgs = {
  input: UpdateTeamBoostsInput;
};


export type MutationUpdateTeamHeatArgs = {
  input: TeamHeatUpdateInput;
};


export type MutationUpdateTeamHeatIterationMilestonesArgs = {
  input: TeamHeatIterationInput;
};


export type MutationUpdateTeamShopItemArgs = {
  item: CreateUpdateTeamShopItemInput;
  itemId: Scalars['ID'];
};


export type MutationUpdateTournamentArgs = {
  input: UpdateTournamentInput;
};


export type MutationUpdateTournamentContentPacksArgs = {
  input: UpdateTournamentContentPacksInput;
};


export type MutationUpdateTournamentMilestonesArgs = {
  input: UpdateTournamentMilestonesInput;
};


export type MutationUpdateTournamentRankGroupsArgs = {
  input: UpdateTournamentRankGroupsInput;
};


export type MutationUpdateUnsupportedPopupConfigArgs = {
  input: UpdateUnsupportedPopupConfigInput;
};


export type MutationUpdateUpdateGiftHistoryArgs = {
  betaAndroidVersions?: InputMaybe<Array<Scalars['Int']>>;
  betaIosVersions?: InputMaybe<Array<Scalars['Int']>>;
  eligibleAndroidVersions?: InputMaybe<Array<Scalars['Int']>>;
  eligibleIosVersions?: InputMaybe<Array<Scalars['Int']>>;
  gift1Amount?: InputMaybe<Scalars['Int']>;
  gift1Type?: InputMaybe<Scalars['String']>;
  gift2Amount?: InputMaybe<Scalars['Int']>;
  gift2Type?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};


export type MutationUpdateUserBasicTierContentPackArgs = {
  input: UpdateUserBasicTierContentPackInput;
};


export type MutationUpdateUserContentItemStatusArgs = {
  input: UpdateUserContentItemStatusInput;
};


export type MutationUpdateUserDisplayNameArgs = {
  input: UpdateUserDisplayNameInput;
};


export type MutationUpdateUserEmojiPackArgs = {
  input: UpdateUserEmojiPackInput;
};


export type MutationUpdateUserHurdleQuizArgs = {
  input: UpdateUserHurdleQuizInput;
};


export type MutationUpdateUserInfluencerArgs = {
  input: UpdateUserInfluencerInput;
};


export type MutationUpdateUserMarathonAchievementProgressArgs = {
  input: UpdateUmeAchievement;
};


export type MutationUpdateUserMarathonEventArgs = {
  input: UpdateUserMarathonEventInput;
};


export type MutationUpdateUserPictureArgs = {
  input: UpdateUserPictureInput;
};


export type MutationUpdateUserRoleArgs = {
  input: UpdateUserRoleInput;
};


export type MutationUpdateUserSelectedCategoriesArgs = {
  input: UpdateUserSelectedCategoriesInput;
};


export type MutationUpdateUserSettingsArgs = {
  input: UpdateUserSettingsInput;
};


export type MutationUpdateUserSpecialEventPointsArgs = {
  input: UpdateUserSpecialEventPointsInput;
};


export type MutationUpdateUserToUserQuizLiveRoundStateArgs = {
  input: UpdateUserToUserQuizLiveRoundStateInput;
};


export type MutationUpdateWfRewardTemplateArgs = {
  input: UpdateWfrTemplateInput;
};


export type MutationUpdateWheelFortuneEventArgs = {
  input: UpdateWfEventInput;
};


export type MutationUpgradeItemArgs = {
  input: UpgradeItemInput;
};


export type MutationUpgradeUserContentPackArgs = {
  input: UpgradeUserContentPackInput;
};


export type MutationUploadAssetArgs = {
  input: UploadAssetInput;
};


export type MutationUploadBadgeAssetsArgs = {
  input: UploadBadgeAssetInput;
};


export type MutationUploadBatchEmojiAssetArgs = {
  input: UploadBatchEmojiAssetInput;
};


export type MutationUploadChainedOfferEventAssetArgs = {
  input?: InputMaybe<UploadChainedOfferEventAssetInput>;
};


export type MutationUploadCollectionAssetsArgs = {
  input: UploadCollectionAssetInput;
};


export type MutationUploadEmojiAssetArgs = {
  input: UploadEmojiAssetInput;
};


export type MutationUploadEmojiPackAssetArgs = {
  input: UploadEmojiPackAssetInput;
};


export type MutationUploadEmojisFontArgs = {
  input: UploadEmojisFontInput;
};


export type MutationUploadIconAssetArgs = {
  input: UploadIconAssetInput;
};


export type MutationUploadLiveShowCharacterAssetArgs = {
  input: UploadAssetInput;
};


export type MutationUploadLiveShowHeaderAssetArgs = {
  input: UploadAssetInput;
};


export type MutationUploadPosterAssetsArgs = {
  input: UploadPosterAssetInput;
};


export type MutationUploadSaleEventAssetArgs = {
  input: UploadSaleEventAssetInput;
};


export type MutationUploadSheetArgs = {
  input: UploadSheetInput;
};


export type MutationUploadSpecialEventAssetArgs = {
  input: UploadSpecialEventAssetInput;
};


export type MutationUploadTournamentCharacterAssetArgs = {
  input: UploadAssetInput;
};


export type MutationUploadTournamentHeaderAssetArgs = {
  input: UploadAssetInput;
};


export type MutationUploadUserGeneratedPictureArgs = {
  input: UploadUserGeneratedPictureInput;
};


export type MutationUpsertLoyaltyCampaignConfigArgs = {
  amount: Scalars['Int'];
  id: Scalars['ID'];
};


export type MutationUpsertQuizLiveShowArgs = {
  input: UpsertQuizLiveShowInput;
};


export type MutationUseFreeReviveInMarathonArgs = {
  input: ResumeMarathonRoundInput;
};


export type MutationUseReviveInMarathonArgs = {
  input: UseReviveInMarathonInput;
};


export type MutationUseHurdleHintBoostArgs = {
  input?: InputMaybe<UseHurdleHintBoostInput>;
};


export type MutationUseQuizLiveShowBoostArgs = {
  input: UseQuizLiveShowBoostInput;
};


export type MutationUseRemove2BoostArgs = {
  isMarathon?: InputMaybe<Scalars['Boolean']>;
};

export type NewAppVersionsPayload = {
  __typename: 'NewAppVersionsPayload';
  updateGift?: Maybe<LatestUpdateGift>;
  versions: Array<AppVersionConfig>;
};

export type NextLevelsInput = {
  asset: Scalars['String'];
};

export type NoReturnMutationPayload = {
  __typename: 'NoReturnMutationPayload';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export enum NotificationPreset {
  CUSTOM = 'CUSTOM',
  LIVE_SHOW_START_SOON = 'LIVE_SHOW_START_SOON',
  SONG_OF_THE_DAY = 'SONG_OF_THE_DAY'
}

export type NumericAggregatedMetrics = {
  __typename: 'NumericAggregatedMetrics';
  P0: Scalars['Float'];
  P10: Scalars['Float'];
  P20: Scalars['Float'];
  P30: Scalars['Float'];
  P40: Scalars['Float'];
  P50: Scalars['Float'];
  P71: Scalars['Float'];
  P85: Scalars['Float'];
  P95: Scalars['Float'];
  P99: Scalars['Float'];
  P100: Scalars['Float'];
  average: Scalars['Float'];
  count: Scalars['Int'];
  datetime: Scalars['Date'];
  env: Scalars['String'];
  id: Scalars['String'];
  mode: ServerMode;
  name: Scalars['String'];
  std: Scalars['Float'];
  timestamp: MetricTimestamp;
  type: MetricType;
};

export type NumericAggregatedMetricsSerie = {
  __typename: 'NumericAggregatedMetricsSerie';
  bytesProcessed: Scalars['Int'];
  end: Scalars['String'];
  records: Array<NumericAggregatedMetrics>;
  start: Scalars['String'];
  timestamp: MetricTimestamp;
  title: Scalars['String'];
};

export type NumericAggregatedRedisCountMetrics = {
  __typename: 'NumericAggregatedRedisCountMetrics';
  cache_hit: Scalars['Int'];
  cache_miss: Scalars['Int'];
  cache_miss_ratio: Scalars['Float'];
  count: Scalars['Int'];
  datetime: Scalars['Date'];
  env: Scalars['String'];
  id: Scalars['String'];
  mode: ServerMode;
  name: Scalars['String'];
  timeout: Scalars['Int'];
  timeout_ratio: Scalars['Float'];
  timestamp: MetricTimestamp;
  type: MetricType;
};

export type NumericAggregatedRedisCountMetricsSerie = {
  __typename: 'NumericAggregatedRedisCountMetricsSerie';
  bytesProcessed: Scalars['Int'];
  end: Scalars['String'];
  records: Array<NumericAggregatedRedisCountMetrics>;
  start: Scalars['String'];
  timestamp: MetricTimestamp;
  title: Scalars['String'];
};

export type OnMissionProgressPayload = {
  __typename: 'OnMissionProgressPayload';
  source?: Maybe<MissionProgressSource>;
  updatedMissions: Array<MissionProgress>;
  user: User;
};

export type OnSpecialEventUpdatedPayload = {
  __typename: 'OnSpecialEventUpdatedPayload';
  specialEvent: SpecialEvent;
};

export type OnTeammateJoinedShowPayload = {
  __typename: 'OnTeammateJoinedShowPayload';
  /** liveShowParticipants is updated even if the user making the request is not on its team pod */
  liveShowParticipants: Array<User>;
  /** For now team.liveShowParticipants, only works if the user making the request is on the pod the team members are playing on */
  team: Team;
};

export type OnUserToUserQuizArchivePayload = {
  __typename: 'OnUserToUserQuizArchivePayload';
  user: User;
  userToUser: UserToUser;
};

export type OnUserToUserQuizTurnGameChangePayload = {
  __typename: 'OnUserToUserQuizTurnGameChangePayload';
  user: User;
  userToUser: UserToUser;
};

export type PaginatedFriendHurdleQuiz = {
  __typename: 'PaginatedFriendHurdleQuiz';
  hasMore: Scalars['Boolean'];
  id: Scalars['ID'];
  list: Array<FriendHurdleQuiz>;
  totalCount: Scalars['Int'];
};

export type PaginationParams = {
  limit: Scalars['Int'];
  offset?: Scalars['Int'];
};

export type PaidCalendar = {
  __typename: 'PaidCalendar';
  calendarItems: Array<PaidCalendarReward>;
  endDate: Scalars['Date'];
  filterUserIds: Array<Scalars['ID']>;
  filterVersion?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  name: Scalars['String'];
  purchaseReward?: Maybe<PaidCalendarReward>;
  skuId?: Maybe<Scalars['String']>;
  startDate: Scalars['Date'];
};

export type PaidCalendarReward = {
  __typename: 'PaidCalendarReward';
  amount: Scalars['Int'];
  itemId?: Maybe<Scalars['ID']>;
  type: Scalars['String'];
};

export type PickUserToUserQuizLiveRoundContentPackInput = {
  contentPackId: Scalars['ID'];
  userToUserQuizLiveRoundId: Scalars['ID'];
};

export type PiggyBank = {
  __typename: 'PiggyBank';
  appId: Scalars['ID'];
  coins?: Maybe<Scalars['Int']>;
  diamonds?: Maybe<Scalars['Int']>;
  reminderLastSeen?: Maybe<Scalars['Date']>;
  userId: Scalars['ID'];
};

export type PiggyBankInput = {
  coins?: InputMaybe<Scalars['Int']>;
  diamonds?: InputMaybe<Scalars['Int']>;
};

export type PiggyBankPack = BundlePack & {
  __typename: 'PiggyBankPack';
  cost: Scalars['Float'];
  id: Scalars['String'];
  rewards: Array<LevelReward>;
  sku: Scalars['String'];
};

export type PingEventTypeConfig = {
  __typename: 'PingEventTypeConfig';
  isMuted: Scalars['Boolean'];
  type: PingUserToUserEventType;
};

export type PingEventTypeConfigs = {
  __typename: 'PingEventTypeConfigs';
  availableForLiveGame: PingEventTypeConfig;
  playTurnGame: PingEventTypeConfig;
};

export type PingInput = {
  clientDate?: InputMaybe<Scalars['Date']>;
};

export type PingPayload = {
  __typename: 'PingPayload';
  clientDate?: Maybe<Scalars['Date']>;
  serverDate: Scalars['Date'];
};

/** For now we just need an event when a player is starting to play a turn game challenge, but we can add more in the future (eg. LOOK_AT_PROFILE) */
export enum PingUserToUserEventType {
  AVAILABLE_FOR_LIVE_GAME = 'AVAILABLE_FOR_LIVE_GAME',
  PLAY_TURN_GAME = 'PLAY_TURN_GAME'
}

export type PingUserToUserInput = {
  eventType: PingUserToUserEventType;
  userToUserId: Scalars['ID'];
};

export type PingUserToUserPayload = {
  __typename: 'PingUserToUserPayload';
  eventType: PingUserToUserEventType;
  userToUser: UserToUser;
};

export enum PopupPlacement {
  MAIN_MENU = 'MAIN_MENU',
  PROFILE = 'PROFILE',
  SETTINGS = 'SETTINGS',
  SHOP = 'SHOP'
}

export type Poster = {
  __typename: 'Poster';
  asset?: Maybe<Scalars['String']>;
  currencyCost?: Maybe<Scalars['Int']>;
  currencyType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  itemId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: PosterType;
};

export enum PosterType {
  BADGE = 'BADGE',
  FRAME = 'FRAME',
  POSTER = 'POSTER',
  STICKER = 'STICKER',
  VINYL = 'VINYL'
}

export type PracticeQuiz = {
  __typename: 'PracticeQuiz';
  contentPack: ContentPack;
  id: Scalars['ID'];
  questions: Array<QuizQuestion>;
};

export type PreviousAggregatedMetricsInput = {
  env?: InputMaybe<ServerEnv>;
  filterOutSubscriptions?: InputMaybe<Scalars['Boolean']>;
  maxNumberOfRequests?: InputMaybe<Scalars['Int']>;
  maxNumberOfTimestamps?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<ServerMode>;
  orderQuery?: InputMaybe<MetricOrderBy>;
  skipTimestamps?: InputMaybe<Scalars['Int']>;
  timestamp: MetricTimestamp;
  type: MetricType;
};

export type ProcessExportRequestInput = {
  requestId: Scalars['String'];
};

export type ProcessExportRequestPayload = {
  __typename: 'ProcessExportRequestPayload';
  userExport: UserExport;
};

export enum ProfileBadgeType {
  CATEGORY = 'CATEGORY',
  LIVE_EVENT = 'LIVE_EVENT',
  PROGRESS = 'PROGRESS',
  RARE = 'RARE',
  SHOP = 'SHOP',
  SP2 = 'SP2'
}

export type ProfileFrame = Item & {
  __typename: 'ProfileFrame';
  allLevelItems: Array<Item>;
  asset: Scalars['String'];
  availability: ItemAvailability;
  cost?: Maybe<Currency>;
  id: Scalars['ID'];
  level: Scalars['Int'];
  liveOpsAvailability: ItemAvailability;
  name: Scalars['String'];
  nextLevelItem?: Maybe<Item>;
  nextLevelItems: Array<Item>;
};

export type ProfileFramePaginated = {
  __typename: 'ProfileFramePaginated';
  hasMore: Scalars['Boolean'];
  list: Array<ProfileFrame>;
  totalCount: Scalars['Int'];
};

export type Promotion = {
  __typename: 'Promotion';
  claimedDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  isAvailable: Scalars['Boolean'];
  isClaimed: Scalars['Boolean'];
  rewards: Array<LevelReward>;
};

export type PurchaseBoostPackInput = {
  amount?: InputMaybe<Scalars['Int']>;
  boostPackId: Scalars['ID'];
  liveShowId?: InputMaybe<Scalars['String']>;
};

export type PurchaseBoostPackPayload = {
  __typename: 'PurchaseBoostPackPayload';
  sale?: Maybe<Sale>;
  user: User;
};

export type PurchaseCalendarInput = {
  calendarId: Scalars['ID'];
  priceAmount?: InputMaybe<Scalars['Float']>;
  priceCurrency?: InputMaybe<Scalars['String']>;
  receipt: Scalars['String'];
  sku: Scalars['ID'];
  store: Scalars['String'];
};

export type PurchaseCurrencyPackInput = {
  priceAmount?: InputMaybe<Scalars['Float']>;
  priceCurrency?: InputMaybe<Scalars['String']>;
  /** Only send receipt if the currency pack is purchasable via IAP */
  receipt?: InputMaybe<Scalars['String']>;
  sku: Scalars['ID'];
  store: StoreType;
};

export type PurchaseCurrencyPackPayload = {
  __typename: 'PurchaseCurrencyPackPayload';
  pack?: Maybe<CurrencyPack>;
  sale?: Maybe<Sale>;
  user: User;
};

export type PurchaseEmojiInput = {
  id: Scalars['ID'];
  saleId?: InputMaybe<Scalars['ID']>;
};

export type PurchaseEmojiPayload = {
  __typename: 'PurchaseEmojiPayload';
  user: User;
};

export type PurchaseItemInput = {
  itemId: Scalars['ID'];
};

export enum PurchaseLimitEnum {
  PER_DAY = 'PER_DAY',
  PER_SALE = 'PER_SALE',
  UNLIMITED = 'UNLIMITED'
}

export type PurchasePiggyBankInput = {
  receipt?: InputMaybe<Scalars['String']>;
  sku: Scalars['ID'];
  store: StoreType;
};

export type PurchasePiggyBankPayload = {
  __typename: 'PurchasePiggyBankPayload';
  user: User;
};

export type PurchaseSaleBundlePackInput = {
  priceAmount?: InputMaybe<Scalars['Float']>;
  priceCurrency?: InputMaybe<Scalars['String']>;
  receipt?: InputMaybe<Scalars['String']>;
  sku: Scalars['ID'];
  store: StoreType;
};

export type PurchaseSaleBundlePackPayload = {
  __typename: 'PurchaseSaleBundlePackPayload';
  saleBundlePack: SaleBundlePack;
  user: User;
};

export type PurchaseStarterPackInput = {
  priceAmount?: InputMaybe<Scalars['Float']>;
  priceCurrency?: InputMaybe<Scalars['String']>;
  receipt?: InputMaybe<Scalars['String']>;
  sku: Scalars['ID'];
  store: StoreType;
};

export type PurchaseStarterPackPayload = {
  __typename: 'PurchaseStarterPackPayload';
  starterPack: StarterPack;
  user: User;
};

export type PurchaseSubscriptionDaysInput = {
  receipt?: InputMaybe<Scalars['String']>;
  sku: Scalars['ID'];
  store: StoreType;
};

export type PurchaseSubscriptionDaysPayload = {
  __typename: 'PurchaseSubscriptionDaysPayload';
  user: User;
};

export type PurchaseSubscriptionInput = {
  priceAmount?: InputMaybe<Scalars['Float']>;
  priceCurrency?: InputMaybe<Scalars['String']>;
  receipt: Scalars['String'];
  sku: Scalars['ID'];
  store: StoreType;
};

export type PurchaseSubscriptionPayload = {
  __typename: 'PurchaseSubscriptionPayload';
  user?: Maybe<User>;
};

export type Query = {
  __typename: 'Query';
  activeConnections: Scalars['Int'];
  /** Only used for AppCenter Test. This endpoint does nothing for beta/production */
  activeUserSubscriptionUpdateLogs: ActiveUserSubscriptionUpdateLogsPayload;
  adminSearchUsersForRecovery: AdminSearchUsersPayload;
  agentToUser?: Maybe<AgentToUser>;
  /**
   * All special events (even draft) - order by start date DESC
   * @deprecated use LiveOps.specialEvents
   */
  allSpecialEvents: SpecialEventPaginated;
  /** Entry point for analytics queries */
  analytics: Analytics;
  /** Entry point for all game data not related to a user */
  app: App;
  badgesProfile: BadgePaginated;
  batchContentModeration: BatchContentModeration;
  batchContentModerationList: BatchContentModerationPaginated;
  canLinkToSp2: Sp2LinkResult;
  checkMusicReportStatus: CheckMusicReportStatusPayload;
  collectionById: UserCollection;
  combinedMusicReportStatus: MusicReportPayload;
  combinedMusicReportStatusByDate: MusicReportPayload;
  contentPackList?: Maybe<ContentPackList>;
  contentPackLists: ContentPackListPaginated;
  conversation?: Maybe<Conversation>;
  curation: Curation;
  /** Gets a curation content item based on its ID. Can be either a CurationSong, CurationSongInput or CurationQuizQuestion. */
  curationContentItem: CurationContentItem;
  /** Gets a CCP based on the version and the ID of the last version. By default, returns the last version. */
  curationContentPack: CurationContentPack;
  curationContentPackList?: Maybe<CurationContentPackList>;
  curationContentPackLists: CurationContentPackListPaginated;
  /**
   * Searches CCPs by name. Very simple search algorithm that checks if the provided search term is a substring
   * of the CCP name, ignoring case
   */
  curationContentPacksByName: Array<CurationContentPack>;
  /** Searches songs in the DDEX database, based on various parameters */
  curationSongDDEXSearch: Array<DdexSong>;
  /** Searches songs in the Spanner database, based on various parameters */
  curationSongDatabaseSearch: Array<CurationSongInput>;
  /**
   * Return all quizes for the user, active and future, order by (startDate, endDate), paginated
   * For the given type and namespace
   */
  currentHurdleQuizzes: HurdleQuizzesPaginated;
  currentTeamShop: Array<UserTeamShopItem>;
  ddexJob?: Maybe<DdexJob>;
  ddexJobTasks: Array<DdexTask>;
  ddexJobs: DdexJobsPaginated;
  /** Returns didomi notice id based on country code, from hardcoded configuration on the server */
  didomiNoticeId: Scalars['String'];
  emojiPacksById: EmojiPacksByIdPayload;
  /** @deprecated use listFutureQuizLiveShows instead */
  futureQuizLiveShows: Array<QuizLiveShow>;
  generateSubscriptionPromoSignature?: Maybe<IosSubscriptionPromoSignature>;
  getAppVersionConfigs: Array<AppVersionConfig>;
  getCalendars: Array<PaidCalendar>;
  getDraftGifts: Array<IapGiftDraft>;
  getEligibleRecipients: Array<RecipientInfo>;
  getExternalLinkForSong?: Maybe<SongExternalLinks>;
  /** Return additionnal contentPack suggestions for the player to choose from */
  getFTUEContentPackCatalog: FtueContentPackCatalogPayload;
  getImportantEvents: Array<ImportantEvent>;
  getLatestUpdateGift?: Maybe<LatestUpdateGift>;
  /**
   * Returns didomi notice id, kids mode age, CMP forbidden age and ATT forbidden age,
   * based on country code, from hardcoded configuration on the server
   */
  getLegalSetup: LegalSetup;
  getLinkState?: Maybe<LinkInfoPayload>;
  getLinkStateAdmin: LinkInfoPayload;
  getLinkStateBySp3IdFromSp2: LinkInfoPayload;
  getLinkStateFromSp2: LinkInfoPayload;
  getMessageTemplates: Array<MessageTemplate>;
  getNewAppVersions: Array<AppVersionConfig>;
  getNewAppVersionsPayload: NewAppVersionsPayload;
  getPotentialNumberOfRecipients: AdminGiftPayload;
  getSignedDownloadUrl: GetSignedDownloadUrlPayload;
  getSongSampleByIds: Array<Maybe<SongSample>>;
  getUnsupportedPopupConfigs: Array<UnsupportedPopupConfig>;
  getUserCalendars: Array<UserPaidCalendar>;
  /**
   * Returns legal age-gate status for current user and country.
   * This is expected to be used after login.
   */
  getUserLegalSetup: UserLegalSetup;
  /**
   * Autocomplete user search: for a few characters given by user input get
   * some number of matching songs.
   * For performance reasons
   *     - only return id title, artist
   *     - is specific to the type of
   */
  hurdleAutoComplete: HurdleAutoCompletePayload;
  /**
   * Get all hurdle quiz between 2 dates, for a given type/namespace, past or future
   * In admin mode, will return everything
   */
  hurdleCalendar: HurdleCalendarPayload;
  /** Read one */
  hurdleCatalogItem: HurdleCatalogItemPayload;
  /** Read many */
  hurdleCatalogItemList: HurdleCatalogItemListPayload;
  /** Get a single quiz */
  hurdleQuiz: HurdleQuizPayload;
  /** search item (Sticker/AppSkin/Profile/Frame) */
  item?: Maybe<Item>;
  listFutureQuizLiveShows: QuizLiveShowsPaginated;
  liveEvent?: Maybe<LiveEvent>;
  /** Entry points for everything related to live ops. Schedule/create live items/events */
  liveOps: LiveOps;
  loyaltyCampaignCards: Array<LoyaltyCampaignCard>;
  loyaltyCampaignConfigs: Array<LoyaltyCampaignConfig>;
  loyaltyCampaignNextRefreshAt?: Maybe<Scalars['Date']>;
  loyaltyCampaignServerNow: Scalars['Date'];
  lyrics: LyricsResult;
  marathonEvent?: Maybe<MarathonEvent>;
  /**
   * The current User
   * @throw USER_DELETED
   */
  me: User;
  moderationContentItems?: Maybe<ModeratedContentItemPaginated>;
  monitoringBetween: MetricsSerie;
  monitoringPrevious: MetricsSerie;
  monitoringRequestNames: Array<Scalars['String']>;
  monitoringSpecificRequestsBetween: MetricsSerie;
  monitoringSpecificRequestsPrevious: MetricsSerie;
  monthlyPassLeaderboardNotClaimed?: Maybe<UserMonthlyPass>;
  musicReports: MusicReportPaginated;
  /** @deprecated use LiveOps.quizLiveShows */
  pastQuizLiveShows: QuizLiveShowsPaginated;
  pastSpecialEvents: SpecialEventPaginated;
  /** @deprecated use LiveOps.tournaments */
  pastTournaments: TournamentPaginated;
  ping: PingPayload;
  /**
   * Count of active connections on a specific pod.
   * Helpful for k8s autoscaling
   */
  podInstanceIP: Scalars['String'];
  posters: Array<Poster>;
  /**
   * Get a practice quiz. Used during FTUE
   * allowExplicitContent is deprecated (and should be removed after March 1st 2021)
   */
  practiceQuiz: Array<PracticeQuiz>;
  quizLiveShow?: Maybe<QuizLiveShow>;
  quizLiveShowUser?: Maybe<Array<Maybe<QuizLiveShowUser>>>;
  /** Search ContentCategories by name */
  searchContentCategories: Array<ContentCategory>;
  /**
   * Search ContentPack by ContentPackSearchType filtered by
   * ContentPackType - sorted by name first (when searching by name) by popularity DESC
   */
  searchContentPacks: ContentPackPaginated;
  /**
   * Search ContentPack by ContentPackSearchType filtered by
   * ContentPackType - sorted by name first (when searching by name) by popularity DESC
   */
  searchFTUEContentPacks: ContentPackPaginated;
  /**
   * Search UserContentPack by ContentSearchType filtered by
   * ContentPackType - sorted by name (when searching by name) & popularity DESC
   */
  searchUserContentPacks: UserContentPackPaginated;
  sp2CurationPlaylist?: Maybe<Sp2CurationPlaylist>;
  sp2Playlists?: Maybe<Sp2PlaylistsResult>;
  sp2ReleaseStatus: Sp2ReleaseStatus;
  specialEvent?: Maybe<SpecialEvent>;
  specialEvents: SpecialEventPaginated;
  specialEventsNotClaimed: SpecialEventPaginated;
  /** Streak history data */
  streakHistory?: Maybe<StreakHistoryPayload>;
  teamById: Team;
  teamMonthlyPass: TeamMonthlyPass;
  teamMonthlyPassNotClaimed: TeamMonthlyPassPaginated;
  /** represent rank groups for current teamMonthlyPass */
  teamMonthlyPassRankGroupsRewards: Array<LbRankGroup>;
  teamPreviousSeasons: Array<TeamPreviousSeasonPayload>;
  teamPromotion: TeamPromotion;
  teamPromotionNewLeader?: Maybe<TeamPromotionNewLeaderPayload>;
  teamShop: TeamShopPaginated;
  /** @deprecated use teamsByNamePaginated instead */
  teamsByName: Array<Team>;
  teamsByNamePaginated: TeamsByNamePaginated;
  /** @deprecated use teamsByRecommendationPaginated instead */
  teamsByRecommendation: Array<Team>;
  teamsByRecommendationPaginated: TeamsByRecommendationPaginated;
  tournament?: Maybe<Tournament>;
  tournaments: TournamentPaginated;
  tournamentsNotClaimed: TournamentPaginated;
  updateGiftHistory: Array<UpdateGiftHistory>;
  /** Search a user by its attribute */
  user?: Maybe<User>;
  userBadgesAdmin: Array<Badge>;
  userCollections: Array<UserCollection>;
  /** Search content pack by contentPackId */
  userContentPack?: Maybe<UserContentPack>;
  /** Search content packs by attributes */
  userContentPacks: ContentPackSearchPayload;
  userExports: UserExportsPayload;
  userGiftStatusAdmin: Array<GiftInfo>;
  /** The user settings for the current user and device */
  userSettings: UserSettings;
  userToUser?: Maybe<UserToUser>;
  userToUserByOpponentId?: Maybe<UserToUser>;
  /** Search list of users by their attributes */
  users: Array<User>;
  /** Check and return warning messages about hurdle quiz config */
  validateHurdleQuizConfig?: Maybe<ValidateHurdleQuizConfigPayload>;
  version: Scalars['String'];
  wheelFortuneEvent?: Maybe<WheelFortuneEvent>;
};


export type QueryActiveUserSubscriptionUpdateLogsArgs = {
  input: ActiveUserSubscriptionUpdateLogsInput;
};


export type QueryAdminSearchUsersForRecoveryArgs = {
  input: AdminSearchUsersInput;
};


export type QueryAgentToUserArgs = {
  id: Scalars['ID'];
};


export type QueryAllSpecialEventsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryBadgesProfileArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<ProfileBadgeType>;
};


export type QueryBatchContentModerationArgs = {
  id: Scalars['ID'];
};


export type QueryBatchContentModerationListArgs = {
  pagination?: InputMaybe<PaginationParams>;
};


export type QueryCanLinkToSp2Args = {
  input: LinkTokenInput;
};


export type QueryCheckMusicReportStatusArgs = {
  month: Scalars['Int'];
  year: Scalars['Int'];
};


export type QueryCollectionByIdArgs = {
  collectionId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type QueryCombinedMusicReportStatusArgs = {
  id: Scalars['String'];
};


export type QueryCombinedMusicReportStatusByDateArgs = {
  month: Scalars['Int'];
  year: Scalars['Int'];
};


export type QueryContentPackListArgs = {
  contentPackListId: Scalars['ID'];
};


export type QueryContentPackListsArgs = {
  pagination?: InputMaybe<PaginationParams>;
};


export type QueryConversationArgs = {
  id: Scalars['ID'];
};


export type QueryCurationContentItemArgs = {
  id: Scalars['ID'];
  songInputId?: InputMaybe<Scalars['ID']>;
};


export type QueryCurationContentPackArgs = {
  id?: InputMaybe<Scalars['ID']>;
  originId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryCurationContentPackListArgs = {
  id: Scalars['ID'];
};


export type QueryCurationContentPackListsArgs = {
  appId: Scalars['ID'];
  pagination?: InputMaybe<PaginationParams>;
};


export type QueryCurationContentPacksByNameArgs = {
  name: Scalars['String'];
};


export type QueryCurationSongDdexSearchArgs = {
  term: CurationSongSearchTerm;
};


export type QueryCurationSongDatabaseSearchArgs = {
  term: CurationSongSearchTerm;
};


export type QueryCurrentHurdleQuizzesArgs = {
  input: CurrentHurdleQuizzesInput;
};


export type QueryDdexJobArgs = {
  jobId: Scalars['ID'];
};


export type QueryDdexJobTasksArgs = {
  jobId?: InputMaybe<Scalars['ID']>;
};


export type QueryDdexJobsArgs = {
  pagination?: InputMaybe<PaginationParams>;
};


export type QueryDidomiNoticeIdArgs = {
  countryCode: Scalars['String'];
};


export type QueryEmojiPacksByIdArgs = {
  input: EmojiPacksByIdInput;
};


export type QueryGenerateSubscriptionPromoSignatureArgs = {
  input: GenerateSubscriptionPromoSignatureInput;
};


export type QueryGetEligibleRecipientsArgs = {
  sku: Scalars['String'];
};


export type QueryGetExternalLinkForSongArgs = {
  isSpotify: Scalars['Boolean'];
  songId: Scalars['ID'];
};


export type QueryGetFtueContentPackCatalogArgs = {
  categoryIds: Array<Scalars['ID']>;
  contentPackIdsToExclude: Array<Scalars['ID']>;
  isExplicitContentExcluded: Scalars['Boolean'];
};


export type QueryGetImportantEventsArgs = {
  input: GetImportantEventsInput;
};


export type QueryGetLegalSetupArgs = {
  countryCode: Scalars['String'];
};


export type QueryGetLinkStateAdminArgs = {
  input: Sp3IdInput;
};


export type QueryGetLinkStateBySp3IdFromSp2Args = {
  input: Sp3IdInput;
};


export type QueryGetLinkStateFromSp2Args = {
  input: Sp2IdInput;
};


export type QueryGetPotentialNumberOfRecipientsArgs = {
  filters: GiftFiltersInput;
};


export type QueryGetSignedDownloadUrlArgs = {
  input: GetSignedDownloadUrlInput;
};


export type QueryGetSongSampleByIdsArgs = {
  songIds: Array<Scalars['ID']>;
};


export type QueryGetUnsupportedPopupConfigsArgs = {
  place: PopupPlacement;
};


export type QueryGetUserLegalSetupArgs = {
  countryCode: Scalars['String'];
};


export type QueryHurdleAutoCompleteArgs = {
  input: HurdleAutoCompleteInput;
};


export type QueryHurdleCalendarArgs = {
  input: HurdleCalendarInput;
};


export type QueryHurdleCatalogItemArgs = {
  input: HurdleCatalogItemInput;
};


export type QueryHurdleCatalogItemListArgs = {
  input: HurdleCatalogItemListInput;
};


export type QueryHurdleQuizArgs = {
  input: HurdleQuizInput;
};


export type QueryItemArgs = {
  property: Scalars['String'];
  type: SearchType;
};


export type QueryListFutureQuizLiveShowsArgs = {
  pagination?: InputMaybe<PaginationParams>;
};


export type QueryLiveEventArgs = {
  liveEventId: Scalars['ID'];
};


export type QueryLyricsArgs = {
  artist: Scalars['String'];
  title: Scalars['String'];
};


export type QueryModerationContentItemsArgs = {
  batchId: Scalars['ID'];
  locale: Scalars['String'];
  packId?: InputMaybe<Scalars['ID']>;
  pagination?: InputMaybe<PaginationParams>;
};


export type QueryMonitoringBetweenArgs = {
  input: BetweenAggregatedMetricsInput;
};


export type QueryMonitoringPreviousArgs = {
  input: PreviousAggregatedMetricsInput;
};


export type QueryMonitoringRequestNamesArgs = {
  input: MonitoringRequestNamesInput;
};


export type QueryMonitoringSpecificRequestsBetweenArgs = {
  input: RequestBetweenAggregatedMetricsInput;
};


export type QueryMonitoringSpecificRequestsPreviousArgs = {
  input: RequestPreviousAggregatedMetricsInput;
};


export type QueryMusicReportsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryPastQuizLiveShowsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryPastSpecialEventsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryPastTournamentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryPingArgs = {
  input?: InputMaybe<PingInput>;
};


export type QueryPracticeQuizArgs = {
  allowExplicitContent?: InputMaybe<Scalars['Boolean']>;
  categoryIds: Array<Scalars['ID']>;
  explicitContent?: InputMaybe<Scalars['Boolean']>;
};


export type QueryQuizLiveShowArgs = {
  showId: Scalars['ID'];
};


export type QueryQuizLiveShowUserArgs = {
  playDate: Scalars['Date'];
  userId: Scalars['ID'];
};


export type QuerySearchContentCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  offset?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchContentPacksArgs = {
  contentType?: InputMaybe<ContentPackType>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search: Scalars['String'];
  searchType: ContentSearchType;
};


export type QuerySearchFtueContentPacksArgs = {
  isExplicitContentExcluded: Scalars['Boolean'];
  pagination?: InputMaybe<PaginationParams>;
  search: Scalars['String'];
  searchType: ContentSearchType;
};


export type QuerySearchUserContentPacksArgs = {
  contentType?: InputMaybe<ContentPackType>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search: Scalars['String'];
  searchType: ContentSearchType;
};


export type QuerySp2CurationPlaylistArgs = {
  id: Scalars['ID'];
};


export type QuerySp2PlaylistsArgs = {
  input: Sp2PlaylistsParams;
};


export type QuerySpecialEventArgs = {
  specialEventId: Scalars['ID'];
};


export type QuerySpecialEventsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QuerySpecialEventsNotClaimedArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryStreakHistoryArgs = {
  input?: InputMaybe<StreakHistoryInput>;
};


export type QueryTeamByIdArgs = {
  teamId: Scalars['ID'];
};


export type QueryTeamMonthlyPassArgs = {
  monthId: Scalars['ID'];
  teamId: Scalars['ID'];
};


export type QueryTeamMonthlyPassNotClaimedArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryTeamPreviousSeasonsArgs = {
  monthId: Scalars['ID'];
  teamId: Scalars['ID'];
};


export type QueryTeamPromotionArgs = {
  teamId: Scalars['ID'];
};


export type QueryTeamPromotionNewLeaderArgs = {
  teamId: Scalars['ID'];
};


export type QueryTeamShopArgs = {
  filter?: InputMaybe<TeamShopFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryTeamsByNameArgs = {
  name: Scalars['String'];
};


export type QueryTeamsByNamePaginatedArgs = {
  name: Scalars['String'];
  pagination?: InputMaybe<PaginationParams>;
};


export type QueryTeamsByRecommendationPaginatedArgs = {
  pagination?: InputMaybe<PaginationParams>;
};


export type QueryTournamentArgs = {
  tournamentId: Scalars['ID'];
};


export type QueryTournamentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryTournamentsNotClaimedArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryUpdateGiftHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryUserArgs = {
  property: Scalars['String'];
  type: UserSearchType;
};


export type QueryUserBadgesAdminArgs = {
  userId: Scalars['ID'];
};


export type QueryUserCollectionsArgs = {
  type?: InputMaybe<CollectionType>;
  userId: Scalars['ID'];
};


export type QueryUserContentPackArgs = {
  id: Scalars['ID'];
};


export type QueryUserContentPacksArgs = {
  property: Scalars['String'];
  type: ContentSearchType;
  userToUserId?: InputMaybe<Scalars['String']>;
};


export type QueryUserExportsArgs = {
  input: UserExportsInput;
};


export type QueryUserGiftStatusAdminArgs = {
  userId: Scalars['ID'];
};


export type QueryUserToUserArgs = {
  id: Scalars['ID'];
};


export type QueryUserToUserByOpponentIdArgs = {
  opponentId: Scalars['ID'];
};


export type QueryUsersArgs = {
  properties: Array<Scalars['String']>;
  type: UserSearchType;
};


export type QueryValidateHurdleQuizConfigArgs = {
  input?: InputMaybe<ValidateHurdleQuizConfigInput>;
};

export type QuizEncryptedQuestion = {
  __typename: 'QuizEncryptedQuestion';
  choiceType?: Maybe<QuizQuestionChoiceType>;
  correctChoiceIndex?: Maybe<Scalars['Int']>;
  end?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  song?: Maybe<Song>;
  start?: Maybe<Scalars['Date']>;
};

export type QuizLiveShow = {
  __typename: 'QuizLiveShow';
  adminSpecialEvent?: Maybe<SpecialEvent>;
  answerGraceDuration: Scalars['Float'];
  category: ContentCategory;
  /**
   * the current User result
   * even if the user didn't participate to the show we return a default QuizLiveShowUser
   */
  currentUserResult?: Maybe<QuizLiveShowUser>;
  diamondPrize: Scalars['Int'];
  extraConfig: ExtraConfig;
  firstQuestionStartDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  lastQuestionStartDate?: Maybe<Scalars['Date']>;
  lastSchedule: LiveShowLastSchedulePayload;
  lastUpdateDate: Scalars['Date'];
  namespace: GameNamespace;
  playerCount: Scalars['Int'];
  rounds: Array<QuizLiveShowRound>;
  specialEvent?: Maybe<SpecialEvent>;
  /** total special event points winners will share if they win the quiz live show - equal 0 if not linked to a specialEvent */
  specialEventPrize: Scalars['Int'];
  /** special event point a player will get for each round win (alive) - equal [] if not linked to a specialEvent */
  specialEventRewards: Array<Maybe<LevelReward>>;
  specialRewards: Array<Maybe<LevelReward>>;
  startDate: Scalars['Date'];
  timeBetweenRound: Scalars['Float'];
  timeLobbyIsOpenBeforeShow: Scalars['Float'];
  timeToCalculateAnswer: Scalars['Float'];
  timeToDecryptBeforeQuestion: Scalars['Float'];
  timeToLoad: Scalars['Float'];
  timeToRevive: Scalars['Float'];
  userPrize: QuizLiveShowUserPrize;
  winners: Array<QuizLiveShowWinner>;
};

export type QuizLiveShowPreset = {
  __typename: 'QuizLiveShowPreset';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type QuizLiveShowResult = {
  __typename: 'QuizLiveShowResult';
  quizLiveShowUser: QuizLiveShowUser;
  winners: Array<QuizLiveShowWinner>;
};

export type QuizLiveShowRound = {
  __typename: 'QuizLiveShowRound';
  contentPack: ContentPack;
  encryptedRoundAssetUrl: Scalars['String'];
  encryptedRoundAssetUrlV2?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastEncryptionDate?: Maybe<Scalars['Date']>;
  liveOpsQuestions: Array<QuizQuestion>;
  questionDuration: Scalars['Float'];
  questions: Array<QuizEncryptedQuestion>;
  startDate?: Maybe<Scalars['Date']>;
};

export type QuizLiveShowUser = {
  __typename: 'QuizLiveShowUser';
  /**
   * Total Coins rewarded during the liveshow (all rounds claimed)
   * Can be null if any round have been claimed
   */
  coinReward?: Maybe<Scalars['Int']>;
  diamondReward?: Maybe<Scalars['Int']>;
  ghostQuestionId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  reviveQuestionId?: Maybe<Scalars['ID']>;
  show: QuizLiveShow;
  /**
   * Total specialEvent points rewarded during the liveshow (all rounds claimed)
   * Can be null if any round have been claimed
   */
  specialEventReward?: Maybe<Scalars['Int']>;
  teammates: Array<User>;
  user: User;
  userRounds: Array<QuizLiveShowUserRound>;
  /**
   * Total XP rewarded during the liveshow (all rounds claimed)
   * Can be null if any round have been claimed
   */
  xpReward?: Maybe<Scalars['Int']>;
};

export type QuizLiveShowUserPrize = {
  __typename: 'QuizLiveShowUserPrize';
  coinPrize: Scalars['Int'];
  id: Scalars['ID'];
};

export type QuizLiveShowUserRound = {
  __typename: 'QuizLiveShowUserRound';
  boostReviveUsedAtQuestionId?: Maybe<Scalars['ID']>;
  boostReviveUsedAtQuestionIndex?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  rewards: Array<LevelReward>;
  round: QuizLiveShowRound;
  specialReward?: Maybe<LevelReward>;
  userAnswers: Array<UserQuizAnswer>;
  userContentPack: UserContentPack;
  userLikedContent: Array<UserContentItem>;
  userNewContent: Array<UserContentItem>;
};

export type QuizLiveShowWinner = {
  __typename: 'QuizLiveShowWinner';
  celebration?: Maybe<Sticker>;
  id: Scalars['ID'];
  user: User;
};

export type QuizLiveShowsPaginated = {
  __typename: 'QuizLiveShowsPaginated';
  hasMore: Scalars['Boolean'];
  id: Scalars['ID'];
  list: Array<QuizLiveShow>;
  totalCount: Scalars['Int'];
};

export type QuizQuestion = {
  __typename: 'QuizQuestion';
  /** @deprecated use song instead */
  a41song?: Maybe<Song>;
  asset?: Maybe<Scalars['String']>;
  choiceType: QuizQuestionChoiceType;
  choices: Array<Scalars['String']>;
  correctChoiceIndex: Scalars['Int'];
  id: Scalars['ID'];
  song?: Maybe<Song>;
  title: Scalars['String'];
};

export enum QuizQuestionChoiceType {
  MUSIC_ARTIST = 'MUSIC_ARTIST',
  MUSIC_TITLE = 'MUSIC_TITLE',
  TRIVIA = 'TRIVIA',
  UNKNOWN = 'UNKNOWN'
}

export type RecipientInfo = {
  __typename: 'RecipientInfo';
  badges: Array<Scalars['String']>;
  emojiPacks: Array<Scalars['String']>;
  emojis: Array<Scalars['String']>;
  frames: Array<Scalars['String']>;
  isFriend: Scalars['Boolean'];
  isTeammate: Scalars['Boolean'];
  loyaltyPoints: Scalars['Int'];
  playlists: Array<Scalars['String']>;
  stickers: Array<Scalars['String']>;
  user: User;
  vinyls: Array<Scalars['String']>;
};

export enum RedisCacheModel {
  ABTEST = 'ABTEST',
  CHAINED_OFFER = 'CHAINED_OFFER',
  SALE_EVENT = 'SALE_EVENT',
  SPECIAL_EVENT = 'SPECIAL_EVENT',
  SUBSCRIPTION_UTIL = 'SUBSCRIPTION_UTIL',
  SYSTEM_EVENT = 'SYSTEM_EVENT',
  UNREAD_COUNT = 'UNREAD_COUNT'
}

export type ReferralReward = {
  __typename: 'ReferralReward';
  fromClaimState: ReferralRewardClaimState;
  fromId: Scalars['String'];
  id: Scalars['ID'];
  opponent: User;
  toClaimState: ReferralRewardClaimState;
  toId: Scalars['String'];
};

export enum ReferralRewardClaimState {
  CLAIMED = 'CLAIMED',
  NEW = 'NEW',
  PENDING = 'PENDING',
  READY_TO_CLAIM = 'READY_TO_CLAIM'
}

export type ReferralRewardPayload = {
  __typename: 'ReferralRewardPayload';
  referralReward: ReferralReward;
  user: User;
};

export type RefillEmptyCapInput = {
  capType: CapType;
  /** method by default if RefillEmptyCapMode.FULL (to be retro-compatible) */
  mode?: InputMaybe<RefillEmptyCapMode>;
};

export enum RefillEmptyCapMode {
  FULL = 'FULL',
  PARTIAL = 'PARTIAL'
}

export type RefillEmptyCapPayload = {
  __typename: 'RefillEmptyCapPayload';
  user: User;
};

export type RefreshSppContentInput = {
  playlists: Scalars['Boolean'];
  questionables: Scalars['Boolean'];
};

export type RefreshUserRedisCacheInput = {
  userId: Scalars['ID'];
};

export type RefreshUserRedisCachePayload = {
  __typename: 'RefreshUserRedisCachePayload';
  user: User;
};

export type RefundLiveShowUserBoostsInput = {
  showId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type RefundLiveShowUserBoostsPayload = {
  __typename: 'RefundLiveShowUserBoostsPayload';
  user: User;
};

export type RegisterAppsFlyerIdInput = {
  appsFlyerId: Scalars['ID'];
};

export type RegisterAppsFlyerIdPayload = {
  __typename: 'RegisterAppsFlyerIdPayload';
  user?: Maybe<User>;
};

export type RegisterSingularDeviceId = {
  aifa?: InputMaybe<Scalars['ID']>;
  asid?: InputMaybe<Scalars['ID']>;
};

export type RegisterSingularDeviceIdPayload = {
  __typename: 'RegisterSingularDeviceIdPayload';
  user?: Maybe<User>;
};

export type RemoveBadgeInput = {
  id: Scalars['ID'];
};

export type RemoveBadgePayload = {
  __typename: 'RemoveBadgePayload';
  badgeDeleted: Scalars['ID'];
};

export type RemoveCalendarAdminPayload = {
  __typename: 'RemoveCalendarAdminPayload';
  isRemoved: Scalars['Boolean'];
};

export type RemoveCollectionPayload = {
  __typename: 'RemoveCollectionPayload';
  id: Scalars['ID'];
};

export type RemoveDraftGiftAdminPayload = {
  __typename: 'RemoveDraftGiftAdminPayload';
  isRemoved: Scalars['Boolean'];
};

export type RemoveFriendInput = {
  userId: Scalars['ID'];
};

export type RemoveFriendPayload = {
  __typename: 'RemoveFriendPayload';
  success?: Maybe<Scalars['Boolean']>;
};

export type RemoveLiveEventContentPackInput = {
  contentPackId: Scalars['ID'];
  liveEventId: Scalars['ID'];
};

export type RemoveLiveEventContentPackPayload = {
  __typename: 'RemoveLiveEventContentPackPayload';
  contentPack: ContentPack;
  liveEvent: LiveEvent;
};

export type RemoveLiveEventInput = {
  liveEventId: Scalars['ID'];
};

export type RemoveLiveEventPayload = {
  __typename: 'RemoveLiveEventPayload';
  isRemoved: Scalars['Boolean'];
};

export type RemoveLiveShowInput = {
  showId: Scalars['ID'];
};

export type RemoveLiveShowPayload = {
  __typename: 'RemoveLiveShowPayload';
  isRemoved: Scalars['Boolean'];
  isUnscheduled?: Maybe<Scalars['Boolean']>;
};

export type RemovePosterPayload = {
  __typename: 'RemovePosterPayload';
  id: Scalars['ID'];
};

export type RemoveSongFromCurationContentPackInput = {
  id: Scalars['ID'];
  songInputId?: InputMaybe<Scalars['ID']>;
  songInputIds?: InputMaybe<Array<Scalars['ID']>>;
  updateCommittedPack?: InputMaybe<Scalars['Boolean']>;
};

export type RemoveSpecialEventContentPackInput = {
  contentPackId: Scalars['ID'];
  specialEventId: Scalars['ID'];
};

export type RemoveSpecialEventContentPackPayload = {
  __typename: 'RemoveSpecialEventContentPackPayload';
  contentPack: ContentPack;
  specialEvent: SpecialEvent;
};

export type RemoveSpecialEventInput = {
  specialEventId: Scalars['ID'];
};

export type RemoveSpecialEventPayload = {
  __typename: 'RemoveSpecialEventPayload';
  isRemoved: Scalars['Boolean'];
};

export type RemoveSpecialEventQuizLiveShowInput = {
  quizLiveShowId: Scalars['ID'];
  specialEventId: Scalars['ID'];
};

export type RemoveSpecialEventQuizLiveShowPayload = {
  __typename: 'RemoveSpecialEventQuizLiveShowPayload';
  quizLiveShow: QuizLiveShow;
  specialEvent: SpecialEvent;
};

export type RemoveSpecialEventTournamentInput = {
  specialEventId: Scalars['ID'];
  tournamentId: Scalars['ID'];
};

export type RemoveSpecialEventTournamentPayload = {
  __typename: 'RemoveSpecialEventTournamentPayload';
  specialEvent: SpecialEvent;
  tournament: Tournament;
};

export type RemoveTournamentInput = {
  id: Scalars['ID'];
};

export type RemoveTournamentPayload = {
  __typename: 'RemoveTournamentPayload';
  isRemoved: Scalars['Boolean'];
};

export type ReorderSongsFromCurationContentPackInput = {
  id: Scalars['ID'];
  songInputIds: Array<Scalars['ID']>;
};

export type ReplaceDdexSongMatchInput = {
  ddexSongId: Scalars['ID'];
  songId: Scalars['ID'];
};

export type ReplaceDdexSongMatchPayload = {
  __typename: 'ReplaceDDEXSongMatchPayload';
  curationSong?: Maybe<CurationSong>;
  ddexSong?: Maybe<DdexSong>;
};

export type ReportSongListenCountInput = {
  appKey: Scalars['String'];
  country: Scalars['String'];
  listenCount: Array<ListenCountInput>;
};

export type ReportSongListenCountPayload = {
  __typename: 'ReportSongListenCountPayload';
  success: Scalars['Boolean'];
};

export type ReportSongSampleInput = {
  contentPackId?: InputMaybe<Scalars['ID']>;
  reason?: InputMaybe<Scalars['String']>;
  songId: Scalars['ID'];
};

export type ReportSongSamplePayload = {
  __typename: 'ReportSongSamplePayload';
  success: Scalars['Boolean'];
};

export type ReportUserInput = {
  comment?: InputMaybe<Scalars['String']>;
  images?: InputMaybe<Array<Scalars['String']>>;
  userId: Scalars['ID'];
};

export type ReportUserPayload = {
  __typename: 'ReportUserPayload';
  user: User;
};

export type RequestBetweenAggregatedMetricsInput = {
  end: Scalars['String'];
  env?: InputMaybe<ServerEnv>;
  mode?: InputMaybe<ServerMode>;
  onlyRequestNames: Array<Scalars['String']>;
  start: Scalars['String'];
  timestamp: MetricTimestamp;
  type: MetricType;
};

export type RequestPreviousAggregatedMetricsInput = {
  env?: InputMaybe<ServerEnv>;
  maxNumberOfTimestamps?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<ServerMode>;
  onlyRequestNames: Array<Scalars['String']>;
  skipTimestamps?: InputMaybe<Scalars['Int']>;
  timestamp: MetricTimestamp;
  type: MetricType;
};

export type RescheduleQuizLiveShowInput = {
  showId: Scalars['ID'];
};

export type ResetHurdleQuizInput = {
  id: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
};

export type ResetHurdleQuizPayload = {
  __typename: 'ResetHurdleQuizPayload';
  hurdleQuiz: HurdleQuiz;
};

export type ResetLiveGameMemoryPayload = {
  __typename: 'ResetLiveGameMemoryPayload';
  nbLiveGameReset: Scalars['Int'];
};

export type ResetLoyaltyCardInput = {
  userId: Scalars['ID'];
};

export type ResetLoyaltyCardPayload = {
  __typename: 'ResetLoyaltyCardPayload';
  user: User;
};

export type ResetMissionProgressInput = {
  missionSetUserId: Scalars['ID'];
};

export type ResetMissionProgressPayload = {
  __typename: 'ResetMissionProgressPayload';
  user: User;
};

export type ResetPromotionInput = {
  promotionId: Scalars['ID'];
};

export type ResetPromotionPayload = {
  __typename: 'ResetPromotionPayload';
  user: User;
};

export type ResetQuizLiveShowRoundQuestionsInput = {
  roundId: Scalars['ID'];
  showId: Scalars['ID'];
};

export type ResetSpecialOfferRewardsInput = {
  userId?: InputMaybe<Scalars['ID']>;
};

export type ResetSpecialOfferRewardsPayload = {
  __typename: 'ResetSpecialOfferRewardsPayload';
  user?: Maybe<User>;
};

export type ResetTeamHeatClaimedMilestonesInput = {
  onlyForMe: Scalars['Boolean'];
  teamId: Scalars['ID'];
};

export type ResetTeamHeatClaimedMilestonesPayload = {
  __typename: 'ResetTeamHeatClaimedMilestonesPayload';
  userMonthlyPass: UserMonthlyPass;
};

export type ResetUserMarathonEventInput = {
  eventId: Scalars['String'];
  isFull: Scalars['Boolean'];
  isLastRound: Scalars['Boolean'];
  userId: Scalars['String'];
};

export type ResetUserMarathonEventPayload = {
  __typename: 'ResetUserMarathonEventPayload';
  userEvent?: Maybe<UserMarathonEvent>;
};

export type ResetUserSubscriptionsInput = {
  userId: Scalars['String'];
};

export type ResetUserSubscriptionsPayload = {
  __typename: 'ResetUserSubscriptionsPayload';
  user: User;
};

export type ResumeMarathonPayload = {
  __typename: 'ResumeMarathonPayload';
  round: UserMarathonRound;
};

export type ResumeMarathonRoundInput = {
  eventId: Scalars['ID'];
  roundId: Scalars['ID'];
};

export enum RetentionSendingType {
  FTUELAPSEDBEFORETURNROUNDBACK1MAIL = 'FtueLapsedBeforeTurnRoundBack1Mail',
  FTUELAPSEDBEFORETURNROUNDBACK1PUSH = 'FtueLapsedBeforeTurnRoundBack1Push',
  FTUELAPSEDBEFORETURNROUNDBACK2MAIL = 'FtueLapsedBeforeTurnRoundBack2Mail',
  FTUELAPSEDBEFORETURNROUNDBACK2PUSH = 'FtueLapsedBeforeTurnRoundBack2Push',
  FTUELAPSEDBEFORETURNROUNDBACK3MAIL = 'FtueLapsedBeforeTurnRoundBack3Mail',
  FTUELAPSEDBEFORETURNROUNDBACK3PUSH = 'FtueLapsedBeforeTurnRoundBack3Push',
  REGULARLAPSEDMAILALLCONTENT = 'RegularLapsedMailAllContent',
  REGULARLAPSEDMAILCONTENTPACKS = 'RegularLapsedMailContentPacks',
  REGULARLAPSEDMAILGOODBYE = 'RegularLapsedMailGoodbye',
  REGULARLAPSEDMAILLASTCHANCE = 'RegularLapsedMailLastChance',
  REGULARLAPSEDMAILNOADS = 'RegularLapsedMailNoAds',
  REGULARLAPSEDMAILPENDINGTURNS = 'RegularLapsedMailPendingTurns',
  REGULARLAPSEDMAILSOMUCHMORE = 'RegularLapsedMailSoMuchMore',
  REGULARLAPSEDMAILSTREAK = 'RegularLapsedMailStreak',
  REGULARLAPSEDNOTIFALLCONTENT = 'RegularLapsedNotifAllContent',
  REGULARLAPSEDNOTIFCONTENTPACKS = 'RegularLapsedNotifContentPacks',
  REGULARLAPSEDNOTIFMONTHEND = 'RegularLapsedNotifMonthEnd',
  REGULARLAPSEDNOTIFNOADS = 'RegularLapsedNotifNoAds',
  REGULARLAPSEDNOTIFPENDINGTURNS = 'RegularLapsedNotifPendingTurns',
  REGULARLAPSEDNOTIFSOMUCHMORE = 'RegularLapsedNotifSoMuchMore',
  WELCOMENOTSUBSCRIBER = 'WelcomeNotSubscriber',
  WELCOMESUBSCRIBER = 'WelcomeSubscriber'
}

export type RetryCurationExternalLinksInput = {
  curationContentPackIds: Array<Scalars['ID']>;
};

export type RetryCurationExternalLinksPayload = {
  __typename: 'RetryCurationExternalLinksPayload';
  success: Scalars['Boolean'];
};

export type RetryCurationMatchingInput = {
  songIds?: InputMaybe<Array<Scalars['String']>>;
  songInputIds?: InputMaybe<Array<Scalars['String']>>;
};

export type RetryCurationMatchingPayload = {
  __typename: 'RetryCurationMatchingPayload';
  success: Scalars['Boolean'];
};

export type RetrySongsMatchingPayload = {
  __typename: 'RetrySongsMatchingPayload';
  success: Scalars['Boolean'];
};

export type ReturningGift = {
  __typename: 'ReturningGift';
  rewards: Array<LevelReward>;
};

export type ReviveLoyaltyCardDayInput = {
  id: Scalars['ID'];
  receipt?: InputMaybe<ReviveLoyaltyCardDayReceiptInput>;
};

export type ReviveLoyaltyCardDayPayload = {
  __typename: 'ReviveLoyaltyCardDayPayload';
  user: User;
};

export type ReviveLoyaltyCardDayReceiptInput = {
  receipt?: InputMaybe<Scalars['String']>;
  sku: Scalars['ID'];
  store: StoreType;
};

export type ReviveLoyaltyCardInput = {
  userId: Scalars['ID'];
};

export type ReviveLoyaltyCardPayload = {
  __typename: 'ReviveLoyaltyCardPayload';
  user: User;
};

export type RevokeUserBadgeAdminInput = {
  badgeId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type RevokeUserBadgeAdminPayload = {
  __typename: 'RevokeUserBadgeAdminPayload';
  badgeId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type RewardCap = {
  __typename: 'RewardCap';
  /** Number of free refills per day for BASIC users as reward for watching ads (refillEmptyCap -> RefillEmptyCapMode.PARTIAL) */
  freeRefillCount?: Maybe<Scalars['Int']>;
  /** Size of increment for free refill(for watching ads) for LIVE_EVENT_TICKET */
  freeRefillIncrement?: Maybe<Scalars['Int']>;
  /** Size of increment during your replenish */
  increment: Scalars['Int'];
  /** Total reward amount you can earn without any replenish */
  maxStorage: Scalars['Int'];
  /** Size of increment for partial refill (refillEmptyCap -> RefillEmptyCapMode.PARTIAL) */
  partialRefillIncrement: Scalars['Int'];
  /** Total amount (in sec) before your next replenish */
  period: Scalars['Int'];
};

export type Sp2CurationContentPackPayload = {
  __typename: 'SP2CurationContentPackPayload';
  sp2CurationPlaylist?: Maybe<Sp2CurationPlaylist>;
};

export type Sp2CurationPlaylist = {
  __typename: 'SP2CurationPlaylist';
  /** Playlist artwork in SP2 (can be different from SP3) */
  artwork?: Maybe<Scalars['String']>;
  /** List of all available badges the user can choose from */
  availableBadges: Array<Scalars['String']>;
  /** List of badge ids for SP2 Mastery Race. Up to 2 */
  badges?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Creation date in SP2 */
  created?: Maybe<Scalars['Date']>;
  /** Similar to sp2ExportId in CurationContentPack */
  id: Scalars['ID'];
  /** Is current playlist being committed */
  isCommitInProgress?: Maybe<Scalars['Boolean']>;
  /** Last SP2 commit date (different than export date) */
  lastCommitted?: Maybe<Scalars['Date']>;
  /** SP2 commit logs */
  logs?: Maybe<Array<Scalars['String']>>;
  /** If mastery race has started, badges cannot be updated */
  masteryRaceStarted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  /** AMP url to this playlist */
  pageUrl?: Maybe<Scalars['String']>;
  /** SP2 Playlist cost in the shop */
  price?: Maybe<Scalars['Int']>;
  /** Released playlist ID */
  productionPlaylistId?: Maybe<Scalars['ID']>;
};

export type Sp2Info = {
  __typename: 'SP2Info';
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  /** The user has an active SP2 subscription (auto-renew = true) sync in the SP3 BE */
  hasActiveSubscription?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  picture?: Maybe<Scalars['String']>;
  /**
   * This data is refreshed async only once per 24h on user connection or on linkToSp2 call
   * isFirstTimeSinceLink = false by default, by using isFirstTimeSinceLink = true,
   * the query will try to access data from the SP2 BE directly only if there opponents have never been in cache
   * forceCacheRefresh = false by default, by using forceCacheRefresh = true,
   * the query will try to access data from the SP2 BE directly and update the current cache
   * Important: the latency could be higher for this first call / refreshCache
   */
  sp2Opponents: Sp2OpponentPaginated;
  sp2Tier?: Maybe<UserSubscriptionTier>;
  /** Can be null if the user doesn't have a SP2 subscription sync in the SP3 BE */
  subscriptionStore?: Maybe<StoreType>;
};


export type Sp2InfoSp2OpponentsArgs = {
  forceCacheRefresh?: InputMaybe<Scalars['Boolean']>;
  isFirstTimeSinceLink?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationParams>;
};

export type Sp2Opponent = {
  __typename: 'SP2Opponent';
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastChallenge?: Maybe<Scalars['Date']>;
  lastInvite?: Maybe<Scalars['Date']>;
  picture?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userToUser?: Maybe<UserToUser>;
};

export type Sp2OpponentPaginated = {
  __typename: 'SP2OpponentPaginated';
  hasMore: Scalars['Boolean'];
  id: Scalars['ID'];
  list: Array<Sp2Opponent>;
  totalCount: Scalars['Int'];
};

export type Sp2ReleaseStatus = {
  __typename: 'SP2ReleaseStatus';
  canUseMinutes: Scalars['Boolean'];
  id: Scalars['ID'];
  playlists: Array<Sp2ReleaseStatusPlaylist>;
  releases: Array<Sp2ReleaseStatusRelease>;
};

export type Sp2ReleaseStatusPlaylist = {
  __typename: 'SP2ReleaseStatusPlaylist';
  created?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  runningRace: Scalars['Boolean'];
  visible: Scalars['Boolean'];
};

export type Sp2ReleaseStatusRelease = {
  __typename: 'SP2ReleaseStatusRelease';
  id: Scalars['ID'];
  playlistIds: Array<Scalars['String']>;
  state: Scalars['String'];
  type: Scalars['String'];
  visibleDate: Scalars['Date'];
};

export type Sale = {
  __typename: 'Sale';
  /**
   * Indicate if the user can claim this offer or not
   * Potential reasons why a user can't claim a Sale:
   * - He reached the maximum number of claim
   */
  canBeClaimed: Scalars['Boolean'];
  currentPurchaseCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  newPrice: Scalars['Float'];
  offerPercentage: Scalars['Int'];
  oldPrice: Scalars['Float'];
  purchaseLimitNextResetTime?: Maybe<Scalars['Date']>;
  purchaseLimitTotal?: Maybe<Scalars['Int']>;
  purchaseLimitType?: Maybe<PurchaseLimitEnum>;
  saleProductId: Scalars['ID'];
  startDate?: Maybe<Scalars['Date']>;
  stopDate?: Maybe<Scalars['Date']>;
  tag: SaleTagType;
  /** original product id that will be replaced by the saleProductId */
  targetedProductId: Scalars['ID'];
};

export type SaleBundleConfig = {
  __typename: 'SaleBundleConfig';
  backgroundImage?: Maybe<Scalars['String']>;
  displayTimer?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  items: Array<BundleItem>;
  name?: Maybe<Scalars['String']>;
  offerPercentage?: Maybe<Scalars['Int']>;
  purchaseLimitType?: Maybe<PurchaseLimitEnum>;
  ruleMaximumNumberOfClaim?: Maybe<Scalars['Int']>;
  skuId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
  stopDate?: Maybe<Scalars['Date']>;
  tag?: Maybe<Scalars['String']>;
};

export type SaleBundlePack = BundlePack & {
  __typename: 'SaleBundlePack';
  backgroundImage?: Maybe<Scalars['String']>;
  cost: Scalars['Float'];
  currentPurchaseCount?: Maybe<Scalars['Int']>;
  displayTimer?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  offerPercentage?: Maybe<Scalars['Int']>;
  purchaseLimitNextResetTime?: Maybe<Scalars['Date']>;
  purchaseLimitTotal?: Maybe<Scalars['Int']>;
  purchaseLimitType?: Maybe<PurchaseLimitEnum>;
  rewards: Array<LevelReward>;
  sku: Scalars['String'];
  state?: Maybe<SaleBundlePackState>;
  tag?: Maybe<Scalars['String']>;
};

export enum SaleBundlePackState {
  AVAILABLE = 'AVAILABLE',
  CLAIMED = 'CLAIMED'
}

export type SaleConfig = {
  __typename: 'SaleConfig';
  id: Scalars['ID'];
  /** Can be null, set a name only if you want to override the parent name (not used for now) */
  name?: Maybe<Scalars['String']>;
  newPrice?: Maybe<Scalars['Float']>;
  offerPercentage?: Maybe<Scalars['Int']>;
  oldPrice?: Maybe<Scalars['Float']>;
  purchaseLimitType?: Maybe<PurchaseLimitEnum>;
  ruleMaximumNumberOfClaim?: Maybe<Scalars['Int']>;
  saleProductId?: Maybe<Scalars['ID']>;
  startDate?: Maybe<Scalars['Date']>;
  stopDate?: Maybe<Scalars['Date']>;
  tag: SaleTagType;
  /** original product id that will be replaced by the saleProductId */
  targetedProductId?: Maybe<Scalars['ID']>;
};

export type SaleEvent = {
  __typename: 'SaleEvent';
  assetsConfig: SaleEventAssetsConfig;
  id: Scalars['ID'];
  /**
   * Indicate if the user can access this offer or not
   * Potential reasons why a user can't participate to a Sale:
   * - He doesn't have the minimum Subscription Tier required
   * - He created his account before a specific date
   * - He is not part of the selected userIds that can access this sale
   */
  isParticipating: Scalars['Boolean'];
  minimumSubscriptionTierRequirement: UserSubscriptionTier;
  name: Scalars['String'];
  packs: Array<SaleBundlePack>;
  priority: Scalars['Int'];
  sales: Array<Sale>;
  startDate: Scalars['Date'];
  stopDate: Scalars['Date'];
  subscriptions: Array<SubscriptionSale>;
};

export enum SaleEventAssetType {
  BACKGROUND = 'BACKGROUND',
  BUNDLE = 'BUNDLE',
  CHARACTER = 'CHARACTER'
}

export type SaleEventAssetsConfig = {
  __typename: 'SaleEventAssetsConfig';
  backgroundImage?: Maybe<Scalars['String']>;
  characterImage?: Maybe<Scalars['String']>;
};

export type SaleEventAssetsConfigInput = {
  backgroundImage?: InputMaybe<Scalars['String']>;
  characterImage?: InputMaybe<Scalars['String']>;
};

export type SaleEventConfig = {
  __typename: 'SaleEventConfig';
  assetsConfig: SaleEventAssetsConfig;
  dailyItems: Array<Item>;
  filterAppVersion?: Maybe<Scalars['String']>;
  filterHadSub?: Maybe<Scalars['Boolean']>;
  filterSubscriptionTier?: Maybe<UserSubscriptionTier>;
  filterUserIds?: Maybe<Array<Scalars['String']>>;
  filterUserLevel?: Maybe<Scalars['Int']>;
  filterUserMaxCreationDate?: Maybe<Scalars['String']>;
  filterUserMinCreationDate?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /**
   * Some saleEvents config are hard coded BE side (see src/common/concerns/saleEvent/config.ts)
   * In this case they only be displayed in ReadOnly in the admin - require manual update in the source code
   */
  isHardCoded: Scalars['Boolean'];
  name: Scalars['String'];
  packs: Array<SaleBundleConfig>;
  priority: Scalars['Int'];
  sales: Array<SaleConfig>;
  startDate: Scalars['Date'];
  status: SaleEventStatus;
  stopDate: Scalars['Date'];
  subscriptions: Array<SubscriptionSaleConfig>;
};

export type SaleEventPayload = {
  __typename: 'SaleEventPayload';
  saleEvent: SaleEventConfig;
};

export enum SaleEventStatus {
  ACTIVE = 'ACTIVE',
  DRAFT = 'DRAFT'
}

export enum SaleTagType {
  BONUS = 'BONUS',
  NEW = 'NEW',
  SALE = 'SALE',
  SPECIAL = 'SPECIAL'
}

export type SaveMarathonPayload = {
  __typename: 'SaveMarathonPayload';
  round: UserMarathonRound;
  userMarathonEvent: UserMarathonEvent;
};

export type SaveMarathonRoundInput = {
  answers: Array<UserAnswerInput>;
  eventId: Scalars['ID'];
  roundId: Scalars['ID'];
};

export type SaveUserContentPackInput = {
  contentPackId: Scalars['ID'];
};

export type ScheduleQuizLiveShowRoundEncryptionInput = {
  roundId: Scalars['ID'];
  showId: Scalars['ID'];
};

export type ScoreConfig = {
  __typename: 'ScoreConfig';
  digitsAfterComa: Scalars['Int'];
  dynamic1Range: Scalars['Int'];
  dynamic2Range: Scalars['Int'];
  precompute2Range: Scalars['Float'];
  precompute3Range: Scalars['Float'];
};

export enum SearchType {
  BY_ID = 'BY_ID',
  BY_NAME = 'BY_NAME'
}

export type SelectAppSkinInput = {
  itemId: Scalars['ID'];
};

export type SelectBadgeInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type SelectBadgePayload = {
  __typename: 'SelectBadgePayload';
  user?: Maybe<User>;
};

export type SelectProfileFrameInput = {
  itemId: Scalars['ID'];
};

export type SendContentItemMessageInput = {
  contentItemId: Scalars['ID'];
  conversationId: Scalars['ID'];
};

export type SendFriendRequestInput = {
  userId: Scalars['ID'];
};

export type SendGiftInput = {
  amount?: InputMaybe<Scalars['Int']>;
  priceAmount?: InputMaybe<Scalars['Float']>;
  priceCurrency?: InputMaybe<Scalars['String']>;
  receipt?: InputMaybe<Scalars['String']>;
  recipientId: Scalars['ID'];
  sku: Scalars['ID'];
  store?: InputMaybe<StoreType>;
};

export type SendMessageInput = {
  content: Scalars['String'];
  conversationId: Scalars['ID'];
};

export type SendMessageUserToUserQuizLiveRoundInput = {
  content: Scalars['String'];
  quizQuestionId: Scalars['ID'];
  type: MessageType;
  userToUserQuizLiveRoundId: Scalars['ID'];
};

export type SendNotificationInput = {
  content?: InputMaybe<Scalars['String']>;
  overwriteMessage?: InputMaybe<Scalars['String']>;
  preset?: InputMaybe<NotificationPreset>;
  userId: Scalars['ID'];
  userLang?: InputMaybe<Scalars['String']>;
};

export type SendQuizMessageInput = {
  content: Scalars['String'];
  conversationId: Scalars['ID'];
  quizId?: InputMaybe<Scalars['ID']>;
  stickerId?: InputMaybe<Scalars['ID']>;
};

export type SendRetentionReminderInput = {
  doNotMockTemplateData?: InputMaybe<Scalars['Boolean']>;
  templateData?: InputMaybe<ForcedTemplateData>;
  type: RetentionSendingType;
  userId: Scalars['ID'];
  userLang?: InputMaybe<Scalars['String']>;
};

export type SendTeamMemberInviteInput = {
  teamId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type SendTeamMemberInvitePayload = {
  __typename: 'SendTeamMemberInvitePayload';
  invite: TeamInvite;
  team: Team;
};

export type SendTeamQuizLiveGameRequestInput = {
  teamId: Scalars['ID'];
};

export type SendTeamQuizLiveGameRequestPayload = {
  __typename: 'SendTeamQuizLiveGameRequestPayload';
  team: Team;
};

export type SendUserToUserQuizLiveGameRequestInput = {
  isInviteTimeoutLonger?: InputMaybe<Scalars['Boolean']>;
  userToUserId: Scalars['ID'];
};

export type SendWinnerStickerInput = {
  quizLiveShowId: Scalars['ID'];
  stickerId: Scalars['ID'];
};

export type SendWinnerStickerPayload = {
  __typename: 'SendWinnerStickerPayload';
  quizLiveShow: QuizLiveShow;
};

export enum ServerEnv {
  BETA = 'beta',
  PROD = 'prod',
  TEST = 'test'
}

export enum ServerMode {
  ADMIN = 'admin',
  API = 'api',
  BACKGROUND = 'background'
}

export type SetActiveEmojiPackInput = {
  isActive: Scalars['Boolean'];
  packId: Scalars['ID'];
};

export type SetActiveEmojiPackPayload = {
  __typename: 'SetActiveEmojiPackPayload';
  user: User;
};

export type SetModeratorToContentPack = {
  batchId: Scalars['ID'];
  /** If empty, moderatorId is set to userId making the mutation */
  moderatorId?: InputMaybe<Scalars['ID']>;
  packId: Scalars['ID'];
};

export type SetStickerPositionInput = {
  itemId: Scalars['ID'];
  position: Scalars['Int'];
};

export type SetStickerPositionPayload = {
  __typename: 'SetStickerPositionPayload';
  sticker: Sticker;
};

export type SetSubscriptionExpiresInput = {
  appId?: InputMaybe<Scalars['String']>;
  expires: Scalars['Date'];
  originalTransactionId?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type SetSubscriptionExpiresPayload = {
  __typename: 'SetSubscriptionExpiresPayload';
  user: User;
};

export type SetSubscriptionTierInput = {
  email?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['ID']>;
  subscriptionTier: UserSubscriptionTier;
  userId?: InputMaybe<Scalars['ID']>;
};

export type SetUserBadgeLevelAdminInput = {
  badgeId: Scalars['ID'];
  level: Scalars['Int'];
  userId: Scalars['ID'];
};

export type SetUserContentItemPositionInput = {
  contentItemId: Scalars['ID'];
  position: Scalars['Int'];
};

export type SetUserContentItemPositionPayload = {
  __typename: 'SetUserContentItemPositionPayload';
  userContentItem: UserContentItem;
};

export type SetUserContentPackPositionInput = {
  contentPackId: Scalars['ID'];
  position: Scalars['Int'];
};

export type SetUserContentPackPositionPayload = {
  __typename: 'SetUserContentPackPositionPayload';
  userContentPack: UserContentPack;
};

export enum ShardType {
  BRONZE = 'BRONZE',
  GOLD = 'GOLD',
  SILVER = 'SILVER'
}

export type Shards = {
  __typename: 'Shards';
  BRONZE?: Maybe<Scalars['Int']>;
  GOLD?: Maybe<Scalars['Int']>;
  SILVER?: Maybe<Scalars['Int']>;
};

export type ShardsInput = {
  BRONZE?: InputMaybe<Scalars['Int']>;
  GOLD?: InputMaybe<Scalars['Int']>;
  SILVER?: InputMaybe<Scalars['Int']>;
};

export type ShiftLoyaltyCardInput = {
  newCurrentDayIdx?: InputMaybe<Scalars['Int']>;
  newNextClaimableDayIdx?: InputMaybe<Scalars['Int']>;
  userId: Scalars['ID'];
};

export type ShiftLoyaltyCardPayload = {
  __typename: 'ShiftLoyaltyCardPayload';
  user: User;
};

export type ShopChainedOfferPack = {
  __typename: 'ShopChainedOfferPack';
  cost: Scalars['Float'];
  id: Scalars['String'];
  sku: Scalars['String'];
  type: Scalars['String'];
};

export type SignInInput = {
  credentialType: CredentialSignUpType;
  refLink?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};

export type SignInPayload = {
  __typename: 'SignInPayload';
  authToken: Scalars['String'];
  isNewUser: Scalars['Boolean'];
  user: User;
};

export type SignOutPayload = {
  __typename: 'SignOutPayload';
  success?: Maybe<Scalars['Boolean']>;
};

export type SignUpAnswer = {
  answerIndex: Scalars['Int'];
  answerTime: Scalars['Int'];
  contentItemId: Scalars['ID'];
  id: Scalars['ID'];
  isCorrect: Scalars['Boolean'];
};

export type SignUpInput = {
  credentialType: CredentialSignUpType;
  metadata?: InputMaybe<SignUpMetadata>;
  refLink?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};

export type SignUpMetadata = {
  answers: Array<SignUpAnswer>;
  birthyear?: InputMaybe<Scalars['Int']>;
  decadeId?: InputMaybe<Scalars['ID']>;
  displayName?: InputMaybe<Scalars['String']>;
  genreId?: InputMaybe<Scalars['ID']>;
  playlistId: Scalars['ID'];
};

export type Song = {
  __typename: 'Song';
  artist: Scalars['String'];
  displayArtist: Scalars['String'];
  displayTitle: Scalars['String'];
  externalLinks: SongExternalLinks;
  id: Scalars['ID'];
  isExplicit: Scalars['Boolean'];
  isrc: Scalars['String'];
  picture?: Maybe<Scalars['String']>;
  samples: Array<SongSample>;
  title: Scalars['String'];
};


export type SongSamplesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type SongExternalLinks = {
  __typename: 'SongExternalLinks';
  itunes?: Maybe<Scalars['String']>;
  spotify?: Maybe<Scalars['String']>;
};

export enum SongInputMatchType {
  ISRC = 'ISRC',
  ISRC_ALBUM = 'ISRC_ALBUM',
  MANUAL = 'MANUAL',
  OUTDATED = 'OUTDATED',
  SIMILARITY = 'SIMILARITY',
  TITLE_ARTIST = 'TITLE_ARTIST',
  TITLE_ARTIST_ALBUM = 'TITLE_ARTIST_ALBUM'
}

export type SongItemSuggestion = {
  __typename: 'SongItemSuggestion';
  artist: Scalars['String'];
  catalogItemId: Scalars['ID'];
  id: Scalars['ID'];
  title: Scalars['String'];
};

export enum SongQuestionableStatus {
  CLEAN = 'CLEAN',
  QUESTIONABLE = 'QUESTIONABLE',
  TO_REVIEW = 'TO_REVIEW'
}

export type SongSample = {
  __typename: 'SongSample';
  id: Scalars['ID'];
  song: Song;
  url: Scalars['String'];
  variation: Scalars['String'];
};

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type Sp2IdInput = {
  sp2id: Scalars['ID'];
};

export enum Sp2LinkError {
  ALREADYLINKEDSP2USERERROR = 'AlreadyLinkedSP2UserError',
  ALREADYLINKEDSP3USERERROR = 'AlreadyLinkedSP3UserError',
  BADGESNOTFOUNDERROR = 'BadgesNotFoundError',
  LINKALREADYPENDINGERROR = 'LinkAlreadyPendingError',
  LINKEXPIREDERROR = 'LinkExpiredError',
  LINKFAILEDERROR = 'LinkFailedError',
  LINKINVALIDERROR = 'LinkInvalidError',
  LINKNOTFOUNDERROR = 'LinkNotFoundError',
  LINKNOTINITIALIZEDERROR = 'LinkNotInitializedError',
  LINKEDSUBSCRIPTIONEXPIREDERROR = 'LinkedSubscriptionExpiredError',
  LINKEDSUBSCRIPTIONNOTFOUNDERROR = 'LinkedSubscriptionNotFoundError',
  LINKEDSUBSCRIPTIONNOTVALIDERROR = 'LinkedSubscriptionNotValidError',
  PLAYLISTNOTFOUNDERROR = 'PlaylistNotFoundError',
  USERNOTFOUNDERROR = 'UserNotFoundError'
}

export type Sp2LinkIdPairInput = {
  sp2id: Scalars['ID'];
  sp3id: Scalars['ID'];
};

export type Sp2LinkResult = {
  __typename: 'Sp2LinkResult';
  error?: Maybe<Sp2LinkError>;
  errorMessage?: Maybe<Scalars['String']>;
  isPending?: Maybe<Scalars['Boolean']>;
  sp2Info?: Maybe<Sp2Info>;
  success?: Maybe<Scalars['Boolean']>;
};

export enum Sp2LinkState {
  LINKED = 'LINKED',
  PENDING = 'PENDING',
  UNLINKED = 'UNLINKED'
}

export type Sp2LinkTokenInput = {
  linkToken: Scalars['String'];
  sp3id: Scalars['ID'];
};

export type Sp2LinkTokenPayload = {
  __typename: 'Sp2LinkTokenPayload';
  error?: Maybe<Sp2LinkError>;
  errorMessage?: Maybe<Scalars['String']>;
  linkToken?: Maybe<Scalars['String']>;
};

export type Sp2PlaylistsItem = {
  __typename: 'Sp2PlaylistsItem';
  artwork?: Maybe<Scalars['String']>;
  contentPackId?: Maybe<Scalars['String']>;
  exportedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  lastCommittedAt: Scalars['Date'];
  name: Scalars['String'];
  productionPlaylistId: Scalars['ID'];
  releasedAt: Scalars['Date'];
  state?: Maybe<Scalars['String']>;
};

export type Sp2PlaylistsParams = {
  cursor?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type Sp2PlaylistsResult = {
  __typename: 'Sp2PlaylistsResult';
  currentCursor?: Maybe<Scalars['String']>;
  endDate: Scalars['String'];
  nextCursor?: Maybe<Scalars['String']>;
  pageSize?: Maybe<Scalars['Int']>;
  playlists: Array<Sp2PlaylistsItem>;
  startDate: Scalars['String'];
};

export type Sp3IdInput = {
  sp3id: Scalars['ID'];
};

export type SpecialEvent = {
  __typename: 'SpecialEvent';
  /** The current active tournament */
  activeTournament?: Maybe<Tournament>;
  /** SpecialEventAssetsConfig define later */
  assetsConfig: SpecialEventAssetsConfig;
  configWarnings: Array<Scalars['String']>;
  contentPacks: Array<ContentPack>;
  description: Scalars['String'];
  endDate: Scalars['Date'];
  id: Scalars['ID'];
  isDraft: Scalars['Boolean'];
  /**
   * Will be false until we have processed all specialEvent's tournaments unclaimed yet by players
   * We need some time to process all this data to have a final leaderboard with the finale scores
   */
  isRankGroupRewardClaimable?: Maybe<Scalars['Boolean']>;
  /**
   * Can be null if the user doesn't have played special event related game modes yet
   * Even if the player has no userRankGroup (score too low) - isRankGroupRewardClaimed will be false
   * claimSpecialEventRankGroupReward mutation needs to be called in any case if the user has participated to the special event
   */
  isRankGroupRewardClaimed?: Maybe<Scalars['Boolean']>;
  /**
   * Unlike ContentPack and MonthlyPass leaderboards which use the XP gain as value,
   * SpecialEvent leaderboard value is the commulative score of each round.
   */
  leaderboard?: Maybe<Leaderboard>;
  meScore: Scalars['Int'];
  meScoreDetails: Array<SpecialEventScoreDetail>;
  milestones: Array<SpecialEventMilestone>;
  /**
   * This endpoint is used to view the global mission config for a special event.
   * The FE should use SpecialEvent.userMissions instead, which also includes the user's progress on each mission.
   */
  missions?: Maybe<SpecialEventMissions>;
  name: Scalars['String'];
  /** The next liveshow, or the current one if it's not finished yet */
  nextQuizLiveShow?: Maybe<QuizLiveShow>;
  plusMilestones: Array<SpecialEventMilestone>;
  quizLiveShows: Array<QuizLiveShow>;
  rankGroups: Array<SpecialEventRankGroup>;
  startDate: Scalars['Date'];
  tournaments: Array<Tournament>;
  /**
   * This endpoint is used to view the global missions progress for a special event and a special.
   * The FE should use SpecialEvent.userMissions instead, which also includes the user's progress on each mission.
   */
  userAllMissions?: Maybe<UserSpecialEventAllMissions>;
  /** All userContentPacks linked to the special event */
  userContentPacks: UserContentPacksPaginated;
  userMissions?: Maybe<UserSpecialEventMissions>;
  /** Can be null if the user doesn't have played special event related game modes yet or doesn't reach at least the lowest rank group */
  userRankGroup?: Maybe<SpecialEventRankGroup>;
};


export type SpecialEventUserContentPacksArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export enum SpecialEventAssetType {
  BACKGROUND = 'BACKGROUND',
  HEADER = 'HEADER',
  ICON = 'ICON'
}

export type SpecialEventAssetsConfig = {
  __typename: 'SpecialEventAssetsConfig';
  animatedOverlay?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
  backgroundImage?: Maybe<Scalars['String']>;
  buttonColor?: Maybe<Scalars['String']>;
  character?: Maybe<Scalars['String']>;
  contrast?: Maybe<Scalars['String']>;
  contrastGradient1?: Maybe<Scalars['String']>;
  contrastGradient2?: Maybe<Scalars['String']>;
  frame?: Maybe<Scalars['String']>;
  headerImage?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  palette?: Maybe<Scalars['String']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  secondaryDarkColor?: Maybe<Scalars['String']>;
  sticker?: Maybe<Scalars['String']>;
  vinyl?: Maybe<Scalars['String']>;
};

export type SpecialEventAssetsConfigInput = {
  backgroundImage?: InputMaybe<Scalars['String']>;
  buttonColor?: InputMaybe<Scalars['String']>;
  contrast?: InputMaybe<Scalars['String']>;
  contrastGradient1?: InputMaybe<Scalars['String']>;
  contrastGradient2?: InputMaybe<Scalars['String']>;
  headerImage?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['String']>;
  primaryColor?: InputMaybe<Scalars['String']>;
  secondaryColor?: InputMaybe<Scalars['String']>;
  secondaryDarkColor?: InputMaybe<Scalars['String']>;
};

export type SpecialEventMilestone = {
  __typename: 'SpecialEventMilestone';
  id: Scalars['ID'];
  isClaimed: Scalars['Boolean'];
  rewards: Array<LevelReward>;
  score: Scalars['Int'];
};

export type SpecialEventMilestoneInput = {
  rewards: Array<LevelRewardInput>;
  score: Scalars['Int'];
};

export type SpecialEventMissions = {
  __typename: 'SpecialEventMissions';
  id: Scalars['ID'];
  sequentialMissions: Array<Mission>;
};

export type SpecialEventMissionsPayload = {
  __typename: 'SpecialEventMissionsPayload';
  missions: SpecialEventMissions;
};

export type SpecialEventPaginated = {
  __typename: 'SpecialEventPaginated';
  hasMore: Scalars['Boolean'];
  id: Scalars['ID'];
  list: Array<SpecialEvent>;
  totalCount: Scalars['Int'];
};

export type SpecialEventPayload = {
  __typename: 'SpecialEventPayload';
  specialEvent: SpecialEvent;
};

export type SpecialEventRankGroup = {
  __typename: 'SpecialEventRankGroup';
  id: Scalars['ID'];
  maxRank: Scalars['Int'];
  minRank: Scalars['Int'];
  rewards: Array<LevelReward>;
};

export type SpecialEventRankGroupInput = {
  maxRank: Scalars['Int'];
  minRank: Scalars['Int'];
  rewards: Array<LevelRewardInput>;
};

export type SpecialEventScoreDetail = {
  __typename: 'SpecialEventScoreDetail';
  score: Scalars['Int'];
  type: SpecialEventScoreDetailType;
};

export type SpecialEventScoreDetailInput = {
  score: Scalars['Int'];
  type: SpecialEventScoreDetailType;
};

export enum SpecialEventScoreDetailType {
  CONTENT_PACK_LEVEL_UP = 'CONTENT_PACK_LEVEL_UP',
  LIVE_SHOW = 'LIVE_SHOW',
  MISSION = 'MISSION',
  TOURNAMENT = 'TOURNAMENT'
}

export type SpinWheelFortuneInput = {
  eventId: Scalars['ID'];
  seed: Scalars['String'];
};

export type SpinWheelFortunePayload = {
  __typename: 'SpinWheelFortunePayload';
  user: User;
  userWheelFortune: UserWheelFortune;
};

export type StartBatchContentModerationInput = {
  id: Scalars['ID'];
};

export type StartExportJobInput = {
  requestId: Scalars['String'];
};

export type StartExportJobPayload = {
  __typename: 'StartExportJobPayload';
  userExport: UserExport;
};

export type StartLiveEventGameRoundPayload = {
  __typename: 'StartLiveEventGameRoundPayload';
  appUser: User;
  liveEvent: LiveEvent;
  userToUserQuizLiveRound: UserToUserQuizLiveRound;
};

export type StartLiveEventMatchmakingPayload = {
  __typename: 'StartLiveEventMatchmakingPayload';
  liveEvent: LiveEvent;
  userToUser?: Maybe<UserToUser>;
};

export type StartLiveEventSessionPayload = {
  __typename: 'StartLiveEventSessionPayload';
  userToUser: UserToUser;
};

export type StartLoyaltyCardPayload = {
  __typename: 'StartLoyaltyCardPayload';
  user: User;
};

export type StartMarathonPayload = {
  __typename: 'StartMarathonPayload';
  round: UserMarathonRound;
  user: User;
};

export type StartMarathonRoundInput = {
  category: Scalars['String'];
  eventId: Scalars['ID'];
};

export type StartTournamentRoundInput = {
  tournamentId: Scalars['ID'];
};

export type StartTournamentRoundPayload = {
  __typename: 'StartTournamentRoundPayload';
  tournament: Tournament;
  user: User;
};

export type StarterPack = BundlePack & {
  __typename: 'StarterPack';
  cost: Scalars['Float'];
  expires?: Maybe<Scalars['Date']>;
  feature: Scalars['String'];
  id: Scalars['String'];
  rewards: Array<LevelReward>;
  sku: Scalars['String'];
  state?: Maybe<StarterPackState>;
  value: Scalars['Int'];
};

export enum StarterPackState {
  AVAILABLE = 'AVAILABLE',
  CLAIMED = 'CLAIMED',
  UNAVAILABLE = 'UNAVAILABLE',
  UNCLAIMED = 'UNCLAIMED'
}

export type Sticker = Item & {
  __typename: 'Sticker';
  allLevelItems: Array<Item>;
  asset: Scalars['String'];
  availability: ItemAvailability;
  cost?: Maybe<Currency>;
  id: Scalars['ID'];
  level: Scalars['Int'];
  liveOpsAvailability: ItemAvailability;
  name: Scalars['String'];
  nextLevelItem?: Maybe<Item>;
  nextLevelItems: Array<Item>;
};

export type StickerPaginated = {
  __typename: 'StickerPaginated';
  hasMore: Scalars['Boolean'];
  list: Array<Sticker>;
  totalCount: Scalars['Int'];
};

export type StopCurrentLiveShowPayload = {
  __typename: 'StopCurrentLiveShowPayload';
  isStopped: Scalars['Boolean'];
};

export enum StoreType {
  AMAZON = 'AMAZON',
  ANDROID = 'ANDROID',
  FACEBOOK = 'FACEBOOK',
  IOS = 'IOS',
  WINDOWS = 'WINDOWS'
}

export type StreakHistoryInput = {
  userId: Scalars['ID'];
};

export type StreakHistoryPayload = {
  __typename: 'StreakHistoryPayload';
  currentStreak: Scalars['Int'];
  lostGames: Array<UserHurdleLostGame>;
};

export type SubmitAgeGateInput = {
  birthyear: Scalars['Int'];
  countryCode: Scalars['String'];
};

export type Subscription = {
  __typename: 'Subscription';
  iapGiftReceived: User;
  /** @deprecated Replaced by onConversationUpdate */
  onConversationMessageSent: Conversation;
  onConversationUpdate: ConversationPayload;
  onLiveEventOpponentFound: LiveEventOpponentFoundPayload;
  onLiveEventStatesUpdated: LiveEventStatesUpdatedPayload;
  onMissionProgress: OnMissionProgressPayload;
  onQuizLiveShowEnded: QuizLiveShowResult;
  onQuizLiveShowWinnerUpdated: Array<QuizLiveShowWinner>;
  onReferralRewardReady: ReferralRewardPayload;
  onSpecialEventUpdated: OnSpecialEventUpdatedPayload;
  onTeamHeatUpdated?: Maybe<TeamHeat>;
  onTeamInvitesUpdated: User;
  onTeamMissionProgress?: Maybe<Array<MissionProgress>>;
  onTeamMonthlyPassUpdated?: Maybe<TeamMonthlyPass>;
  onTeamPromotionUpdated: TeamPromotion;
  /**
   * onTeamUpdated is triggered whenever something changes in Team:
   * - team attributes, members, leaders...
   * - when a team member onlineStatus changes
   * - special case, when the current user is kicked, onTeamUpdated return null
   */
  onTeamUpdated?: Maybe<Team>;
  onTeammateAnswered: TeammateAnswers;
  onTeammateJoinedShow: OnTeammateJoinedShowPayload;
  /**
   * Send notification when the current user is connected to another device.
   * We only allow one device per active user.
   */
  onUserConnectedToOtherDevice: User;
  onUserSubscriptionUpdated: User;
  onUserToUserBlockUpdated: BlockUserPayload;
  onUserToUserOpponentOnlineStatusUpdated: UserToUser;
  onUserToUserPing: PingUserToUserPayload;
  onUserToUserQuizArchive: OnUserToUserQuizArchivePayload;
  onUserToUserQuizLiveGameUpdated: UserToUser;
  onUserToUserQuizLiveRoundUpdated: UserToUserQuizLiveGame;
  /** @deprecated Use onUserToUserQuizArchive instead */
  onUserToUserQuizStateUpdated: User;
  /**
   * Will replace onUserToUserQuizTurnGameUpdated in a near futur.
   * onUserToUserQuizTurnGameChange is triggered by the same event than onUserToUserQuizTurnGameUpdated.
   */
  onUserToUserQuizTurnGameChange: OnUserToUserQuizTurnGameChangePayload;
  onUserToUserQuizTurnGameUpdated: UserToUser;
  onUserToUserStatusUpdated: UserToUser;
};


export type SubscriptionOnTeamHeatUpdatedArgs = {
  teamId: Scalars['ID'];
};


export type SubscriptionOnTeamMissionProgressArgs = {
  teamId: Scalars['ID'];
};


export type SubscriptionOnTeamMonthlyPassUpdatedArgs = {
  teamId: Scalars['ID'];
};


export type SubscriptionOnTeamPromotionUpdatedArgs = {
  teamId: Scalars['ID'];
};


export type SubscriptionOnTeamUpdatedArgs = {
  teamId: Scalars['ID'];
};


export type SubscriptionOnUserToUserPingArgs = {
  input?: InputMaybe<OnUserToUserPingInput>;
};

export type SubscriptionDetails = {
  __typename: 'SubscriptionDetails';
  activeSince: Scalars['Date'];
  autoRenews: Scalars['Boolean'];
  downgradeTier?: Maybe<UserSubscriptionTier>;
  expires: Scalars['Date'];
  id: Scalars['ID'];
  /** @deprecated abtest lost */
  includeAds: Scalars['Boolean'];
  isFreeTrial: Scalars['Boolean'];
  /**
   * If the subscription has been created through IOS or Play Stores it will match the sku from the store (eg. com.freshplanet.sp3.ios.premium.1)
   * If the subscription has been created through the facebook IAP sku = "com.freshplanet.sp3.facebook.premium.iap" | "com.freshplanet.sp3.facebook.vip.iap"
   * If the subscription has been created through the admin sku = "com.freshplanet.sp3.premium" | "com.freshplanet.sp3.vip"
   * If the subscription is BASIC tier (no subscription) sku = "com.freshplanet.sp3.basic"
   */
  sku: Scalars['String'];
  status: SubscriptionDetailsStatus;
};

export enum SubscriptionDetailsStatus {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
  GRACED = 'GRACED',
  ON_HOLD = 'ON_HOLD',
  PAUSED = 'PAUSED'
}

export enum SubscriptionPeriod {
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY'
}

export type SubscriptionPromoOffer = {
  __typename: 'SubscriptionPromoOffer';
  expireDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  offerPercentage: Scalars['Int'];
  promoSku: Scalars['String'];
  sku: Scalars['String'];
  type?: Maybe<SubscriptionPeriod>;
};

export type SubscriptionSale = {
  __typename: 'SubscriptionSale';
  backgroundTheme: Scalars['String'];
  id: Scalars['String'];
  offerPercentage: Scalars['Int'];
  promoSku: Scalars['String'];
  sku: Scalars['String'];
};

export type SubscriptionSaleConfig = {
  __typename: 'SubscriptionSaleConfig';
  backgroundTheme?: Maybe<Scalars['String']>;
  discount: Scalars['Int'];
  id: Scalars['String'];
};

export type SubscriptionV1ToV2Transition = {
  __typename: 'SubscriptionV1ToV2Transition';
  /** Return true if the user have created his account before the transition to PLUS tier */
  isV1User: Scalars['Boolean'];
  /**
   * PREMIUM and VIP are converted to PLUS in User.subscriptionTier.
   * So to know the original value in DB without conversion (it can be BASIC, PREMIUM, VIP),
   * you can use this subscriptionTierV1 field.
   * After the transition, we plan to store PLUS tier value as PLUS in DB instead of PREMIUM, so the value could be PLUS too
   */
  subscriptionTierV1: UserSubscriptionTier;
  /** Return true if the user have a expired VIP subscription (doesn't check facebook subscription days case) */
  wasVIP: Scalars['Boolean'];
};

export type SyncFriendsFromFacebookInput = {
  facebookIds: Array<Scalars['ID']>;
};

export type SyncFriendsFromFacebookPayload = {
  __typename: 'SyncFriendsFromFacebookPayload';
  userToUsers: Array<UserToUser>;
};

export type SyncFriendsFromGameCenterInput = {
  gameCenterIds: Array<Scalars['String']>;
};

export type SyncFriendsFromGameCenterPayload = {
  __typename: 'SyncFriendsFromGameCenterPayload';
  userToUsers: Array<UserToUser>;
};

export type SyncSp2Badges = {
  __typename: 'SyncSP2Badges';
  badges: Array<Badge>;
  user: User;
};

export enum TaskState {
  COPY_ASSET = 'COPY_ASSET',
  DONE = 'DONE',
  FAILED = 'FAILED',
  MISSING_FILE = 'MISSING_FILE',
  NEW = 'NEW'
}

export type Team = {
  __typename: 'Team';
  availableBoosts: Scalars['Int'];
  banner: Scalars['String'];
  boosts: Array<Maybe<TeamHeatBoost>>;
  conversation: Conversation;
  description: Scalars['String'];
  id: Scalars['ID'];
  leaders: Array<User>;
  liveGameRequestCreated?: Maybe<Scalars['Date']>;
  /** Expires 2mins after creation */
  liveGameRequestExpires?: Maybe<Scalars['Date']>;
  /**
   * If liveGameRequestId = null but liveGameRequestCreated != null, it's because the liveGameRequest has been created
   * by a player that is in a BLOCKED userToUser relation with the current player
   */
  liveGameRequestId?: Maybe<Scalars['String']>;
  liveGameRequestSender?: Maybe<User>;
  /** For now, only works if the user making the request is on the pod the team members are playing on */
  liveShowParticipants: Array<User>;
  members: Array<User>;
  name: Scalars['String'];
  safetyLevel: TeamSafetyLevel;
  teamHeat: TeamHeat;
  teamMonthlyPass?: Maybe<TeamMonthlyPass>;
  teamStats: TeamStats;
  type: TeamType;
};

export type TeamBoostMutationPayload = {
  __typename: 'TeamBoostMutationPayload';
  team: Team;
  user: User;
};

export type TeamBoostsInput = {
  expireTimestamp: Scalars['Date'];
  type: CurrencyBoostType;
};

export type TeamHeat = {
  __typename: 'TeamHeat';
  currentScore: Scalars['Int'];
  id: Scalars['ID'];
  isMaxHeat: Scalars['Boolean'];
  lastUpdateScore: Scalars['Int'];
  lastUpdateScoreTimestamp?: Maybe<Scalars['Date']>;
  maxHeatExpireTimestamp?: Maybe<Scalars['Date']>;
};

export type TeamHeatActivateBoostInput = {
  boostType: CurrencyBoostType;
  index: Scalars['Int'];
  isHalf: Scalars['Boolean'];
  prolong: Scalars['Boolean'];
  teamId: Scalars['ID'];
};

export type TeamHeatBoost = {
  __typename: 'TeamHeatBoost';
  expireTimestamp: Scalars['Date'];
  type: CurrencyBoostType;
};

export type TeamHeatIteration = {
  __typename: 'TeamHeatIteration';
  milestonesReward: Array<LevelReward>;
};

export type TeamHeatIterationInput = {
  id: Scalars['ID'];
  /**
   * Array<Array<LevelRewardInput>> where first array has fixed size corresponding to number of iterations,
   *  and second is milestone rewards
   */
  milestonesReward: Array<Array<InputMaybe<LevelRewardInput>>>;
};

export type TeamHeatUpdateInput = {
  availableMilestoneIdx: Scalars['Int'];
  currentScore: Scalars['Int'];
  iteration: Scalars['Int'];
  lastUpdateScoreTimestamp: Scalars['Date'];
  maxHeatExpireTimestamp: Scalars['Date'];
  teamId: Scalars['ID'];
};

export type TeamHeatUpdatePayload = {
  __typename: 'TeamHeatUpdatePayload';
  teamHeat: TeamHeat;
  teamMonthlyPass: TeamMonthlyPass;
};

export type TeamInvite = {
  __typename: 'TeamInvite';
  id: Scalars['ID'];
  sender: User;
  sent: Scalars['Date'];
  team: Team;
};

export type TeamLeaderboardEntriesPayload = {
  __typename: 'TeamLeaderboardEntriesPayload';
  id: Scalars['ID'];
  rankEntries: Array<LeaderboardEntry>;
  teams: Array<Team>;
  total: Scalars['Int'];
};

export type TeamMonthlyPass = {
  __typename: 'TeamMonthlyPass';
  availableTeamHeatMilestone: Scalars['Int'];
  boostsUsed: Scalars['Int'];
  endDate: Scalars['Date'];
  gamesPlayed: Scalars['Int'];
  id: Scalars['ID'];
  membersRanking: Array<LeaderboardEntry>;
  missionsCompletedCount: Scalars['Int'];
  monthId: Scalars['ID'];
  rank: Scalars['Int'];
  /** represent rank groups for specific teamMonthlyPass */
  rankGroups: Array<LbRankGroup>;
  startDate: Scalars['Date'];
  teamHeatIteration: Scalars['Int'];
  teamRankGroup?: Maybe<LbRankGroup>;
  totalXP: Scalars['Int'];
};

export type TeamMonthlyPassPaginated = {
  __typename: 'TeamMonthlyPassPaginated';
  hasMore: Scalars['Boolean'];
  id: Scalars['ID'];
  list: Array<Maybe<TeamMonthlyPass>>;
  totalCount: Scalars['Int'];
};

export type TeamPayload = {
  __typename: 'TeamPayload';
  team?: Maybe<Team>;
  teamMonthlyPass?: Maybe<TeamMonthlyPass>;
  user?: Maybe<User>;
};

export type TeamPreviousSeasonPayload = {
  __typename: 'TeamPreviousSeasonPayload';
  teamMonthlyPass: TeamMonthlyPass;
  user: User;
};

export type TeamPromotion = {
  __typename: 'TeamPromotion';
  candidates: Array<Scalars['ID']>;
  id: Scalars['ID'];
  minVotes: Scalars['Int'];
  myVote?: Maybe<Scalars['ID']>;
  phaseEnd?: Maybe<Scalars['Date']>;
  state: TeamPromotionState;
  votes: Array<TeamVote>;
};

export type TeamPromotionNewLeaderPayload = {
  __typename: 'TeamPromotionNewLeaderPayload';
  id: Scalars['ID'];
  timestamp: Scalars['Date'];
};

export enum TeamPromotionState {
  IDLE = 'IDLE',
  PROMOTION = 'PROMOTION',
  VOTING = 'VOTING'
}

export enum TeamSafetyLevel {
  ALL_ACCESS = 'ALL_ACCESS',
  NO_EXPLICIT_CONTENT_NO_USER_GENERATED = 'NO_EXPLICIT_CONTENT_NO_USER_GENERATED'
}

export enum TeamShopBuyLimitEnum {
  PER_DAY = 'PER_DAY',
  PER_SALE = 'PER_SALE',
  UNLIMITED = 'UNLIMITED'
}

export type TeamShopFilter = {
  endDate?: InputMaybe<Scalars['Date']>;
  rewardType?: InputMaybe<LevelRewardInputType>;
  startDate?: InputMaybe<Scalars['Date']>;
  withDiscount?: InputMaybe<Scalars['Boolean']>;
};

export type TeamShopItem = {
  __typename: 'TeamShopItem';
  buyLimit?: Maybe<Scalars['Int']>;
  buyLimitType?: Maybe<TeamShopBuyLimitEnum>;
  cost: Scalars['Int'];
  discount?: Maybe<Scalars['Int']>;
  endDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  reward: TeamShopItemConfig;
  startDate: Scalars['Date'];
};

export type TeamShopItemConfig = {
  __typename: 'TeamShopItemConfig';
  amount?: Maybe<Scalars['Int']>;
  itemId?: Maybe<Scalars['ID']>;
  type: Scalars['String'];
};

export type TeamShopPaginated = {
  __typename: 'TeamShopPaginated';
  hasMore: Scalars['Boolean'];
  list: Array<TeamShopItem>;
  totalCount: Scalars['Int'];
};

export type TeamStats = {
  __typename: 'TeamStats';
  accuracy: Scalars['Float'];
  averageScore: Scalars['Int'];
  averageSpeed: Scalars['Float'];
  bestScore: Scalars['Int'];
};

export enum TeamType {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC'
}

export type TeamVote = {
  __typename: 'TeamVote';
  amount: Scalars['Int'];
  id: Scalars['ID'];
};

export type TeamVoteResult = {
  __typename: 'TeamVoteResult';
  id: Scalars['ID'];
  resultCode: Scalars['Int'];
  userId?: Maybe<Scalars['ID']>;
};

export type TeammateAnswers = {
  __typename: 'TeammateAnswers';
  a1: Array<User>;
  a2: Array<User>;
  a3: Array<User>;
  a4: Array<User>;
  questionId: Scalars['ID'];
};

export type TeamsByNamePaginated = {
  __typename: 'TeamsByNamePaginated';
  hasMore: Scalars['Boolean'];
  list: Array<Team>;
};

export type TeamsByRecommendationPaginated = {
  __typename: 'TeamsByRecommendationPaginated';
  hasMore: Scalars['Boolean'];
  id: Scalars['ID'];
  list: Array<Team>;
  totalCount: Scalars['Int'];
};

export type ToggleCurationContentPackAdultOnlyTagInput = {
  id: Scalars['ID'];
};

export type ToggleSp2OnlyTagInput = {
  id: Scalars['ID'];
};

export type Tournament = {
  __typename: 'Tournament';
  adminSpecialEvent?: Maybe<SpecialEvent>;
  assetsConfig: TournamentAssetsConfig;
  category: ContentCategory;
  /** @deprecated Use category instead */
  categoryId: Scalars['ID'];
  /**
   * By default, contentPacks are randomly chosen based on their music category,
   * but for special events, we want to have the possibility to force a list of contentPacks.
   * In any case, we return here the list of all ContentPacks that can be played in this tournament.
   */
  contentPacks: Array<ContentPack>;
  /**
   * Can be null if the user don't have call startTournamentRound
   * If currentRound.state === TournamentRoundState.Done, user need to call startTournamentRound again to get a new round
   */
  currentRound?: Maybe<TournamentRound>;
  description: Scalars['String'];
  endDate: Scalars['Date'];
  /**
   * Array of Artist names - 1st artist of the first four Tournament's contentPacks
   * The array can be less than 4 items if the tournament doesn't have enough contentPacks
   */
  featuredArtists: Array<Scalars['String']>;
  id: Scalars['ID'];
  /**
   * Can be null if the user doesn't have played any round yet
   * Even if the player has no userRankGroup (score too low) - isRankGroupRewardClaimed will be false
   * claimTournamentRankGroupReward mutaiton need to be called in any case if the user has participated to the tournament
   */
  isRankGroupRewardClaimed?: Maybe<Scalars['Boolean']>;
  /**
   * Unlike ContentPack and MonthlyPass leaderboards which use the XP gain as value,
   * Tournament leaderboard value is the commulative score of each round.
   */
  leaderboard?: Maybe<Leaderboard>;
  meScore?: Maybe<Scalars['Int']>;
  milestones: Array<TournamentMilestone>;
  name: Scalars['String'];
  rankGroups: Array<TournamentRankGroup>;
  specialEvent?: Maybe<SpecialEvent>;
  startDate: Scalars['Date'];
  ticketCost: Scalars['Int'];
  /** Can be null if the user doesn't join the tournament or didn't reach at least the lowest rank group */
  userRankGroup?: Maybe<TournamentRankGroup>;
};

export type TournamentAssetsConfig = {
  __typename: 'TournamentAssetsConfig';
  buttonColor?: Maybe<Scalars['String']>;
  characterImage?: Maybe<Scalars['String']>;
  contrast?: Maybe<Scalars['String']>;
  contrastGradient1?: Maybe<Scalars['String']>;
  contrastGradient2?: Maybe<Scalars['String']>;
  headerImage?: Maybe<Scalars['String']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  secondaryDarkColor?: Maybe<Scalars['String']>;
};

export type TournamentAssetsConfigInput = {
  buttonColor?: InputMaybe<Scalars['String']>;
  characterImage?: InputMaybe<Scalars['String']>;
  contrast?: InputMaybe<Scalars['String']>;
  contrastGradient1?: InputMaybe<Scalars['String']>;
  contrastGradient2?: InputMaybe<Scalars['String']>;
  headerImage?: InputMaybe<Scalars['String']>;
  primaryColor?: InputMaybe<Scalars['String']>;
  secondaryColor?: InputMaybe<Scalars['String']>;
  secondaryDarkColor?: InputMaybe<Scalars['String']>;
};

export type TournamentMilestone = {
  __typename: 'TournamentMilestone';
  id: Scalars['ID'];
  isClaimed: Scalars['Boolean'];
  rewards: Array<LevelReward>;
  score: Scalars['Int'];
};

export type TournamentMilestoneInput = {
  rewards: Array<LevelRewardInput>;
  score: Scalars['Int'];
};

export type TournamentPaginated = {
  __typename: 'TournamentPaginated';
  hasMore: Scalars['Boolean'];
  id: Scalars['ID'];
  list: Array<Tournament>;
  totalCount: Scalars['Int'];
};

export type TournamentPayload = {
  __typename: 'TournamentPayload';
  tournament: Tournament;
};

export type TournamentRankGroup = {
  __typename: 'TournamentRankGroup';
  id: Scalars['ID'];
  maxRank: Scalars['Int'];
  minRank: Scalars['Int'];
  rewards: Array<LevelReward>;
};

export type TournamentRankGroupInput = {
  maxRank: Scalars['Int'];
  minRank: Scalars['Int'];
  rewards: Array<LevelRewardInput>;
};

export type TournamentRound = {
  __typename: 'TournamentRound';
  id: Scalars['ID'];
  isUserSpeedsterBoostActivated: Scalars['Boolean'];
  opponents: Array<TournamentRoundOpponent>;
  questions: Array<QuizQuestion>;
  sent?: Maybe<Scalars['Date']>;
  state: TournamentRoundState;
  userAnswers: Array<UserQuizAnswer>;
  userContentPack: UserContentPack;
  userLikedContent: Array<UserContentItem>;
  userNewContent: Array<UserContentItem>;
};

export type TournamentRoundOpponent = {
  __typename: 'TournamentRoundOpponent';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  opponentAnswers: Array<UserQuizAnswer>;
  picture?: Maybe<Scalars['String']>;
};

export enum TournamentRoundState {
  DONE = 'DONE',
  READY_TO_PLAY = 'READY_TO_PLAY',
  TOO_LATE = 'TOO_LATE'
}

export type TradeLoyaltyCardsInput = {
  item: LoyaltyTradeableItem;
  itemAmount: Scalars['Int'];
};

export type TradeLoyaltyCardsPayload = {
  __typename: 'TradeLoyaltyCardsPayload';
  user: User;
};

export type UnbanUserInput = {
  userId: Scalars['ID'];
};

export type UnbanUserPayload = {
  __typename: 'UnbanUserPayload';
  user: User;
};

export type UnblockUserInput = {
  userId: Scalars['ID'];
};

export type UnblockUserPayload = {
  __typename: 'UnblockUserPayload';
  userToUser?: Maybe<UserToUser>;
};

export type UnlimitedBoosts = {
  __typename: 'UnlimitedBoosts';
  unlimitedBoostAdFreeBalance: Scalars['Int'];
  unlimitedBoostAdFreeBalanceExpiration?: Maybe<Scalars['Date']>;
  unlimitedBoostAdFreeEnd: Scalars['Date'];
  unlimitedBoostAdFreeLastBalanceActivated: Scalars['Int'];
  unlimitedBoostCoinsAndXpBalance: Scalars['Int'];
  unlimitedBoostCoinsAndXpBalanceExpiration?: Maybe<Scalars['Date']>;
  unlimitedBoostCoinsAndXpEnd: Scalars['Date'];
  unlimitedBoostCoinsAndXpLastBalanceActivated: Scalars['Int'];
  unlimitedBoostRemove2Balance: Scalars['Int'];
  unlimitedBoostRemove2BalanceExpiration?: Maybe<Scalars['Date']>;
  unlimitedBoostRemove2End: Scalars['Date'];
  unlimitedBoostRemove2LastBalanceActivated: Scalars['Int'];
  unlimitedBoostSpeedsterBalance: Scalars['Int'];
  unlimitedBoostSpeedsterBalanceExpiration?: Maybe<Scalars['Date']>;
  unlimitedBoostSpeedsterEnd: Scalars['Date'];
  unlimitedBoostSpeedsterLastBalanceActivated: Scalars['Int'];
  unlimitedBoostTournamentTicketBalance: Scalars['Int'];
  unlimitedBoostTournamentTicketBalanceExpiration?: Maybe<Scalars['Date']>;
  unlimitedBoostTournamentTicketEnd: Scalars['Date'];
  unlimitedBoostTournamentTicketLastBalanceActivated: Scalars['Int'];
};

export type UnlimitedBoostsInput = {
  unlimitedBoostRemove2Balance: Scalars['Int'];
  unlimitedBoostSpeedsterBalance: Scalars['Int'];
};

export type UnlockMonthlyPassLevelPayload = {
  __typename: 'UnlockMonthlyPassLevelPayload';
  user: User;
  userMonthlyPass: UserMonthlyPass;
};

export type UnsaveUserContentPackInput = {
  contentPackId: Scalars['ID'];
};

export type UnsupportedPopupConfig = {
  __typename: 'UnsupportedPopupConfig';
  blockerReleaseVersion?: Maybe<Scalars['String']>;
  bodyTexts: Scalars['JSON'];
  displayPolicy: UnsupportedPopupDisplayPolicy;
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  key: Scalars['String'];
  minimumDeviceVersion?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  place: PopupPlacement;
  popupType: UnsupportedPopupType;
  targetSystemName: UnsupportedPopupTargetSystemName;
  titleTexts: Scalars['JSON'];
};

export type UnsupportedPopupConfigInput = {
  blockerReleaseVersion?: InputMaybe<Scalars['String']>;
  bodyTexts: Scalars['JSON'];
  displayPolicy: UnsupportedPopupDisplayPolicy;
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  key: Scalars['String'];
  minimumDeviceVersion?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  place: PopupPlacement;
  popupType: UnsupportedPopupType;
  targetSystemName: UnsupportedPopupTargetSystemName;
  titleTexts: Scalars['JSON'];
};

export enum UnsupportedPopupDisplayPolicy {
  EVERY_LAUNCH = 'EVERY_LAUNCH',
  ONCE_PER_DAY = 'ONCE_PER_DAY'
}

export enum UnsupportedPopupTargetSystemName {
  ANDROID = 'ANDROID',
  IOS = 'IOS'
}

export enum UnsupportedPopupType {
  BLOCKER = 'BLOCKER',
  REMINDER = 'REMINDER'
}

export type UpdateAbTestInput = {
  audience: AbTestAudienceType;
  /**
   * Can be null if variationsWithPercentage = []
   * If defaultVariation is not defined but variationsWithPercentage != [], the defaultVariation will be variationsWithPercentage[0].name
   */
  defaultVariation?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['ID'];
  isNewAudienceOnly: Scalars['Boolean'];
  startDate: Scalars['Date'];
  status: AbTestStatus;
  variationsWithPercentage: Array<AbTestVariationInput>;
  /** Should be not null only if status = ABTestStatus.WINNER */
  winnerVariation?: InputMaybe<Scalars['String']>;
};

export type UpdateAbTestPayload = {
  __typename: 'UpdateABTestPayload';
  abTest: AbTestConfig;
};

export type UpdateAppFeatureTogglesInput = {
  autoRenewReminderPopupEnabled?: InputMaybe<Scalars['Boolean']>;
  sandboxSubscriptionSkuCheatEnabled?: InputMaybe<Scalars['Boolean']>;
  sandboxSubscriptionSkuCheatUserIds?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateAppInstallPayload = {
  __typename: 'UpdateAppInstallPayload';
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateBadgeInput = {
  details?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  levelUpReq?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  unlockReq?: InputMaybe<Scalars['String']>;
};

export type UpdateBadgePayload = {
  __typename: 'UpdateBadgePayload';
  badge: BadgeConfig;
};

export type UpdateBatchContentModerationInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  packIds: Array<Scalars['ID']>;
};

export type UpdateBundleItem = {
  amount?: InputMaybe<Scalars['Int']>;
  itemId?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<Scalars['String']>;
};

export type UpdateChainedOfferEventInput = {
  backgroundImage?: InputMaybe<Scalars['String']>;
  filterAppVersion?: InputMaybe<Scalars['String']>;
  filterSubscriptionTier?: InputMaybe<UserSubscriptionTier>;
  filterUserIds?: InputMaybe<Array<Scalars['String']>>;
  filterUserLevel?: InputMaybe<Scalars['Int']>;
  filterUserMaxCreationDate?: InputMaybe<Scalars['Date']>;
  filterUserMinCreationDate?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  packs: Array<ChainedOfferPackConfigInput>;
  startDate: Scalars['Date'];
  status: ChainedOfferEventStatus;
  stopDate: Scalars['Date'];
};

export type UpdateChainedOfferEventPayload = {
  __typename: 'UpdateChainedOfferEventPayload';
  chainedOfferEvent: ChainedOfferEventConfig;
};

export type UpdateCollectionInput = {
  asset?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isDraft: Scalars['Boolean'];
  levels?: InputMaybe<Array<CollectionLevelInput>>;
  name: Scalars['String'];
  type: CollectionType;
};

export type UpdateContentItemStatusUserToUserQuizLiveRoundInput = {
  contentItemId: Scalars['ID'];
  quizQuestionId: Scalars['ID'];
  userToUserQuizLiveRoundId: Scalars['ID'];
};

export type UpdateContentPackAvailabilityDateInput = {
  date: Scalars['Date'];
  id: Scalars['ID'];
};

export type UpdateContentPackAvailabilityTypeInput = {
  id: Scalars['ID'];
  type: ContentPackAvailabilityType;
};

export type UpdateContentPackLastUpdateDateInput = {
  date: Scalars['Date'];
  id: Scalars['ID'];
};

export type UpdateContentPackListInput = {
  contentPackIds?: InputMaybe<Array<Scalars['ID']>>;
  contentPackListId: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateCurationContentPackBadgesToSp2Input = {
  badges: Array<InputMaybe<Scalars['String']>>;
  sp2CurationPlaylistId: Scalars['ID'];
};

export type UpdateCurationContentPackCategoriesInput = {
  categories?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
};

export type UpdateCurationContentPackCustomFieldsInput = {
  fields?: InputMaybe<Array<CurationContentPackCustomField>>;
  id: Scalars['ID'];
};

export type UpdateCurationContentPackDescriptionInput = {
  description: Scalars['String'];
  id: Scalars['ID'];
};

export type UpdateCurationContentPackListInput = {
  appId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  packIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdateCurationContentPackLocaleInput = {
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['String']>;
};

export type UpdateCurationContentPackNameInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateCurationContentPackPictureInput = {
  file: Scalars['Upload'];
  id: Scalars['ID'];
};

export type UpdateCurationContentPackPictureToSp2Input = {
  file: Scalars['Upload'];
  id: Scalars['ID'];
};

export type UpdateCurationContentPackPriceToSp2Input = {
  price: Scalars['Int'];
  sp2CurationPlaylistId: Scalars['ID'];
};

export type UpdateCurationContentPackTypeInput = {
  id: Scalars['ID'];
  type: ContentPackType;
};

export type UpdateCurationSongInput = {
  contentPackId: Scalars['ID'];
  id: Scalars['ID'];
  songInputId?: InputMaybe<Scalars['ID']>;
  type: UpdateCurationSongInputType;
  value?: InputMaybe<Scalars['String']>;
};

export enum UpdateCurationSongInputType {
  COMPOSER = 'COMPOSER',
  DISPLAY_ARTIST = 'DISPLAY_ARTIST',
  DISPLAY_TITLE = 'DISPLAY_TITLE',
  JESTER = 'JESTER',
  LEAD_SINGER = 'LEAD_SINGER',
  MOVIE = 'MOVIE',
  PLAYLIST_CUSTOM_FIELD = 'PLAYLIST_CUSTOM_FIELD',
  PLAYLIST_FULL_CUSTOM_FIELD = 'PLAYLIST_FULL_CUSTOM_FIELD'
}

export type UpdateCurationSongSampleInput = {
  contentPackId: Scalars['ID'];
  file?: InputMaybe<Scalars['Upload']>;
  id: Scalars['ID'];
  songInputId?: InputMaybe<Scalars['ID']>;
  startingTime?: InputMaybe<Scalars['Float']>;
  type: UpdateCurationSongSampleInputType;
  url?: InputMaybe<Scalars['String']>;
};

export enum UpdateCurationSongSampleInputType {
  CUSTOM = 'CUSTOM',
  DEFAULT = 'DEFAULT',
  INTRO = 'INTRO'
}

export type UpdateEmojiInput = {
  asset: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  utfCode: Scalars['String'];
};

export type UpdateEmojiPackInput = {
  asset: Scalars['String'];
  emojis: Array<UpdateEmojiInput>;
  id: Scalars['ID'];
  isDraft: Scalars['Boolean'];
  layout: EmojiPackLayout;
  name: Scalars['String'];
};

export type UpdateEmojiPackPayload = {
  __typename: 'UpdateEmojiPackPayload';
  emojiPack: EmojiPack;
};

export type UpdateEmojiPayload = {
  __typename: 'UpdateEmojiPayload';
  emoji: Emoji;
};

export type UpdateGameCenterIdInput = {
  gameCenterId?: InputMaybe<Scalars['String']>;
};

export type UpdateGiftHistory = {
  __typename: 'UpdateGiftHistory';
  appId: Scalars['String'];
  betaAndroidVersions: Array<Scalars['Int']>;
  betaIosVersions: Array<Scalars['Int']>;
  createdAt: Scalars['Date'];
  eligibleAndroidVersions: Array<Scalars['Int']>;
  eligibleIosVersions: Array<Scalars['Int']>;
  gift1Amount: Scalars['Int'];
  gift1Type: Scalars['String'];
  gift2Amount: Scalars['Int'];
  gift2Type: Scalars['String'];
  id: Scalars['ID'];
};

export type UpdateHurdleCatalogItemInput = {
  catalogItemId: Scalars['ID'];
  categoryId?: InputMaybe<Scalars['String']>;
  excludeFromAutogeneration?: InputMaybe<Scalars['Boolean']>;
  excludeFromCheck?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type UpdateHurdleCatalogItemPayload = {
  __typename: 'UpdateHurdleCatalogItemPayload';
  catalogItem: HurdleCatalogItem;
};

export type UpdateHurdleQuizInput = {
  catalogItemId?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['String']>;
  hurdleQuizId: Scalars['ID'];
};

export type UpdateHurdleQuizPayload = {
  __typename: 'UpdateHurdleQuizPayload';
  hurdleQuiz: HurdleQuiz;
};

export type UpdateImportantEventInput = {
  datetime?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  eventKey: Scalars['String'];
  important?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  type: ImportantEventType;
};

export type UpdateItemInput = {
  asset: Scalars['String'];
  availability: ItemAvailability;
  cost?: InputMaybe<CurrencyInput>;
  iconAsset?: InputMaybe<Scalars['String']>;
  iconBackgroundColor?: InputMaybe<Scalars['String']>;
  iconPrimaryColor?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  levelItems?: InputMaybe<Array<LevelItemInput>>;
  name: Scalars['String'];
  type: CreateItemInputType;
};

export type UpdateItemPayload = {
  __typename: 'UpdateItemPayload';
  item: Item;
};

export type UpdateLiveEventContentPacksInput = {
  contentPackIds: Array<Scalars['ID']>;
  liveEventId: Scalars['ID'];
};

export type UpdateLiveEventInput = {
  endDate: Scalars['Date'];
  filterOnlyAdmin: Scalars['Boolean'];
  filterUserIds: Array<Scalars['ID']>;
  filterVersion: Scalars['Int'];
  isDraft: Scalars['Boolean'];
  liveEventId: Scalars['ID'];
  name: Scalars['String'];
  startDate: Scalars['Date'];
};

export type UpdateLiveEventShopInput = {
  liveEventId: Scalars['ID'];
  shopItemIds: Array<LiveEventShopItemInput>;
};

export type UpdateLocaleForModerationContentItemInput = {
  id: Scalars['ID'];
  locale: Scalars['String'];
};

export type UpdateLoyaltyCardInput = {
  cardId: Scalars['ID'];
  cardStreak: Scalars['Int'];
  tradeableCardCount: Scalars['Int'];
  userId: Scalars['ID'];
};

export type UpdateLoyaltyCardPayload = {
  __typename: 'UpdateLoyaltyCardPayload';
  user: User;
};

export type UpdateMmTemplateInput = {
  id: Scalars['ID'];
  milestones: Array<MMilestonesInput>;
  name: Scalars['String'];
};

export type UpdateMmTemplatePayload = {
  __typename: 'UpdateMMTemplatePayload';
  template: MarathonMilestoneTemplate;
};

export type UpdateMarathonEventInput = {
  category: Scalars['String'];
  economy: MarathonEconomyConfigInput;
  filterAppVersion?: InputMaybe<Scalars['String']>;
  filterSubscriptionTier?: InputMaybe<UserSubscriptionTier>;
  filterUserIds?: InputMaybe<Array<Scalars['String']>>;
  filterUserLevel?: InputMaybe<Scalars['Int']>;
  filterUserMaxCreationDate?: InputMaybe<Scalars['Date']>;
  filterUserMinCreationDate?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
  milestoneGroups: Array<MarathonMilestoneGroupInput>;
  name: Scalars['String'];
  status: ChainedOfferEventStatus;
};

export type UpdateMarathonEventPayload = {
  __typename: 'UpdateMarathonEventPayload';
  event: MarathonEventConfig;
};

export type UpdateMonthlyPassInput = {
  id: Scalars['ID'];
  leaderboardRankGroups: Array<MonthlyPassRankGroupInput>;
  levels: Array<LevelConfigMonthlyPassInput>;
  rankGroups: Array<MonthlyPassRankGroupInput>;
};

export type UpdateMonthlyPassMissionsInput = {
  dailyMissions: Array<Array<MissionInput>>;
  extraMissions: Array<MissionInput>;
  id: Scalars['ID'];
  monthlyMissions: Array<MissionInput>;
  teamMissions: Array<Array<MissionInput>>;
};

export type UpdatePingUserToUserConfigInput = {
  isMuted: Scalars['Boolean'];
  type: PingUserToUserEventType;
  userToUserId: Scalars['ID'];
};

export type UpdatePingUserToUserConfigPayload = {
  __typename: 'UpdatePingUserToUserConfigPayload';
  eventType: PingUserToUserEventType;
  userToUser: UserToUser;
};

export type UpdatePosterInput = {
  asset?: InputMaybe<Scalars['String']>;
  currencyCost?: InputMaybe<Scalars['Int']>;
  currencyType?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  itemId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type UpdatePushTokenInput = {
  apnToken?: InputMaybe<Scalars['String']>;
  fcmToken: Scalars['String'];
};

export type UpdateQuizLiveShowContentPacksInput = {
  contentPackIds: Array<Scalars['ID']>;
  showId: Scalars['ID'];
};

export type UpdateQuizLiveShowRoundInput = {
  contentPackId: Scalars['ID'];
  questionDuration: Scalars['Int'];
  roundId: Scalars['ID'];
  showId: Scalars['ID'];
};

export type UpdateReferralRewardStatusToPendingInput = {
  referralRewardIds: Array<Scalars['String']>;
};

export type UpdateReplacingCurationContentPackInput = {
  id: Scalars['ID'];
  replacingId?: InputMaybe<Scalars['ID']>;
};

export type UpdateSaleBundleInput = {
  backgroundImage?: InputMaybe<Scalars['String']>;
  displayTimer?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  items?: InputMaybe<Array<UpdateBundleItem>>;
  name?: InputMaybe<Scalars['String']>;
  offerPercentage?: InputMaybe<Scalars['Int']>;
  purchaseLimitType?: InputMaybe<PurchaseLimitEnum>;
  ruleMaximumNumberOfClaim?: InputMaybe<Scalars['Int']>;
  skuId: Scalars['String'];
  startDate?: InputMaybe<Scalars['Date']>;
  stopDate?: InputMaybe<Scalars['Date']>;
  tag?: InputMaybe<Scalars['String']>;
};

export type UpdateSaleEventInput = {
  assetsConfig?: InputMaybe<SaleEventAssetsConfigInput>;
  dailyItems: Array<Scalars['ID']>;
  filterAppVersion?: InputMaybe<Scalars['String']>;
  filterHadSub?: InputMaybe<Scalars['Boolean']>;
  filterSubscriptionTier?: InputMaybe<UserSubscriptionTier>;
  filterUserIds?: InputMaybe<Array<Scalars['String']>>;
  filterUserLevel?: InputMaybe<Scalars['Int']>;
  filterUserMaxCreationDate?: InputMaybe<Scalars['Date']>;
  filterUserMinCreationDate?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  packs?: InputMaybe<Array<UpdateSaleBundleInput>>;
  priority: Scalars['Int'];
  sales: Array<UpdateSaleInput>;
  startDate: Scalars['Date'];
  status: SaleEventStatus;
  stopDate: Scalars['Date'];
  subscriptions: Array<UpdateSubscriptionSaleInput>;
};

export type UpdateSaleEventPayload = {
  __typename: 'UpdateSaleEventPayload';
  saleEvent: SaleEventConfig;
};

export type UpdateSaleInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  purchaseLimitType?: InputMaybe<PurchaseLimitEnum>;
  ruleMaximumNumberOfClaim?: InputMaybe<Scalars['Int']>;
  saleProductId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['Date']>;
  stopDate?: InputMaybe<Scalars['Date']>;
  tag?: InputMaybe<Scalars['String']>;
  /** original product id that will be replaced by the saleProductId */
  targetedProductId?: InputMaybe<Scalars['ID']>;
};

export type UpdateSongQuestionableStatusInput = {
  id: Scalars['ID'];
  status?: InputMaybe<SongQuestionableStatus>;
};

export type UpdateSpecialEventContentPacksInput = {
  contentPackIds: Array<Scalars['ID']>;
  specialEventId: Scalars['ID'];
};

export type UpdateSpecialEventInput = {
  assetsConfig: SpecialEventAssetsConfigInput;
  description: Scalars['String'];
  endDate: Scalars['Date'];
  isDraft: Scalars['Boolean'];
  name: Scalars['String'];
  specialEventId: Scalars['ID'];
  startDate: Scalars['Date'];
};

export type UpdateSpecialEventMilestonesInput = {
  milestones: Array<SpecialEventMilestoneInput>;
  specialEventId: Scalars['ID'];
};

export type UpdateSpecialEventMissionsInput = {
  missionSetId: Scalars['ID'];
  sequentialMissions: Array<MissionInput>;
};

export type UpdateSpecialEventPlusMilestonesInput = {
  plusMilestones: Array<SpecialEventMilestoneInput>;
  specialEventId: Scalars['ID'];
};

export type UpdateSpecialEventRankGroupsInput = {
  rankGroups: Array<SpecialEventRankGroupInput>;
  specialEventId: Scalars['ID'];
};

export type UpdateSubscriptionSaleInput = {
  backgroundTheme?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type UpdateSubscriptionTierInput = {
  sku?: InputMaybe<Scalars['ID']>;
  subscriptionTier: UserSubscriptionTier;
  userId?: InputMaybe<Scalars['ID']>;
};

export type UpdateSubscriptionTierPayload = {
  __typename: 'UpdateSubscriptionTierPayload';
  user?: Maybe<User>;
};

export type UpdateTeamBoostsInput = {
  availableBoosts: Scalars['Int'];
  boosts: Array<TeamBoostsInput>;
  teamId: Scalars['ID'];
};

export type UpdateTeamBoostsPayload = {
  __typename: 'UpdateTeamBoostsPayload';
  team: Team;
};

export type UpdateTeamHeatIterationMilestonesPayload = {
  __typename: 'UpdateTeamHeatIterationMilestonesPayload';
  monthlyPass: MonthlyPass;
};

export type UpdateTeamInput = {
  banner: Scalars['String'];
  description: Scalars['String'];
  teamId: Scalars['ID'];
  type: TeamType;
};

export type UpdateTournamentContentPacksInput = {
  contentPackIds: Array<Scalars['ID']>;
  id: Scalars['ID'];
};

export type UpdateTournamentInput = {
  assetsConfig: TournamentAssetsConfigInput;
  categoryId: Scalars['ID'];
  description: Scalars['String'];
  endDate: Scalars['Date'];
  id: Scalars['ID'];
  name: Scalars['String'];
  startDate: Scalars['Date'];
  ticketCost: Scalars['Int'];
};

export type UpdateTournamentMilestonesInput = {
  id: Scalars['ID'];
  milestones: Array<TournamentMilestoneInput>;
};

export type UpdateTournamentRankGroupsInput = {
  id: Scalars['ID'];
  rankGroups: Array<TournamentRankGroupInput>;
};

export type UpdateUmeAchievement = {
  newProgress: Scalars['Int'];
  userId: Scalars['String'];
};

export type UpdateUnsupportedPopupConfigInput = {
  blockerReleaseVersion?: InputMaybe<Scalars['String']>;
  bodyTexts?: InputMaybe<Scalars['JSON']>;
  displayPolicy?: InputMaybe<UnsupportedPopupDisplayPolicy>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  key?: InputMaybe<Scalars['String']>;
  minimumDeviceVersion?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  place?: InputMaybe<PopupPlacement>;
  popupType?: InputMaybe<UnsupportedPopupType>;
  targetSystemName?: InputMaybe<UnsupportedPopupTargetSystemName>;
  titleTexts?: InputMaybe<Scalars['JSON']>;
};

export type UpdateUserBasicTierContentPackInput = {
  contentPackId: Scalars['ID'];
  costAmount?: InputMaybe<Scalars['Int']>;
};

export type UpdateUserBasicTierContentPackPayload = {
  __typename: 'UpdateUserBasicTierContentPackPayload';
  user: User;
};

export type UpdateUserContentItemStatusInput = {
  contentItemId: Scalars['ID'];
  status: UserContentItemLikeStatus;
};

export type UpdateUserContentItemStatusPayload = {
  __typename: 'UpdateUserContentItemStatusPayload';
  userContentItem: UserContentItem;
};

export type UpdateUserDisplayNameInput = {
  name: Scalars['String'];
};

export type UpdateUserEmojiPackInput = {
  availableEmojis: Array<Scalars['Boolean']>;
  packId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type UpdateUserHurdleQuizInput = {
  currentStreak?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
};

export type UpdateUserHurdleQuizPayload = {
  __typename: 'UpdateUserHurdleQuizPayload';
  hurdleQuiz: HurdleQuiz;
};

export type UpdateUserInfluencerInput = {
  influencerId?: InputMaybe<Scalars['ID']>;
  isInfluencer: Scalars['Boolean'];
  userId: Scalars['ID'];
};

export type UpdateUserInfluencerPayload = {
  __typename: 'UpdateUserInfluencerPayload';
  user: User;
};

export type UpdateUserMarathonEventInput = {
  eventId: Scalars['ID'];
  /** Set checkPoint to an exact checkpoint milestone value (0 to clear). */
  newCheckPoint?: InputMaybe<Scalars['Int']>;
  newMaxReached?: InputMaybe<Scalars['Int']>;
  resetClaimedRewards?: InputMaybe<Scalars['Boolean']>;
  /** Deprecated by newCheckPoint; true => highest unlocked checkpoint value, false => 0. */
  useCheckPoint?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['ID'];
};

export type UpdateUserMarathonEventPayload = {
  __typename: 'UpdateUserMarathonEventPayload';
  userEvent: UserMarathonEvent;
};

export type UpdateUserPayload = {
  __typename: 'UpdateUserPayload';
  user?: Maybe<User>;
};

export type UpdateUserPictureInput = {
  picture: Scalars['String'];
};

export type UpdateUserRoleInput = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  role: UserRole;
};

export type UpdateUserRolePayload = {
  __typename: 'UpdateUserRolePayload';
  user: User;
};

export type UpdateUserSelectedCategoriesInput = {
  categoryIds: Array<Scalars['ID']>;
};

export type UpdateUserSelectedCategoriesPayload = {
  __typename: 'UpdateUserSelectedCategoriesPayload';
  user: User;
};

export type UpdateUserSettingsInput = {
  chainedOfferEventNotificationsEnabled?: InputMaybe<Scalars['Boolean']>;
  chatNotificationsEnabled?: InputMaybe<Scalars['Boolean']>;
  dailyBonusEnabled?: InputMaybe<Scalars['Boolean']>;
  friendNotificationsEnabled?: InputMaybe<Scalars['Boolean']>;
  hurdleNotificationsEnabled?: InputMaybe<Scalars['Boolean']>;
  liveGameNotificationsEnabled?: InputMaybe<Scalars['Boolean']>;
  liveShowNotificationsEnabled?: InputMaybe<Scalars['Boolean']>;
  marathonEventNotificationsEnabled?: InputMaybe<Scalars['Boolean']>;
  missionNotificationsEnabled?: InputMaybe<Scalars['Boolean']>;
  onlineNotificationsEnabled?: InputMaybe<Scalars['Boolean']>;
  quotaNotificationsEnabled?: InputMaybe<Scalars['Boolean']>;
  reminderNotificationsEnabled?: InputMaybe<Scalars['Boolean']>;
  returnGiftNotificationsEnabled?: InputMaybe<Scalars['Boolean']>;
  saleEventNotificationsEnabled?: InputMaybe<Scalars['Boolean']>;
  specialEventNotificationsEnabled?: InputMaybe<Scalars['Boolean']>;
  tournamentNotificationsEnabled?: InputMaybe<Scalars['Boolean']>;
  turnGameNotificationsEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateUserSettingsPayload = {
  __typename: 'UpdateUserSettingsPayload';
  user?: Maybe<User>;
};

export type UpdateUserSpecialEventPointsInput = {
  specialEventId: Scalars['ID'];
  userId: Scalars['ID'];
  userScoreDetails: Array<SpecialEventScoreDetailInput>;
};

export type UpdateUserSpecialEventPointsPayload = {
  __typename: 'UpdateUserSpecialEventPointsPayload';
  user: User;
};

export enum UpdateUserToUserQuizLiveRoundState {
  FINISHED = 'FINISHED',
  QUIZ_LOADED = 'QUIZ_LOADED',
  READY_TO_START = 'READY_TO_START'
}

export type UpdateUserToUserQuizLiveRoundStateInput = {
  state: UpdateUserToUserQuizLiveRoundState;
  userToUserQuizLiveRoundId: Scalars['ID'];
};

export type UpdateUserToUserQuizLiveRoundStatePayload = {
  __typename: 'UpdateUserToUserQuizLiveRoundStatePayload';
  user: User;
  userToUser: UserToUser;
  userToUserQuizLiveRound: UserToUserQuizLiveRound;
};

export type UpdateWfEventInput = {
  filterAppVersion?: InputMaybe<Scalars['String']>;
  filterSubscriptionTier?: InputMaybe<UserSubscriptionTier>;
  filterUserIds?: InputMaybe<Array<Scalars['String']>>;
  filterUserLevel?: InputMaybe<Scalars['Int']>;
  filterUserMaxCreationDate?: InputMaybe<Scalars['Date']>;
  filterUserMinCreationDate?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  rewards: Array<WfRewardInput>;
  spinPrice: LevelRewardInput;
  spinPricePlus: LevelRewardInput;
  startDate: Scalars['Date'];
  status: ChainedOfferEventStatus;
  stopDate: Scalars['Date'];
};

export type UpdateWfEventPayload = {
  __typename: 'UpdateWFEventPayload';
  event: WheelFortuneEventConfig;
};

export type UpdateWfrTemplateInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
  rewards: Array<WfRewardInput>;
};

export type UpdateWfrTemplatePayload = {
  __typename: 'UpdateWFRTemplatePayload';
  template: WheelFortuneRewardTemplate;
};

export type UpdatedMonthlyPassPayload = {
  __typename: 'UpdatedMonthlyPassPayload';
  monthlyPass: MonthlyPass;
};

export type UpgradeItemInput = {
  itemId: Scalars['ID'];
};

export type UpgradeUserContentPackInput = {
  contentPackId: Scalars['ID'];
};

export type UpgradeUserContentPackPayload = {
  __typename: 'UpgradeUserContentPackPayload';
  user: User;
  userContentPack: UserContentPack;
};

export type UploadAssetInput = {
  file: Scalars['Upload'];
  id: Scalars['ID'];
  level?: InputMaybe<Scalars['Int']>;
};

export type UploadAssetPayload = {
  __typename: 'UploadAssetPayload';
  item: Item;
};

export type UploadBadgeAssetInput = {
  file: Scalars['Upload'];
  id: Scalars['ID'];
  level?: InputMaybe<Scalars['Int']>;
};

export type UploadBadgeAssetPayload = {
  __typename: 'UploadBadgeAssetPayload';
  asset: Scalars['String'];
};

export type UploadBatchEmojiAssetInput = {
  file: Scalars['Upload'];
};

export type UploadBatchEmojiAssetPayload = {
  __typename: 'UploadBatchEmojiAssetPayload';
  assets: Array<Scalars['String']>;
};

export type UploadChainedOfferEventAssetInput = {
  file: Scalars['Upload'];
  id: Scalars['ID'];
};

export type UploadCollectionAssetInput = {
  file: Scalars['Upload'];
  id: Scalars['ID'];
};

export type UploadEmojiAssetInput = {
  file: Scalars['Upload'];
};

export type UploadEmojiAssetPayload = {
  __typename: 'UploadEmojiAssetPayload';
  asset: Scalars['String'];
};

export type UploadEmojiPackAssetInput = {
  file: Scalars['Upload'];
  id: Scalars['ID'];
};

export type UploadEmojiPackAssetPayload = {
  __typename: 'UploadEmojiPackAssetPayload';
  emojiPack: EmojiPack;
};

export type UploadEmojisFontInput = {
  file: Scalars['Upload'];
  isOldAndroid: Scalars['Boolean'];
};

export type UploadEmojisFontPayload = {
  __typename: 'UploadEmojisFontPayload';
  asset: Scalars['String'];
};

export type UploadIconAssetInput = {
  file: Scalars['Upload'];
  id: Scalars['ID'];
};

export type UploadPosterAssetInput = {
  file: Scalars['Upload'];
  id: Scalars['ID'];
};

export type UploadSaleEventAssetInput = {
  bundleId?: InputMaybe<Scalars['ID']>;
  file: Scalars['Upload'];
  saleEventId: Scalars['ID'];
  type: SaleEventAssetType;
};

export type UploadSheetInput = {
  file: Scalars['Upload'];
  id?: InputMaybe<Scalars['ID']>;
  type: Scalars['String'];
};

export type UploadSheetPayload = {
  __typename: 'UploadSheetPayload';
  message: Scalars['String'];
};

export type UploadSpecialEventAssetInput = {
  file: Scalars['Upload'];
  specialEventId: Scalars['ID'];
  type: SpecialEventAssetType;
};

export type UploadUserGeneratedPictureInput = {
  file: Scalars['Upload'];
};

export type UploadUserGeneratedPicturePayload = {
  __typename: 'UploadUserGeneratedPicturePayload';
  url?: Maybe<Scalars['String']>;
};

export type UpsertQuizLiveShowInput = {
  category: Scalars['ID'];
  diamondPrize: Scalars['Int'];
  extraConfig?: InputMaybe<ExtraConfigInput>;
  preset?: InputMaybe<Scalars['String']>;
  showId?: InputMaybe<Scalars['ID']>;
  start: Scalars['Date'];
};

export type UseHurdleHintBoostInput = {
  hurdleQuizId?: InputMaybe<Scalars['ID']>;
};

export type UseHurdleHintBoostPayload = {
  __typename: 'UseHurdleHintBoostPayload';
  hurdleQuiz: HurdleQuizPayload;
  user: User;
};

export type UseQuizLiveShowBoostInput = {
  boostType: CurrencyBoostType;
  quizLiveRoundId: Scalars['ID'];
  quizLiveShowId: Scalars['ID'];
};

export type UseQuizLiveShowBoostPayload = {
  __typename: 'UseQuizLiveShowBoostPayload';
  user: User;
};

export type UseRemove2BoostPayload = {
  __typename: 'UseRemove2BoostPayload';
  user: User;
};

export type UseReviveInMarathonInput = {
  eventId: Scalars['ID'];
  roundId: Scalars['ID'];
};

export type UseReviveInMarathonPayload = {
  __typename: 'UseReviveInMarathonPayload';
  user: User;
};

/**
 * Represents a user in a specific game.
 * Regroups shared and app specific information
 */
export type User = {
  __typename: 'User';
  /**
   * List of all currently testing ABTestConfig (currently active only : testing & winners)
   * We support only ABTestType.User for now
   * Order by startDate DESC
   */
  ABTestConfigs: Array<AbTestConfig>;
  /**
   * List of forced abtests for this user (currently active only : testing & winners)
   * Those forced variation will override the ABTest even if the test is not already started or
   * if the user should not participate to it.
   */
  ABTestForcedList: Array<AbTest>;
  ABTestLastAppInstallList: Array<AbTest>;
  /** List of active (testing & winners) user based ab tests and their variations */
  ABTestList: Array<AbTest>;
  /**
   * This endpoint will return an empty array temporary to avoid crash on production
   * @deprecated Replaced by ABTestList
   */
  ABTests: Array<AbTest>;
  /** @deprecated use conversations instead */
  a41conversations: UserConnectionsPaginated;
  accoladeBalance: Scalars['Int'];
  /** @deprecated Replaced by User.stats.turnQuiz.accuracy or User.stats.liveQuiz.accuracy */
  accuracy: Scalars['Float'];
  achievementMissions?: Maybe<UserAchievementMissions>;
  activeReferralRewards: Array<ReferralReward>;
  allGifts: Array<GiftInfo>;
  appSkinIds: Array<Scalars['String']>;
  appSkins: Array<AppSkin>;
  appleCredential?: Maybe<Scalars['String']>;
  appsFlyerId?: Maybe<Scalars['ID']>;
  availableReturningGift?: Maybe<ReturningGift>;
  availableStarterPacks: Array<StarterPack>;
  availableYearInReview?: Maybe<YearInReview>;
  /** @deprecated Replaced by User.stats.turnQuiz.averageScore or User.stats.liveQuiz.averageScore */
  averageScore: Scalars['Int'];
  /** @deprecated Replaced by User.stats.turnQuiz.averageSpeed or User.stats.liveQuiz.averageSpeed */
  averageSpeed: Scalars['Float'];
  badgeCraftDetails: BadgeCraftDetails;
  badges: BadgePaginated;
  basicTierContentPack: UserContentPack;
  birthYear?: Maybe<Scalars['Int']>;
  /** list of people the user has blocked */
  blocked: UserToUsersPaginated;
  boostArtistOnlyBalance: Scalars['Int'];
  boostBombBalance: Scalars['Int'];
  boostHurdleHintBalance: Scalars['Int'];
  boostNinjaBalance: Scalars['Int'];
  boostRemove2Balance: Scalars['Int'];
  boostReviveBalance: Scalars['Int'];
  boostSpeedsterBalance: Scalars['Int'];
  boostTeamSpiritBalance: Scalars['Int'];
  calendars: Array<PaidCalendar>;
  /**
   * Active chainedOfferEvent for the current user
   * Reason why a chainedOfferEvent is filtered out from this list:
   * - it is DRAFT
   * - startDate not reached
   * - stopDate reached
   * - filtered out by user list used for test purposes
   */
  chainedOfferEvent?: Maybe<ChainedOfferEvent>;
  claimableAdsReward: AdsReward;
  claimedUpdateGiftId?: Maybe<Scalars['String']>;
  coinBalance: Scalars['Int'];
  /**
   * Has the user already used his free coin refill
   * @deprecated use User.energySystems.coin.isCapFreeRefillUsed
   */
  coinCapFreeRefillUsed: Scalars['Boolean'];
  comingSoonContentPacks: UserContentPacksPaginated;
  conversations: UserConnectionsPaginated;
  created: Scalars['Date'];
  /**
   * Last time the coin cap supply has been auto-refilled. Used with RewardCap.period to display useful information to the user (like how long he has to wait before earning again)
   * @deprecated use User.energySystems.coin.currentCapLastUpdate
   */
  currentCoinCapLastUpdate?: Maybe<Scalars['Date']>;
  /**
   * Current amount of coins you can earn. Starts at RewardCap.maxStorage and get lowered everytime you earned coins
   * @deprecated use User.energySystems.coin.currentCapSupply
   */
  currentCoinCapSupply: Scalars['Int'];
  currentDailyBonus: DailyBonus;
  currentSpecialEvent?: Maybe<SpecialEvent>;
  /**
   * Last time the tournament ticket cap supply has been auto-refilled. Used with RewardCap.period to display useful information to the user (like how long he has to wait before getting a new ticket)
   * @deprecated use User.energySystems.tournamentTicket.currentCapLastUpdate
   */
  currentTournamentTicketCapLastUpdate?: Maybe<Scalars['Date']>;
  /**
   * Current amount of ticket you can use from the automatically renewed balance.
   * Starts at RewardCap.maxStorage and get lowered everytime you use a ticket.
   * @deprecated use User.energySystems.tournamentTicket.currentCapSupply
   */
  currentTournamentTicketCapSupply: Scalars['Int'];
  currentUserMonthlyPass: UserMonthlyPass;
  /**
   * Last time the xp cap supply has been auto-refilled. Used with RewardCap.period to display useful information to the user (like how long he has to wait before earning again)
   * @deprecated use User.energySystems.xp.currentCapLastUpdate
   */
  currentXPCapLastUpdate?: Maybe<Scalars['Date']>;
  /**
   * Current amount of xp you can earn. Starts at RewardCap.maxStorage and get lowered everytime you earned coins
   * @deprecated use User.energySystems.xp.currentCapSupply
   */
  currentXPCapSupply: Scalars['Int'];
  diamondBalance: Scalars['Int'];
  displayName: Scalars['String'];
  emailCredential?: Maybe<Scalars['String']>;
  emojiPacks: UserEmojiPackPaginated;
  energySystems: EnergySystems;
  facebookCredential?: Maybe<Scalars['String']>;
  fragmentBalance: Array<CurrencyCategoryFragment>;
  freeSpins: Scalars['Int'];
  friends: UserToUsersPaginated;
  /**
   * List of FTUE steps the user has completed.
   * Each achieved step is supposed to give some (hardcoded) rewards to the user.
   */
  ftueSteps: Array<Scalars['String']>;
  gameCenterId?: Maybe<Scalars['String']>;
  /** @deprecated use turnGamesToPlay and/or turnGamesToWait instead */
  games: Array<UserToUser>;
  gender?: Maybe<UserGender>;
  getAllYearInReview?: Maybe<Array<YearInReview>>;
  getSpecialEvent: GetSpecialEventPayload;
  getUserMonthlyPass: GetUserMonthlyPassPayload;
  googleCredential?: Maybe<Scalars['String']>;
  iapGiftsSent: Scalars['Int'];
  id: Scalars['ID'];
  influencerId?: Maybe<Scalars['ID']>;
  inviteCode: Scalars['String'];
  isInfluencer?: Maybe<Scalars['Boolean']>;
  /**
   * Check if the user can use the internal free trial (based on some specs condition: https://jira.gameloft.org/browse/SONGPOPFRE-63)
   * @deprecated abtest lost
   */
  isInternalFreeTrialAvailable: Scalars['Boolean'];
  /**
   * Check if the user has already used his internal trial
   * @deprecated abtest lost
   */
  isInternalFreeTrialUsed: Scalars['Boolean'];
  /** Check if the user has already used his Premium / Plus subscription trial on his current device */
  isSubscriptionFreeTrialUsed: Scalars['Boolean'];
  itemCraftDetails: ItemCraftDetails;
  /** Items details for the current user (all items owned by the user) */
  itemDetails?: Maybe<ItemDetails>;
  lastOnline?: Maybe<Scalars['Date']>;
  likedContentItem: UserContentItemsPaginated;
  liveEvent?: Maybe<UserLiveEvent>;
  liveEventCurrency?: Maybe<Scalars['Int']>;
  liveEventLastGames: Array<UserLiveEventGame>;
  /** Return paginated UserToUsers relations with an active or pending (not expired) UserToUser.quizLiveGame */
  liveGamesToPlay: UserToUsersPaginated;
  liveShowFreeJoinUsed: Scalars['Boolean'];
  loyalty: Loyalty;
  loyaltyCampaignProgress: UserLoyaltyCampaignProgress;
  loyaltyCampaignRewardLogs: Array<UserLoyaltyCampaignRewardLog>;
  loyaltyCardTrades: Array<LoyaltyCardTrade>;
  metaFragments: MetaFragments;
  mostAdvancedContentPacks: UserContentPacksPaginated;
  newAndUpdatedContentPacks: UserContentPacksPaginated;
  nextDailyBonus?: Maybe<DailyBonus>;
  onlineStatus: UserOnlineStatus;
  onlineUsers: UserToUsersPaginated;
  ownedContentPacks: UserContentPacksPaginated;
  phoneCredential?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
  piggyBank: PiggyBank;
  plusDays: Scalars['Int'];
  posterIds: Array<Scalars['String']>;
  premiumDays: Scalars['Int'];
  /** list of people the user has deleted */
  previousOpponents: UserToUsersPaginated;
  profileFrameIds: Array<Scalars['String']>;
  /** returns list of non-default profile frames */
  profileFrames: Array<ProfileFrame>;
  promotions: Array<Promotion>;
  receivedFriendRequests: UserToUsersPaginated;
  recentContentPacks: UserContentPacksPaginated;
  recommendedContentPacks: UserContentPacksPaginated;
  /** list of ban reports filed against the user */
  reports: Array<UserReport>;
  role: UserRole;
  /**
   * This determines what type of content the user can see in the app.
   * Explict content and/or user generated content (like chat)
   */
  safetyLevel: UserSafetyLevel;
  /**
   * List of active saleEvents for the current user
   * Reason why a saleEvent is filtered out from this list:
   * - SaleEventStatus is DRAFT
   * - Sale startDate not reached
   * - Sale stopDate reached
   */
  saleEventList: Array<SaleEvent>;
  savedArtistContentPacks: UserContentPacksPaginated;
  savedContentPacks: UserContentPacksPaginated;
  selectedAppSkin?: Maybe<AppSkin>;
  selectedBadge?: Maybe<Badge>;
  selectedCategories: Array<ContentCategory>;
  /** is empty if the default profile frame is selected */
  selectedProfileFrame?: Maybe<ProfileFrame>;
  sentFriendRequests: UserToUsersPaginated;
  shards: Shards;
  /**
   * the current User result for a specific show
   * even if the user didn't participate to the show we return a default QuizLiveShowUser
   */
  show?: Maybe<QuizLiveShowUser>;
  sp2Info?: Maybe<Sp2Info>;
  /**
   * A few details about stampCard endpoints:
   * - stampCardBalance corresponds to the number of tradeableCardCount of a loyaltyCard added to the stampCards current balance
   * - stampCards corresponds to the current stampCards balance
   * - totalStampCardsEarned corresponds to the total of stampCards ever earned
   */
  stampCardBalance: Scalars['Int'];
  stampCards: Scalars['Int'];
  stats: UserStats;
  stickerIds: Array<Scalars['String']>;
  stickers: Array<Sticker>;
  subscriptionDetails?: Maybe<SubscriptionDetails>;
  subscriptionPromoOffers: Array<SubscriptionPromoOffer>;
  subscriptionTier?: Maybe<UserSubscriptionTier>;
  /** Give information about the old V1 subscription tiers (Premium / VIP) to help the transition to PLUS */
  subscriptionV1ToV2Transition: SubscriptionV1ToV2Transition;
  team?: Maybe<Team>;
  teamInvites: Array<TeamInvite>;
  testCredential?: Maybe<Scalars['String']>;
  totalStampCardsEarned: Scalars['Int'];
  /**
   * This balance is for ticket bough as currency - to get tickets balance that are automatically renewed,
   * use User.currentTournamentTicketCapSupply
   * @deprecated use User.energySystems.tournamentTicket.extraBalance
   */
  tournamentTicketBalance: Scalars['Int'];
  /**
   * Has the user already used his free tournament ticket refill
   * @deprecated use User.energySystems.tournamentTicket.isCapFreeRefillUsed
   */
  tournamentTicketCapFreeRefillUsed: Scalars['Boolean'];
  /**
   * Return all turn quiz games the player can play (player turn) or
   * can archive in its turn (the opponent has already archived the game on his side)
   * default sortOrder value is DESC and is applyed on the lastPing date => newest first
   */
  turnGamesToPlay: UserToUsersPaginated;
  /**
   * Return all turn quiz games the player need to wait (opponent turn)
   * default sortOrder value is DESC and is applyed on the lastPing date => newest first
   */
  turnGamesToWait: UserToUsersPaginated;
  unlimitedBoosts: UnlimitedBoosts;
  /** Number of messages unread for all UserConnection's conversation (UserToUser and AgentToUser) */
  unreadMessagesCount: Scalars['Int'];
  userLevel: Scalars['Int'];
  /**
   * levels list the user has already claimed, for each subscriptionTier
   * Claimed rewards are regrouped - one entry per level with the highest tier as bestTierClaimed and all tier claimed in tiersClaimed
   */
  userLevelClaimedRewards: Array<LevelTieredRewardClaimed>;
  userLevelProgressToNextLevel: Scalars['Float'];
  userMarathonEvent?: Maybe<UserMarathonEvent>;
  userSettings: UserSettings;
  userWheelFortune?: Maybe<UserWheelFortune>;
  vipDays: Scalars['Int'];
  /**
   * Has the user already used his free xp refill
   * @deprecated use User.energySystems.xp.isCapFreeRefillUsed
   */
  xpCapFreeRefillUsed: Scalars['Boolean'];
  yearInReview?: Maybe<YearInReview>;
};


/**
 * Represents a user in a specific game.
 * Regroups shared and app specific information
 */
export type UserA41conversationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Represents a user in a specific game.
 * Regroups shared and app specific information
 */
export type UserBadgesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Represents a user in a specific game.
 * Regroups shared and app specific information
 */
export type UserBlockedArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Represents a user in a specific game.
 * Regroups shared and app specific information
 */
export type UserComingSoonContentPacksArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Represents a user in a specific game.
 * Regroups shared and app specific information
 */
export type UserConversationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Represents a user in a specific game.
 * Regroups shared and app specific information
 */
export type UserEmojiPacksArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Represents a user in a specific game.
 * Regroups shared and app specific information
 */
export type UserFriendsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Represents a user in a specific game.
 * Regroups shared and app specific information
 */
export type UserGetSpecialEventArgs = {
  input: GetSpecialEventInput;
};


/**
 * Represents a user in a specific game.
 * Regroups shared and app specific information
 */
export type UserGetUserMonthlyPassArgs = {
  input: GetUserMonthlyPassInput;
};


/**
 * Represents a user in a specific game.
 * Regroups shared and app specific information
 */
export type UserLikedContentItemArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Represents a user in a specific game.
 * Regroups shared and app specific information
 */
export type UserLiveEventLastGamesArgs = {
  eventId: Scalars['ID'];
};


/**
 * Represents a user in a specific game.
 * Regroups shared and app specific information
 */
export type UserLiveGamesToPlayArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortOrder>;
};


/**
 * Represents a user in a specific game.
 * Regroups shared and app specific information
 */
export type UserLoyaltyCampaignRewardLogsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


/**
 * Represents a user in a specific game.
 * Regroups shared and app specific information
 */
export type UserMostAdvancedContentPacksArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Represents a user in a specific game.
 * Regroups shared and app specific information
 */
export type UserNewAndUpdatedContentPacksArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Represents a user in a specific game.
 * Regroups shared and app specific information
 */
export type UserOnlineUsersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Represents a user in a specific game.
 * Regroups shared and app specific information
 */
export type UserOwnedContentPacksArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Represents a user in a specific game.
 * Regroups shared and app specific information
 */
export type UserPreviousOpponentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Represents a user in a specific game.
 * Regroups shared and app specific information
 */
export type UserReceivedFriendRequestsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Represents a user in a specific game.
 * Regroups shared and app specific information
 */
export type UserRecentContentPacksArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Represents a user in a specific game.
 * Regroups shared and app specific information
 */
export type UserRecommendedContentPacksArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Represents a user in a specific game.
 * Regroups shared and app specific information
 */
export type UserSavedArtistContentPacksArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Represents a user in a specific game.
 * Regroups shared and app specific information
 */
export type UserSavedContentPacksArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Represents a user in a specific game.
 * Regroups shared and app specific information
 */
export type UserSentFriendRequestsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Represents a user in a specific game.
 * Regroups shared and app specific information
 */
export type UserShowArgs = {
  showId: Scalars['ID'];
};


/**
 * Represents a user in a specific game.
 * Regroups shared and app specific information
 */
export type UserTurnGamesToPlayArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortOrder>;
};


/**
 * Represents a user in a specific game.
 * Regroups shared and app specific information
 */
export type UserTurnGamesToWaitArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortOrder>;
};


/**
 * Represents a user in a specific game.
 * Regroups shared and app specific information
 */
export type UserYearInReviewArgs = {
  year: Scalars['Int'];
};

export type UserAchievementMissions = {
  __typename: 'UserAchievementMissions';
  id: Scalars['ID'];
  /** Active missions lasting the whole player game lifetime */
  missions: Array<MissionProgress>;
};

export type UserAnswerInput = {
  answerIndex: Scalars['Int'];
  answerTime: Scalars['Int'];
  id: Scalars['ID'];
  isLiked?: InputMaybe<Scalars['Boolean']>;
  messageContent?: InputMaybe<Scalars['String']>;
  messageType?: InputMaybe<MessageType>;
};

export type UserBadgeAdminPayload = {
  __typename: 'UserBadgeAdminPayload';
  badge: Badge;
};

export type UserCollection = {
  __typename: 'UserCollection';
  asset?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  currentLevel: Scalars['Int'];
  id: Scalars['ID'];
  levels: Array<UserCollectionLevel>;
  name: Scalars['String'];
  type: CollectionType;
  userId: Scalars['ID'];
};

export type UserCollectionItem = {
  __typename: 'UserCollectionItem';
  item: UserCollectionItemType;
  itemLevel: Scalars['Int'];
};

export type UserCollectionItemType = AppSkin | Badge | ProfileFrame | Sticker | UserContentPack;

export type UserCollectionLevel = {
  __typename: 'UserCollectionLevel';
  items: Array<UserCollectionItem>;
  rewards: Array<LevelReward>;
};

export type UserConnection = AgentToUser | UserToUser;

export type UserConnectionsPaginated = {
  __typename: 'UserConnectionsPaginated';
  hasMore: Scalars['Boolean'];
  id: Scalars['ID'];
  list: Array<UserConnection>;
  totalCount: Scalars['Int'];
};

export type UserContentItem = {
  __typename: 'UserContentItem';
  contentItem: ContentItem;
  id: Scalars['ID'];
  likeStatus?: Maybe<UserContentItemLikeStatus>;
  user: User;
};

export enum UserContentItemLikeStatus {
  DISLIKE = 'DISLIKE',
  LIKE = 'LIKE',
  NEUTRAL = 'NEUTRAL'
}

export type UserContentItemsPaginated = {
  __typename: 'UserContentItemsPaginated';
  hasMore: Scalars['Boolean'];
  id: Scalars['ID'];
  list: Array<UserContentItem>;
  totalCount: Scalars['Int'];
};

export type UserContentPack = {
  __typename: 'UserContentPack';
  accuracy: Scalars['Float'];
  averageScore: Scalars['Int'];
  averageSpeed: Scalars['Float'];
  contentDiscoveredCount: Scalars['Int'];
  contentPack: ContentPack;
  currentLevelConfig: LevelConfigContentPack;
  /**
   * Current month accumulated XP for the current contentPack
   * Return 0 by default if the user have not played with the current contentPack.
   * It's the same value as "UserContentPack.ContentPack.monthlyLeaderboard.meScore",
   * but it's available even if the MonthlyPass feature is not unlocked yet
   */
  currentMonthXP: Scalars['Int'];
  highestScore: Scalars['Int'];
  id: Scalars['ID'];
  level: Scalars['Int'];
  likedContent: Array<UserContentItem>;
  nextLevelConfig?: Maybe<LevelConfigContentPack>;
  progressToNextLevel: Scalars['Float'];
  roundPlayedCount: Scalars['Int'];
  /** Show the current me user if the content pack is saved. The me user can be different than the user linked to this UserContentPack. */
  saved: Scalars['Boolean'];
  /** Counts the total content items currently available to the user (based on the contentpack level) */
  totalContentItemsCount: Scalars['Int'];
  totalXP: Scalars['Int'];
  user: User;
};


export type UserContentPackLikedContentArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type UserContentPackPaginated = {
  __typename: 'UserContentPackPaginated';
  hasMore: Scalars['Boolean'];
  id: Scalars['ID'];
  list: Array<UserContentPack>;
  totalCount: Scalars['Int'];
};

export type UserContentPackPayload = {
  __typename: 'UserContentPackPayload';
  userContentPack: UserContentPack;
};

export type UserContentPacksPaginated = {
  __typename: 'UserContentPacksPaginated';
  hasMore: Scalars['Boolean'];
  id: Scalars['ID'];
  list: Array<UserContentPack>;
  totalCount: Scalars['Int'];
};

export type UserEmojiPack = {
  __typename: 'UserEmojiPack';
  availability: Array<EmojiAvailabilityInfo>;
  emojiPack: EmojiPack;
  isActive: Scalars['Boolean'];
};

export type UserEmojiPackCommonPayload = {
  __typename: 'UserEmojiPackCommonPayload';
  user: User;
};

export type UserEmojiPackPaginated = {
  __typename: 'UserEmojiPackPaginated';
  hasMore: Scalars['Boolean'];
  id: Scalars['ID'];
  list: Array<UserEmojiPack>;
  totalCount: Scalars['Int'];
};

export type UserExport = {
  __typename: 'UserExport';
  exportedAt?: Maybe<Scalars['Date']>;
  fileExpiresAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  jobStartedAt?: Maybe<Scalars['Date']>;
  jobStatus?: Maybe<UserExportJobStatus>;
  processed?: Maybe<Scalars['Date']>;
  requested: Scalars['Date'];
  status?: Maybe<UserExportStatus>;
  updated?: Maybe<Scalars['Date']>;
  user: User;
};

export enum UserExportJobStatus {
  DONE = 'DONE',
  EXPORTING = 'EXPORTING',
  FAILED = 'FAILED'
}

export enum UserExportStatus {
  DONE = 'DONE',
  PENDING = 'PENDING'
}

export type UserExportsInput = {
  userId: Scalars['String'];
};

export type UserExportsPayload = {
  __typename: 'UserExportsPayload';
  userExports: Array<UserExport>;
};

export enum UserGender {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
  OTHER = 'OTHER'
}

export type UserGetUserMonthlyPassPayload = {
  __typename: 'UserGetUserMonthlyPassPayload';
  userMonthlyPass: UserMonthlyPass;
};

export type UserHurdleAnswer = {
  __typename: 'UserHurdleAnswer';
  isGuessed?: Maybe<Scalars['Boolean']>;
  itemAnswered?: Maybe<HurdleItem>;
  listenCount: Scalars['Int'];
  skipped: Scalars['Boolean'];
};

export type UserHurdleLostGame = {
  __typename: 'UserHurdleLostGame';
  hurdleQuizId: Scalars['ID'];
  lostDate: Scalars['Date'];
  previousStreak?: Maybe<Scalars['Int']>;
  songArtist: Scalars['String'];
  songTitle: Scalars['String'];
};

export type UserHurdleQuiz = {
  __typename: 'UserHurdleQuiz';
  answers: Array<UserHurdleAnswer>;
  claimedDate?: Maybe<Scalars['Date']>;
  claimedMultiplier?: Maybe<Scalars['Float']>;
  claimedRewards?: Maybe<Array<LevelReward>>;
  currentStreak: Scalars['Int'];
  friendResults?: Maybe<PaginatedFriendHurdleQuiz>;
  guessedIn?: Maybe<Scalars['Int']>;
  hurdleHintUsed: Scalars['Boolean'];
  id: Scalars['ID'];
  isCompleted: Scalars['Boolean'];
  isCorrectlyGuessed: Scalars['Boolean'];
  mode: HurdleMode;
  potentialMultiplier: Scalars['Float'];
  previousStreak?: Maybe<Scalars['Int']>;
};


export type UserHurdleQuizFriendResultsArgs = {
  pagination: PaginationParams;
};

export type UserHurdleQuizzesHistoryModeStats = {
  __typename: 'UserHurdleQuizzesHistoryModeStats';
  accuracy?: Maybe<Scalars['Float']>;
  lostGames?: Maybe<Scalars['Int']>;
  totalGames?: Maybe<Scalars['Int']>;
  totalGamesWon?: Maybe<Scalars['Int']>;
  wonAtStepGames?: Maybe<Array<Scalars['Int']>>;
};

export type UserHurdleQuizzesHistoryStats = {
  __typename: 'UserHurdleQuizzesHistoryStats';
  hard?: Maybe<UserHurdleQuizzesHistoryModeStats>;
  normal?: Maybe<UserHurdleQuizzesHistoryModeStats>;
};

export type UserHurdleQuizzesStats = {
  __typename: 'UserHurdleQuizzesStats';
  currentStreak?: Maybe<Scalars['Int']>;
  highestStreak?: Maybe<Scalars['Int']>;
  history?: Maybe<UserHurdleQuizzesHistoryStats>;
  lastUpdate?: Maybe<Scalars['Date']>;
};

export type UserItemInput = {
  id: Scalars['ID'];
  level?: InputMaybe<Scalars['Int']>;
};

export type UserLiveEvent = {
  __typename: 'UserLiveEvent';
  currency: Scalars['Int'];
  currentStates: UserToUserLiveEvent;
  energy: EnergySystem;
  event: LiveEvent;
  id: Scalars['ID'];
  stats: UserLiveEventStats;
  userContentPackForRound: UserContentPack;
  userContentPacks: UserContentPacksPaginated;
  userShop: Array<UserLiveEventShopItem>;
};


export type UserLiveEventCurrentStatesArgs = {
  userToUserId: Scalars['ID'];
};


export type UserLiveEventUserContentPackForRoundArgs = {
  userToUserId: Scalars['ID'];
};


export type UserLiveEventUserContentPacksArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type UserLiveEventGame = {
  __typename: 'UserLiveEventGame';
  isWon: Scalars['Boolean'];
  opponent: User;
  opponentScore: Scalars['Int'];
  playedDate: Scalars['Date'];
  score: Scalars['Int'];
};

export type UserLiveEventShopItem = {
  __typename: 'UserLiveEventShopItem';
  boughtCount: Scalars['Int'];
  id: Scalars['ID'];
  isClaimed: Scalars['Boolean'];
  item: LiveEventShopItem;
};

export type UserLiveEventStats = {
  __typename: 'UserLiveEventStats';
  gamePlayed: Scalars['Int'];
  gameWon: Scalars['Int'];
  totalClaimed: Scalars['Int'];
};

export type UserLiveQuizStats = {
  __typename: 'UserLiveQuizStats';
  accuracy?: Maybe<Scalars['Float']>;
  averageScore?: Maybe<Scalars['Int']>;
  averageSpeed?: Maybe<Scalars['Float']>;
  bestScore?: Maybe<Scalars['Int']>;
  lastUpdate?: Maybe<Scalars['Date']>;
};

export type UserLiveShowStats = {
  __typename: 'UserLiveShowStats';
  accuracy?: Maybe<Scalars['Float']>;
  averageSpeed?: Maybe<Scalars['Float']>;
  lastUpdate?: Maybe<Scalars['Date']>;
  nbWon?: Maybe<Scalars['Int']>;
};

export type UserLoyaltyCampaignProgress = {
  __typename: 'UserLoyaltyCampaignProgress';
  claimedLoyaltyCardCounts: Array<LoyaltyCampaignCardClaimCount>;
  claimedLoyaltyCards: Array<Scalars['ID']>;
  hasSubscriptionBackfillReward: Scalars['Boolean'];
  loyaltyPoints: Scalars['Int'];
};

export type UserLoyaltyCampaignRewardLog = {
  __typename: 'UserLoyaltyCampaignRewardLog';
  amount: Scalars['Int'];
  created: Scalars['Date'];
  productId: Scalars['String'];
  referenceId: Scalars['String'];
  sourceType: Scalars['String'];
};

export type UserMarathonEvent = {
  __typename: 'UserMarathonEvent';
  checkPoint: Scalars['Int'];
  currentRound?: Maybe<UserMarathonRound>;
  eventId: Scalars['ID'];
  freeStartsUsed: Scalars['Int'];
  id: Scalars['ID'];
  maxSongReached: Scalars['Int'];
  milestoneClaimed: Array<UserMarathonMilestone>;
};

export type UserMarathonMilestone = {
  __typename: 'UserMarathonMilestone';
  index: Scalars['Int'];
  isBasicClaimed: Scalars['Boolean'];
  isPlusClaimed: Scalars['Boolean'];
};

export type UserMarathonRound = {
  __typename: 'UserMarathonRound';
  answers: Array<UserQuizAnswer>;
  freeRevivesUsed: Scalars['Int'];
  /** @deprecated Use freeRevivesUsed */
  freeReviveUsed: Scalars['Boolean'];
  id: Scalars['ID'];
  questions: Array<QuizQuestion>;
  state: Scalars['Int'];
};

export type UserMonthlyPass = {
  __typename: 'UserMonthlyPass';
  allMissions?: Maybe<UserMonthlyPassAllMissions>;
  /** Claimed rewards are regrouped - one entry per level with the highest tier as bestTierClaimed and all tier claimed in tiersClaimed */
  claimedRewards: Array<LevelTieredRewardClaimed>;
  claimedTeamHeatMilestone: Array<Scalars['Int']>;
  coinBuff: Scalars['Int'];
  coinEarned?: Maybe<Scalars['Int']>;
  currentLevelConfig: LevelConfigMonthlyPass;
  id: Scalars['ID'];
  /** represent rank groups for specific monthlyPassLeaderboard */
  leaderboardRankGroups: Array<LbRankGroup>;
  level: Scalars['Int'];
  missions?: Maybe<UserMonthlyPassMissions>;
  monthlyPass: MonthlyPass;
  mostChattedWith: Array<UserMonthlyPassOpponent>;
  mostPlayedWith: Array<UserMonthlyPassOpponent>;
  /** progress as percentage */
  progressToNextLevel: Scalars['Float'];
  /** @deprecated use Leaderboard.meRank instead */
  rank?: Maybe<Scalars['Int']>;
  /** @deprecated use Leaderboard.meScore instead */
  score?: Maybe<Scalars['Int']>;
  stickerMessageSentCount?: Maybe<Scalars['Int']>;
  textMessageSentCount?: Maybe<Scalars['Int']>;
  topAppSkin?: Maybe<AppSkin>;
  topContentItem?: Maybe<UserContentItem>;
  topContentItemGuessCount?: Maybe<Scalars['Int']>;
  topContentPacks: Array<UserMonthlyPassContentPack>;
  topProfileFrame?: Maybe<ProfileFrame>;
  topSticker?: Maybe<Sticker>;
  topStickerSentCount?: Maybe<Scalars['Int']>;
  totalXP: Scalars['Int'];
  userToUserLiveGamePlayed?: Maybe<Scalars['Int']>;
  userToUserTurnGamePlayed?: Maybe<Scalars['Int']>;
  xpBuff: Scalars['Int'];
};


export type UserMonthlyPassTopContentPacksArgs = {
  types: Array<ContentPackType>;
};

export type UserMonthlyPassAllMissions = {
  __typename: 'UserMonthlyPassAllMissions';
  activeExtraMissionIdx?: Maybe<Scalars['Int']>;
  dailyMissions: Array<MissionProgress>;
  extraMissions: Array<MissionProgress>;
  id: Scalars['ID'];
  monthlyMissions: Array<MissionProgress>;
  teamMissions: Array<MissionProgress>;
};

export type UserMonthlyPassContentPack = {
  __typename: 'UserMonthlyPassContentPack';
  id: Scalars['ID'];
  /** @deprecated use Leaderboard.meRank instead */
  rank: Scalars['Int'];
  roundPlayedCount: Scalars['Int'];
  /** @deprecated use Leaderboard.meScore instead */
  score: Scalars['Int'];
  totalXP: Scalars['Int'];
  userContentPack: UserContentPack;
};

export type UserMonthlyPassInput = {
  level: Scalars['Int'];
  progressToNextLevel: Scalars['Float'];
};

export type UserMonthlyPassMissions = {
  __typename: 'UserMonthlyPassMissions';
  /**
   * Index of the current extra mission
   * Can be null if there are no extra missions or if all have been completed
   */
  activeExtraMissionIdx?: Maybe<Scalars['Int']>;
  dailyMissions: Array<MissionProgress>;
  /**
   * Active extra mission (get unlocked one after the other)
   * Can be null if there are no extra missions or if all have been completed
   * @deprecated use extraMissions[activeExtraMissionIdx] instead
   */
  extraMission?: Maybe<MissionProgress>;
  /**
   * Which extra mission is active (extra mission #1, #2, etc.)
   * Can be null if there are no extra missions or if all have been completed
   * @deprecated use activeExtraMissionIdx + 1 instead
   */
  extraMissionNo?: Maybe<Scalars['Int']>;
  /**
   * Sequence of extra missions (get unlocked one after the other)
   * Only the one at index activeExtraMissionIdx is active
   */
  extraMissions: Array<MissionProgress>;
  id: Scalars['ID'];
  monthlyMissions: Array<MissionProgress>;
  teamMissions: Array<MissionProgress>;
};

export type UserMonthlyPassOpponent = {
  __typename: 'UserMonthlyPassOpponent';
  id: Scalars['ID'];
  opponent: User;
  opponentScore?: Maybe<Scalars['Int']>;
  userScore?: Maybe<Scalars['Int']>;
};

export type UserMonthlyPassPaginated = {
  __typename: 'UserMonthlyPassPaginated';
  hasMore: Scalars['Boolean'];
  id: Scalars['ID'];
  list: Array<Maybe<UserMonthlyPass>>;
  totalCount: Scalars['Int'];
};

export enum UserOnlineStatus {
  BUSY = 'BUSY',
  OFFLINE = 'OFFLINE',
  ONLINE = 'ONLINE'
}

export type UserPaidCalendar = {
  __typename: 'UserPaidCalendar';
  calendarItems: Array<LevelReward>;
  claimedRewardIndex?: Maybe<Scalars['Int']>;
  endDate: Scalars['Date'];
  id: Scalars['String'];
  name: Scalars['String'];
  purchaseDate?: Maybe<Scalars['Date']>;
  purchaseReward?: Maybe<LevelReward>;
  skuId: Scalars['String'];
  startDate: Scalars['Date'];
};

export type UserPayload = {
  __typename: 'UserPayload';
  user: User;
};

export type UserPlaylistInput = {
  id: Scalars['ID'];
  level: Scalars['Int'];
  progressToNextLevel: Scalars['Float'];
};

export type UserQuizAnswer = {
  __typename: 'UserQuizAnswer';
  answerIndex: Scalars['Int'];
  answerTime: Scalars['Int'];
  hasBeenBombed: Scalars['Boolean'];
  id: Scalars['ID'];
  isBombBoostActivated: Scalars['Boolean'];
  isLiked?: Maybe<Scalars['Boolean']>;
  messageContent?: Maybe<Scalars['String']>;
  messageType?: Maybe<MessageType>;
};

export type UserQuizContentItemLike = {
  __typename: 'UserQuizContentItemLike';
  contentItemId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  isLiked?: Maybe<Scalars['Boolean']>;
};

export type UserQuizMessage = {
  __typename: 'UserQuizMessage';
  content?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  type?: Maybe<MessageType>;
};

export enum UserRelatedRedisModel {
  SUBSCRIPTION_UTIL = 'SUBSCRIPTION_UTIL',
  SYSTEM_EVENT = 'SYSTEM_EVENT',
  UNREAD_COUNT = 'UNREAD_COUNT'
}

export type UserReport = {
  __typename: 'UserReport';
  comment?: Maybe<Scalars['String']>;
  created: Scalars['Date'];
  reported: User;
  reporter: User;
};

export enum UserRole {
  ADMIN = 'ADMIN',
  BANNED = 'BANNED',
  CONTENT_MODERATOR = 'CONTENT_MODERATOR',
  CURATOR = 'CURATOR',
  USER = 'USER'
}

export enum UserSafetyLevel {
  ALL_ACCESS = 'ALL_ACCESS',
  NO_EXPLICIT_CONTENT = 'NO_EXPLICIT_CONTENT',
  NO_EXPLICIT_CONTENT_NO_USER_GENERATED = 'NO_EXPLICIT_CONTENT_NO_USER_GENERATED'
}

export enum UserSearchType {
  BY_ANONYMOUS = 'BY_ANONYMOUS',
  BY_CODE = 'BY_CODE',
  BY_EMAIL = 'BY_EMAIL',
  BY_ID = 'BY_ID',
  BY_NAME = 'BY_NAME',
  BY_PHONE = 'BY_PHONE',
  BY_SESSION = 'BY_SESSION'
}

export type UserSettings = {
  __typename: 'UserSettings';
  chainedOfferEventNotificationsEnabled: Scalars['Boolean'];
  chatNotificationsEnabled: Scalars['Boolean'];
  dailyBonusEnabled: Scalars['Boolean'];
  friendNotificationsEnabled: Scalars['Boolean'];
  hurdleNotificationsEnabled: Scalars['Boolean'];
  liveGameNotificationsEnabled: Scalars['Boolean'];
  liveShowNotificationsEnabled: Scalars['Boolean'];
  marathonEventNotificationsEnabled: Scalars['Boolean'];
  missionNotificationsEnabled: Scalars['Boolean'];
  onlineNotificationsEnabled: Scalars['Boolean'];
  quotaNotificationsEnabled: Scalars['Boolean'];
  reminderNotificationsEnabled: Scalars['Boolean'];
  returnGiftNotificationsEnabled: Scalars['Boolean'];
  saleEventNotificationsEnabled: Scalars['Boolean'];
  specialEventNotificationsEnabled: Scalars['Boolean'];
  tournamentNotificationsEnabled: Scalars['Boolean'];
  turnGameNotificationsEnabled: Scalars['Boolean'];
};

export type UserSpecialEventAllMissions = {
  __typename: 'UserSpecialEventAllMissions';
  activeSequentialMissionIdx?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  sequentialMissions: Array<MissionProgress>;
};

export type UserSpecialEventMissions = {
  __typename: 'UserSpecialEventMissions';
  /**
   * Index of the current sequentialMissions mission
   * Can be null if there are no missions or if all have been completed
   */
  activeSequentialMissionIdx?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  /**
   * Sequence of missions (get unlocked one after the other)
   * Only the one at index activeSequentialMissionIdx is active
   */
  sequentialMissions: Array<MissionProgress>;
};

export type UserStats = {
  __typename: 'UserStats';
  hurdleQuiz: UserHurdleQuizzesStats;
  /**
   * If the stats have never been processed yet, isNeverProcessedYet = true
   * This could happen if this endpoint has been accessed but the statistics has never been processed yet.
   * Case example: user never played any game yet since the stats have been implemented.
   */
  isNeverProcessedYet: Scalars['Boolean'];
  liveQuiz: UserLiveQuizStats;
  liveShow: UserLiveShowStats;
  tournament: UserTournamentStats;
  turnQuiz: UserTurnQuizStats;
};

export enum UserSubscriptionTier {
  AD_FREE = 'AD_FREE',
  BASIC = 'BASIC',
  PLUS = 'PLUS',
  PREMIUM = 'PREMIUM',
  VIP = 'VIP'
}

export type UserSubscriptionUpdateLog = {
  __typename: 'UserSubscriptionUpdateLog';
  autoRenew?: Maybe<Scalars['Boolean']>;
  cancelled?: Maybe<Scalars['Date']>;
  cancelledReason?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['Date']>;
  environment: Scalars['String'];
  expires?: Maybe<Scalars['Date']>;
  iosWebOrderLineItemId?: Maybe<Scalars['String']>;
  logId: Scalars['String'];
  originalTransactionId: Scalars['String'];
  purchased?: Maybe<Scalars['Date']>;
  retrying?: Maybe<Scalars['Boolean']>;
  sku: Scalars['String'];
  store: Scalars['String'];
  type: Scalars['String'];
  userId: Scalars['String'];
  valid?: Maybe<Scalars['Boolean']>;
};

export type UserTeamShopItem = {
  __typename: 'UserTeamShopItem';
  buyLimit?: Maybe<Scalars['Int']>;
  buyLimitType?: Maybe<TeamShopBuyLimitEnum>;
  cost: Scalars['Int'];
  currentBuyCount?: Maybe<Scalars['Int']>;
  discount?: Maybe<Scalars['Int']>;
  endDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  reward: LevelReward;
  startDate: Scalars['Date'];
};

/**
 * Represents a connection between 2 users.
 * Regroups shared and app specific information.
 * Conversation is shared across apps.
 * liveGame and turnGame are specific to an app.
 */
export type UserToUser = {
  __typename: 'UserToUser';
  /** @deprecated use conversation instead */
  a41conversation?: Maybe<Conversation>;
  /** Amount in percentage of compatibility with the opponent */
  compatibility: Scalars['Int'];
  conversation?: Maybe<Conversation>;
  created: Scalars['Date'];
  id: Scalars['ID'];
  /**
   * Is the opponent currently connected on the same server
   * If the opponent is a bot, this value is true in any case.
   * If the opponent is a player, this value check if he has at least one websocket open
   */
  isOpponentOnSameServer: Scalars['Boolean'];
  /**
   * IMPORTANT: Be careful to use this endpoint only if you know what you are doing.
   * This could add significant latency - Preferably use me query instead of userToUser.me.
   */
  me: User;
  metViaNetwork: UserToUserMetViaNetwork;
  opponent: User;
  opponentMonthlyScore?: Maybe<Scalars['Int']>;
  pingEventTypeConfigs: PingEventTypeConfigs;
  quizLiveGame?: Maybe<UserToUserQuizLiveGame>;
  quizTurnGame?: Maybe<UserToUserQuizTurnGame>;
  recommendedContentPacks: UserContentPacksPaginated;
  safetyLevel: UserToUserSafetyLevel;
  status: UserToUserStatus;
  userMonthlyScore?: Maybe<Scalars['Int']>;
};

export type UserToUserLiveEvent = {
  __typename: 'UserToUserLiveEvent';
  opponentState: UserToUserLiveEventState;
  userState: UserToUserLiveEventState;
};

/**
 * MATCHMAKING => default state - players finding and opponent
 * OPPONENT_FOUND => when both player I found each other in liveEvent (automatically set when event opponent found sent)
 * STARTING_ROUND => players starting the round after playlist and boosts picked (automatically set by the player by calling startLiveEventRound)
 * CANCEL => when player has cancel matchmaking before actual game is started (need to be called by player by calling cancelLiveEventRound)
 * PLAYING => players can now play (automatically set by the backend when both players have QUIZ_LOADED)
 * FINISHED => player has finished to play the live event (automatically set by the player by calling updateUserToUserQuizLiveRoundState)
 * DISCONNECTED => player is offline (automatically set by the backend on websocket disconnection)
 */
export enum UserToUserLiveEventState {
  CANCEL = 'CANCEL',
  DISCONNECTED = 'DISCONNECTED',
  FINISHED = 'FINISHED',
  MATCHMAKING = 'MATCHMAKING',
  OPPONENT_FOUND = 'OPPONENT_FOUND',
  PLAYING = 'PLAYING',
  STARTING_ROUND = 'STARTING_ROUND'
}

export enum UserToUserMetViaNetwork {
  EMAIL = 'EMAIL',
  FACEBOOK = 'FACEBOOK',
  GAMECENTER = 'GAMECENTER',
  INFLUENCER = 'INFLUENCER',
  PHONE = 'PHONE',
  SONGPOP = 'SONGPOP',
  UNKNOWN = 'UNKNOWN',
  WHATSAPP = 'WHATSAPP'
}

export type UserToUserQuizLiveGame = {
  __typename: 'UserToUserQuizLiveGame';
  created: Scalars['Date'];
  currentRound?: Maybe<UserToUserQuizLiveRound>;
  /** Expires 2mins after creation */
  expires: Scalars['Date'];
  id: Scalars['ID'];
  invitationSource: UserToUserQuizLiveGameInvitationSource;
  state: UserToUserQuizLiveGameState;
  user: User;
};

export enum UserToUserQuizLiveGameInvitationSource {
  CHAT = 'CHAT',
  LIVE_EVENT = 'LIVE_EVENT',
  TEAM = 'TEAM'
}

export type UserToUserQuizLiveGamePayload = {
  __typename: 'UserToUserQuizLiveGamePayload';
  userToUser: UserToUser;
};

export enum UserToUserQuizLiveGameState {
  ACTIVE = 'ACTIVE',
  DECLINED = 'DECLINED',
  ENDED = 'ENDED',
  /** A live game is set to EXPIRED after 2mins if the request has not been accepted */
  EXPIRED = 'EXPIRED',
  REQUEST_RECEIVED = 'REQUEST_RECEIVED',
  REQUEST_SENT = 'REQUEST_SENT'
}

export type UserToUserQuizLiveRound = {
  __typename: 'UserToUserQuizLiveRound';
  id: Scalars['ID'];
  isArtistOnlyBoostActivated: Scalars['Boolean'];
  isOpponentNinjaBoostActivated: Scalars['Boolean'];
  isSpeedsterBoostActivated: Scalars['Boolean'];
  isUserNinjaBoostActivated: Scalars['Boolean'];
  opponentAnswers?: Maybe<Array<UserQuizAnswer>>;
  opponentContentPack?: Maybe<UserContentPack>;
  opponentLikedContent: Array<UserContentItem>;
  /** For live games, liking content items can be done before or after the answer, so we don't embed it the opponentAnswers */
  opponentLikedContentItems?: Maybe<Array<UserQuizContentItemLike>>;
  /** For live games, the messages (sticker or safeText) can be sent before or after the answer, so we don't embed it the opponentAnswers */
  opponentMessages?: Maybe<Array<UserQuizMessage>>;
  opponentState: UserToUserQuizLiveRoundState;
  questions?: Maybe<Array<QuizQuestion>>;
  /** Live game type to separate regular live quiz and live matchmaking */
  type?: Maybe<UserToUserQuizLiveRoundType>;
  userAnswers?: Maybe<Array<UserQuizAnswer>>;
  userContentPack?: Maybe<UserContentPack>;
  userLikedContent: Array<UserContentItem>;
  /** For live games, liking content items can be done before or after the answer, so we don't embed it the userAnswers */
  userLikedContentItems?: Maybe<Array<UserQuizContentItemLike>>;
  /** For live games, the messages (sticker or safeText) can be sent before or after the answer, so we don't embed it the userAnswers */
  userMessages?: Maybe<Array<UserQuizMessage>>;
  /** returns the list of never "correctly" guessed (or never guessed at all) content items */
  userNewContent: Array<UserContentItem>;
  userState: UserToUserQuizLiveRoundState;
};

export type UserToUserQuizLiveRoundPayload = {
  __typename: 'UserToUserQuizLiveRoundPayload';
  user: User;
  userToUserQuizLiveRound: UserToUserQuizLiveRound;
};

/**
 * HANGING_OUT_IN_CHAT => default state - players need to start a live game request (liveSesion)
 * READY_TO_START => both players are ok to start a live game request (liveSesion) (Need to be set by the player by calling updateUserToUserQuizLiveRoundState)
 * PICKING_PLAYLIST => player needs to choose a playlist (automatically set by the backend when both players are READY_TO_START)
 * PLAYLIST_PICKED => player has chosen a playlist by calling pickUserToUserQuizLiveRoundContentPack
 * LOADING_QUIZ => player needs to load the quiz assets (automatically set by the backend when both players have PLAYLIST_PICKED)
 * QUIZ_LOADED => player has loaded the quiz (Need to be set by the player by calling updateUserToUserQuizLiveRoundState)
 * PLAYING => players can now play (automatically set by the backend when both players have QUIZ_LOADED)
 * CHECKING_RESULT => players can now see the result screen (automatically set by the backend when both players have answered all questions)
 * FINISHED => player has finished to play this round (Need to be set by the player by calling updateUserToUserQuizLiveRoundState)
 * DISCONNECTED => player is offline (automatically set by the backend on websocket disconnection)
 */
export enum UserToUserQuizLiveRoundState {
  CHECKING_RESULT = 'CHECKING_RESULT',
  DISCONNECTED = 'DISCONNECTED',
  FINISHED = 'FINISHED',
  HANGING_OUT_IN_CHAT = 'HANGING_OUT_IN_CHAT',
  LOADING_QUIZ = 'LOADING_QUIZ',
  PICKING_PLAYLIST = 'PICKING_PLAYLIST',
  PLAYING = 'PLAYING',
  PLAYLIST_PICKED = 'PLAYLIST_PICKED',
  QUIZ_LOADED = 'QUIZ_LOADED',
  READY_TO_START = 'READY_TO_START'
}

export enum UserToUserQuizLiveRoundType {
  LIVE_EVENT = 'LIVE_EVENT',
  REGULAR = 'REGULAR'
}

export type UserToUserQuizTurnGame = {
  __typename: 'UserToUserQuizTurnGame';
  currentRound: UserToUserQuizTurnRound;
  id: Scalars['ID'];
  isArchived?: Maybe<Scalars['Boolean']>;
  previousUnclaimedRound?: Maybe<UserToUserQuizTurnRound>;
  state: UserToUserQuizTurnGameState;
};

export enum UserToUserQuizTurnGameState {
  CLAIM = 'CLAIM',
  EXPIRED = 'EXPIRED',
  NEW = 'NEW',
  PLAY = 'PLAY',
  WAIT = 'WAIT'
}

export type UserToUserQuizTurnRound = {
  __typename: 'UserToUserQuizTurnRound';
  /** @deprecated use opponentAttachedMessage instead */
  a41opponentAttachedMessage?: Maybe<Message>;
  /** @deprecated use userAttachedMessage instead */
  a41userAttachedMessage?: Maybe<Message>;
  id: Scalars['ID'];
  isArtistOnlyBoostActivated: Scalars['Boolean'];
  isSpeedsterBoostActivated: Scalars['Boolean'];
  opponentAnswers: Array<UserQuizAnswer>;
  opponentAttachedMessage?: Maybe<Message>;
  opponentCoins?: Maybe<Scalars['Int']>;
  opponentLikedContent: Array<UserContentItem>;
  opponentScore?: Maybe<Scalars['Int']>;
  questions: Array<QuizQuestion>;
  sent?: Maybe<Scalars['Date']>;
  state: UserToUserQuizTurnRoundState;
  userAnswers: Array<UserQuizAnswer>;
  userAttachedMessage?: Maybe<Message>;
  userCoins?: Maybe<Scalars['Int']>;
  userContentPack: UserContentPack;
  userLikedContent: Array<UserContentItem>;
  /** returns the list of never "correctly" guessed (or never guessed at all) content items */
  userNewContent: Array<UserContentItem>;
  userScore?: Maybe<Scalars['Int']>;
};

export enum UserToUserQuizTurnRoundState {
  CLAIM = 'CLAIM',
  DONE = 'DONE',
  PLAYING = 'PLAYING',
  READY_TO_PLAY = 'READY_TO_PLAY',
  SENT = 'SENT'
}

export enum UserToUserSafetyLevel {
  ALL_ACCESS = 'ALL_ACCESS',
  NO_EXPLICIT_CONTENT = 'NO_EXPLICIT_CONTENT',
  NO_EXPLICIT_CONTENT_NO_USER_GENERATED = 'NO_EXPLICIT_CONTENT_NO_USER_GENERATED'
}

export enum UserToUserStatus {
  BLOCKED = 'BLOCKED',
  FRIEND = 'FRIEND',
  NEUTRAL = 'NEUTRAL',
  RECEIVED_FRIEND_REQUEST = 'RECEIVED_FRIEND_REQUEST',
  SENT_FRIEND_REQUEST = 'SENT_FRIEND_REQUEST'
}

export type UserToUsersPaginated = {
  __typename: 'UserToUsersPaginated';
  hasMore: Scalars['Boolean'];
  id: Scalars['ID'];
  list: Array<UserToUser>;
  totalCount: Scalars['Int'];
};

export type UserTournamentStats = {
  __typename: 'UserTournamentStats';
  averageRank?: Maybe<Scalars['Int']>;
  averageRoundPlayed?: Maybe<Scalars['Int']>;
  averageTotalScore?: Maybe<Scalars['Int']>;
  bestRank?: Maybe<Scalars['Int']>;
  bestTotalScore?: Maybe<Scalars['Int']>;
  lastUpdate?: Maybe<Scalars['Date']>;
  maxNbRoundPlayed?: Maybe<Scalars['Int']>;
  nbWon?: Maybe<Scalars['Int']>;
  totalRoundPlayed?: Maybe<Scalars['Int']>;
};

export type UserTurnQuizStats = {
  __typename: 'UserTurnQuizStats';
  accuracy?: Maybe<Scalars['Float']>;
  averageScore?: Maybe<Scalars['Int']>;
  averageSpeed?: Maybe<Scalars['Float']>;
  bestScore?: Maybe<Scalars['Int']>;
  lastUpdate?: Maybe<Scalars['Date']>;
};

export type UserWheelFortune = {
  __typename: 'UserWheelFortune';
  hasSpinsAfterRefresh: Scalars['Boolean'];
  id: Scalars['ID'];
  nextTimeSpin: Scalars['Date'];
  nextWinIndex: Scalars['Int'];
};

export type ValidateHurdleQuizConfigInput = {
  catalogItemId: Scalars['ID'];
  categoryId: Scalars['String'];
  hurdleQuizId: Scalars['ID'];
};

export type ValidateHurdleQuizConfigPayload = {
  __typename: 'ValidateHurdleQuizConfigPayload';
  isValid: Scalars['Boolean'];
  messages: Array<Scalars['String']>;
};

export type WfRewardInput = {
  reward: LevelRewardInput;
  weight: Scalars['Float'];
};

export type WheelFortuneEvent = {
  __typename: 'WheelFortuneEvent';
  id: Scalars['ID'];
  name: Scalars['String'];
  rewards: Array<WheelFortuneReward>;
  seed: Scalars['String'];
  spinPrice: LevelReward;
  spinPricePlus: LevelReward;
  startDate: Scalars['Date'];
  stopDate: Scalars['Date'];
};

export type WheelFortuneEventConfig = {
  __typename: 'WheelFortuneEventConfig';
  filterAppVersion?: Maybe<Scalars['String']>;
  filterSubscriptionTier?: Maybe<UserSubscriptionTier>;
  filterUserIds?: Maybe<Array<Scalars['String']>>;
  filterUserLevel?: Maybe<Scalars['Int']>;
  filterUserMaxCreationDate?: Maybe<Scalars['Date']>;
  filterUserMinCreationDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  rewards: Array<WheelFortuneRewardConfig>;
  spinPrice: GenericLevelReward;
  spinPricePlus: GenericLevelReward;
  startDate: Scalars['Date'];
  status: ChainedOfferEventStatus;
  stopDate: Scalars['Date'];
};

export type WheelFortuneReward = {
  __typename: 'WheelFortuneReward';
  reward: LevelReward;
  weight: Scalars['Float'];
};

export type WheelFortuneRewardConfig = {
  __typename: 'WheelFortuneRewardConfig';
  reward: GenericLevelReward;
  weight: Scalars['Float'];
};

export type WheelFortuneRewardTemplate = {
  __typename: 'WheelFortuneRewardTemplate';
  id: Scalars['ID'];
  name: Scalars['String'];
  rewards: Array<WheelFortuneRewardConfig>;
};

export type YearInReview = {
  __typename: 'YearInReview';
  achievementsEarnedCount?: Maybe<Scalars['Int']>;
  achievementsEarnedTopPercent?: Maybe<Scalars['Float']>;
  artistPlaylist?: Maybe<ContentPack>;
  artistPlaylistCount?: Maybe<Scalars['Int']>;
  available: Scalars['Date'];
  collectedBadgesCount?: Maybe<Scalars['Int']>;
  collectedCraftBadgeCount?: Maybe<Scalars['Int']>;
  collectedItemsCount?: Maybe<Scalars['Int']>;
  decade?: Maybe<ContentCategory>;
  decadeCount?: Maybe<Scalars['Int']>;
  friend?: Maybe<User>;
  friendGamePlayed?: Maybe<Scalars['Int']>;
  friendGameWinratePercent?: Maybe<Scalars['Float']>;
  friendshipCreated?: Maybe<Scalars['Date']>;
  genre?: Maybe<ContentCategory>;
  genreCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  lastAchievementsEarned?: Maybe<Array<MissionProgress>>;
  lastAcquiredCollections?: Maybe<Array<Collection>>;
  lastCollectedBadge?: Maybe<Badge>;
  lastCollectedCraftBadge?: Maybe<Badge>;
  lastCollectedItems?: Maybe<Array<Item>>;
  lastUsedOrAcquiredEmojis?: Maybe<Array<Emoji>>;
  liveGamePlayed?: Maybe<Scalars['Int']>;
  liveGameRank?: Maybe<Scalars['Float']>;
  liveGameWinrateTopPercent?: Maybe<Scalars['Float']>;
  liveGameWon?: Maybe<Scalars['Int']>;
  liveGameWonTopPercent?: Maybe<Scalars['Float']>;
  numberOfSpins?: Maybe<Scalars['Int']>;
  playedGames?: Maybe<Scalars['Int']>;
  playedGamesTopPercent?: Maybe<Scalars['Float']>;
  rareRewardsCount?: Maybe<Scalars['Int']>;
  seen?: Maybe<Scalars['Date']>;
  /** @deprecated No longer supported */
  song?: Maybe<Song>;
  songCount?: Maybe<Scalars['Int']>;
  songSample?: Maybe<SongSample>;
  team?: Maybe<Team>;
  teamAverageAccuracy?: Maybe<Scalars['Float']>;
  teamAverageScore?: Maybe<Scalars['Int']>;
  teamAverageSpeed?: Maybe<Scalars['Float']>;
  teamBestRank?: Maybe<Scalars['Int']>;
  teamBestScore?: Maybe<Scalars['Int']>;
  teamGamesPlayed?: Maybe<Scalars['Int']>;
  tournamentBestRank?: Maybe<Scalars['Int']>;
  tournamentGamePlayed?: Maybe<Scalars['Int']>;
  tournamentHighestScore?: Maybe<Scalars['Int']>;
  tournamentWonTopPercent?: Maybe<Scalars['Float']>;
  tournamentsWon?: Maybe<Scalars['Int']>;
  tuneologyGamePlayed?: Maybe<Scalars['Int']>;
  tuneologyGameSpeedRank?: Maybe<Scalars['Float']>;
  tuneologyGameTopPercent?: Maybe<Scalars['Float']>;
  tuneologyGameWon?: Maybe<Scalars['Int']>;
  turnGameHighestScore?: Maybe<Scalars['Int']>;
  turnGamePlayed?: Maybe<Scalars['Int']>;
  turnGamePlayedTopPercent?: Maybe<Scalars['Float']>;
  turnGameWinrateTopPercent?: Maybe<Scalars['Float']>;
  turnGameWon?: Maybe<Scalars['Float']>;
  uniqueCollectionsCount?: Maybe<Scalars['Int']>;
  uniqueEmojisCount?: Maybe<Scalars['Int']>;
  winratePvpAndLive1v1?: Maybe<Scalars['Float']>;
  winratePvpAndLive1v1TopPercent?: Maybe<Scalars['Float']>;
  year: Scalars['Int'];
};

/**
 * According to doc https://docs.google.com/spreadsheets/d/1y5fX5CcNNlpfn2CxeBKipqwUxiaDBZ8VymA2BVJ73AQ/edit?usp=sharing
 * Values in doc are given mostly in form '<X', or 'less than X', where X is age. So it will be the same here.
 * So, if cmpAllowedAge===14 or attAllowedAge===14, then it is forbidden for users are lower than 14, and is allowed for 14 or bigger than 14.
 * If adultAge===14, then users lower then 14 are kids (kids mode), and are 'adults' for 14 or bigger than 14.
 * So this is adult in meaning not-games-kids-mode only
 * Strictly talking, adultAge is not defined in doc directly, there are many parameters like social features or data collection.
 * We try to compile this under single 'adultAge', maybe this will need changes in the future.
 */
export type LegalSetup = {
  __typename: 'legalSetup';
  adultAge: Scalars['Int'];
  attAllowedAge: Scalars['Int'];
  cmpAllowedAge: Scalars['Int'];
  didomiNoticeId: Scalars['String'];
};

export type OnUserToUserPingInput = {
  eventTypes: Array<PingUserToUserEventType>;
};

export type UserLegalSetup = {
  __typename: 'userLegalSetup';
  forceAgeGate: Scalars['Boolean'];
  shouldBlockFromGame: Scalars['Boolean'];
};

export type AdminUserSummaryFieldsFragment = { __typename: 'AdminUserSummary', userId: string, displayName: string, email?: string | null, phone?: string | null, picture?: string | null, role: UserRole, created: any, firebaseUid?: string | null, firebaseEmail?: string | null, firebaseEmailVerified?: boolean | null, firebaseDisabled?: boolean | null, firebaseProviders?: Array<string> | null, providers: Array<{ __typename: 'AdminCredentialSummary', type: string, credentialId: string, created?: any | null }> };

export type CompleteImportantEventFragment = { __typename: 'ImportantEvent', type: ImportantEventType, eventKey: string, notes: string, description: string, datetime: any, important: boolean };

export type EssentialMetricsFragment = { __typename: 'NumericAggregatedMetricsSerie', title: string, bytesProcessed: number, timestamp: MetricTimestamp, start: string, end: string, records: Array<{ __typename: 'NumericAggregatedMetrics', name: string, datetime: any, average: number, P50: number, P95: number, P99: number, P100: number, count: number, std: number }> };

export type EssentialRedisCountMetricsFragment = { __typename: 'NumericAggregatedRedisCountMetricsSerie', title: string, bytesProcessed: number, timestamp: MetricTimestamp, start: string, end: string, records: Array<{ __typename: 'NumericAggregatedRedisCountMetrics', name: string, datetime: any, count: number, cache_hit: number, cache_miss: number, timeout: number, cache_miss_ratio: number, timeout_ratio: number }> };

export type FulllMetricsFragment = { __typename: 'NumericAggregatedMetricsSerie', timestamp: MetricTimestamp, start: string, end: string, records: Array<{ __typename: 'NumericAggregatedMetrics', type: MetricType, name: string, datetime: any, timestamp: MetricTimestamp, average: number, P0: number, P10: number, P20: number, P30: number, P40: number, P50: number, P71: number, P85: number, P95: number, P99: number, P100: number, count: number, std: number }> };

export type DdexJobFragmentFragment = { __typename: 'DDEXJob', jobId: string, created: any, label: string, nbExecutions: number, path: string, state: JobState };

export type DdexTaskFragmentFragment = { __typename: 'DDEXTask', jobId: string, taskId: string, nbExecutions: number, originalAssetUrl?: string | null, newAssetUrl?: string | null, state: TaskState, type: string };

export type BasicSongInfoFragment = { __typename: 'CurationSong', isrc: string, title: string, artist: string, album: string, albumYear: number, label: string, subLabel?: string | null, defaultSample: string, picture: string, state: CurationSongState, isExplicit: boolean, questionableStatus?: SongQuestionableStatus | null, isDDEXSong: boolean };

export type SongCustomFieldsFragment = { __typename: 'CurationSong', displayTitle: string, displayArtist: string, movieTitle?: string | null, jesterTitle?: string | null, leadSinger?: string | null, introSample?: string | null, composer?: string | null };

export type HurdleCatalogItemFragmentFragment = { __typename: 'HurdleCatalogItem', id: string, categoryId?: string | null, excludeFromAutogeneration?: boolean | null, excludeFromCheck?: boolean | null, offset: number, addedAt: any, removed?: boolean | null, item: { __typename: 'HurdleSongItem', id: string, asset: string, song?: { __typename: 'Song', id: string, title: string, artist: string, picture?: string | null } | null } };

export type SongDetailsFragment = { __typename: 'CurationSong', externalLinks: { __typename: 'CurationSongExternalLinks', itunes: { __typename: 'CurationSongExternalLinksByStore', us?: string | null, gb?: string | null, fr?: string | null, br?: string | null, de?: string | null, es?: string | null }, spotify: { __typename: 'CurationSongExternalLinksByStore', us?: string | null, gb?: string | null, fr?: string | null, br?: string | null, de?: string | null, es?: string | null } } };

export type DdexBasicSongInfoFragment = { __typename: 'DDEXSong', id: string, label: string, subLabel: string, isrc: string, title: string, artist: string, album: string, albumId: string, releaseDate: any, isWhitelisted: boolean, artwork: string, sample: string, isExplicit: boolean };

export type ItunesBasicSongInfoFragment = { __typename: 'ItunesSong', id: string, title: string, artist: string, album: string, albumId: string, albumArtwork?: string | null, albumYear: number, isWhitelisted: boolean, parentalAdvisory: ItunesParentalAdvisory, sample: string, isrc: string, label: string, subLabel?: string | null };

export type UserViewerFragmentFragment = { __typename: 'User', id: string, displayName: string, picture?: string | null, lastOnline?: any | null, emailCredential?: string | null, subscriptionTier?: UserSubscriptionTier | null, userLevel: number, userLevelProgressToNextLevel: number, coinBalance: number, diamondBalance: number, claimedUpdateGiftId?: string | null, vipDays: number, premiumDays: number, liveEventCurrency?: number | null, boostRemove2Balance: number, boostTeamSpiritBalance: number, boostReviveBalance: number, boostNinjaBalance: number, boostBombBalance: number, boostSpeedsterBalance: number, boostArtistOnlyBalance: number, boostHurdleHintBalance: number, stampCards: number, totalStampCardsEarned: number, role: UserRole, accoladeBalance: number, freeSpins: number, subscriptionDetails?: { __typename: 'SubscriptionDetails', sku: string, autoRenews: boolean, activeSince: any, expires: any, isFreeTrial: boolean } | null, currentUserMonthlyPass: { __typename: 'UserMonthlyPass', progressToNextLevel: number, level: number, missions?: { __typename: 'UserMonthlyPassMissions', id: string, extraMissionNo?: number | null, dailyMissions: Array<{ __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } }>, monthlyMissions: Array<{ __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } }>, extraMission?: { __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } } | null } | null }, achievementMissions?: { __typename: 'UserAchievementMissions', id: string, missions: Array<{ __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } }> } | null, energySystems: { __typename: 'EnergySystems', tournamentTicket: { __typename: 'EnergySystem', currentCapSupply: number, extraBalance?: number | null }, coin: { __typename: 'EnergySystem', currentCapSupply: number }, xp: { __typename: 'EnergySystem', currentCapSupply: number }, liveEventTicket: { __typename: 'EnergySystem', currentCapSupply: number } }, basicTierContentPack: { __typename: 'UserContentPack', id: string, level: number, progressToNextLevel: number, contentPack: { __typename: 'ContentPack', id: string, name: string, picture?: string | null } }, fragmentBalance: Array<{ __typename: 'CurrencyCategoryFragment', id: string, amount: number, category: { __typename: 'ContentCategory', id: string, name: string } }>, stickers: Array<{ __typename: 'Sticker', id: string }>, profileFrames: Array<{ __typename: 'ProfileFrame', id: string }>, appSkins: Array<{ __typename: 'AppSkin', id: string }>, ABTestList: Array<{ __typename: 'ABTest', id: string, variation: string }>, ABTestForcedList: Array<{ __typename: 'ABTest', id: string }>, ABTestConfigs: Array<{ __typename: 'ABTestConfig', id: string, variations: Array<string>, status: AbTestStatus }>, ABTestLastAppInstallList: Array<{ __typename: 'ABTest', id: string, variation: string }>, reports: Array<{ __typename: 'UserReport', created: any, comment?: string | null, reporter: { __typename: 'User', id: string } }>, unlimitedBoosts: { __typename: 'UnlimitedBoosts', unlimitedBoostRemove2Balance: number, unlimitedBoostSpeedsterBalance: number }, loyalty: { __typename: 'Loyalty', tradeableCardCount: number, cardStreak: number, dayStreak: number, previousCardStreak?: number | null, futureCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null, currentCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null, previousCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null }, ownedContentPacks: { __typename: 'UserContentPacksPaginated', list: Array<{ __typename: 'UserContentPack', contentPack: { __typename: 'ContentPack', id: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null, name: string } }> }, currentSpecialEvent?: { __typename: 'SpecialEvent', id: string, meScoreDetails: Array<{ __typename: 'SpecialEventScoreDetail', type: SpecialEventScoreDetailType, score: number }> } | null, piggyBank: { __typename: 'PiggyBank', coins?: number | null, diamonds?: number | null }, metaFragments: { __typename: 'MetaFragments', BRONZE?: { __typename: 'MetaFragmentAmount', amount?: number | null } | null, SILVER?: { __typename: 'MetaFragmentAmount', amount?: number | null } | null, GOLD?: { __typename: 'MetaFragmentAmount', amount?: number | null } | null }, shards: { __typename: 'Shards', BRONZE?: number | null, SILVER?: number | null, GOLD?: number | null }, team?: { __typename: 'Team', id: string } | null, calendars: Array<{ __typename: 'PaidCalendar', id: string, name: string }> };

export type MonthlyPassMissionsFragmentFragment = { __typename: 'UserMonthlyPassMissions', id: string, extraMissionNo?: number | null, dailyMissions: Array<{ __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } }>, monthlyMissions: Array<{ __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } }>, extraMission?: { __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } } | null };

export type MissionProgressFragmentFragment = { __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } };

export type MissionFragmentFragment = { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null };

export type LoyaltyFragmentFragment = { __typename: 'Loyalty', tradeableCardCount: number, cardStreak: number, dayStreak: number, previousCardStreak?: number | null, futureCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null, currentCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null, previousCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null };

export type LoyaltyCardFragmentFragment = { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> };

export type HurdleQuizFragmentFragment = { __typename: 'HurdleQuiz', id: string, startDate: any, endDate: any, namespace: HurdleNamespace, categoryId: string, type: HurdleType, catalogItemId: string, question?: { __typename: 'HurdleQuestion', id: string, asset: string, offset: number, song?: { __typename: 'Song', id: string, displayTitle: string, displayArtist: string } | null } | null };

export type HurdleQuestionFragmentFragment = { __typename: 'HurdleQuestion', id: string, asset: string, offset: number, song?: { __typename: 'Song', id: string, displayTitle: string, displayArtist: string } | null };

export type QuizLiveShowUserFragmentFragment = { __typename: 'QuizLiveShowUser', id: string, diamondReward?: number | null, ghostQuestionId?: string | null, reviveQuestionId?: string | null, show: { __typename: 'QuizLiveShow', id: string, startDate: any, lastQuestionStartDate?: any | null, diamondPrize: number, rounds: Array<{ __typename: 'QuizLiveShowRound', id: string, questionDuration: number, questions: Array<{ __typename: 'QuizEncryptedQuestion', id: string }> }>, winners: Array<{ __typename: 'QuizLiveShowWinner', id: string, user: { __typename: 'User', id: string } }> } };

export type YearInReviewFragmentFragment = { __typename: 'YearInReview', id: string, year: number, seen?: any | null, available: any };

export type UserEmojiPackFragmentFragment = { __typename: 'UserEmojiPackPaginated', id: string, totalCount: number, hasMore: boolean, list: Array<{ __typename: 'UserEmojiPack', isActive: boolean, availability: Array<{ __typename: 'EmojiAvailabilityInfo', isAvailable: boolean, type: EmojiAvailabilityType }>, emojiPack: { __typename: 'EmojiPack', id: string, name: string, asset: string, layout: EmojiPackLayout, emojis: Array<{ __typename: 'Emoji', id: string, asset: string, name: string, utfCode: string }> } }> };

export type UserExportsFragmentFragment = { __typename: 'UserExport', id: string, requested: any, processed?: any | null, status?: UserExportStatus | null, jobStatus?: UserExportJobStatus | null, jobStartedAt?: any | null, exportedAt?: any | null, fileExpiresAt?: any | null };

export type DraftGiftFragmentFragment = { __typename: 'IapGiftDraft', id: string, created: any, sendDate?: any | null, sku: string, messageId?: string | null, recipientsCount?: number | null, sentRecipientsCount: number, deliveryStatus: string, totalBatches: number, pendingBatches: number, runningBatches: number, completedBatches: number, failedBatches: number, filters: { __typename: 'GiftFilters', appVersion?: string | null, platform?: string | null, region?: string | null, country?: string | null, age?: number | null, gender?: string | null, subTier?: UserSubscriptionTier | null, daysSinceInstall?: number | null, isSpender?: number | null, specificUsers?: Array<string> | null, daysSinceLastOnline?: number | null }, rewards: Array<{ __typename: 'IapGiftDraftReward', itemId: string, type: string, amount: number }> };

export type MonthlyPassRewardFragmentAppSkinFragment = { __typename: 'AppSkin', id: string };

export type MonthlyPassRewardFragmentBadgeFragment = { __typename: 'Badge', id: string };

export type MonthlyPassRewardFragmentContentPackRewardFragment = { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string, name: string } };

export type MonthlyPassRewardFragmentCurrencyAccoladeFragment = { __typename: 'CurrencyAccolade', amount: number };

export type MonthlyPassRewardFragmentCurrencyBoostFragment = { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType };

export type MonthlyPassRewardFragmentCurrencyCategoryFragmentFragment = { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } };

export type MonthlyPassRewardFragmentCurrencyCategoryRandomFragment = { __typename: 'CurrencyCategoryRandom', amount: number };

export type MonthlyPassRewardFragmentCurrencyCoinFragment = { __typename: 'CurrencyCoin', amount: number };

export type MonthlyPassRewardFragmentCurrencyDiamondFragment = { __typename: 'CurrencyDiamond', amount: number };

export type MonthlyPassRewardFragmentCurrencyFreeSpinFragment = { __typename: 'CurrencyFreeSpin', amount: number };

export type MonthlyPassRewardFragmentCurrencyLiveEventFragment = { __typename: 'CurrencyLiveEvent', amount: number };

export type MonthlyPassRewardFragmentCurrencyLoyaltyPointsFragment = { __typename: 'CurrencyLoyaltyPoints', amount: number };

export type MonthlyPassRewardFragmentCurrencyMetaFragmentBronzeFragment = { __typename: 'CurrencyMetaFragmentBronze', amount: number };

export type MonthlyPassRewardFragmentCurrencyMetaFragmentGoldFragment = { __typename: 'CurrencyMetaFragmentGold', amount: number };

export type MonthlyPassRewardFragmentCurrencyMetaFragmentSilverFragment = { __typename: 'CurrencyMetaFragmentSilver', amount: number };

export type MonthlyPassRewardFragmentCurrencyShardBronzeFragment = { __typename: 'CurrencyShardBronze', amount: number };

export type MonthlyPassRewardFragmentCurrencyShardGoldFragment = { __typename: 'CurrencyShardGold', amount: number };

export type MonthlyPassRewardFragmentCurrencyShardSilverFragment = { __typename: 'CurrencyShardSilver', amount: number };

export type MonthlyPassRewardFragmentCurrencySpecialEventFragment = { __typename: 'CurrencySpecialEvent', amount: number };

export type MonthlyPassRewardFragmentCurrencyStampCardFragment = { __typename: 'CurrencyStampCard', amount: number };

export type MonthlyPassRewardFragmentCurrencySubscriptionDayFragment = { __typename: 'CurrencySubscriptionDay', amount: number };

export type MonthlyPassRewardFragmentCurrencyTournamentTicketFragment = { __typename: 'CurrencyTournamentTicket', amount: number };

export type MonthlyPassRewardFragmentCurrencyUnlimitedBoostFragment = { __typename: 'CurrencyUnlimitedBoost', amount: number };

export type MonthlyPassRewardFragmentCurrencyXpFragment = { __typename: 'CurrencyXP', amount: number };

export type MonthlyPassRewardFragmentEmojiFragment = { __typename: 'Emoji', id: string };

export type MonthlyPassRewardFragmentEmojiPackFragment = { __typename: 'EmojiPack', id: string };

export type MonthlyPassRewardFragmentMonthlyBuffFragment = { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null };

export type MonthlyPassRewardFragmentPosterFragment = { __typename: 'Poster' };

export type MonthlyPassRewardFragmentProfileFrameFragment = { __typename: 'ProfileFrame', id: string };

export type MonthlyPassRewardFragmentStickerFragment = { __typename: 'Sticker', id: string };

export type MonthlyPassRewardFragmentFragment = MonthlyPassRewardFragmentAppSkinFragment | MonthlyPassRewardFragmentBadgeFragment | MonthlyPassRewardFragmentContentPackRewardFragment | MonthlyPassRewardFragmentCurrencyAccoladeFragment | MonthlyPassRewardFragmentCurrencyBoostFragment | MonthlyPassRewardFragmentCurrencyCategoryFragmentFragment | MonthlyPassRewardFragmentCurrencyCategoryRandomFragment | MonthlyPassRewardFragmentCurrencyCoinFragment | MonthlyPassRewardFragmentCurrencyDiamondFragment | MonthlyPassRewardFragmentCurrencyFreeSpinFragment | MonthlyPassRewardFragmentCurrencyLiveEventFragment | MonthlyPassRewardFragmentCurrencyLoyaltyPointsFragment | MonthlyPassRewardFragmentCurrencyMetaFragmentBronzeFragment | MonthlyPassRewardFragmentCurrencyMetaFragmentGoldFragment | MonthlyPassRewardFragmentCurrencyMetaFragmentSilverFragment | MonthlyPassRewardFragmentCurrencyShardBronzeFragment | MonthlyPassRewardFragmentCurrencyShardGoldFragment | MonthlyPassRewardFragmentCurrencyShardSilverFragment | MonthlyPassRewardFragmentCurrencySpecialEventFragment | MonthlyPassRewardFragmentCurrencyStampCardFragment | MonthlyPassRewardFragmentCurrencySubscriptionDayFragment | MonthlyPassRewardFragmentCurrencyTournamentTicketFragment | MonthlyPassRewardFragmentCurrencyUnlimitedBoostFragment | MonthlyPassRewardFragmentCurrencyXpFragment | MonthlyPassRewardFragmentEmojiFragment | MonthlyPassRewardFragmentEmojiPackFragment | MonthlyPassRewardFragmentMonthlyBuffFragment | MonthlyPassRewardFragmentPosterFragment | MonthlyPassRewardFragmentProfileFrameFragment | MonthlyPassRewardFragmentStickerFragment;

export type ItemFragmentAppSkinFragment = { __typename: 'AppSkin', iconAsset?: string | null, iconPrimaryColor?: string | null, iconBackgroundColor?: string | null, id: string, name: string, asset: string, level: number, availability: ItemAvailability, cost?: { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | null };

export type ItemFragmentProfileFrameFragment = { __typename: 'ProfileFrame', id: string, name: string, asset: string, level: number, availability: ItemAvailability, cost?: { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | null };

export type ItemFragmentStickerFragment = { __typename: 'Sticker', id: string, name: string, asset: string, level: number, availability: ItemAvailability, cost?: { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | null };

export type ItemFragmentFragment = ItemFragmentAppSkinFragment | ItemFragmentProfileFrameFragment | ItemFragmentStickerFragment;

export type BadgeConfigFragmentFragment = { __typename: 'BadgeConfig', id: string, type: BadgeType, name: string, unlockReq?: string | null, levelUpReq?: string | null, details: string };

export type EmojiPackFragmentFragment = { __typename: 'EmojiPack', id: string, name: string, asset: string, layout: EmojiPackLayout, isDraft: boolean, emojis: Array<{ __typename: 'Emoji', id: string, name: string, asset: string, utfCode: string, cost: { __typename: 'CurrencyDiamond', id: string, amount: number } }> };

export type PosterFragmentFragment = { __typename: 'Poster', id: string, type: PosterType, name: string, currencyCost?: number | null, currencyType?: string | null, itemId?: string | null, asset?: string | null };

export type AbTestFragmentFragment = { __typename: 'ABTestConfig', id: string, status: AbTestStatus, type: AbTestType, audience: AbTestAudienceType, defaultVariation?: string | null, description?: string | null, isNewAudienceOnly: boolean, isHardCoded: boolean, startDate: any, winnerVariation?: string | null, variationsWithPercentage: Array<{ __typename: 'ABTestVariation', name: string, percentage: number }> };

export type ChainedOfferConfigFragmentFragment = { __typename: 'ChainedOfferEventConfig', id: string, startDate: any, stopDate: any, status: ChainedOfferEventStatus, name: string, backgroundImage?: string | null, filterUserIds?: Array<string> | null, filterSubscriptionTier?: UserSubscriptionTier | null, filterUserMinCreationDate?: string | null, filterUserMaxCreationDate?: string | null, filterAppVersion?: string | null, filterUserLevel?: number | null, packs: Array<{ __typename: 'ChainedOfferPackConfig', cost?: number | null, sku?: string | null, claimType: ChainedOfferClaimType, rewards: Array<{ __typename: 'ChainedOfferPackRewardConfig', type: string, amount: number, itemId: string }> }> };

export type CollectionFragmentFragment = { __typename: 'Collection', id: string, name: string, type: CollectionType, categoryId?: string | null, asset?: string | null, isDraft: boolean, levels: Array<{ __typename: 'CollectionLevel', rewards?: Array<{ __typename: 'CollectionReward', type: string, amount?: number | null, itemId?: string | null }> | null, items?: Array<{ __typename: 'CollectionLevelItem', itemLevel: number, type: CollectionItemType, itemId: string }> | null }> };

export type LiveEventFragmentFragment = { __typename: 'LiveEvent', id: string, name: string, startDate: any, endDate: any, isDraft: boolean, filterUserIds: Array<string>, filterOnlyAdmin: boolean, filterVersion: number, contentPacks: Array<{ __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }>, shop: Array<{ __typename: 'LiveEventShopItemConfig', type: string, amount: number, itemId: string, cost: number, buyLimit: number }> };

export type QuizLiveShowFragmentFragment = { __typename: 'QuizLiveShow', id: string, startDate: any, lastUpdateDate: any, playerCount: number, diamondPrize: number, category: { __typename: 'ContentCategory', id: string, name: string }, lastSchedule: { __typename: 'LiveShowLastSchedulePayload', isCurrentlyScheduled: boolean }, adminSpecialEvent?: { __typename: 'SpecialEvent', id: string, name: string, startDate: any, endDate: any } | null, extraConfig: { __typename: 'ExtraConfig', primaryColor?: string | null, secondaryColor?: string | null, secondaryDarkColor?: string | null, buttonColor?: string | null, contrastGradient1?: string | null, contrastGradient2?: string | null, headerImage?: string | null, characterImage?: string | null }, rounds: Array<{ __typename: 'QuizLiveShowRound', id: string, questionDuration: number, encryptedRoundAssetUrl: string, encryptedRoundAssetUrlV2?: string | null, contentPack: { __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }, liveOpsQuestions: Array<{ __typename: 'QuizQuestion', id: string, title: string, asset?: string | null, song?: { __typename: 'Song', id: string, title: string, artist: string, picture?: string | null } | null }> }> };

export type QuizLiveShowRoundFragmentFragment = { __typename: 'QuizLiveShowRound', id: string, questionDuration: number, encryptedRoundAssetUrl: string, encryptedRoundAssetUrlV2?: string | null, contentPack: { __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }, liveOpsQuestions: Array<{ __typename: 'QuizQuestion', id: string, title: string, asset?: string | null, song?: { __typename: 'Song', id: string, title: string, artist: string, picture?: string | null } | null }> };

export type QuestionFragmentFragment = { __typename: 'QuizQuestion', id: string, title: string, asset?: string | null, song?: { __typename: 'Song', id: string, title: string, artist: string, picture?: string | null } | null };

export type LoyaltyCampaignConfigFragmentFragment = { __typename: 'LoyaltyCampaignConfig', id: string, amount: number, updatedAt: any };

export type LoyaltyCampaignCardFragmentFragment = { __typename: 'LoyaltyCampaignCard', id: string, kind: LoyaltyCampaignCardKind, name: string, groupId?: string | null, groupName?: string | null, groupDisplayOrder?: number | null, groupStartDate?: any | null, groupEndDate?: any | null, subgroupId?: string | null, subgroupName?: string | null, subgroupDisplayOrder?: number | null, subgroupStartDate?: any | null, subgroupEndDate?: any | null, itemDisplayOrder?: number | null, displayOrder: number, cost: number, itemBonusLoyaltyPoints?: number | null, maxClaims: number, created: any, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge', id: string, name: string } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string } | { __typename: 'EmojiPack', id: string } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster', id: string } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> };

export type LoyaltyCampaignCardRewardFragmentAppSkinFragment = { __typename: 'AppSkin', id: string };

export type LoyaltyCampaignCardRewardFragmentBadgeFragment = { __typename: 'Badge', id: string, name: string };

export type LoyaltyCampaignCardRewardFragmentContentPackRewardFragment = { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string } };

export type LoyaltyCampaignCardRewardFragmentCurrencyAccoladeFragment = { __typename: 'CurrencyAccolade', amount: number };

export type LoyaltyCampaignCardRewardFragmentCurrencyBoostFragment = { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType };

export type LoyaltyCampaignCardRewardFragmentCurrencyCategoryFragmentFragment = { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string } };

export type LoyaltyCampaignCardRewardFragmentCurrencyCategoryRandomFragment = { __typename: 'CurrencyCategoryRandom', amount: number };

export type LoyaltyCampaignCardRewardFragmentCurrencyCoinFragment = { __typename: 'CurrencyCoin', amount: number };

export type LoyaltyCampaignCardRewardFragmentCurrencyDiamondFragment = { __typename: 'CurrencyDiamond', amount: number };

export type LoyaltyCampaignCardRewardFragmentCurrencyFreeSpinFragment = { __typename: 'CurrencyFreeSpin', amount: number };

export type LoyaltyCampaignCardRewardFragmentCurrencyLiveEventFragment = { __typename: 'CurrencyLiveEvent', amount: number };

export type LoyaltyCampaignCardRewardFragmentCurrencyLoyaltyPointsFragment = { __typename: 'CurrencyLoyaltyPoints', amount: number };

export type LoyaltyCampaignCardRewardFragmentCurrencyMetaFragmentBronzeFragment = { __typename: 'CurrencyMetaFragmentBronze', amount: number };

export type LoyaltyCampaignCardRewardFragmentCurrencyMetaFragmentGoldFragment = { __typename: 'CurrencyMetaFragmentGold', amount: number };

export type LoyaltyCampaignCardRewardFragmentCurrencyMetaFragmentSilverFragment = { __typename: 'CurrencyMetaFragmentSilver', amount: number };

export type LoyaltyCampaignCardRewardFragmentCurrencyShardBronzeFragment = { __typename: 'CurrencyShardBronze', amount: number };

export type LoyaltyCampaignCardRewardFragmentCurrencyShardGoldFragment = { __typename: 'CurrencyShardGold', amount: number };

export type LoyaltyCampaignCardRewardFragmentCurrencyShardSilverFragment = { __typename: 'CurrencyShardSilver', amount: number };

export type LoyaltyCampaignCardRewardFragmentCurrencySpecialEventFragment = { __typename: 'CurrencySpecialEvent', amount: number };

export type LoyaltyCampaignCardRewardFragmentCurrencyStampCardFragment = { __typename: 'CurrencyStampCard', amount: number };

export type LoyaltyCampaignCardRewardFragmentCurrencySubscriptionDayFragment = { __typename: 'CurrencySubscriptionDay', amount: number };

export type LoyaltyCampaignCardRewardFragmentCurrencyTournamentTicketFragment = { __typename: 'CurrencyTournamentTicket', amount: number };

export type LoyaltyCampaignCardRewardFragmentCurrencyUnlimitedBoostFragment = { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType };

export type LoyaltyCampaignCardRewardFragmentCurrencyXpFragment = { __typename: 'CurrencyXP', amount: number };

export type LoyaltyCampaignCardRewardFragmentEmojiFragment = { __typename: 'Emoji', id: string };

export type LoyaltyCampaignCardRewardFragmentEmojiPackFragment = { __typename: 'EmojiPack', id: string };

export type LoyaltyCampaignCardRewardFragmentMonthlyBuffFragment = { __typename: 'MonthlyBuff' };

export type LoyaltyCampaignCardRewardFragmentPosterFragment = { __typename: 'Poster', id: string };

export type LoyaltyCampaignCardRewardFragmentProfileFrameFragment = { __typename: 'ProfileFrame', id: string };

export type LoyaltyCampaignCardRewardFragmentStickerFragment = { __typename: 'Sticker', id: string };

export type LoyaltyCampaignCardRewardFragmentFragment = LoyaltyCampaignCardRewardFragmentAppSkinFragment | LoyaltyCampaignCardRewardFragmentBadgeFragment | LoyaltyCampaignCardRewardFragmentContentPackRewardFragment | LoyaltyCampaignCardRewardFragmentCurrencyAccoladeFragment | LoyaltyCampaignCardRewardFragmentCurrencyBoostFragment | LoyaltyCampaignCardRewardFragmentCurrencyCategoryFragmentFragment | LoyaltyCampaignCardRewardFragmentCurrencyCategoryRandomFragment | LoyaltyCampaignCardRewardFragmentCurrencyCoinFragment | LoyaltyCampaignCardRewardFragmentCurrencyDiamondFragment | LoyaltyCampaignCardRewardFragmentCurrencyFreeSpinFragment | LoyaltyCampaignCardRewardFragmentCurrencyLiveEventFragment | LoyaltyCampaignCardRewardFragmentCurrencyLoyaltyPointsFragment | LoyaltyCampaignCardRewardFragmentCurrencyMetaFragmentBronzeFragment | LoyaltyCampaignCardRewardFragmentCurrencyMetaFragmentGoldFragment | LoyaltyCampaignCardRewardFragmentCurrencyMetaFragmentSilverFragment | LoyaltyCampaignCardRewardFragmentCurrencyShardBronzeFragment | LoyaltyCampaignCardRewardFragmentCurrencyShardGoldFragment | LoyaltyCampaignCardRewardFragmentCurrencyShardSilverFragment | LoyaltyCampaignCardRewardFragmentCurrencySpecialEventFragment | LoyaltyCampaignCardRewardFragmentCurrencyStampCardFragment | LoyaltyCampaignCardRewardFragmentCurrencySubscriptionDayFragment | LoyaltyCampaignCardRewardFragmentCurrencyTournamentTicketFragment | LoyaltyCampaignCardRewardFragmentCurrencyUnlimitedBoostFragment | LoyaltyCampaignCardRewardFragmentCurrencyXpFragment | LoyaltyCampaignCardRewardFragmentEmojiFragment | LoyaltyCampaignCardRewardFragmentEmojiPackFragment | LoyaltyCampaignCardRewardFragmentMonthlyBuffFragment | LoyaltyCampaignCardRewardFragmentPosterFragment | LoyaltyCampaignCardRewardFragmentProfileFrameFragment | LoyaltyCampaignCardRewardFragmentStickerFragment;

export type LoyaltyCampaignOfferOptionFragmentFragment = { __typename: 'LoyaltyCampaignOfferOption', id: string, label: string, priceUsd?: number | null, skus: Array<string> };

export type LoyaltyCampaignSkuPriceFragmentFragment = { __typename: 'LoyaltyCampaignSkuPrice', sku: string, priceUsd: number };

export type MarathonEventConfigFragmentFragment = { __typename: 'MarathonEventConfig', id: string, name: string, startDate: any, stopDate: any, status: ChainedOfferEventStatus, category?: string | null, filterUserIds?: Array<string> | null, filterSubscriptionTier?: UserSubscriptionTier | null, filterUserMinCreationDate?: any | null, filterUserMaxCreationDate?: any | null, filterAppVersion?: string | null, filterUserLevel?: number | null, milestones: Array<{ __typename: 'MarathonMilestoneConfig', numberOfGuesses: number, basicReward: { __typename: 'GenericLevelReward', type: LevelRewardInputType, amount: number, itemId?: string | null }, plusReward: { __typename: 'GenericLevelReward', type: LevelRewardInputType, amount: number, itemId?: string | null } }> };

export type MarathonMilestoneTemplateFragmentFragment = { __typename: 'MarathonMilestoneTemplate', id: string, name: string, milestones: Array<{ __typename: 'MarathonMilestoneConfig', numberOfGuesses: number, basicReward: { __typename: 'GenericLevelReward', type: LevelRewardInputType, amount: number, itemId?: string | null }, plusReward: { __typename: 'GenericLevelReward', type: LevelRewardInputType, amount: number, itemId?: string | null } }> };

export type CalendarFragmentFragment = { __typename: 'PaidCalendar', id: string, name: string, skuId?: string | null, startDate: any, endDate: any, filterUserIds: Array<string>, filterVersion?: number | null, purchaseReward?: { __typename: 'PaidCalendarReward', type: string, amount: number, itemId?: string | null } | null, calendarItems: Array<{ __typename: 'PaidCalendarReward', type: string, amount: number, itemId?: string | null }> };

export type SaleEventConfigFragmentFragment = { __typename: 'SaleEventConfig', id: string, startDate: any, stopDate: any, priority: number, status: SaleEventStatus, name: string, isHardCoded: boolean, filterUserIds?: Array<string> | null, filterSubscriptionTier?: UserSubscriptionTier | null, filterUserMinCreationDate?: string | null, filterUserMaxCreationDate?: string | null, filterAppVersion?: string | null, filterUserLevel?: number | null, filterHadSub?: boolean | null, sales: Array<{ __typename: 'SaleConfig', id: string, startDate?: any | null, stopDate?: any | null, name?: string | null, targetedProductId?: string | null, saleProductId?: string | null, newPrice?: number | null, oldPrice?: number | null, offerPercentage?: number | null, tag: SaleTagType, ruleMaximumNumberOfClaim?: number | null, purchaseLimitType?: PurchaseLimitEnum | null }>, packs: Array<{ __typename: 'SaleBundleConfig', id: string, startDate?: any | null, stopDate?: any | null, name?: string | null, backgroundImage?: string | null, offerPercentage?: number | null, tag?: string | null, ruleMaximumNumberOfClaim?: number | null, purchaseLimitType?: PurchaseLimitEnum | null, displayTimer?: boolean | null, skuId?: string | null, items: Array<{ __typename: 'BundleItem', itemId?: string | null, type?: string | null, amount?: number | null }> }>, dailyItems: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }>, subscriptions: Array<{ __typename: 'SubscriptionSaleConfig', id: string, discount: number, backgroundTheme?: string | null }>, assetsConfig: { __typename: 'SaleEventAssetsConfig', backgroundImage?: string | null, characterImage?: string | null } };

export type SaleConfigFragmentFragment = { __typename: 'SaleConfig', id: string, startDate?: any | null, stopDate?: any | null, name?: string | null, targetedProductId?: string | null, saleProductId?: string | null, newPrice?: number | null, oldPrice?: number | null, offerPercentage?: number | null, tag: SaleTagType, ruleMaximumNumberOfClaim?: number | null, purchaseLimitType?: PurchaseLimitEnum | null };

export type SaleBundleConfigFragmentFragment = { __typename: 'SaleBundleConfig', id: string, startDate?: any | null, stopDate?: any | null, name?: string | null, backgroundImage?: string | null, offerPercentage?: number | null, tag?: string | null, ruleMaximumNumberOfClaim?: number | null, purchaseLimitType?: PurchaseLimitEnum | null, displayTimer?: boolean | null, skuId?: string | null, items: Array<{ __typename: 'BundleItem', itemId?: string | null, type?: string | null, amount?: number | null }> };

export type BundleItemFragmentFragment = { __typename: 'BundleItem', itemId?: string | null, type?: string | null, amount?: number | null };

export type HighPriorDailyDealsFragmentAppSkinFragment = { __typename: 'AppSkin', id: string };

export type HighPriorDailyDealsFragmentProfileFrameFragment = { __typename: 'ProfileFrame', id: string };

export type HighPriorDailyDealsFragmentStickerFragment = { __typename: 'Sticker', id: string };

export type HighPriorDailyDealsFragmentFragment = HighPriorDailyDealsFragmentAppSkinFragment | HighPriorDailyDealsFragmentProfileFrameFragment | HighPriorDailyDealsFragmentStickerFragment;

export type SpecialEventFragmentFragment = { __typename: 'SpecialEvent', id: string, name: string, description: string, startDate: any, endDate: any, isDraft: boolean, configWarnings: Array<string>, assetsConfig: { __typename: 'SpecialEventAssetsConfig', primaryColor?: string | null, secondaryColor?: string | null, secondaryDarkColor?: string | null, buttonColor?: string | null, contrast?: string | null, contrastGradient1?: string | null, contrastGradient2?: string | null, headerImage?: string | null, backgroundImage?: string | null, icon?: string | null }, missions?: { __typename: 'SpecialEventMissions', id: string, sequentialMissions: Array<{ __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null }> } | null, tournaments: Array<{ __typename: 'Tournament', id: string, startDate: any }>, quizLiveShows: Array<{ __typename: 'QuizLiveShow', id: string, startDate: any }>, contentPacks: Array<{ __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }>, milestones: Array<{ __typename: 'SpecialEventMilestone', id: string, score: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string, name: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string, name: string } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }>, plusMilestones: Array<{ __typename: 'SpecialEventMilestone', id: string, score: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string, name: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string, name: string } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }>, rankGroups: Array<{ __typename: 'SpecialEventRankGroup', id: string, minRank: number, maxRank: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string, name: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string, name: string } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }> };

export type SpecialEventRewardFragmentAppSkinFragment = { __typename: 'AppSkin', id: string };

export type SpecialEventRewardFragmentBadgeFragment = { __typename: 'Badge' };

export type SpecialEventRewardFragmentContentPackRewardFragment = { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string, name: string } };

export type SpecialEventRewardFragmentCurrencyAccoladeFragment = { __typename: 'CurrencyAccolade', amount: number };

export type SpecialEventRewardFragmentCurrencyBoostFragment = { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType };

export type SpecialEventRewardFragmentCurrencyCategoryFragmentFragment = { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } };

export type SpecialEventRewardFragmentCurrencyCategoryRandomFragment = { __typename: 'CurrencyCategoryRandom', amount: number };

export type SpecialEventRewardFragmentCurrencyCoinFragment = { __typename: 'CurrencyCoin', amount: number };

export type SpecialEventRewardFragmentCurrencyDiamondFragment = { __typename: 'CurrencyDiamond', amount: number };

export type SpecialEventRewardFragmentCurrencyFreeSpinFragment = { __typename: 'CurrencyFreeSpin', amount: number };

export type SpecialEventRewardFragmentCurrencyLiveEventFragment = { __typename: 'CurrencyLiveEvent', amount: number };

export type SpecialEventRewardFragmentCurrencyLoyaltyPointsFragment = { __typename: 'CurrencyLoyaltyPoints', amount: number };

export type SpecialEventRewardFragmentCurrencyMetaFragmentBronzeFragment = { __typename: 'CurrencyMetaFragmentBronze', amount: number };

export type SpecialEventRewardFragmentCurrencyMetaFragmentGoldFragment = { __typename: 'CurrencyMetaFragmentGold', amount: number };

export type SpecialEventRewardFragmentCurrencyMetaFragmentSilverFragment = { __typename: 'CurrencyMetaFragmentSilver', amount: number };

export type SpecialEventRewardFragmentCurrencyShardBronzeFragment = { __typename: 'CurrencyShardBronze', amount: number };

export type SpecialEventRewardFragmentCurrencyShardGoldFragment = { __typename: 'CurrencyShardGold', amount: number };

export type SpecialEventRewardFragmentCurrencyShardSilverFragment = { __typename: 'CurrencyShardSilver', amount: number };

export type SpecialEventRewardFragmentCurrencySpecialEventFragment = { __typename: 'CurrencySpecialEvent', amount: number };

export type SpecialEventRewardFragmentCurrencyStampCardFragment = { __typename: 'CurrencyStampCard', amount: number };

export type SpecialEventRewardFragmentCurrencySubscriptionDayFragment = { __typename: 'CurrencySubscriptionDay', amount: number };

export type SpecialEventRewardFragmentCurrencyTournamentTicketFragment = { __typename: 'CurrencyTournamentTicket', amount: number };

export type SpecialEventRewardFragmentCurrencyUnlimitedBoostFragment = { __typename: 'CurrencyUnlimitedBoost', amount: number };

export type SpecialEventRewardFragmentCurrencyXpFragment = { __typename: 'CurrencyXP', amount: number };

export type SpecialEventRewardFragmentEmojiFragment = { __typename: 'Emoji', id: string, name: string };

export type SpecialEventRewardFragmentEmojiPackFragment = { __typename: 'EmojiPack' };

export type SpecialEventRewardFragmentMonthlyBuffFragment = { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null };

export type SpecialEventRewardFragmentPosterFragment = { __typename: 'Poster' };

export type SpecialEventRewardFragmentProfileFrameFragment = { __typename: 'ProfileFrame', id: string };

export type SpecialEventRewardFragmentStickerFragment = { __typename: 'Sticker', id: string };

export type SpecialEventRewardFragmentFragment = SpecialEventRewardFragmentAppSkinFragment | SpecialEventRewardFragmentBadgeFragment | SpecialEventRewardFragmentContentPackRewardFragment | SpecialEventRewardFragmentCurrencyAccoladeFragment | SpecialEventRewardFragmentCurrencyBoostFragment | SpecialEventRewardFragmentCurrencyCategoryFragmentFragment | SpecialEventRewardFragmentCurrencyCategoryRandomFragment | SpecialEventRewardFragmentCurrencyCoinFragment | SpecialEventRewardFragmentCurrencyDiamondFragment | SpecialEventRewardFragmentCurrencyFreeSpinFragment | SpecialEventRewardFragmentCurrencyLiveEventFragment | SpecialEventRewardFragmentCurrencyLoyaltyPointsFragment | SpecialEventRewardFragmentCurrencyMetaFragmentBronzeFragment | SpecialEventRewardFragmentCurrencyMetaFragmentGoldFragment | SpecialEventRewardFragmentCurrencyMetaFragmentSilverFragment | SpecialEventRewardFragmentCurrencyShardBronzeFragment | SpecialEventRewardFragmentCurrencyShardGoldFragment | SpecialEventRewardFragmentCurrencyShardSilverFragment | SpecialEventRewardFragmentCurrencySpecialEventFragment | SpecialEventRewardFragmentCurrencyStampCardFragment | SpecialEventRewardFragmentCurrencySubscriptionDayFragment | SpecialEventRewardFragmentCurrencyTournamentTicketFragment | SpecialEventRewardFragmentCurrencyUnlimitedBoostFragment | SpecialEventRewardFragmentCurrencyXpFragment | SpecialEventRewardFragmentEmojiFragment | SpecialEventRewardFragmentEmojiPackFragment | SpecialEventRewardFragmentMonthlyBuffFragment | SpecialEventRewardFragmentPosterFragment | SpecialEventRewardFragmentProfileFrameFragment | SpecialEventRewardFragmentStickerFragment;

export type TeamShopItemFragmentFragment = { __typename: 'TeamShopItem', id: string, startDate: any, endDate?: any | null, buyLimit?: number | null, buyLimitType?: TeamShopBuyLimitEnum | null, cost: number, discount?: number | null, reward: { __typename: 'TeamShopItemConfig', type: string, amount?: number | null, itemId?: string | null } };

export type TournamentFragmentFragment = { __typename: 'Tournament', id: string, name: string, description: string, startDate: any, endDate: any, ticketCost: number, category: { __typename: 'ContentCategory', id: string }, assetsConfig: { __typename: 'TournamentAssetsConfig', primaryColor?: string | null, secondaryColor?: string | null, secondaryDarkColor?: string | null, buttonColor?: string | null, characterImage?: string | null, headerImage?: string | null, contrast?: string | null, contrastGradient1?: string | null, contrastGradient2?: string | null }, contentPacks: Array<{ __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }>, adminSpecialEvent?: { __typename: 'SpecialEvent', id: string, name: string, startDate: any, endDate: any } | null, milestones: Array<{ __typename: 'TournamentMilestone', id: string, score: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }>, rankGroups: Array<{ __typename: 'TournamentRankGroup', id: string, minRank: number, maxRank: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }> };

export type WheelFortuneEventConfigFragmentFragment = { __typename: 'WheelFortuneEventConfig', id: string, name: string, startDate: any, stopDate: any, status: ChainedOfferEventStatus, filterUserIds?: Array<string> | null, filterSubscriptionTier?: UserSubscriptionTier | null, filterUserMinCreationDate?: any | null, filterUserMaxCreationDate?: any | null, filterAppVersion?: string | null, filterUserLevel?: number | null, spinPrice: { __typename: 'GenericLevelReward', type: LevelRewardInputType, amount: number }, spinPricePlus: { __typename: 'GenericLevelReward', type: LevelRewardInputType, amount: number }, rewards: Array<{ __typename: 'WheelFortuneRewardConfig', weight: number, reward: { __typename: 'GenericLevelReward', type: LevelRewardInputType, amount: number, itemId?: string | null } }> };

export type WheelFortuneRewardTemplateFragmentFragment = { __typename: 'WheelFortuneRewardTemplate', id: string, name: string, rewards: Array<{ __typename: 'WheelFortuneRewardConfig', weight: number, reward: { __typename: 'GenericLevelReward', type: LevelRewardInputType, amount: number, itemId?: string | null } }> };

export type AdmMeQueryVariables = Exact<{ [key: string]: never; }>;


export type AdmMeQuery = { __typename: 'Query', me: { __typename: 'User', id: string, role: UserRole, displayName: string, picture?: string | null } };

export type GetUsersQueryVariables = Exact<{
  role: UserRole;
}>;


export type GetUsersQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', usersWithRoles: Array<{ __typename: 'User', id: string, role: UserRole, displayName: string, picture?: string | null, emailCredential?: string | null }> } };

export type UpdateAccountRoleMutationVariables = Exact<{
  input: UpdateUserRoleInput;
}>;


export type UpdateAccountRoleMutation = { __typename: 'Mutation', updateUserRole: { __typename: 'UpdateUserRolePayload', user: { __typename: 'User', id: string, role: UserRole } } };

export type SetSubscriptionTierMutationVariables = Exact<{
  input: SetSubscriptionTierInput;
}>;


export type SetSubscriptionTierMutation = { __typename: 'Mutation', setSubscriptionTier: { __typename: 'UpdateSubscriptionTierPayload', user?: { __typename: 'User', id: string } | null } };

export type AdminSearchUsersForRecoveryQueryVariables = Exact<{
  input: AdminSearchUsersInput;
}>;


export type AdminSearchUsersForRecoveryQuery = { __typename: 'Query', adminSearchUsersForRecovery: { __typename: 'AdminSearchUsersPayload', users: Array<{ __typename: 'AdminUserSummary', userId: string, displayName: string, email?: string | null, phone?: string | null, picture?: string | null, role: UserRole, created: any, firebaseUid?: string | null, firebaseEmail?: string | null, firebaseEmailVerified?: boolean | null, firebaseDisabled?: boolean | null, firebaseProviders?: Array<string> | null, providers: Array<{ __typename: 'AdminCredentialSummary', type: string, credentialId: string, created?: any | null }> }> } };

export type AdminLinkEmailCredentialMutationVariables = Exact<{
  input: AdminLinkEmailCredentialInput;
}>;


export type AdminLinkEmailCredentialMutation = { __typename: 'Mutation', adminLinkEmailCredential: { __typename: 'AdminLinkEmailCredentialPayload', success: boolean, message?: string | null, user?: { __typename: 'AdminUserSummary', userId: string, displayName: string, email?: string | null, phone?: string | null, picture?: string | null, role: UserRole, created: any, firebaseUid?: string | null, firebaseEmail?: string | null, firebaseEmailVerified?: boolean | null, firebaseDisabled?: boolean | null, firebaseProviders?: Array<string> | null, providers: Array<{ __typename: 'AdminCredentialSummary', type: string, credentialId: string, created?: any | null }> } | null } };

export type AdminSendSignInLinkToUserMutationVariables = Exact<{
  input: AdminSendSignInLinkInput;
}>;


export type AdminSendSignInLinkToUserMutation = { __typename: 'Mutation', adminSendSignInLinkToUser: { __typename: 'AdminSendSignInLinkPayload', success: boolean, message?: string | null, sentToEmail?: string | null } };

export type CreateCustomImportantEventMutationVariables = Exact<{
  input: CreateImportantEventInput;
}>;


export type CreateCustomImportantEventMutation = { __typename: 'Mutation', createCustomImportantEvent: { __typename: 'ImportantEvent', type: ImportantEventType, eventKey: string, notes: string, description: string, datetime: any, important: boolean } };

export type CreateBackendDeploymentImportantEventMutationVariables = Exact<{
  input: CreateBackendDeploymentImportantEventInput;
}>;


export type CreateBackendDeploymentImportantEventMutation = { __typename: 'Mutation', createBackendDeploymentImportantEvent: { __typename: 'ImportantEvent', type: ImportantEventType, eventKey: string, notes: string, description: string, datetime: any, important: boolean } };

export type CreateFrontendDeploymentImportantEventMutationVariables = Exact<{
  input: CreateFrontendDeploymentImportantEventInput;
}>;


export type CreateFrontendDeploymentImportantEventMutation = { __typename: 'Mutation', createFrontendDeploymentImportantEvent: { __typename: 'ImportantEvent', type: ImportantEventType, eventKey: string, notes: string, description: string, datetime: any, important: boolean } };

export type UpdateImportantEventMutationVariables = Exact<{
  input: UpdateImportantEventInput;
}>;


export type UpdateImportantEventMutation = { __typename: 'Mutation', updateImportantEvent: { __typename: 'ImportantEvent', type: ImportantEventType, eventKey: string, notes: string, description: string, datetime: any, important: boolean } };

export type GetImportantEventsQueryVariables = Exact<{
  input: GetImportantEventsInput;
}>;


export type GetImportantEventsQuery = { __typename: 'Query', getImportantEvents: Array<{ __typename: 'ImportantEvent', type: ImportantEventType, eventKey: string, notes: string, description: string, datetime: any, important: boolean }> };

export type DeleteImportantEventMutationVariables = Exact<{
  input: DeleteImportantEventInput;
}>;


export type DeleteImportantEventMutation = { __typename: 'Mutation', deleteImportantEvent: { __typename: 'DeleteImportantEventPayload', deletedEventType: ImportantEventType, deletedEventKey: string } };

export type MonitoringPreviousQueryVariables = Exact<{
  input: PreviousAggregatedMetricsInput;
}>;


export type MonitoringPreviousQuery = { __typename: 'Query', monitoring: { __typename: 'NumericAggregatedMetricsSerie', title: string, bytesProcessed: number, timestamp: MetricTimestamp, start: string, end: string, records: Array<{ __typename: 'NumericAggregatedMetrics', name: string, datetime: any, average: number, P50: number, P95: number, P99: number, P100: number, count: number, std: number }> } | { __typename: 'NumericAggregatedRedisCountMetricsSerie', title: string, bytesProcessed: number, timestamp: MetricTimestamp, start: string, end: string, records: Array<{ __typename: 'NumericAggregatedRedisCountMetrics', name: string, datetime: any, count: number, cache_hit: number, cache_miss: number, timeout: number, cache_miss_ratio: number, timeout_ratio: number }> } };

export type MonitoringBetweenQueryVariables = Exact<{
  input: BetweenAggregatedMetricsInput;
}>;


export type MonitoringBetweenQuery = { __typename: 'Query', monitoring: { __typename: 'NumericAggregatedMetricsSerie', title: string, bytesProcessed: number, timestamp: MetricTimestamp, start: string, end: string, records: Array<{ __typename: 'NumericAggregatedMetrics', name: string, datetime: any, average: number, P50: number, P95: number, P99: number, P100: number, count: number, std: number }> } | { __typename: 'NumericAggregatedRedisCountMetricsSerie', title: string, bytesProcessed: number, timestamp: MetricTimestamp, start: string, end: string, records: Array<{ __typename: 'NumericAggregatedRedisCountMetrics', name: string, datetime: any, count: number, cache_hit: number, cache_miss: number, timeout: number, cache_miss_ratio: number, timeout_ratio: number }> } };

export type MonitoringSpecificRequestsPreviousQueryVariables = Exact<{
  input: RequestPreviousAggregatedMetricsInput;
}>;


export type MonitoringSpecificRequestsPreviousQuery = { __typename: 'Query', monitoring: { __typename: 'NumericAggregatedMetricsSerie', title: string, bytesProcessed: number, timestamp: MetricTimestamp, start: string, end: string, records: Array<{ __typename: 'NumericAggregatedMetrics', name: string, datetime: any, average: number, P50: number, P95: number, P99: number, P100: number, count: number, std: number }> } | { __typename: 'NumericAggregatedRedisCountMetricsSerie', title: string, bytesProcessed: number, timestamp: MetricTimestamp, start: string, end: string, records: Array<{ __typename: 'NumericAggregatedRedisCountMetrics', name: string, datetime: any, count: number, cache_hit: number, cache_miss: number, timeout: number, cache_miss_ratio: number, timeout_ratio: number }> } };

export type MonitoringSpecificRequestsBetweenQueryVariables = Exact<{
  input: RequestBetweenAggregatedMetricsInput;
}>;


export type MonitoringSpecificRequestsBetweenQuery = { __typename: 'Query', monitoring: { __typename: 'NumericAggregatedMetricsSerie', title: string, bytesProcessed: number, timestamp: MetricTimestamp, start: string, end: string, records: Array<{ __typename: 'NumericAggregatedMetrics', name: string, datetime: any, average: number, P50: number, P95: number, P99: number, P100: number, count: number, std: number }> } | { __typename: 'NumericAggregatedRedisCountMetricsSerie', title: string, bytesProcessed: number, timestamp: MetricTimestamp, start: string, end: string, records: Array<{ __typename: 'NumericAggregatedRedisCountMetrics', name: string, datetime: any, count: number, cache_hit: number, cache_miss: number, timeout: number, cache_miss_ratio: number, timeout_ratio: number }> } };

export type MonitoringRequestNamesQueryVariables = Exact<{
  input: MonitoringRequestNamesInput;
}>;


export type MonitoringRequestNamesQuery = { __typename: 'Query', monitoringRequestNames: Array<string> };

export type FullMonitoringPreviousQueryVariables = Exact<{
  input: PreviousAggregatedMetricsInput;
}>;


export type FullMonitoringPreviousQuery = { __typename: 'Query', monitoring: { __typename: 'NumericAggregatedMetricsSerie', timestamp: MetricTimestamp, start: string, end: string, records: Array<{ __typename: 'NumericAggregatedMetrics', type: MetricType, name: string, datetime: any, timestamp: MetricTimestamp, average: number, P0: number, P10: number, P20: number, P30: number, P40: number, P50: number, P71: number, P85: number, P95: number, P99: number, P100: number, count: number, std: number }> } | { __typename: 'NumericAggregatedRedisCountMetricsSerie', title: string, bytesProcessed: number, timestamp: MetricTimestamp, start: string, end: string, records: Array<{ __typename: 'NumericAggregatedRedisCountMetrics', name: string, datetime: any, count: number, cache_hit: number, cache_miss: number, timeout: number, cache_miss_ratio: number, timeout_ratio: number }> } };

export type FullMonitoringBetweenQueryVariables = Exact<{
  input: BetweenAggregatedMetricsInput;
}>;


export type FullMonitoringBetweenQuery = { __typename: 'Query', monitoring: { __typename: 'NumericAggregatedMetricsSerie', timestamp: MetricTimestamp, start: string, end: string, records: Array<{ __typename: 'NumericAggregatedMetrics', type: MetricType, name: string, datetime: any, timestamp: MetricTimestamp, average: number, P0: number, P10: number, P20: number, P30: number, P40: number, P50: number, P71: number, P85: number, P95: number, P99: number, P100: number, count: number, std: number }> } | { __typename: 'NumericAggregatedRedisCountMetricsSerie', title: string, bytesProcessed: number, timestamp: MetricTimestamp, start: string, end: string, records: Array<{ __typename: 'NumericAggregatedRedisCountMetrics', name: string, datetime: any, count: number, cache_hit: number, cache_miss: number, timeout: number, cache_miss_ratio: number, timeout_ratio: number }> } };

export type FullMonitoringSpecificRequestsPreviousQueryVariables = Exact<{
  input: RequestPreviousAggregatedMetricsInput;
}>;


export type FullMonitoringSpecificRequestsPreviousQuery = { __typename: 'Query', monitoring: { __typename: 'NumericAggregatedMetricsSerie', timestamp: MetricTimestamp, start: string, end: string, records: Array<{ __typename: 'NumericAggregatedMetrics', type: MetricType, name: string, datetime: any, timestamp: MetricTimestamp, average: number, P0: number, P10: number, P20: number, P30: number, P40: number, P50: number, P71: number, P85: number, P95: number, P99: number, P100: number, count: number, std: number }> } | { __typename: 'NumericAggregatedRedisCountMetricsSerie', title: string, bytesProcessed: number, timestamp: MetricTimestamp, start: string, end: string, records: Array<{ __typename: 'NumericAggregatedRedisCountMetrics', name: string, datetime: any, count: number, cache_hit: number, cache_miss: number, timeout: number, cache_miss_ratio: number, timeout_ratio: number }> } };

export type FullMonitoringSpecificRequestsBetweenQueryVariables = Exact<{
  input: RequestBetweenAggregatedMetricsInput;
}>;


export type FullMonitoringSpecificRequestsBetweenQuery = { __typename: 'Query', monitoring: { __typename: 'NumericAggregatedMetricsSerie', timestamp: MetricTimestamp, start: string, end: string, records: Array<{ __typename: 'NumericAggregatedMetrics', type: MetricType, name: string, datetime: any, timestamp: MetricTimestamp, average: number, P0: number, P10: number, P20: number, P30: number, P40: number, P50: number, P71: number, P85: number, P95: number, P99: number, P100: number, count: number, std: number }> } | { __typename: 'NumericAggregatedRedisCountMetricsSerie', title: string, bytesProcessed: number, timestamp: MetricTimestamp, start: string, end: string, records: Array<{ __typename: 'NumericAggregatedRedisCountMetrics', name: string, datetime: any, count: number, cache_hit: number, cache_miss: number, timeout: number, cache_miss_ratio: number, timeout_ratio: number }> } };

export type DdexJobQueryVariables = Exact<{
  jobId: Scalars['ID'];
}>;


export type DdexJobQuery = { __typename: 'Query', ddexJob?: { __typename: 'DDEXJob', jobId: string, created: any, label: string, nbExecutions: number, path: string, state: JobState } | null };

export type DdexJobsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationParams>;
}>;


export type DdexJobsQuery = { __typename: 'Query', ddexJobs: { __typename: 'DDEXJobsPaginated', hasMore: boolean, totalCount: number, list: Array<{ __typename: 'DDEXJob', jobId: string, created: any, label: string, nbExecutions: number, path: string, state: JobState }> } };

export type DdexJobTasksQueryVariables = Exact<{
  jobId: Scalars['ID'];
}>;


export type DdexJobTasksQuery = { __typename: 'Query', ddexJobTasks: Array<{ __typename: 'DDEXTask', jobId: string, taskId: string, nbExecutions: number, originalAssetUrl?: string | null, newAssetUrl?: string | null, state: TaskState, type: string }> };

export type DdexJobLogsQueryVariables = Exact<{
  jobId: Scalars['ID'];
  pagination?: InputMaybe<PaginationParams>;
}>;


export type DdexJobLogsQuery = { __typename: 'Query', analytics: { __typename: 'Analytics', ddexJobLogs: { __typename: 'DDEXJobLogsPaginated', totalCount: number, list: Array<{ __typename: 'DDEXJobLog', timestamp: any, message: string, label: string, jobId?: string | null, taskId?: string | null, level: string, extraData?: any | null }> } } };

export type CreateCurationContentPackByUrlMutationVariables = Exact<{
  input: CreateCurationContentPackByUrlInput;
}>;


export type CreateCurationContentPackByUrlMutation = { __typename: 'Mutation', createCurationContentPackByUrl: { __typename: 'CurationContentPackPayload', curationContentPack: { __typename: 'CurationContentPack', id: string, name: string, picture: string, created: any, state?: CurationContentPackState | null, explicitContentStatus: ContentPackExplicitContentStatus } } };

export type CreateCurationContentPackByCsvMutationVariables = Exact<{
  input: CreateCurationContentPackByCsvInput;
}>;


export type CreateCurationContentPackByCsvMutation = { __typename: 'Mutation', createCurationContentPackByCSV: { __typename: 'CurationContentPackPayload', curationContentPack: { __typename: 'CurationContentPack', id: string, name: string, picture: string, created: any, state?: CurationContentPackState | null, explicitContentStatus: ContentPackExplicitContentStatus } } };

export type CreateCurationContentPackFromSp2MutationVariables = Exact<{
  input: CreateCurationContentPackFromSp2Input;
}>;


export type CreateCurationContentPackFromSp2Mutation = { __typename: 'Mutation', createCurationContentPackFromSp2: { __typename: 'CurationContentPackPayload', curationContentPack: { __typename: 'CurationContentPack', id: string, name: string, picture: string, created: any, state?: CurationContentPackState | null, explicitContentStatus: ContentPackExplicitContentStatus } } };

export type CreateCurationContentPackByArtistsMutationVariables = Exact<{
  input: CreateCurationContentPackByArtistsInput;
}>;


export type CreateCurationContentPackByArtistsMutation = { __typename: 'Mutation', createCurationContentPackByArtists: { __typename: 'CurationContentPackPayload', curationContentPack: { __typename: 'CurationContentPack', id: string, name: string, picture: string, created: any, state?: CurationContentPackState | null, explicitContentStatus: ContentPackExplicitContentStatus } } };

export type ImportItunesDatabaseMutationVariables = Exact<{ [key: string]: never; }>;


export type ImportItunesDatabaseMutation = { __typename: 'Mutation', importItunesDatabase: { __typename: 'ImportItunesDatabasePayload', ingestStatus?: { __typename: 'CurationTask', resultUrl?: string | null, created: any, status: CurationTaskStatus } | null } };

export type ExportMusicCatalogMutationVariables = Exact<{ [key: string]: never; }>;


export type ExportMusicCatalogMutation = { __typename: 'Mutation', exportMusicCatalog: { __typename: 'ExportMusicCatalogPayload', success: boolean } };

export type MakeMusicCatalogAvailableMutationVariables = Exact<{ [key: string]: never; }>;


export type MakeMusicCatalogAvailableMutation = { __typename: 'Mutation', makeMusicCatalogAvailable: { __typename: 'MakeMusicCatalogAvailablePayload', catalogExport?: { __typename: 'CurationTask', id: string, status: CurationTaskStatus, created: any, started?: any | null, completed?: any | null, available?: any | null } | null } };

export type GenerateSp2ReportingTableMutationVariables = Exact<{
  input: GenerateReportInput;
}>;


export type GenerateSp2ReportingTableMutation = { __typename: 'Mutation', generateSP2ReportingTable: { __typename: 'GenerateReportPayload', success: boolean } };

export type GenerateSppReportingTableMutationVariables = Exact<{
  input: GenerateReportInput;
}>;


export type GenerateSppReportingTableMutation = { __typename: 'Mutation', generateReport: { __typename: 'GenerateReportPayload', success: boolean } };

export type GenerateCombinedMusicReportMutationVariables = Exact<{
  input: GenerateReportInput;
}>;


export type GenerateCombinedMusicReportMutation = { __typename: 'Mutation', generateCombinedMusicReport: { __typename: 'MusicReportPayload', report?: { __typename: 'MusicReport', id: string, created: any, formattedDate: string } | null } };

export type DeleteCurationContentPackMutationVariables = Exact<{
  input: DeleteCurationContentPackInput;
}>;


export type DeleteCurationContentPackMutation = { __typename: 'Mutation', deleteCurationContentPack: { __typename: 'CurationContentPackPayload', curationContentPack: { __typename: 'CurationContentPack', id: string, state?: CurationContentPackState | null, deleted?: any | null } } };

export type AddDdexSongToCurationContentPackMutationVariables = Exact<{
  input: AddDdexSongToCurationContentPackInput;
}>;


export type AddDdexSongToCurationContentPackMutation = { __typename: 'Mutation', addDDEXSongToCurationContentPack: { __typename: 'CurationContentPackPayload', curationContentPack: { __typename: 'CurationContentPack', id: string, contentItems: Array<{ __typename: 'CurationQuizQuestion' } | { __typename: 'CurationSong', id: string, songInput: { __typename: 'CurationSongInput', id: string } } | { __typename: 'CurationSongInput', id: string }> } } };

export type ReorderSongsFromCurationContentPackMutationVariables = Exact<{
  input: ReorderSongsFromCurationContentPackInput;
  id: Scalars['ID'];
}>;


export type ReorderSongsFromCurationContentPackMutation = { __typename: 'Mutation', reorderSongsFromCurationContentPack: { __typename: 'CurationContentPackPayload', curationContentPack: { __typename: 'CurationContentPack', id: string, contentItems: Array<{ __typename: 'CurationQuizQuestion' } | { __typename: 'CurationSong', id: string, playlistCustomDisplay?: string | null, songInput: { __typename: 'CurationSongInput', id: string } } | { __typename: 'CurationSongInput', id: string }> } } };

export type CreateCurationContentPackNewDraftMutationVariables = Exact<{
  input: CreateCurationContentPackNewDraftInput;
}>;


export type CreateCurationContentPackNewDraftMutation = { __typename: 'Mutation', createCurationContentPackNewDraft: { __typename: 'CurationContentPackPayload', curationContentPack: { __typename: 'CurationContentPack', id: string, originId: string, state?: CurationContentPackState | null, version: number } } };

export type CommitCurationContentPackMutationVariables = Exact<{
  input: CommitCurationContentPackInput;
}>;


export type CommitCurationContentPackMutation = { __typename: 'Mutation', commitCurationContentPack: { __typename: 'CurationContentPackPayload', curationContentPack: { __typename: 'CurationContentPack', id: string, state?: CurationContentPackState | null, committed?: any | null } } };

export type UpdateCurationContentPackNameMutationVariables = Exact<{
  input: UpdateCurationContentPackNameInput;
}>;


export type UpdateCurationContentPackNameMutation = { __typename: 'Mutation', updateCurationContentPackName: { __typename: 'CurationContentPackPayload', curationContentPack: { __typename: 'CurationContentPack', id: string, name: string } } };

export type UpdateCurationContentPackDescriptionMutationVariables = Exact<{
  input: UpdateCurationContentPackDescriptionInput;
}>;


export type UpdateCurationContentPackDescriptionMutation = { __typename: 'Mutation', updateCurationContentPackDescription: { __typename: 'CurationContentPackPayload', curationContentPack: { __typename: 'CurationContentPack', id: string, description: string } } };

export type UpdateCurationContentPackCustomFieldsMutationVariables = Exact<{
  input: UpdateCurationContentPackCustomFieldsInput;
  id: Scalars['ID'];
}>;


export type UpdateCurationContentPackCustomFieldsMutation = { __typename: 'Mutation', updateCurationContentPackCustomFields: { __typename: 'CurationContentPackPayload', curationContentPack: { __typename: 'CurationContentPack', id: string, selectedCustomFields: Array<CurationContentPackCustomField>, contentItems: Array<{ __typename: 'CurationQuizQuestion' } | { __typename: 'CurationSong', id: string, isInvalid: boolean, songInput: { __typename: 'CurationSongInput', id: string } } | { __typename: 'CurationSongInput' }> } } };

export type UpdateCurationContentPackCategoriesMutationVariables = Exact<{
  input: UpdateCurationContentPackCategoriesInput;
}>;


export type UpdateCurationContentPackCategoriesMutation = { __typename: 'Mutation', updateCurationContentPackCategories: { __typename: 'CurationContentPackPayload', curationContentPack: { __typename: 'CurationContentPack', id: string, categories: Array<{ __typename: 'ContentCategory', id: string, name: string }> } } };

export type UpdateCurationContentPackLocaleMutationVariables = Exact<{
  input: UpdateCurationContentPackLocaleInput;
}>;


export type UpdateCurationContentPackLocaleMutation = { __typename: 'Mutation', updateCurationContentPackLocale: { __typename: 'CurationContentPackPayload', curationContentPack: { __typename: 'CurationContentPack', id: string, locale?: string | null } } };

export type UpdateCurationContentPackTypeMutationVariables = Exact<{
  input: UpdateCurationContentPackTypeInput;
}>;


export type UpdateCurationContentPackTypeMutation = { __typename: 'Mutation', updateCurationContentPackType: { __typename: 'CurationContentPackPayload', curationContentPack: { __typename: 'CurationContentPack', id: string, type: ContentPackType } } };

export type ToggleSp2OnlyTagMutationVariables = Exact<{
  input: ToggleSp2OnlyTagInput;
}>;


export type ToggleSp2OnlyTagMutation = { __typename: 'Mutation', toggleSP2OnlyTag: { __typename: 'CurationContentPackPayload', curationContentPack: { __typename: 'CurationContentPack', id: string, sp2Only?: boolean | null } } };

export type ToggleCurationContentPackAdultOnlyTagMutationVariables = Exact<{
  input: ToggleCurationContentPackAdultOnlyTagInput;
}>;


export type ToggleCurationContentPackAdultOnlyTagMutation = { __typename: 'Mutation', toggleCurationContentPackAdultOnlyTag: { __typename: 'CurationContentPackPayload', curationContentPack: { __typename: 'CurationContentPack', id: string, adultOnly: boolean } } };

export type UpdateContentPackAvailabilityTypeMutationVariables = Exact<{
  input: UpdateContentPackAvailabilityTypeInput;
}>;


export type UpdateContentPackAvailabilityTypeMutation = { __typename: 'Mutation', updateContentPackAvailabilityType: { __typename: 'ContentPackPayload', contentPack: { __typename: 'ContentPack', id: string, availabilityType: ContentPackAvailabilityType } } };

export type UpdateContentPackAvailabilityDateMutationVariables = Exact<{
  input: UpdateContentPackAvailabilityDateInput;
}>;


export type UpdateContentPackAvailabilityDateMutation = { __typename: 'Mutation', updateContentPackAvailabilityDate: { __typename: 'ContentPackPayload', contentPack: { __typename: 'ContentPack', id: string, availabilityDate: any } } };

export type UpdateContentPackLastUpdateDateMutationVariables = Exact<{
  input: UpdateContentPackLastUpdateDateInput;
}>;


export type UpdateContentPackLastUpdateDateMutation = { __typename: 'Mutation', updateContentPackLastUpdateDate: { __typename: 'ContentPackPayload', contentPack: { __typename: 'ContentPack', id: string, lastUpdateDate: any } } };

export type UpdateCurationSongMutationVariables = Exact<{
  id: Scalars['ID'];
  contentPackId: Scalars['ID'];
  type: UpdateCurationSongInputType;
  value?: InputMaybe<Scalars['String']>;
  songInputId: Scalars['ID'];
}>;


export type UpdateCurationSongMutation = { __typename: 'Mutation', updateCurationSong: { __typename: 'CurationSongPayload', curationSong?: { __typename: 'CurationSong', id: string, isInvalid: boolean, displayTitle: string, displayArtist: string, movieTitle?: string | null, leadSinger?: string | null, jesterTitle?: string | null, composer?: string | null, songInput: { __typename: 'CurationSongInput', id: string } } | null } };

export type UpdatePlaylistCustomDisplayMutationVariables = Exact<{
  id: Scalars['ID'];
  contentPackId: Scalars['ID'];
  songInputId: Scalars['ID'];
  value?: InputMaybe<Scalars['String']>;
}>;


export type UpdatePlaylistCustomDisplayMutation = { __typename: 'Mutation', updateCurationSong: { __typename: 'CurationSongPayload', curationSong?: { __typename: 'CurationSong', id: string, isInvalid: boolean, playlistCustomDisplay?: string | null, songInput: { __typename: 'CurationSongInput', id: string } } | null } };

export type UpdateCurationSongSampleMutationVariables = Exact<{
  id: Scalars['ID'];
  contentPackId: Scalars['ID'];
  file?: InputMaybe<Scalars['Upload']>;
  url?: InputMaybe<Scalars['String']>;
  type: UpdateCurationSongSampleInputType;
  startingTime?: InputMaybe<Scalars['Float']>;
  songInputId: Scalars['ID'];
}>;


export type UpdateCurationSongSampleMutation = { __typename: 'Mutation', updateCurationSongSample?: { __typename: 'CurationSongPayload', curationSong?: { __typename: 'CurationSong', id: string, isInvalid: boolean, playlistCustomSample?: string | null, defaultSample: string, introSample?: string | null, songInput: { __typename: 'CurationSongInput', id: string } } | null } | null };

export type RemoveSongFromCurationContentPackMutationVariables = Exact<{
  id: Scalars['ID'];
  songInputId: Scalars['ID'];
}>;


export type RemoveSongFromCurationContentPackMutation = { __typename: 'Mutation', removeSongFromCurationContentPack: { __typename: 'CurationContentPackPayload', curationContentPack: { __typename: 'CurationContentPack', id: string, contentItems: Array<{ __typename: 'CurationQuizQuestion' } | { __typename: 'CurationSong', id: string, playlistCustomDisplay?: string | null, songInput: { __typename: 'CurationSongInput', id: string } } | { __typename: 'CurationSongInput', id: string }> } } };

export type RemoveSongsFromCurationContentPackMutationVariables = Exact<{
  id: Scalars['ID'];
  songInputIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type RemoveSongsFromCurationContentPackMutation = { __typename: 'Mutation', removeSongFromCurationContentPack: { __typename: 'CurationContentPackPayload', curationContentPack: { __typename: 'CurationContentPack', id: string, contentItems: Array<{ __typename: 'CurationQuizQuestion' } | { __typename: 'CurationSong', id: string, playlistCustomDisplay?: string | null, songInput: { __typename: 'CurationSongInput', id: string } } | { __typename: 'CurationSongInput', id: string }> } } };

export type RemoveSongsFromCommittedContentPackMutationVariables = Exact<{
  id: Scalars['ID'];
  songInputIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  updateCommittedPack?: InputMaybe<Scalars['Boolean']>;
}>;


export type RemoveSongsFromCommittedContentPackMutation = { __typename: 'Mutation', removeSongFromCurationContentPack: { __typename: 'CurationContentPackPayload', curationContentPack: { __typename: 'CurationContentPack', id: string, contentItems: Array<{ __typename: 'CurationQuizQuestion' } | { __typename: 'CurationSong', id: string, playlistCustomDisplay?: string | null, songInput: { __typename: 'CurationSongInput', id: string } } | { __typename: 'CurationSongInput', id: string }> } } };

export type ForceSongInputMatchingMutationVariables = Exact<{
  songInputId: Scalars['ID'];
  songId?: InputMaybe<Scalars['ID']>;
  itunesId?: InputMaybe<Scalars['Int']>;
  ddexSongId?: InputMaybe<Scalars['ID']>;
  contentPackId: Scalars['ID'];
}>;


export type ForceSongInputMatchingMutation = { __typename: 'Mutation', forceSongInputMatching: { __typename: 'ForceSongInputMatchingPayload', curationSong?: { __typename: 'CurationSong', id: string, isrc: string, title: string, artist: string, album: string, albumYear: number, label: string, subLabel?: string | null, defaultSample: string, picture: string, state: CurationSongState, isExplicit: boolean, questionableStatus?: SongQuestionableStatus | null, isDDEXSong: boolean, displayTitle: string, displayArtist: string, movieTitle?: string | null, jesterTitle?: string | null, leadSinger?: string | null, introSample?: string | null, composer?: string | null, isInvalid: boolean, playlistCustomDisplay?: string | null, songInput: { __typename: 'CurationSongInput', id: string, matchType?: SongInputMatchType | null } } | null, suggestedSong?: { __typename: 'CurationSong', id: string, title: string, artist: string, album: string, isrc: string } | null } };

export type UpdateCurationContentPackPictureMutationVariables = Exact<{
  input: UpdateCurationContentPackPictureInput;
}>;


export type UpdateCurationContentPackPictureMutation = { __typename: 'Mutation', updateCurationContentPackPicture: { __typename: 'CurationContentPackPayload', curationContentPack: { __typename: 'CurationContentPack', id: string, picture: string } } };

export type UpdateReplacingCurationContentPackMutationVariables = Exact<{
  input: UpdateReplacingCurationContentPackInput;
}>;


export type UpdateReplacingCurationContentPackMutation = { __typename: 'Mutation', updateReplacingCurationContentPack: { __typename: 'CurationContentPackPayload', curationContentPack: { __typename: 'CurationContentPack', id: string, replacingContentPack?: { __typename: 'CurationContentPack', id: string, originId: string, name: string, picture: string, description: string } | null } } };

export type ConvertSamplesMutationVariables = Exact<{
  input: ConvertSamplesInput;
}>;


export type ConvertSamplesMutation = { __typename: 'Mutation', convertSamples: { __typename: 'NoReturnMutationPayload', success: boolean, message?: string | null } };

export type ConvertToSp2SamplesMutationVariables = Exact<{
  input: ConvertToSp2SamplesInput;
}>;


export type ConvertToSp2SamplesMutation = { __typename: 'Mutation', convertToSp2Samples: { __typename: 'NoReturnMutationPayload', success: boolean, message?: string | null } };

export type RefreshSppContentMutationVariables = Exact<{
  input: RefreshSppContentInput;
}>;


export type RefreshSppContentMutation = { __typename: 'Mutation', refreshSppContent: { __typename: 'NoReturnMutationPayload', success: boolean, message?: string | null } };

export type AuthenticateGoogleSheetMutationVariables = Exact<{
  code: Scalars['String'];
}>;


export type AuthenticateGoogleSheetMutation = { __typename: 'Mutation', authenticateGoogleSheet: { __typename: 'NoReturnMutationPayload', success: boolean, message?: string | null } };

export type ExportCurationContentPackToSp2MutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ExportCurationContentPackToSp2Mutation = { __typename: 'Mutation', exportCurationContentPackToSp2: { __typename: 'CurationContentPackPayload', curationContentPack: { __typename: 'CurationContentPack', id: string, sp2ExportId?: string | null } } };

export type UpdateCurationContentPackPriceToSp2MutationVariables = Exact<{
  input: UpdateCurationContentPackPriceToSp2Input;
}>;


export type UpdateCurationContentPackPriceToSp2Mutation = { __typename: 'Mutation', updateCurationContentPackPriceToSp2: { __typename: 'SP2CurationContentPackPayload', sp2CurationPlaylist?: { __typename: 'SP2CurationPlaylist', id: string, price?: number | null } | null } };

export type UpdateCurationContentPackBadgesToSp2MutationVariables = Exact<{
  input: UpdateCurationContentPackBadgesToSp2Input;
}>;


export type UpdateCurationContentPackBadgesToSp2Mutation = { __typename: 'Mutation', updateCurationContentPackBadgesToSp2: { __typename: 'SP2CurationContentPackPayload', sp2CurationPlaylist?: { __typename: 'SP2CurationPlaylist', id: string, badges?: Array<string | null> | null } | null } };

export type CreateContentPackListMutationVariables = Exact<{
  input: CreateContentPackListInput;
}>;


export type CreateContentPackListMutation = { __typename: 'Mutation', createContentPackList: { __typename: 'ContentPackList', contentPackListId: string, name: string, description: string, contentPacks: Array<{ __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }> } };

export type UpdateContentPackListMutationVariables = Exact<{
  input: UpdateContentPackListInput;
}>;


export type UpdateContentPackListMutation = { __typename: 'Mutation', updateContentPackList?: { __typename: 'ContentPackList', contentPackListId: string, name: string, description: string, contentPacks: Array<{ __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }> } | null };

export type DeleteContentPackListMutationVariables = Exact<{
  contentPackListId: Scalars['ID'];
}>;


export type DeleteContentPackListMutation = { __typename: 'Mutation', deleteContentPackList: boolean };

export type CreateCurationContentPackListMutationVariables = Exact<{
  input: CreateCurationContentPackListInput;
}>;


export type CreateCurationContentPackListMutation = { __typename: 'Mutation', createCurationContentPackList: { __typename: 'CurationContentPackList', id: string, name: string, description: string, curationContentPacks: Array<{ __typename: 'CurationContentPack', id: string, originId: string, name: string, type: ContentPackType, picture: string, locale?: string | null, explicitContentStatus: ContentPackExplicitContentStatus, localeReplacements?: Array<{ __typename: 'CurationContentPack', id: string, name: string, originId: string, picture: string, type: ContentPackType, locale?: string | null }> | null }> } };

export type UpdateCurationContentPackListMutationVariables = Exact<{
  input: UpdateCurationContentPackListInput;
}>;


export type UpdateCurationContentPackListMutation = { __typename: 'Mutation', updateCurationContentPackList?: { __typename: 'CurationContentPackList', id: string, name: string, description: string, curationContentPacks: Array<{ __typename: 'CurationContentPack', id: string, originId: string, name: string, type: ContentPackType, picture: string, locale?: string | null, explicitContentStatus: ContentPackExplicitContentStatus, localeReplacements?: Array<{ __typename: 'CurationContentPack', id: string, name: string, originId: string, picture: string, type: ContentPackType, locale?: string | null }> | null }> } | null };

export type DeleteCurationContentPackListMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCurationContentPackListMutation = { __typename: 'Mutation', deleteCurationContentPackList: boolean };

export type UpdateCurationContentPackPictureToSp2MutationVariables = Exact<{
  input: UpdateCurationContentPackPictureToSp2Input;
}>;


export type UpdateCurationContentPackPictureToSp2Mutation = { __typename: 'Mutation', updateCurationContentPackPictureToSp2: { __typename: 'SP2CurationContentPackPayload', sp2CurationPlaylist?: { __typename: 'SP2CurationPlaylist', id: string, artwork?: string | null } | null } };

export type CommitSp2CurationPlaylistMutationVariables = Exact<{
  input: CommitSp2CurationPlaylistInput;
}>;


export type CommitSp2CurationPlaylistMutation = { __typename: 'Mutation', commitSP2CurationPlaylist: { __typename: 'SP2CurationContentPackPayload', sp2CurationPlaylist?: { __typename: 'SP2CurationPlaylist', id: string, isCommitInProgress?: boolean | null } | null } };

export type CrupdateSp2ReleaseMutationVariables = Exact<{
  input: CrupdateSp2ReleaseInput;
}>;


export type CrupdateSp2ReleaseMutation = { __typename: 'Mutation', crupdateSP2Release: { __typename: 'CrupdateSP2ReleasePayload', sp2Release?: { __typename: 'SP2ReleaseStatusRelease', id: string, visibleDate: any, state: string, type: string, playlistIds: Array<string> } | null } };

export type DeleteSp2ReleaseMutationVariables = Exact<{
  input: DeleteSp2ReleaseInput;
}>;


export type DeleteSp2ReleaseMutation = { __typename: 'Mutation', deleteSP2Release: { __typename: 'CrupdateSP2ReleasePayload', sp2Release?: { __typename: 'SP2ReleaseStatusRelease', id: string } | null } };

export type CreateCurationContentPackFromSp2MultiMutationVariables = Exact<{
  input: CreateCurationContentPackFromSp2MultiInput;
}>;


export type CreateCurationContentPackFromSp2MultiMutation = { __typename: 'Mutation', createCurationContentPackFromSp2Multi?: { __typename: 'CreateCurationContentPackFromSp2MultiPayload', success?: boolean | null } | null };

export type CreateBatchContentModerationMutationVariables = Exact<{
  input: CreateBatchContentModerationInput;
}>;


export type CreateBatchContentModerationMutation = { __typename: 'Mutation', createBatchContentModeration: { __typename: 'BatchContentModeration', id: string, name: string, state: BatchContentModerationState, curationContentPacks: Array<{ __typename: 'CurationContentPack', id: string, name: string, originId: string, picture: string }> } };

export type UpdateBatchContentModerationMutationVariables = Exact<{
  input: UpdateBatchContentModerationInput;
}>;


export type UpdateBatchContentModerationMutation = { __typename: 'Mutation', updateBatchContentModeration: { __typename: 'BatchContentModeration', id: string, name: string, state: BatchContentModerationState, curationContentPacks: Array<{ __typename: 'CurationContentPack', id: string, name: string, originId: string }> } };

export type StartBatchContentModerationMutationVariables = Exact<{
  input: StartBatchContentModerationInput;
}>;


export type StartBatchContentModerationMutation = { __typename: 'Mutation', startBatchContentModeration: { __typename: 'BatchContentModeration', id: string, name: string, state: BatchContentModerationState } };

export type EndBatchContentModerationMutationVariables = Exact<{
  input: EndBatchContentModerationInput;
}>;


export type EndBatchContentModerationMutation = { __typename: 'Mutation', endBatchContentModeration: { __typename: 'BatchContentModeration', id: string, name: string, state: BatchContentModerationState } };

export type ModerateContentItemMutationVariables = Exact<{
  input: ModerateContentItemInput;
}>;


export type ModerateContentItemMutation = { __typename: 'Mutation', moderateContentItem: { __typename: 'ModeratedContentItem', id: string, state: ModeratedContentItemState, note?: string | null } };

export type AdminModerateContentItemMutationVariables = Exact<{
  input: AdminModerateContentItemInput;
}>;


export type AdminModerateContentItemMutation = { __typename: 'Mutation', adminModerateContentItem: { __typename: 'ModeratedContentItem', id: string, state: ModeratedContentItemState, adminState?: ModeratedContentItemState | null } };

export type UpdateLocaleForModerationContentItemMutationVariables = Exact<{
  input: UpdateLocaleForModerationContentItemInput;
}>;


export type UpdateLocaleForModerationContentItemMutation = { __typename: 'Mutation', updateLocaleForModerationContentItem: { __typename: 'ModeratedContentItem', id: string, state: ModeratedContentItemState, locale: string } };

export type SetModeratorToContentPackMutationVariables = Exact<{
  input: SetModeratorToContentPack;
}>;


export type SetModeratorToContentPackMutation = { __typename: 'Mutation', setModeratorToContentPack?: { __typename: 'BatchContentModerationPack', id: string, curationContentPack: { __typename: 'CurationContentPack', id: string }, moderator?: { __typename: 'User', id: string } | null } | null };

export type ImportSongsFromContentPackListToHurdleCatalogMutationVariables = Exact<{
  input: ImportSongsFromContentPackListToHurdleCatalogInput;
}>;


export type ImportSongsFromContentPackListToHurdleCatalogMutation = { __typename: 'Mutation', importSongsFromContentPackListToHurdleCatalog: { __typename: 'ImportSongsFromContentPackListToHurdleCatalogPayload', newSongsImported: number, alreadyInCatalogNumber: number, excludedExplicitItemsNumber: number, excludedQuestionableItemsNumber: number, excludedBannedItemsNumber: number, inSeveralNewContentPacksNumber: number } };

export type UpdateHurdleCatalogItemMutationVariables = Exact<{
  input: UpdateHurdleCatalogItemInput;
}>;


export type UpdateHurdleCatalogItemMutation = { __typename: 'Mutation', updateHurdleCatalogItem: { __typename: 'UpdateHurdleCatalogItemPayload', catalogItem: { __typename: 'HurdleCatalogItem', id: string, categoryId?: string | null, excludeFromAutogeneration?: boolean | null, excludeFromCheck?: boolean | null, offset: number, addedAt: any, removed?: boolean | null, item: { __typename: 'HurdleSongItem', id: string, asset: string, song?: { __typename: 'Song', id: string, title: string, artist: string, picture?: string | null } | null } } } };

export type DeleteHurdleCatalogItemMutationVariables = Exact<{
  input: DeleteHurdleCatalogItemInput;
}>;


export type DeleteHurdleCatalogItemMutation = { __typename: 'Mutation', deleteHurdleCatalogItem: { __typename: 'DeleteHurdleCatalogItemPayload', deleted: boolean } };

export type FlushHurdleCacheMutationVariables = Exact<{ [key: string]: never; }>;


export type FlushHurdleCacheMutation = { __typename: 'Mutation', flushHurdleCache: { __typename: 'FlushHurdleCachePayload', flushed: boolean } };

export type IngestStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type IngestStatusQuery = { __typename: 'Query', curation: { __typename: 'Curation', id: string, ingestStatus?: { __typename: 'CurationTask', id: string, resultUrl?: string | null, created: any, status: CurationTaskStatus, errorMessage?: string | null } | null } };

export type GetTasksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTasksQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', missionTasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, paramsDescriptions: Array<string>, description?: string | null, params: Array<{ __typename: 'MissionParamContentCategory' } | { __typename: 'MissionParamContentPack' } | { __typename: 'MissionParamFloat' } | { __typename: 'MissionParamHour24' } | { __typename: 'MissionParamInt' } | { __typename: 'MissionParamSong' } | { __typename: 'MissionParamString' } | { __typename: 'MissionParamType', typeName: string }> }> } };

export type GetCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCategoriesQuery = { __typename: 'Query', app: { __typename: 'App', contentCategories: Array<{ __typename: 'ContentCategory', id: string, name: string }> } };

export type ContentPacksQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type ContentPacksQuery = { __typename: 'Query', curation: { __typename: 'Curation', id: string, contentPacks: { __typename: 'CurationContentPacksPaginated', totalCount: number, list: Array<{ __typename: 'CurationContentPack', id: string, originId: string, name: string, picture: string, created: any, state?: CurationContentPackState | null, explicitContentStatus: ContentPackExplicitContentStatus, sp2Only?: boolean | null }> } } };

export type CurationContentPacksByNameQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type CurationContentPacksByNameQuery = { __typename: 'Query', curationContentPacksByName: Array<{ __typename: 'CurationContentPack', id: string, originId: string, name: string, picture: string, created: any, state?: CurationContentPackState | null, type: ContentPackType, locale?: string | null, explicitContentStatus: ContentPackExplicitContentStatus }> };

export type CurationContentPacksCsvExportQueryVariables = Exact<{ [key: string]: never; }>;


export type CurationContentPacksCsvExportQuery = { __typename: 'Query', curation: { __typename: 'Curation', id: string, contentPackCsvExport: { __typename: 'CurationCsvExport', content: string } } };

export type CatalogExportQueryVariables = Exact<{ [key: string]: never; }>;


export type CatalogExportQuery = { __typename: 'Query', curation: { __typename: 'Curation', id: string, catalogExport?: { __typename: 'CurationTask', id: string, status: CurationTaskStatus, created: any, started?: any | null, completed?: any | null, available?: any | null } | null } };

export type LegalConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type LegalConfigQuery = { __typename: 'Query', curation: { __typename: 'Curation', id: string, legalConfig: { __typename: 'CurationLegalConfig', blacklistedArtists: Array<string>, whitelistedLabels: Array<{ __typename: 'CurationLegalConfigLabel', id: string, blacklistedArtists: Array<string>, blacklistedSubLabels: Array<string> }>, blacklistedTitles: Array<{ __typename: 'CurationBlacklistedTitle', title: string, artist: string }>, whitelistedTitles: Array<{ __typename: 'CurationBlacklistedTitle', title: string, artist: string }>, blacklistedLabels: Array<{ __typename: 'CurationLegalConfigBlacklistedLabel', id: string, whitelistedSubLabels: Array<string> }> } } };

export type CurationContentPackByOriginIdQueryVariables = Exact<{
  originId: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
}>;


export type CurationContentPackByOriginIdQuery = { __typename: 'Query', curationContentPack: { __typename: 'CurationContentPack', id: string, originId: string } };

export type CurationContentPackQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CurationContentPackQuery = { __typename: 'Query', curationContentPack: { __typename: 'CurationContentPack', id: string, name: string, picture: string, description: string, originId: string, adultOnly: boolean, sp2Only?: boolean | null, state?: CurationContentPackState | null, version: number, locale?: string | null, created: any, committed?: any | null, deleted?: any | null, selectedCustomFields: Array<CurationContentPackCustomField>, externalURI?: string | null, explicitContentStatus: ContentPackExplicitContentStatus, type: ContentPackType, sp2ExportId?: string | null, sp2LastExportDate?: any | null, sp2LastExportedVersion?: number | null, contentPack?: { __typename: 'ContentPack', id: string, availabilityDate: any, availabilityType: ContentPackAvailabilityType, lastUpdateDate: any, adminSpecialEvents: Array<{ __typename: 'SpecialEvent', id: string, name: string, startDate: any, endDate: any }> } | null, contentItems: Array<{ __typename: 'CurationQuizQuestion' } | { __typename: 'CurationSong', id: string, isrc: string, title: string, artist: string, album: string, albumYear: number, label: string, subLabel?: string | null, defaultSample: string, picture: string, state: CurationSongState, isExplicit: boolean, questionableStatus?: SongQuestionableStatus | null, isDDEXSong: boolean, displayTitle: string, displayArtist: string, movieTitle?: string | null, jesterTitle?: string | null, leadSinger?: string | null, introSample?: string | null, composer?: string | null, playlistCustomDisplay?: string | null, playlistCustomSample?: string | null, isInvalid: boolean, songInput: { __typename: 'CurationSongInput', id: string, matchType?: SongInputMatchType | null } } | { __typename: 'CurationSongInput', id: string, title: string, artist: string, album: string, songInputIsrc?: string | null }>, categories: Array<{ __typename: 'ContentCategory', id: string, name: string }>, replacingContentPack?: { __typename: 'CurationContentPack', id: string, originId: string, name: string, description: string, picture: string } | null } };

export type CurationContentPackWithExternalLinksQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CurationContentPackWithExternalLinksQuery = { __typename: 'Query', curationContentPack: { __typename: 'CurationContentPack', id: string, name: string, state?: CurationContentPackState | null, version: number, contentItems: Array<{ __typename: 'CurationQuizQuestion' } | { __typename: 'CurationSong', id: string, isrc: string, title: string, artist: string, album: string, albumYear: number, label: string, subLabel?: string | null, defaultSample: string, picture: string, state: CurationSongState, isExplicit: boolean, questionableStatus?: SongQuestionableStatus | null, isDDEXSong: boolean, displayTitle: string, displayArtist: string, movieTitle?: string | null, jesterTitle?: string | null, leadSinger?: string | null, introSample?: string | null, composer?: string | null, playlistCustomDisplay?: string | null, isInvalid: boolean, externalLinks: { __typename: 'CurationSongExternalLinks', itunes: { __typename: 'CurationSongExternalLinksByStore', us?: string | null, gb?: string | null, fr?: string | null, br?: string | null, de?: string | null, es?: string | null }, spotify: { __typename: 'CurationSongExternalLinksByStore', us?: string | null, gb?: string | null, fr?: string | null, br?: string | null, de?: string | null, es?: string | null } }, songInput: { __typename: 'CurationSongInput', id: string, matchType?: SongInputMatchType | null }, ddexSong?: { __typename: 'DDEXSong', id: string, label: string, subLabel: string, isrc: string, title: string, artist: string, album: string, albumId: string, releaseDate: any, isWhitelisted: boolean, artwork: string, sample: string, isExplicit: boolean } | null } | { __typename: 'CurationSongInput', id: string, title: string, artist: string, album: string, songInputIsrc?: string | null }>, categories: Array<{ __typename: 'ContentCategory', id: string, name: string }> } };

export type CurationContentItemQueryVariables = Exact<{
  id: Scalars['ID'];
  contentPackId: Scalars['ID'];
  songInputId?: InputMaybe<Scalars['ID']>;
}>;


export type CurationContentItemQuery = { __typename: 'Query', curationContentItem: { __typename: 'CurationQuizQuestion' } | { __typename: 'CurationSong', id: string, isrc: string, title: string, artist: string, album: string, albumYear: number, label: string, subLabel?: string | null, defaultSample: string, picture: string, state: CurationSongState, isExplicit: boolean, questionableStatus?: SongQuestionableStatus | null, isDDEXSong: boolean, displayTitle: string, displayArtist: string, movieTitle?: string | null, jesterTitle?: string | null, leadSinger?: string | null, introSample?: string | null, composer?: string | null, itunesId?: number | null, playlistCustomDisplay?: string | null, playlistCustomSample?: string | null, isInvalid: boolean, stateDetail?: CurationSongStateDetail | null, isItunesSong: boolean, ddexFullSample?: string | null, externalLinks: { __typename: 'CurationSongExternalLinks', itunes: { __typename: 'CurationSongExternalLinksByStore', us?: string | null, gb?: string | null, fr?: string | null, br?: string | null, de?: string | null, es?: string | null }, spotify: { __typename: 'CurationSongExternalLinksByStore', us?: string | null, gb?: string | null, fr?: string | null, br?: string | null, de?: string | null, es?: string | null } }, songInput: { __typename: 'CurationSongInput', id: string, title: string, album: string, artist: string, isrc?: string | null, matchType?: SongInputMatchType | null }, ddexSong?: { __typename: 'DDEXSong', id: string, label: string, subLabel: string, isrc: string, title: string, artist: string, album: string, albumId: string, releaseDate: any, isWhitelisted: boolean, artwork: string, sample: string, isExplicit: boolean } | null } | { __typename: 'CurationSongInput' } };

export type CurationContentItemDdexQueryVariables = Exact<{
  id: Scalars['ID'];
  songInputId?: InputMaybe<Scalars['ID']>;
}>;


export type CurationContentItemDdexQuery = { __typename: 'Query', curationContentItem: { __typename: 'CurationQuizQuestion' } | { __typename: 'CurationSong', id: string, songInput: { __typename: 'CurationSongInput', id: string }, ddexSong?: { __typename: 'DDEXSong', id: string, label: string, subLabel: string, isrc: string, title: string, artist: string, album: string, albumId: string, releaseDate: any, isWhitelisted: boolean, artwork: string, sample: string, isExplicit: boolean } | null } | { __typename: 'CurationSongInput' } };

export type CurationContentItemItunesQueryVariables = Exact<{
  id: Scalars['ID'];
  songInputId?: InputMaybe<Scalars['ID']>;
}>;


export type CurationContentItemItunesQuery = { __typename: 'Query', curationContentItem: { __typename: 'CurationQuizQuestion' } | { __typename: 'CurationSong', id: string, songInput: { __typename: 'CurationSongInput', id: string }, itunesSong?: { __typename: 'ItunesSong', id: string, title: string, artist: string, album: string, albumId: string, albumArtwork?: string | null, albumYear: number, isWhitelisted: boolean, parentalAdvisory: ItunesParentalAdvisory, sample: string, isrc: string, label: string, subLabel?: string | null } | null } | { __typename: 'CurationSongInput' } };

export type CurationSongDatabaseSearchQueryVariables = Exact<{
  term: CurationSongSearchTerm;
  includesContentPacks: Scalars['Boolean'];
}>;


export type CurationSongDatabaseSearchQuery = { __typename: 'Query', curationSongDatabaseSearch: Array<{ __typename: 'CurationSongInput', id: string, title: string, album: string, artist: string, isrc?: string | null, matchType?: SongInputMatchType | null, curationSong?: { __typename: 'CurationSong', id: string, isrc: string, title: string, artist: string, album: string, albumYear: number, label: string, subLabel?: string | null, defaultSample: string, picture: string, state: CurationSongState, isExplicit: boolean, questionableStatus?: SongQuestionableStatus | null, isDDEXSong: boolean } | null, curationContentPacks: Array<{ __typename: 'CurationContentPack', id: string, originId: string, version: number, name: string, state?: CurationContentPackState | null }>, contentPacks?: Array<{ __typename: 'ContentPack', id: string, name: string }> }> };

export type CurationSongDdexSearchQueryVariables = Exact<{
  term: CurationSongSearchTerm;
}>;


export type CurationSongDdexSearchQuery = { __typename: 'Query', curationSongDDEXSearch: Array<{ __typename: 'DDEXSong', id: string, label: string, subLabel: string, isrc: string, title: string, artist: string, album: string, albumId: string, releaseDate: any, isWhitelisted: boolean, artwork: string, sample: string, isExplicit: boolean, territoryCodes: Array<string>, alternativeSongs: Array<{ __typename: 'DDEXSong', territoryCodes: Array<string> }> }> };

export type CurationSongDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CurationSongDetailsQuery = { __typename: 'Query', curationContentItem: { __typename: 'CurationQuizQuestion' } | { __typename: 'CurationSong', id: string, isrc: string, title: string, artist: string, album: string, albumYear: number, label: string, subLabel?: string | null, defaultSample: string, picture: string, state: CurationSongState, isExplicit: boolean, questionableStatus?: SongQuestionableStatus | null, isDDEXSong: boolean, displayTitle: string, displayArtist: string, movieTitle?: string | null, jesterTitle?: string | null, leadSinger?: string | null, introSample?: string | null, composer?: string | null, externalLinks: { __typename: 'CurationSongExternalLinks', itunes: { __typename: 'CurationSongExternalLinksByStore', us?: string | null, gb?: string | null, fr?: string | null, br?: string | null, de?: string | null, es?: string | null }, spotify: { __typename: 'CurationSongExternalLinksByStore', us?: string | null, gb?: string | null, fr?: string | null, br?: string | null, de?: string | null, es?: string | null } } } | { __typename: 'CurationSongInput' } };

export type GetContentPackListsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContentPackListsQuery = { __typename: 'Query', contentPackLists: { __typename: 'ContentPackListPaginated', list: Array<{ __typename: 'ContentPackList', contentPackListId: string, name: string }> } };

export type GetContentPackListQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetContentPackListQuery = { __typename: 'Query', contentPackList?: { __typename: 'ContentPackList', contentPackListId: string, name: string, description: string, contentPacks: Array<{ __typename: 'ContentPack', id: string, name: string, picture?: string | null, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }> } | null };

export type GetCurationContentPackListsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurationContentPackListsQuery = { __typename: 'Query', curationContentPackLists: { __typename: 'CurationContentPackListPaginated', list: Array<{ __typename: 'CurationContentPackList', id: string, name: string }> } };

export type GetCurationContentPackListQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCurationContentPackListQuery = { __typename: 'Query', curationContentPackList?: { __typename: 'CurationContentPackList', id: string, name: string, description: string, curationContentPacks: Array<{ __typename: 'CurationContentPack', id: string, originId: string, name: string, type: ContentPackType, picture: string, locale?: string | null, adultOnly: boolean, explicitContentStatus: ContentPackExplicitContentStatus, localeReplacements?: Array<{ __typename: 'CurationContentPack', id: string, name: string, originId: string, picture: string, type: ContentPackType, locale?: string | null }> | null }> } | null };

export type SearchContentPacksQueryVariables = Exact<{
  search: Scalars['String'];
  searchType: ContentSearchType;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type SearchContentPacksQuery = { __typename: 'Query', searchContentPacks: { __typename: 'ContentPackPaginated', totalCount: number, hasMore: boolean, list: Array<{ __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }> } };

export type SearchUserContentPacksQueryVariables = Exact<{
  search: Scalars['String'];
  searchType: ContentSearchType;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type SearchUserContentPacksQuery = { __typename: 'Query', searchUserContentPacks: { __typename: 'UserContentPackPaginated', totalCount: number, hasMore: boolean, list: Array<{ __typename: 'UserContentPack', id: string, contentPack: { __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null } }> } };

export type Sp2CurationPlaylistQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type Sp2CurationPlaylistQuery = { __typename: 'Query', sp2CurationPlaylist?: { __typename: 'SP2CurationPlaylist', id: string, name?: string | null, badges?: Array<string | null> | null, price?: number | null, masteryRaceStarted?: boolean | null, availableBadges: Array<string>, artwork?: string | null, lastCommitted?: any | null, created?: any | null, isCommitInProgress?: boolean | null, productionPlaylistId?: string | null, pageUrl?: string | null } | null };

export type Sp2ReleaseStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type Sp2ReleaseStatusQuery = { __typename: 'Query', sp2ReleaseStatus: { __typename: 'SP2ReleaseStatus', id: string, playlists: Array<{ __typename: 'SP2ReleaseStatusPlaylist', id: string, name: string, visible: boolean, created?: any | null, runningRace: boolean }>, releases: Array<{ __typename: 'SP2ReleaseStatusRelease', id: string, visibleDate: any, state: string, type: string, playlistIds: Array<string> }> } };

export type Sp2PlaylistsQueryVariables = Exact<{
  input: Sp2PlaylistsParams;
}>;


export type Sp2PlaylistsQuery = { __typename: 'Query', sp2Playlists?: { __typename: 'Sp2PlaylistsResult', startDate: string, endDate: string, pageSize?: number | null, currentCursor?: string | null, nextCursor?: string | null, playlists: Array<{ __typename: 'Sp2PlaylistsItem', name: string, id: string, productionPlaylistId: string, artwork?: string | null, releasedAt: any, lastCommittedAt: any, contentPackId?: string | null, exportedAt?: any | null, state?: string | null }> } | null };

export type BatchContentModerationListQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationParams>;
}>;


export type BatchContentModerationListQuery = { __typename: 'Query', batchContentModerationList: { __typename: 'BatchContentModerationPaginated', list: Array<{ __typename: 'BatchContentModeration', id: string, name: string, stats: Array<{ __typename: 'BatchContentModerationStats', id: string, locale: string, totalCount: number, totalDone: number }>, packs: Array<{ __typename: 'BatchContentModerationPack', id: string, curationContentPack: { __typename: 'CurationContentPack', id: string, name: string, originId: string }, moderator?: { __typename: 'User', id: string, displayName: string, picture?: string | null, emailCredential?: string | null } | null }> }> } };

export type BatchContentModerationListStatsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationParams>;
}>;


export type BatchContentModerationListStatsQuery = { __typename: 'Query', batchContentModerationList: { __typename: 'BatchContentModerationPaginated', list: Array<{ __typename: 'BatchContentModeration', id: string, name: string, stats: Array<{ __typename: 'BatchContentModerationStats', id: string, locale: string, totalCount: number, totalDone: number }> }> } };

export type BatchContentModerationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BatchContentModerationQuery = { __typename: 'Query', batchContentModeration: { __typename: 'BatchContentModeration', id: string, name: string, state: BatchContentModerationState, curationContentPacks: Array<{ __typename: 'CurationContentPack', id: string, name: string, originId: string, picture: string }>, stats: Array<{ __typename: 'BatchContentModerationStats', id: string, locale: string, totalCount: number, totalDone: number }>, moderators: Array<{ __typename: 'BatchContentModerator', id: string, totalDone: number, user: { __typename: 'User', id: string, displayName: string, picture?: string | null, emailCredential?: string | null } }> } };

export type BatchContentModerationErrorContentItemsQueryVariables = Exact<{
  id: Scalars['ID'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type BatchContentModerationErrorContentItemsQuery = { __typename: 'Query', batchContentModeration: { __typename: 'BatchContentModeration', id: string, errorReportedContentItems: { __typename: 'ModeratedContentItemPaginated', hasMore: boolean, totalCount: number, list: Array<{ __typename: 'ModeratedContentItem', id: string, note?: string | null, noteType?: ModeratedContentItemNoteType | null, locale: string, state: ModeratedContentItemState, adminState?: ModeratedContentItemState | null, moderator?: { __typename: 'User', id: string, emailCredential?: string | null } | null, curationContentPack?: { __typename: 'CurationContentPack', id: string, originId: string, name: string } | null, contentItem: { __typename: 'CurationQuizQuestion' } | { __typename: 'CurationSong', id: string, isrc: string, itunesId?: number | null, title: string, artist: string, displayTitle: string, displayArtist: string, picture: string, defaultSample: string, isExplicit: boolean } | { __typename: 'CurationSongInput' } }> } } };

export type ModerationContentItemsQueryVariables = Exact<{
  batchId: Scalars['ID'];
  locale: Scalars['String'];
  packId?: InputMaybe<Scalars['ID']>;
  pagination?: InputMaybe<PaginationParams>;
}>;


export type ModerationContentItemsQuery = { __typename: 'Query', moderationContentItems?: { __typename: 'ModeratedContentItemPaginated', totalCount: number, list: Array<{ __typename: 'ModeratedContentItem', id: string, note?: string | null, noteType?: ModeratedContentItemNoteType | null, locale: string, state: ModeratedContentItemState, adminState?: ModeratedContentItemState | null, contentItem: { __typename: 'CurationQuizQuestion' } | { __typename: 'CurationSong', id: string, isrc: string, itunesId?: number | null, displayTitle: string, displayArtist: string, title: string, artist: string, picture: string, defaultSample: string, isExplicit: boolean } | { __typename: 'CurationSongInput' } }> } | null };

export type CheckMusicReportStatusQueryVariables = Exact<{
  month: Scalars['Int'];
  year: Scalars['Int'];
}>;


export type CheckMusicReportStatusQuery = { __typename: 'Query', checkMusicReportStatus: { __typename: 'CheckMusicReportStatusPayload', exportStatusSPPJP?: string | null, exportStatusSP?: string | null, exportStatusAll?: string | null, exportPostProcess?: string | null } };

export type CombinedMusicReportStatusByDateQueryVariables = Exact<{
  month: Scalars['Int'];
  year: Scalars['Int'];
}>;


export type CombinedMusicReportStatusByDateQuery = { __typename: 'Query', combinedMusicReportStatusByDate: { __typename: 'MusicReportPayload', report?: { __typename: 'MusicReport', id: string, created: any, formattedDate: string, jobIdStep2?: string | null, jobIdStep3?: string | null, sp2StatusDone: boolean, sp3StatusDone: boolean, step6StatusDone: boolean, completed?: any | null, lastSuccessStep: string } | null } };

export type CheckCombinedReportStatusQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type CheckCombinedReportStatusQuery = { __typename: 'Query', combinedMusicReportStatus: { __typename: 'MusicReportPayload', report?: { __typename: 'MusicReport', id: string, created: any, formattedDate: string, jobIdStep2?: string | null, jobIdStep3?: string | null, sp2StatusDone: boolean, sp3StatusDone: boolean, step6StatusDone: boolean, completed?: any | null, lastSuccessStep: string } | null } };

export type LyricsQueryVariables = Exact<{
  title: Scalars['String'];
  artist: Scalars['String'];
}>;


export type LyricsQuery = { __typename: 'Query', lyrics: { __typename: 'LyricsResult', id: string, lyricsData?: { __typename: 'LyricsData', id: string, url: string, artist: string, title: string, songImageUrl?: string | null, embedScriptUrl: string } | null } };

export type HurdleCatalogItemListQueryVariables = Exact<{
  input: HurdleCatalogItemListInput;
}>;


export type HurdleCatalogItemListQuery = { __typename: 'Query', hurdleCatalogItemList: { __typename: 'HurdleCatalogItemListPayload', hasMore: boolean, totalCount: number, list: Array<{ __typename: 'HurdleCatalogItem', id: string, categoryId?: string | null, excludeFromAutogeneration?: boolean | null, excludeFromCheck?: boolean | null, offset: number, addedAt: any, removed?: boolean | null, item: { __typename: 'HurdleSongItem', id: string, asset: string, song?: { __typename: 'Song', id: string, title: string, artist: string, picture?: string | null } | null } }> } };

export type GetLogsQueryVariables = Exact<{
  userID?: InputMaybe<Scalars['ID']>;
  installID?: InputMaybe<Scalars['ID']>;
  startDate: Scalars['Date'];
}>;


export type GetLogsQuery = { __typename: 'Query', analytics: { __typename: 'Analytics', id: string, appSessions: { __typename: 'AnalyticsBigQueryPayload', data?: Array<string> | null } } };

export type GetSessionLogsQueryVariables = Exact<{
  sessionID: Scalars['ID'];
  sessionDate: Scalars['Date'];
}>;


export type GetSessionLogsQuery = { __typename: 'Query', analytics: { __typename: 'Analytics', id: string, appLogsBySession: { __typename: 'AnalyticsSessionResult', frontendLogs?: { __typename: 'AnalyticsBigQueryPayload', data?: Array<string> | null, error?: string | null } | null, backendLogs?: { __typename: 'AnalyticsBigQueryPayload', data?: Array<string> | null, error?: string | null } | null, crashLogs?: { __typename: 'AnalyticsBigQueryPayload', data?: Array<string> | null, error?: string | null } | null } } };

export type GetRuntimeLogsQueryVariables = Exact<{
  runtimeID: Scalars['ID'];
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  startDate?: InputMaybe<Scalars['Date']>;
}>;


export type GetRuntimeLogsQuery = { __typename: 'Query', analytics: { __typename: 'Analytics', id: string, backendLogsByRuntime: { __typename: 'AnalyticsBigQueryPayload', data?: Array<string> | null } } };

export type GetUserQueryVariables = Exact<{
  property: Scalars['String'];
  type: UserSearchType;
}>;


export type GetUserQuery = { __typename: 'Query', user?: { __typename: 'User', id: string, displayName: string, picture?: string | null, subscriptionTier?: UserSubscriptionTier | null, phoneCredential?: string | null, emailCredential?: string | null, facebookCredential?: string | null, appleCredential?: string | null, googleCredential?: string | null, userLevel: number, userLevelProgressToNextLevel: number, coinBalance: number, diamondBalance: number, stampCards: number, totalStampCardsEarned: number, energySystems: { __typename: 'EnergySystems', tournamentTicket: { __typename: 'EnergySystem', extraBalance?: number | null } }, basicTierContentPack: { __typename: 'UserContentPack', contentPack: { __typename: 'ContentPack', name: string } }, ABTestList: Array<{ __typename: 'ABTest', id: string, variation: string }> } | null };

export type GetUsersFromSessionQueryVariables = Exact<{
  properties: Array<Scalars['String']> | Scalars['String'];
  type: UserSearchType;
}>;


export type GetUsersFromSessionQuery = { __typename: 'Query', users: Array<{ __typename: 'User', id: string, displayName: string, picture?: string | null, subscriptionTier?: UserSubscriptionTier | null, phoneCredential?: string | null, emailCredential?: string | null, facebookCredential?: string | null, appleCredential?: string | null, googleCredential?: string | null, userLevel: number, userLevelProgressToNextLevel: number, coinBalance: number, diamondBalance: number, basicTierContentPack: { __typename: 'UserContentPack', contentPack: { __typename: 'ContentPack', name: string } }, ABTestList: Array<{ __typename: 'ABTest', id: string, variation: string }> }> };

export type BanUserMutationVariables = Exact<{
  input: BanUserInput;
}>;


export type BanUserMutation = { __typename: 'Mutation', banUser: { __typename: 'BanPlayedPayload', user: { __typename: 'User', id: string, displayName: string, picture?: string | null, role: UserRole } } };

export type UnbanUserMutationVariables = Exact<{
  input: UnbanUserInput;
}>;


export type UnbanUserMutation = { __typename: 'Mutation', unbanUser: { __typename: 'UnbanUserPayload', user: { __typename: 'User', id: string, role: UserRole } } };

export type ForceUserTestMutationVariables = Exact<{
  input: ForceUserAbTestInput;
}>;


export type ForceUserTestMutation = { __typename: 'Mutation', forceUserABTest: { __typename: 'ForceUserABTestPayload', user: { __typename: 'User', id: string, ABTestList: Array<{ __typename: 'ABTest', id: string, variation: string }>, ABTestForcedList: Array<{ __typename: 'ABTest', id: string }> } } };

export type ResetUserSubscriptionsMutationVariables = Exact<{
  input: ResetUserSubscriptionsInput;
}>;


export type ResetUserSubscriptionsMutation = { __typename: 'Mutation', resetUserSubscriptions: { __typename: 'ResetUserSubscriptionsPayload', user: { __typename: 'User', id: string, displayName: string, picture?: string | null, lastOnline?: any | null, emailCredential?: string | null, subscriptionTier?: UserSubscriptionTier | null, userLevel: number, userLevelProgressToNextLevel: number, coinBalance: number, diamondBalance: number, claimedUpdateGiftId?: string | null, vipDays: number, premiumDays: number, liveEventCurrency?: number | null, boostRemove2Balance: number, boostTeamSpiritBalance: number, boostReviveBalance: number, boostNinjaBalance: number, boostBombBalance: number, boostSpeedsterBalance: number, boostArtistOnlyBalance: number, boostHurdleHintBalance: number, stampCards: number, totalStampCardsEarned: number, role: UserRole, accoladeBalance: number, freeSpins: number, subscriptionDetails?: { __typename: 'SubscriptionDetails', sku: string, autoRenews: boolean, activeSince: any, expires: any, isFreeTrial: boolean } | null, currentUserMonthlyPass: { __typename: 'UserMonthlyPass', progressToNextLevel: number, level: number, missions?: { __typename: 'UserMonthlyPassMissions', id: string, extraMissionNo?: number | null, dailyMissions: Array<{ __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } }>, monthlyMissions: Array<{ __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } }>, extraMission?: { __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } } | null } | null }, achievementMissions?: { __typename: 'UserAchievementMissions', id: string, missions: Array<{ __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } }> } | null, energySystems: { __typename: 'EnergySystems', tournamentTicket: { __typename: 'EnergySystem', currentCapSupply: number, extraBalance?: number | null }, coin: { __typename: 'EnergySystem', currentCapSupply: number }, xp: { __typename: 'EnergySystem', currentCapSupply: number }, liveEventTicket: { __typename: 'EnergySystem', currentCapSupply: number } }, basicTierContentPack: { __typename: 'UserContentPack', id: string, level: number, progressToNextLevel: number, contentPack: { __typename: 'ContentPack', id: string, name: string, picture?: string | null } }, fragmentBalance: Array<{ __typename: 'CurrencyCategoryFragment', id: string, amount: number, category: { __typename: 'ContentCategory', id: string, name: string } }>, stickers: Array<{ __typename: 'Sticker', id: string }>, profileFrames: Array<{ __typename: 'ProfileFrame', id: string }>, appSkins: Array<{ __typename: 'AppSkin', id: string }>, ABTestList: Array<{ __typename: 'ABTest', id: string, variation: string }>, ABTestForcedList: Array<{ __typename: 'ABTest', id: string }>, ABTestConfigs: Array<{ __typename: 'ABTestConfig', id: string, variations: Array<string>, status: AbTestStatus }>, ABTestLastAppInstallList: Array<{ __typename: 'ABTest', id: string, variation: string }>, reports: Array<{ __typename: 'UserReport', created: any, comment?: string | null, reporter: { __typename: 'User', id: string } }>, unlimitedBoosts: { __typename: 'UnlimitedBoosts', unlimitedBoostRemove2Balance: number, unlimitedBoostSpeedsterBalance: number }, loyalty: { __typename: 'Loyalty', tradeableCardCount: number, cardStreak: number, dayStreak: number, previousCardStreak?: number | null, futureCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null, currentCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null, previousCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null }, ownedContentPacks: { __typename: 'UserContentPacksPaginated', list: Array<{ __typename: 'UserContentPack', contentPack: { __typename: 'ContentPack', id: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null, name: string } }> }, currentSpecialEvent?: { __typename: 'SpecialEvent', id: string, meScoreDetails: Array<{ __typename: 'SpecialEventScoreDetail', type: SpecialEventScoreDetailType, score: number }> } | null, piggyBank: { __typename: 'PiggyBank', coins?: number | null, diamonds?: number | null }, metaFragments: { __typename: 'MetaFragments', BRONZE?: { __typename: 'MetaFragmentAmount', amount?: number | null } | null, SILVER?: { __typename: 'MetaFragmentAmount', amount?: number | null } | null, GOLD?: { __typename: 'MetaFragmentAmount', amount?: number | null } | null }, shards: { __typename: 'Shards', BRONZE?: number | null, SILVER?: number | null, GOLD?: number | null }, team?: { __typename: 'Team', id: string } | null, calendars: Array<{ __typename: 'PaidCalendar', id: string, name: string }> } } };

export type SetSubscriptionExpiresMutationVariables = Exact<{
  input: SetSubscriptionExpiresInput;
}>;


export type SetSubscriptionExpiresMutation = { __typename: 'Mutation', setSubscriptionExpires: { __typename: 'SetSubscriptionExpiresPayload', user: { __typename: 'User', id: string, displayName: string, picture?: string | null, lastOnline?: any | null, emailCredential?: string | null, subscriptionTier?: UserSubscriptionTier | null, userLevel: number, userLevelProgressToNextLevel: number, coinBalance: number, diamondBalance: number, claimedUpdateGiftId?: string | null, vipDays: number, premiumDays: number, liveEventCurrency?: number | null, boostRemove2Balance: number, boostTeamSpiritBalance: number, boostReviveBalance: number, boostNinjaBalance: number, boostBombBalance: number, boostSpeedsterBalance: number, boostArtistOnlyBalance: number, boostHurdleHintBalance: number, stampCards: number, totalStampCardsEarned: number, role: UserRole, accoladeBalance: number, freeSpins: number, subscriptionDetails?: { __typename: 'SubscriptionDetails', sku: string, autoRenews: boolean, activeSince: any, expires: any, isFreeTrial: boolean } | null, currentUserMonthlyPass: { __typename: 'UserMonthlyPass', progressToNextLevel: number, level: number, missions?: { __typename: 'UserMonthlyPassMissions', id: string, extraMissionNo?: number | null, dailyMissions: Array<{ __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } }>, monthlyMissions: Array<{ __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } }>, extraMission?: { __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } } | null } | null }, achievementMissions?: { __typename: 'UserAchievementMissions', id: string, missions: Array<{ __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } }> } | null, energySystems: { __typename: 'EnergySystems', tournamentTicket: { __typename: 'EnergySystem', currentCapSupply: number, extraBalance?: number | null }, coin: { __typename: 'EnergySystem', currentCapSupply: number }, xp: { __typename: 'EnergySystem', currentCapSupply: number }, liveEventTicket: { __typename: 'EnergySystem', currentCapSupply: number } }, basicTierContentPack: { __typename: 'UserContentPack', id: string, level: number, progressToNextLevel: number, contentPack: { __typename: 'ContentPack', id: string, name: string, picture?: string | null } }, fragmentBalance: Array<{ __typename: 'CurrencyCategoryFragment', id: string, amount: number, category: { __typename: 'ContentCategory', id: string, name: string } }>, stickers: Array<{ __typename: 'Sticker', id: string }>, profileFrames: Array<{ __typename: 'ProfileFrame', id: string }>, appSkins: Array<{ __typename: 'AppSkin', id: string }>, ABTestList: Array<{ __typename: 'ABTest', id: string, variation: string }>, ABTestForcedList: Array<{ __typename: 'ABTest', id: string }>, ABTestConfigs: Array<{ __typename: 'ABTestConfig', id: string, variations: Array<string>, status: AbTestStatus }>, ABTestLastAppInstallList: Array<{ __typename: 'ABTest', id: string, variation: string }>, reports: Array<{ __typename: 'UserReport', created: any, comment?: string | null, reporter: { __typename: 'User', id: string } }>, unlimitedBoosts: { __typename: 'UnlimitedBoosts', unlimitedBoostRemove2Balance: number, unlimitedBoostSpeedsterBalance: number }, loyalty: { __typename: 'Loyalty', tradeableCardCount: number, cardStreak: number, dayStreak: number, previousCardStreak?: number | null, futureCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null, currentCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null, previousCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null }, ownedContentPacks: { __typename: 'UserContentPacksPaginated', list: Array<{ __typename: 'UserContentPack', contentPack: { __typename: 'ContentPack', id: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null, name: string } }> }, currentSpecialEvent?: { __typename: 'SpecialEvent', id: string, meScoreDetails: Array<{ __typename: 'SpecialEventScoreDetail', type: SpecialEventScoreDetailType, score: number }> } | null, piggyBank: { __typename: 'PiggyBank', coins?: number | null, diamonds?: number | null }, metaFragments: { __typename: 'MetaFragments', BRONZE?: { __typename: 'MetaFragmentAmount', amount?: number | null } | null, SILVER?: { __typename: 'MetaFragmentAmount', amount?: number | null } | null, GOLD?: { __typename: 'MetaFragmentAmount', amount?: number | null } | null }, shards: { __typename: 'Shards', BRONZE?: number | null, SILVER?: number | null, GOLD?: number | null }, team?: { __typename: 'Team', id: string } | null, calendars: Array<{ __typename: 'PaidCalendar', id: string, name: string }> } } };

export type SearchUserQueryVariables = Exact<{
  input: Scalars['String'];
  type: UserSearchType;
}>;


export type SearchUserQuery = { __typename: 'Query', user?: { __typename: 'User', id: string, displayName: string, picture?: string | null, lastOnline?: any | null, emailCredential?: string | null, subscriptionTier?: UserSubscriptionTier | null, userLevel: number, userLevelProgressToNextLevel: number, coinBalance: number, diamondBalance: number, claimedUpdateGiftId?: string | null, vipDays: number, premiumDays: number, liveEventCurrency?: number | null, boostRemove2Balance: number, boostTeamSpiritBalance: number, boostReviveBalance: number, boostNinjaBalance: number, boostBombBalance: number, boostSpeedsterBalance: number, boostArtistOnlyBalance: number, boostHurdleHintBalance: number, stampCards: number, totalStampCardsEarned: number, role: UserRole, accoladeBalance: number, freeSpins: number, isInfluencer?: boolean | null, influencerId?: string | null, testCredential?: string | null, subscriptionDetails?: { __typename: 'SubscriptionDetails', sku: string, autoRenews: boolean, activeSince: any, expires: any, isFreeTrial: boolean } | null, currentUserMonthlyPass: { __typename: 'UserMonthlyPass', progressToNextLevel: number, level: number, missions?: { __typename: 'UserMonthlyPassMissions', id: string, extraMissionNo?: number | null, dailyMissions: Array<{ __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } }>, monthlyMissions: Array<{ __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } }>, extraMission?: { __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } } | null } | null }, achievementMissions?: { __typename: 'UserAchievementMissions', id: string, missions: Array<{ __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } }> } | null, energySystems: { __typename: 'EnergySystems', tournamentTicket: { __typename: 'EnergySystem', currentCapSupply: number, extraBalance?: number | null }, coin: { __typename: 'EnergySystem', currentCapSupply: number }, xp: { __typename: 'EnergySystem', currentCapSupply: number }, liveEventTicket: { __typename: 'EnergySystem', currentCapSupply: number } }, basicTierContentPack: { __typename: 'UserContentPack', id: string, level: number, progressToNextLevel: number, contentPack: { __typename: 'ContentPack', id: string, name: string, picture?: string | null } }, fragmentBalance: Array<{ __typename: 'CurrencyCategoryFragment', id: string, amount: number, category: { __typename: 'ContentCategory', id: string, name: string } }>, stickers: Array<{ __typename: 'Sticker', id: string }>, profileFrames: Array<{ __typename: 'ProfileFrame', id: string }>, appSkins: Array<{ __typename: 'AppSkin', id: string }>, ABTestList: Array<{ __typename: 'ABTest', id: string, variation: string }>, ABTestForcedList: Array<{ __typename: 'ABTest', id: string }>, ABTestConfigs: Array<{ __typename: 'ABTestConfig', id: string, variations: Array<string>, status: AbTestStatus }>, ABTestLastAppInstallList: Array<{ __typename: 'ABTest', id: string, variation: string }>, reports: Array<{ __typename: 'UserReport', created: any, comment?: string | null, reporter: { __typename: 'User', id: string } }>, unlimitedBoosts: { __typename: 'UnlimitedBoosts', unlimitedBoostRemove2Balance: number, unlimitedBoostSpeedsterBalance: number }, loyalty: { __typename: 'Loyalty', tradeableCardCount: number, cardStreak: number, dayStreak: number, previousCardStreak?: number | null, futureCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null, currentCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null, previousCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null }, ownedContentPacks: { __typename: 'UserContentPacksPaginated', list: Array<{ __typename: 'UserContentPack', contentPack: { __typename: 'ContentPack', id: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null, name: string } }> }, currentSpecialEvent?: { __typename: 'SpecialEvent', id: string, meScoreDetails: Array<{ __typename: 'SpecialEventScoreDetail', type: SpecialEventScoreDetailType, score: number }> } | null, piggyBank: { __typename: 'PiggyBank', coins?: number | null, diamonds?: number | null }, metaFragments: { __typename: 'MetaFragments', BRONZE?: { __typename: 'MetaFragmentAmount', amount?: number | null } | null, SILVER?: { __typename: 'MetaFragmentAmount', amount?: number | null } | null, GOLD?: { __typename: 'MetaFragmentAmount', amount?: number | null } | null }, shards: { __typename: 'Shards', BRONZE?: number | null, SILVER?: number | null, GOLD?: number | null }, team?: { __typename: 'Team', id: string } | null, calendars: Array<{ __typename: 'PaidCalendar', id: string, name: string }> } | null };

export type UpdateUserMutationVariables = Exact<{
  input: ForceUpdateUserInput;
}>;


export type UpdateUserMutation = { __typename: 'Mutation', forceUpdateUser: { __typename: 'ForceUpdateUserPayload', user: { __typename: 'User', id: string, displayName: string, picture?: string | null, lastOnline?: any | null, emailCredential?: string | null, subscriptionTier?: UserSubscriptionTier | null, userLevel: number, userLevelProgressToNextLevel: number, coinBalance: number, diamondBalance: number, claimedUpdateGiftId?: string | null, vipDays: number, premiumDays: number, liveEventCurrency?: number | null, boostRemove2Balance: number, boostTeamSpiritBalance: number, boostReviveBalance: number, boostNinjaBalance: number, boostBombBalance: number, boostSpeedsterBalance: number, boostArtistOnlyBalance: number, boostHurdleHintBalance: number, stampCards: number, totalStampCardsEarned: number, role: UserRole, accoladeBalance: number, freeSpins: number, subscriptionDetails?: { __typename: 'SubscriptionDetails', sku: string, autoRenews: boolean, activeSince: any, expires: any, isFreeTrial: boolean } | null, currentUserMonthlyPass: { __typename: 'UserMonthlyPass', progressToNextLevel: number, level: number, missions?: { __typename: 'UserMonthlyPassMissions', id: string, extraMissionNo?: number | null, dailyMissions: Array<{ __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } }>, monthlyMissions: Array<{ __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } }>, extraMission?: { __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } } | null } | null }, achievementMissions?: { __typename: 'UserAchievementMissions', id: string, missions: Array<{ __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } }> } | null, energySystems: { __typename: 'EnergySystems', tournamentTicket: { __typename: 'EnergySystem', currentCapSupply: number, extraBalance?: number | null }, coin: { __typename: 'EnergySystem', currentCapSupply: number }, xp: { __typename: 'EnergySystem', currentCapSupply: number }, liveEventTicket: { __typename: 'EnergySystem', currentCapSupply: number } }, basicTierContentPack: { __typename: 'UserContentPack', id: string, level: number, progressToNextLevel: number, contentPack: { __typename: 'ContentPack', id: string, name: string, picture?: string | null } }, fragmentBalance: Array<{ __typename: 'CurrencyCategoryFragment', id: string, amount: number, category: { __typename: 'ContentCategory', id: string, name: string } }>, stickers: Array<{ __typename: 'Sticker', id: string }>, profileFrames: Array<{ __typename: 'ProfileFrame', id: string }>, appSkins: Array<{ __typename: 'AppSkin', id: string }>, ABTestList: Array<{ __typename: 'ABTest', id: string, variation: string }>, ABTestForcedList: Array<{ __typename: 'ABTest', id: string }>, ABTestConfigs: Array<{ __typename: 'ABTestConfig', id: string, variations: Array<string>, status: AbTestStatus }>, ABTestLastAppInstallList: Array<{ __typename: 'ABTest', id: string, variation: string }>, reports: Array<{ __typename: 'UserReport', created: any, comment?: string | null, reporter: { __typename: 'User', id: string } }>, unlimitedBoosts: { __typename: 'UnlimitedBoosts', unlimitedBoostRemove2Balance: number, unlimitedBoostSpeedsterBalance: number }, loyalty: { __typename: 'Loyalty', tradeableCardCount: number, cardStreak: number, dayStreak: number, previousCardStreak?: number | null, futureCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null, currentCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null, previousCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null }, ownedContentPacks: { __typename: 'UserContentPacksPaginated', list: Array<{ __typename: 'UserContentPack', contentPack: { __typename: 'ContentPack', id: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null, name: string } }> }, currentSpecialEvent?: { __typename: 'SpecialEvent', id: string, meScoreDetails: Array<{ __typename: 'SpecialEventScoreDetail', type: SpecialEventScoreDetailType, score: number }> } | null, piggyBank: { __typename: 'PiggyBank', coins?: number | null, diamonds?: number | null }, metaFragments: { __typename: 'MetaFragments', BRONZE?: { __typename: 'MetaFragmentAmount', amount?: number | null } | null, SILVER?: { __typename: 'MetaFragmentAmount', amount?: number | null } | null, GOLD?: { __typename: 'MetaFragmentAmount', amount?: number | null } | null }, shards: { __typename: 'Shards', BRONZE?: number | null, SILVER?: number | null, GOLD?: number | null }, team?: { __typename: 'Team', id: string } | null, calendars: Array<{ __typename: 'PaidCalendar', id: string, name: string }> } } };

export type RefreshUserRedisCacheMutationVariables = Exact<{
  input: RefreshUserRedisCacheInput;
}>;


export type RefreshUserRedisCacheMutation = { __typename: 'Mutation', refreshUserRedisCache: { __typename: 'RefreshUserRedisCachePayload', user: { __typename: 'User', id: string, displayName: string, picture?: string | null, lastOnline?: any | null, emailCredential?: string | null, subscriptionTier?: UserSubscriptionTier | null, userLevel: number, userLevelProgressToNextLevel: number, coinBalance: number, diamondBalance: number, claimedUpdateGiftId?: string | null, vipDays: number, premiumDays: number, liveEventCurrency?: number | null, boostRemove2Balance: number, boostTeamSpiritBalance: number, boostReviveBalance: number, boostNinjaBalance: number, boostBombBalance: number, boostSpeedsterBalance: number, boostArtistOnlyBalance: number, boostHurdleHintBalance: number, stampCards: number, totalStampCardsEarned: number, role: UserRole, accoladeBalance: number, freeSpins: number, subscriptionDetails?: { __typename: 'SubscriptionDetails', sku: string, autoRenews: boolean, activeSince: any, expires: any, isFreeTrial: boolean } | null, currentUserMonthlyPass: { __typename: 'UserMonthlyPass', progressToNextLevel: number, level: number, missions?: { __typename: 'UserMonthlyPassMissions', id: string, extraMissionNo?: number | null, dailyMissions: Array<{ __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } }>, monthlyMissions: Array<{ __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } }>, extraMission?: { __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } } | null } | null }, achievementMissions?: { __typename: 'UserAchievementMissions', id: string, missions: Array<{ __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } }> } | null, energySystems: { __typename: 'EnergySystems', tournamentTicket: { __typename: 'EnergySystem', currentCapSupply: number, extraBalance?: number | null }, coin: { __typename: 'EnergySystem', currentCapSupply: number }, xp: { __typename: 'EnergySystem', currentCapSupply: number }, liveEventTicket: { __typename: 'EnergySystem', currentCapSupply: number } }, basicTierContentPack: { __typename: 'UserContentPack', id: string, level: number, progressToNextLevel: number, contentPack: { __typename: 'ContentPack', id: string, name: string, picture?: string | null } }, fragmentBalance: Array<{ __typename: 'CurrencyCategoryFragment', id: string, amount: number, category: { __typename: 'ContentCategory', id: string, name: string } }>, stickers: Array<{ __typename: 'Sticker', id: string }>, profileFrames: Array<{ __typename: 'ProfileFrame', id: string }>, appSkins: Array<{ __typename: 'AppSkin', id: string }>, ABTestList: Array<{ __typename: 'ABTest', id: string, variation: string }>, ABTestForcedList: Array<{ __typename: 'ABTest', id: string }>, ABTestConfigs: Array<{ __typename: 'ABTestConfig', id: string, variations: Array<string>, status: AbTestStatus }>, ABTestLastAppInstallList: Array<{ __typename: 'ABTest', id: string, variation: string }>, reports: Array<{ __typename: 'UserReport', created: any, comment?: string | null, reporter: { __typename: 'User', id: string } }>, unlimitedBoosts: { __typename: 'UnlimitedBoosts', unlimitedBoostRemove2Balance: number, unlimitedBoostSpeedsterBalance: number }, loyalty: { __typename: 'Loyalty', tradeableCardCount: number, cardStreak: number, dayStreak: number, previousCardStreak?: number | null, futureCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null, currentCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null, previousCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null }, ownedContentPacks: { __typename: 'UserContentPacksPaginated', list: Array<{ __typename: 'UserContentPack', contentPack: { __typename: 'ContentPack', id: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null, name: string } }> }, currentSpecialEvent?: { __typename: 'SpecialEvent', id: string, meScoreDetails: Array<{ __typename: 'SpecialEventScoreDetail', type: SpecialEventScoreDetailType, score: number }> } | null, piggyBank: { __typename: 'PiggyBank', coins?: number | null, diamonds?: number | null }, metaFragments: { __typename: 'MetaFragments', BRONZE?: { __typename: 'MetaFragmentAmount', amount?: number | null } | null, SILVER?: { __typename: 'MetaFragmentAmount', amount?: number | null } | null, GOLD?: { __typename: 'MetaFragmentAmount', amount?: number | null } | null }, shards: { __typename: 'Shards', BRONZE?: number | null, SILVER?: number | null, GOLD?: number | null }, team?: { __typename: 'Team', id: string } | null, calendars: Array<{ __typename: 'PaidCalendar', id: string, name: string }> } } };

export type FlushRedisCacheForOneUserMutationVariables = Exact<{
  input: FlushRedisCacheForOneUserInput;
}>;


export type FlushRedisCacheForOneUserMutation = { __typename: 'Mutation', flushRedisCacheForOneUser: { __typename: 'FlushRedisCacheForOneUserPayload', user: { __typename: 'User', id: string, displayName: string, picture?: string | null, lastOnline?: any | null, emailCredential?: string | null, subscriptionTier?: UserSubscriptionTier | null, userLevel: number, userLevelProgressToNextLevel: number, coinBalance: number, diamondBalance: number, claimedUpdateGiftId?: string | null, vipDays: number, premiumDays: number, liveEventCurrency?: number | null, boostRemove2Balance: number, boostTeamSpiritBalance: number, boostReviveBalance: number, boostNinjaBalance: number, boostBombBalance: number, boostSpeedsterBalance: number, boostArtistOnlyBalance: number, boostHurdleHintBalance: number, stampCards: number, totalStampCardsEarned: number, role: UserRole, accoladeBalance: number, freeSpins: number, subscriptionDetails?: { __typename: 'SubscriptionDetails', sku: string, autoRenews: boolean, activeSince: any, expires: any, isFreeTrial: boolean } | null, currentUserMonthlyPass: { __typename: 'UserMonthlyPass', progressToNextLevel: number, level: number, missions?: { __typename: 'UserMonthlyPassMissions', id: string, extraMissionNo?: number | null, dailyMissions: Array<{ __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } }>, monthlyMissions: Array<{ __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } }>, extraMission?: { __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } } | null } | null }, achievementMissions?: { __typename: 'UserAchievementMissions', id: string, missions: Array<{ __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } }> } | null, energySystems: { __typename: 'EnergySystems', tournamentTicket: { __typename: 'EnergySystem', currentCapSupply: number, extraBalance?: number | null }, coin: { __typename: 'EnergySystem', currentCapSupply: number }, xp: { __typename: 'EnergySystem', currentCapSupply: number }, liveEventTicket: { __typename: 'EnergySystem', currentCapSupply: number } }, basicTierContentPack: { __typename: 'UserContentPack', id: string, level: number, progressToNextLevel: number, contentPack: { __typename: 'ContentPack', id: string, name: string, picture?: string | null } }, fragmentBalance: Array<{ __typename: 'CurrencyCategoryFragment', id: string, amount: number, category: { __typename: 'ContentCategory', id: string, name: string } }>, stickers: Array<{ __typename: 'Sticker', id: string }>, profileFrames: Array<{ __typename: 'ProfileFrame', id: string }>, appSkins: Array<{ __typename: 'AppSkin', id: string }>, ABTestList: Array<{ __typename: 'ABTest', id: string, variation: string }>, ABTestForcedList: Array<{ __typename: 'ABTest', id: string }>, ABTestConfigs: Array<{ __typename: 'ABTestConfig', id: string, variations: Array<string>, status: AbTestStatus }>, ABTestLastAppInstallList: Array<{ __typename: 'ABTest', id: string, variation: string }>, reports: Array<{ __typename: 'UserReport', created: any, comment?: string | null, reporter: { __typename: 'User', id: string } }>, unlimitedBoosts: { __typename: 'UnlimitedBoosts', unlimitedBoostRemove2Balance: number, unlimitedBoostSpeedsterBalance: number }, loyalty: { __typename: 'Loyalty', tradeableCardCount: number, cardStreak: number, dayStreak: number, previousCardStreak?: number | null, futureCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null, currentCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null, previousCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null }, ownedContentPacks: { __typename: 'UserContentPacksPaginated', list: Array<{ __typename: 'UserContentPack', contentPack: { __typename: 'ContentPack', id: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null, name: string } }> }, currentSpecialEvent?: { __typename: 'SpecialEvent', id: string, meScoreDetails: Array<{ __typename: 'SpecialEventScoreDetail', type: SpecialEventScoreDetailType, score: number }> } | null, piggyBank: { __typename: 'PiggyBank', coins?: number | null, diamonds?: number | null }, metaFragments: { __typename: 'MetaFragments', BRONZE?: { __typename: 'MetaFragmentAmount', amount?: number | null } | null, SILVER?: { __typename: 'MetaFragmentAmount', amount?: number | null } | null, GOLD?: { __typename: 'MetaFragmentAmount', amount?: number | null } | null }, shards: { __typename: 'Shards', BRONZE?: number | null, SILVER?: number | null, GOLD?: number | null }, team?: { __typename: 'Team', id: string } | null, calendars: Array<{ __typename: 'PaidCalendar', id: string, name: string }> } } };

export type GetUserLastSessionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetUserLastSessionQuery = { __typename: 'Query', analytics: { __typename: 'Analytics', id: string, userLastSession?: { __typename: 'AnalyticsUserLastSession', id: string, date: any } | null } };

export type UserGiftStatusAdminQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type UserGiftStatusAdminQuery = { __typename: 'Query', userGiftStatusAdmin: Array<{ __typename: 'GiftInfo', isFriend: boolean, isSystem: boolean, sender: { __typename: 'Agent', id: string, displayName: string } | { __typename: 'User', id: string, displayName: string }, gift: { __typename: 'IapGift', id: string, created: any, claimed?: any | null, bundleName?: string | null, message?: string | null, rewards: Array<{ __typename: 'AppSkin', id: string, name: string } | { __typename: 'Badge', id: string, name: string, badgeType: BadgeType } | { __typename: 'ContentPackReward', id: string, rewardType: string, contentPack: { __typename: 'ContentPack', id: string, name: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number, category: { __typename: 'ContentCategory', id: string, name: string } } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string, name: string } | { __typename: 'EmojiPack', id: string, name: string } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster', id: string, name: string, posterType: PosterType } | { __typename: 'ProfileFrame', id: string, name: string } | { __typename: 'Sticker', id: string, name: string }> } }> };

export type UserBadgesAdminQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type UserBadgesAdminQuery = { __typename: 'Query', userBadgesAdmin: Array<{ __typename: 'Badge', id: string, name: string, type: BadgeType, owned: boolean, isSP2: boolean, currentLevel?: number | null, details: string, createdAt?: any | null, updatedAt?: any | null }> };

export type GrantUserBadgeAdminMutationVariables = Exact<{
  input: GrantUserBadgeAdminInput;
}>;


export type GrantUserBadgeAdminMutation = { __typename: 'Mutation', grantUserBadgeAdmin: { __typename: 'UserBadgeAdminPayload', badge: { __typename: 'Badge', id: string, name: string, type: BadgeType, currentLevel?: number | null } } };

export type RevokeUserBadgeAdminMutationVariables = Exact<{
  input: RevokeUserBadgeAdminInput;
}>;


export type RevokeUserBadgeAdminMutation = { __typename: 'Mutation', revokeUserBadgeAdmin: { __typename: 'RevokeUserBadgeAdminPayload', userId: string, badgeId: string } };

export type SetUserBadgeLevelAdminMutationVariables = Exact<{
  input: SetUserBadgeLevelAdminInput;
}>;


export type SetUserBadgeLevelAdminMutation = { __typename: 'Mutation', setUserBadgeLevelAdmin: { __typename: 'UserBadgeAdminPayload', badge: { __typename: 'Badge', id: string, name: string, type: BadgeType, currentLevel?: number | null } } };

export type AppInformationQueryVariables = Exact<{ [key: string]: never; }>;


export type AppInformationQuery = { __typename: 'Query', me: { __typename: 'User', energySystems: { __typename: 'EnergySystems', coin: { __typename: 'EnergySystem', caps: { __typename: 'EnergySystemCap', basic: { __typename: 'RewardCap', maxStorage: number }, ad_free: { __typename: 'RewardCap', maxStorage: number }, premium: { __typename: 'RewardCap', maxStorage: number }, vip: { __typename: 'RewardCap', maxStorage: number }, plus: { __typename: 'RewardCap', maxStorage: number } } }, xp: { __typename: 'EnergySystem', caps: { __typename: 'EnergySystemCap', basic: { __typename: 'RewardCap', maxStorage: number }, ad_free: { __typename: 'RewardCap', maxStorage: number }, premium: { __typename: 'RewardCap', maxStorage: number }, vip: { __typename: 'RewardCap', maxStorage: number }, plus: { __typename: 'RewardCap', maxStorage: number } } }, tournamentTicket: { __typename: 'EnergySystem', caps: { __typename: 'EnergySystemCap', basic: { __typename: 'RewardCap', maxStorage: number }, ad_free: { __typename: 'RewardCap', maxStorage: number }, premium: { __typename: 'RewardCap', maxStorage: number }, vip: { __typename: 'RewardCap', maxStorage: number }, plus: { __typename: 'RewardCap', maxStorage: number } } }, liveEventTicket: { __typename: 'EnergySystem', caps: { __typename: 'EnergySystemCap', basic: { __typename: 'RewardCap', maxStorage: number }, ad_free: { __typename: 'RewardCap', maxStorage: number }, premium: { __typename: 'RewardCap', maxStorage: number }, vip: { __typename: 'RewardCap', maxStorage: number }, plus: { __typename: 'RewardCap', maxStorage: number } } } } }, app: { __typename: 'App', contentCategories: Array<{ __typename: 'ContentCategory', id: string, name: string, icon: string }> } };

export type LiveOpsContentQueryVariables = Exact<{ [key: string]: never; }>;


export type LiveOpsContentQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', stickers: { __typename: 'StickerPaginated', list: Array<{ __typename: 'Sticker', id: string, name: string, asset: string, liveOpsAvailability: ItemAvailability, nextLevelItems: Array<{ __typename: 'AppSkin', level: number } | { __typename: 'ProfileFrame', level: number } | { __typename: 'Sticker', level: number }> }> }, appskins: { __typename: 'AppSkinPaginated', list: Array<{ __typename: 'AppSkin', id: string, name: string, iconAsset?: string | null, liveOpsAvailability: ItemAvailability, nextLevelItems: Array<{ __typename: 'AppSkin', level: number } | { __typename: 'ProfileFrame', level: number } | { __typename: 'Sticker', level: number }> }> }, profileFrames: { __typename: 'ProfileFramePaginated', list: Array<{ __typename: 'ProfileFrame', id: string, name: string, asset: string, liveOpsAvailability: ItemAvailability, nextLevelItems: Array<{ __typename: 'AppSkin', level: number, asset: string } | { __typename: 'ProfileFrame', level: number, asset: string } | { __typename: 'Sticker', level: number, asset: string }> }> } } };

export type UpdateLoyaltyCardMutationVariables = Exact<{
  input: UpdateLoyaltyCardInput;
}>;


export type UpdateLoyaltyCardMutation = { __typename: 'Mutation', updateLoyaltyCard: { __typename: 'UpdateLoyaltyCardPayload', user: { __typename: 'User', id: string, loyalty: { __typename: 'Loyalty', tradeableCardCount: number, cardStreak: number, dayStreak: number, previousCardStreak?: number | null, futureCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null, currentCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null, previousCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null } } } };

export type ResetLoyaltyCardMutationVariables = Exact<{
  input: ResetLoyaltyCardInput;
}>;


export type ResetLoyaltyCardMutation = { __typename: 'Mutation', resetLoyaltyCard: { __typename: 'ResetLoyaltyCardPayload', user: { __typename: 'User', id: string, loyalty: { __typename: 'Loyalty', tradeableCardCount: number, cardStreak: number, dayStreak: number, previousCardStreak?: number | null, futureCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null, currentCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null, previousCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null } } } };

export type ReviveLoyaltyCardMutationVariables = Exact<{
  input: ReviveLoyaltyCardInput;
}>;


export type ReviveLoyaltyCardMutation = { __typename: 'Mutation', reviveLoyaltyCard: { __typename: 'ReviveLoyaltyCardPayload', user: { __typename: 'User', id: string, loyalty: { __typename: 'Loyalty', tradeableCardCount: number, cardStreak: number, dayStreak: number, previousCardStreak?: number | null, futureCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null, currentCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null, previousCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null } } } };

export type ShiftLoyaltyCardMutationVariables = Exact<{
  input: ShiftLoyaltyCardInput;
}>;


export type ShiftLoyaltyCardMutation = { __typename: 'Mutation', shiftLoyaltyCard: { __typename: 'ShiftLoyaltyCardPayload', user: { __typename: 'User', id: string, loyalty: { __typename: 'Loyalty', tradeableCardCount: number, cardStreak: number, dayStreak: number, previousCardStreak?: number | null, futureCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null, currentCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null, previousCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null } } } };

export type UpdateUserSpecialEventPointsMutationVariables = Exact<{
  input: UpdateUserSpecialEventPointsInput;
}>;


export type UpdateUserSpecialEventPointsMutation = { __typename: 'Mutation', updateUserSpecialEventPoints: { __typename: 'UpdateUserSpecialEventPointsPayload', user: { __typename: 'User', id: string, currentSpecialEvent?: { __typename: 'SpecialEvent', meScoreDetails: Array<{ __typename: 'SpecialEventScoreDetail', type: SpecialEventScoreDetailType, score: number }> } | null } } };

export type UpdateUserInfluencerMutationVariables = Exact<{
  input: UpdateUserInfluencerInput;
}>;


export type UpdateUserInfluencerMutation = { __typename: 'Mutation', updateUserInfluencer: { __typename: 'UpdateUserInfluencerPayload', user: { __typename: 'User', id: string, displayName: string, picture?: string | null, lastOnline?: any | null, emailCredential?: string | null, subscriptionTier?: UserSubscriptionTier | null, userLevel: number, userLevelProgressToNextLevel: number, coinBalance: number, diamondBalance: number, claimedUpdateGiftId?: string | null, vipDays: number, premiumDays: number, liveEventCurrency?: number | null, boostRemove2Balance: number, boostTeamSpiritBalance: number, boostReviveBalance: number, boostNinjaBalance: number, boostBombBalance: number, boostSpeedsterBalance: number, boostArtistOnlyBalance: number, boostHurdleHintBalance: number, stampCards: number, totalStampCardsEarned: number, role: UserRole, accoladeBalance: number, freeSpins: number, subscriptionDetails?: { __typename: 'SubscriptionDetails', sku: string, autoRenews: boolean, activeSince: any, expires: any, isFreeTrial: boolean } | null, currentUserMonthlyPass: { __typename: 'UserMonthlyPass', progressToNextLevel: number, level: number, missions?: { __typename: 'UserMonthlyPassMissions', id: string, extraMissionNo?: number | null, dailyMissions: Array<{ __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } }>, monthlyMissions: Array<{ __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } }>, extraMission?: { __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } } | null } | null }, achievementMissions?: { __typename: 'UserAchievementMissions', id: string, missions: Array<{ __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } }> } | null, energySystems: { __typename: 'EnergySystems', tournamentTicket: { __typename: 'EnergySystem', currentCapSupply: number, extraBalance?: number | null }, coin: { __typename: 'EnergySystem', currentCapSupply: number }, xp: { __typename: 'EnergySystem', currentCapSupply: number }, liveEventTicket: { __typename: 'EnergySystem', currentCapSupply: number } }, basicTierContentPack: { __typename: 'UserContentPack', id: string, level: number, progressToNextLevel: number, contentPack: { __typename: 'ContentPack', id: string, name: string, picture?: string | null } }, fragmentBalance: Array<{ __typename: 'CurrencyCategoryFragment', id: string, amount: number, category: { __typename: 'ContentCategory', id: string, name: string } }>, stickers: Array<{ __typename: 'Sticker', id: string }>, profileFrames: Array<{ __typename: 'ProfileFrame', id: string }>, appSkins: Array<{ __typename: 'AppSkin', id: string }>, ABTestList: Array<{ __typename: 'ABTest', id: string, variation: string }>, ABTestForcedList: Array<{ __typename: 'ABTest', id: string }>, ABTestConfigs: Array<{ __typename: 'ABTestConfig', id: string, variations: Array<string>, status: AbTestStatus }>, ABTestLastAppInstallList: Array<{ __typename: 'ABTest', id: string, variation: string }>, reports: Array<{ __typename: 'UserReport', created: any, comment?: string | null, reporter: { __typename: 'User', id: string } }>, unlimitedBoosts: { __typename: 'UnlimitedBoosts', unlimitedBoostRemove2Balance: number, unlimitedBoostSpeedsterBalance: number }, loyalty: { __typename: 'Loyalty', tradeableCardCount: number, cardStreak: number, dayStreak: number, previousCardStreak?: number | null, futureCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null, currentCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null, previousCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null }, ownedContentPacks: { __typename: 'UserContentPacksPaginated', list: Array<{ __typename: 'UserContentPack', contentPack: { __typename: 'ContentPack', id: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null, name: string } }> }, currentSpecialEvent?: { __typename: 'SpecialEvent', id: string, meScoreDetails: Array<{ __typename: 'SpecialEventScoreDetail', type: SpecialEventScoreDetailType, score: number }> } | null, piggyBank: { __typename: 'PiggyBank', coins?: number | null, diamonds?: number | null }, metaFragments: { __typename: 'MetaFragments', BRONZE?: { __typename: 'MetaFragmentAmount', amount?: number | null } | null, SILVER?: { __typename: 'MetaFragmentAmount', amount?: number | null } | null, GOLD?: { __typename: 'MetaFragmentAmount', amount?: number | null } | null }, shards: { __typename: 'Shards', BRONZE?: number | null, SILVER?: number | null, GOLD?: number | null }, team?: { __typename: 'Team', id: string } | null, calendars: Array<{ __typename: 'PaidCalendar', id: string, name: string }> } } };

export type GetUserLoyaltyCampaignProgressQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetUserLoyaltyCampaignProgressQuery = { __typename: 'Query', user?: { __typename: 'User', id: string, loyaltyCampaignProgress: { __typename: 'UserLoyaltyCampaignProgress', loyaltyPoints: number, claimedLoyaltyCards: Array<string> }, loyaltyCampaignRewardLogs: Array<{ __typename: 'UserLoyaltyCampaignRewardLog', referenceId: string, sourceType: string, productId: string, amount: number, created: any }> } | null, liveOps: { __typename: 'LiveOps', id: string, loyaltyCampaignCards: Array<{ __typename: 'LoyaltyCampaignCard', id: string, name: string }> } };

export type SetUserLoyaltyCampaignProgressMutationVariables = Exact<{
  userId: Scalars['ID'];
  loyaltyPoints: Scalars['Int'];
  claimedLoyaltyCardIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type SetUserLoyaltyCampaignProgressMutation = { __typename: 'Mutation', setUserLoyaltyCampaignProgress: { __typename: 'User', id: string, loyaltyCampaignProgress: { __typename: 'UserLoyaltyCampaignProgress', loyaltyPoints: number, claimedLoyaltyCards: Array<string> } } };

export type ResetUserLoyaltyCampaignProgressMutationVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type ResetUserLoyaltyCampaignProgressMutation = { __typename: 'Mutation', resetUserLoyaltyCampaignProgress: { __typename: 'User', id: string, loyaltyCampaignProgress: { __typename: 'UserLoyaltyCampaignProgress', loyaltyPoints: number, claimedLoyaltyCards: Array<string> } } };

export type SendRetentionReminderMutationVariables = Exact<{
  input?: InputMaybe<SendRetentionReminderInput>;
}>;


export type SendRetentionReminderMutation = { __typename: 'Mutation', sendRetentionReminder?: string | null };

export type SendNotificationMutationVariables = Exact<{
  input: SendNotificationInput;
}>;


export type SendNotificationMutation = { __typename: 'Mutation', sendNotification?: string | null };

export type UserTransactionsQueryVariables = Exact<{
  userId: Scalars['ID'];
  startDate: Scalars['String'];
  endDate: Scalars['String'];
}>;


export type UserTransactionsQuery = { __typename: 'Query', analytics: { __typename: 'Analytics', userTransactions: Array<any> } };

export type GetUserMonthIdListQueryVariables = Exact<{
  input: GetUserMonthIdListInput;
}>;


export type GetUserMonthIdListQuery = { __typename: 'Query', app: { __typename: 'App', getUserMonthIdList: { __typename: 'GetUserMonthIdListPayload', list: Array<string> } } };

export type GetUserMonthlyPassQueryVariables = Exact<{
  input: GetUserMonthlyPassInput;
}>;


export type GetUserMonthlyPassQuery = { __typename: 'Query', app: { __typename: 'App', getUserMonthlyPass: { __typename: 'GetUserMonthlyPassPayload', userMonthlyPass: { __typename: 'UserMonthlyPass', allMissions?: { __typename: 'UserMonthlyPassAllMissions', id: string, dailyMissions: Array<{ __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardXp: number, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory' } | { __typename: 'MissionParamContentPack' } | { __typename: 'MissionParamFloat' } | { __typename: 'MissionParamHour24' } | { __typename: 'MissionParamInt' } | { __typename: 'MissionParamSong' } | { __typename: 'MissionParamString' } | { __typename: 'MissionParamType' }> }> } }>, monthlyMissions: Array<{ __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardXp: number, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory' } | { __typename: 'MissionParamContentPack' } | { __typename: 'MissionParamFloat' } | { __typename: 'MissionParamHour24' } | { __typename: 'MissionParamInt' } | { __typename: 'MissionParamSong' } | { __typename: 'MissionParamString' } | { __typename: 'MissionParamType' }> }> } }>, extraMissions: Array<{ __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardXp: number, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory' } | { __typename: 'MissionParamContentPack' } | { __typename: 'MissionParamFloat' } | { __typename: 'MissionParamHour24' } | { __typename: 'MissionParamInt' } | { __typename: 'MissionParamSong' } | { __typename: 'MissionParamString' } | { __typename: 'MissionParamType' }> }> } }>, teamMissions: Array<{ __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardXp: number, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory' } | { __typename: 'MissionParamContentPack' } | { __typename: 'MissionParamFloat' } | { __typename: 'MissionParamHour24' } | { __typename: 'MissionParamInt' } | { __typename: 'MissionParamSong' } | { __typename: 'MissionParamString' } | { __typename: 'MissionParamType' }> }> } }> } | null } } } };

export type ResetMissionProgressMutationVariables = Exact<{
  input: ResetMissionProgressInput;
}>;


export type ResetMissionProgressMutation = { __typename: 'Mutation', resetMissionProgress: { __typename: 'ResetMissionProgressPayload', user: { __typename: 'User', currentUserMonthlyPass: { __typename: 'UserMonthlyPass', missions?: { __typename: 'UserMonthlyPassMissions', id: string, extraMissionNo?: number | null, dailyMissions: Array<{ __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } }>, monthlyMissions: Array<{ __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } }>, extraMission?: { __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } } | null } | null } } } };

export type ForceGrantMpLeaderboardRewardsMutationVariables = Exact<{
  input: ForceGrantMplRewardsInput;
}>;


export type ForceGrantMpLeaderboardRewardsMutation = { __typename: 'Mutation', forceGrantMPLeaderboardRewards: boolean };

export type GetLinkStateAdminQueryVariables = Exact<{
  input: Sp3IdInput;
}>;


export type GetLinkStateAdminQuery = { __typename: 'Query', getLinkStateAdmin: { __typename: 'LinkInfoPayload', state: Sp2LinkState, sp2id?: string | null } };

export type GetLinkStateBySp3IdFromSp2QueryVariables = Exact<{
  input: Sp3IdInput;
}>;


export type GetLinkStateBySp3IdFromSp2Query = { __typename: 'Query', getLinkStateBySp3IdFromSp2: { __typename: 'LinkInfoPayload', state: Sp2LinkState, sp2id?: string | null } };

export type LinkToSp2AdminMutationVariables = Exact<{
  input: Sp2LinkIdPairInput;
}>;


export type LinkToSp2AdminMutation = { __typename: 'Mutation', linkToSp2Admin: { __typename: 'Sp2LinkResult', error?: Sp2LinkError | null, errorMessage?: string | null, success?: boolean | null, isPending?: boolean | null } };

export type UnlinkIdPairMutationVariables = Exact<{
  input: Sp2LinkIdPairInput;
}>;


export type UnlinkIdPairMutation = { __typename: 'Mutation', unlinkIdPair: { __typename: 'Sp2LinkResult', error?: Sp2LinkError | null, errorMessage?: string | null, success?: boolean | null, isPending?: boolean | null } };

export type CurrentHurdleQuizzesQueryVariables = Exact<{
  input: CurrentHurdleQuizzesInput;
}>;


export type CurrentHurdleQuizzesQuery = { __typename: 'Query', currentHurdleQuizzes: { __typename: 'HurdleQuizzesPaginated', id: string, hasMore: boolean, totalCount: number, list: Array<{ __typename: 'HurdleQuiz', id: string, startDate: any, endDate: any, namespace: HurdleNamespace, categoryId: string, type: HurdleType, catalogItemId: string, question?: { __typename: 'HurdleQuestion', id: string, asset: string, offset: number, song?: { __typename: 'Song', id: string, displayTitle: string, displayArtist: string } | null } | null }> } };

export type ResetHurdleQuizMutationVariables = Exact<{
  input: ResetHurdleQuizInput;
}>;


export type ResetHurdleQuizMutation = { __typename: 'Mutation', resetHurdleQuiz: { __typename: 'ResetHurdleQuizPayload', hurdleQuiz: { __typename: 'HurdleQuiz', id: string, startDate: any, endDate: any, namespace: HurdleNamespace, categoryId: string, type: HurdleType, catalogItemId: string, question?: { __typename: 'HurdleQuestion', id: string, asset: string, offset: number, song?: { __typename: 'Song', id: string, displayTitle: string, displayArtist: string } | null } | null } } };

export type UpdateUserHurdleQuizMutationVariables = Exact<{
  input: UpdateUserHurdleQuizInput;
}>;


export type UpdateUserHurdleQuizMutation = { __typename: 'Mutation', updateUserHurdleQuiz: { __typename: 'UpdateUserHurdleQuizPayload', hurdleQuiz: { __typename: 'HurdleQuiz', id: string, startDate: any, endDate: any, namespace: HurdleNamespace, categoryId: string, type: HurdleType, catalogItemId: string, question?: { __typename: 'HurdleQuestion', id: string, asset: string, offset: number, song?: { __typename: 'Song', id: string, displayTitle: string, displayArtist: string } | null } | null } } };

export type CompleteUserHurdleQuizMutationVariables = Exact<{
  input: CompleteUserHurdleQuizInput;
}>;


export type CompleteUserHurdleQuizMutation = { __typename: 'Mutation', completeUserHurdleQuiz: { __typename: 'CompleteUserHurdleQuizPayload', hurdleQuiz: { __typename: 'HurdleQuiz', id: string, startDate: any, endDate: any, namespace: HurdleNamespace, categoryId: string, type: HurdleType, catalogItemId: string, question?: { __typename: 'HurdleQuestion', id: string, asset: string, offset: number, song?: { __typename: 'Song', id: string, displayTitle: string, displayArtist: string } | null } | null } } };

export type StreakHistoryQueryVariables = Exact<{
  input: StreakHistoryInput;
}>;


export type StreakHistoryQuery = { __typename: 'Query', streakHistory?: { __typename: 'StreakHistoryPayload', currentStreak: number, lostGames: Array<{ __typename: 'UserHurdleLostGame', hurdleQuizId: string, previousStreak?: number | null, lostDate: any, songTitle: string, songArtist: string }> } | null };

export type ActiveUserSubscriptionUpdateLogsQueryVariables = Exact<{
  input: ActiveUserSubscriptionUpdateLogsInput;
}>;


export type ActiveUserSubscriptionUpdateLogsQuery = { __typename: 'Query', activeUserSubscriptionUpdateLogs: { __typename: 'ActiveUserSubscriptionUpdateLogsPayload', logs: Array<{ __typename: 'UserSubscriptionUpdateLog', userId: string, logId: string, store: string, type: string, sku: string, environment: string, originalTransactionId: string, created?: any | null, expires?: any | null, purchased?: any | null, cancelled?: any | null, cancelledReason?: number | null, autoRenew?: boolean | null, retrying?: boolean | null, valid?: boolean | null, iosWebOrderLineItemId?: string | null }> } };

export type ApplyUserSubscriptionUpdateLogMutationVariables = Exact<{
  input: ApplyUserSubscriptionUpdateLogInput;
}>;


export type ApplyUserSubscriptionUpdateLogMutation = { __typename: 'Mutation', applyUserSubscriptionUpdateLog: { __typename: 'ApplyUserSubscriptionUpdateLogPayload', user: { __typename: 'User', id: string, displayName: string, picture?: string | null, lastOnline?: any | null, emailCredential?: string | null, subscriptionTier?: UserSubscriptionTier | null, userLevel: number, userLevelProgressToNextLevel: number, coinBalance: number, diamondBalance: number, claimedUpdateGiftId?: string | null, vipDays: number, premiumDays: number, liveEventCurrency?: number | null, boostRemove2Balance: number, boostTeamSpiritBalance: number, boostReviveBalance: number, boostNinjaBalance: number, boostBombBalance: number, boostSpeedsterBalance: number, boostArtistOnlyBalance: number, boostHurdleHintBalance: number, stampCards: number, totalStampCardsEarned: number, role: UserRole, accoladeBalance: number, freeSpins: number, isInfluencer?: boolean | null, influencerId?: string | null, testCredential?: string | null, subscriptionDetails?: { __typename: 'SubscriptionDetails', sku: string, autoRenews: boolean, activeSince: any, expires: any, isFreeTrial: boolean } | null, currentUserMonthlyPass: { __typename: 'UserMonthlyPass', progressToNextLevel: number, level: number, missions?: { __typename: 'UserMonthlyPassMissions', id: string, extraMissionNo?: number | null, dailyMissions: Array<{ __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } }>, monthlyMissions: Array<{ __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } }>, extraMission?: { __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } } | null } | null }, achievementMissions?: { __typename: 'UserAchievementMissions', id: string, missions: Array<{ __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } }> } | null, energySystems: { __typename: 'EnergySystems', tournamentTicket: { __typename: 'EnergySystem', currentCapSupply: number, extraBalance?: number | null }, coin: { __typename: 'EnergySystem', currentCapSupply: number }, xp: { __typename: 'EnergySystem', currentCapSupply: number }, liveEventTicket: { __typename: 'EnergySystem', currentCapSupply: number } }, basicTierContentPack: { __typename: 'UserContentPack', id: string, level: number, progressToNextLevel: number, contentPack: { __typename: 'ContentPack', id: string, name: string, picture?: string | null } }, fragmentBalance: Array<{ __typename: 'CurrencyCategoryFragment', id: string, amount: number, category: { __typename: 'ContentCategory', id: string, name: string } }>, stickers: Array<{ __typename: 'Sticker', id: string }>, profileFrames: Array<{ __typename: 'ProfileFrame', id: string }>, appSkins: Array<{ __typename: 'AppSkin', id: string }>, ABTestList: Array<{ __typename: 'ABTest', id: string, variation: string }>, ABTestForcedList: Array<{ __typename: 'ABTest', id: string }>, ABTestConfigs: Array<{ __typename: 'ABTestConfig', id: string, variations: Array<string>, status: AbTestStatus }>, ABTestLastAppInstallList: Array<{ __typename: 'ABTest', id: string, variation: string }>, reports: Array<{ __typename: 'UserReport', created: any, comment?: string | null, reporter: { __typename: 'User', id: string } }>, unlimitedBoosts: { __typename: 'UnlimitedBoosts', unlimitedBoostRemove2Balance: number, unlimitedBoostSpeedsterBalance: number }, loyalty: { __typename: 'Loyalty', tradeableCardCount: number, cardStreak: number, dayStreak: number, previousCardStreak?: number | null, futureCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null, currentCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null, previousCard?: { __typename: 'LoyaltyCard', id: string, isExpired: boolean, isCompleted: boolean, currentDayIndex?: number | null, nextClaimableDayIndex?: number | null, days: Array<{ __typename: 'LoyaltyCardDay', isClaimed: boolean, claimedMultiplier?: number | null, claimedDate?: any | null, start: any, end: any, rewards: Array<{ __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' }> }> } | null }, ownedContentPacks: { __typename: 'UserContentPacksPaginated', list: Array<{ __typename: 'UserContentPack', contentPack: { __typename: 'ContentPack', id: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null, name: string } }> }, currentSpecialEvent?: { __typename: 'SpecialEvent', id: string, meScoreDetails: Array<{ __typename: 'SpecialEventScoreDetail', type: SpecialEventScoreDetailType, score: number }> } | null, piggyBank: { __typename: 'PiggyBank', coins?: number | null, diamonds?: number | null }, metaFragments: { __typename: 'MetaFragments', BRONZE?: { __typename: 'MetaFragmentAmount', amount?: number | null } | null, SILVER?: { __typename: 'MetaFragmentAmount', amount?: number | null } | null, GOLD?: { __typename: 'MetaFragmentAmount', amount?: number | null } | null }, shards: { __typename: 'Shards', BRONZE?: number | null, SILVER?: number | null, GOLD?: number | null }, team?: { __typename: 'Team', id: string } | null, calendars: Array<{ __typename: 'PaidCalendar', id: string, name: string }> } } };

export type QuizLiveShowUserQueryVariables = Exact<{
  userId: Scalars['ID'];
  playDate: Scalars['Date'];
}>;


export type QuizLiveShowUserQuery = { __typename: 'Query', quizLiveShowUser?: Array<{ __typename: 'QuizLiveShowUser', id: string, diamondReward?: number | null, ghostQuestionId?: string | null, reviveQuestionId?: string | null, show: { __typename: 'QuizLiveShow', id: string, startDate: any, lastQuestionStartDate?: any | null, diamondPrize: number, rounds: Array<{ __typename: 'QuizLiveShowRound', id: string, questionDuration: number, questions: Array<{ __typename: 'QuizEncryptedQuestion', id: string }> }>, winners: Array<{ __typename: 'QuizLiveShowWinner', id: string, user: { __typename: 'User', id: string } }> } } | null> | null };

export type RefundLiveShowMutationVariables = Exact<{
  userId: Scalars['ID'];
  showId: Scalars['ID'];
}>;


export type RefundLiveShowMutation = { __typename: 'Mutation', refundLiveShowUserBoosts: { __typename: 'RefundLiveShowUserBoostsPayload', user: { __typename: 'User', id: string } } };

export type GetAllYearInReviewQueryVariables = Exact<{
  userId: Scalars['String'];
  type: UserSearchType;
}>;


export type GetAllYearInReviewQuery = { __typename: 'Query', user?: { __typename: 'User', getAllYearInReview?: Array<{ __typename: 'YearInReview', id: string, year: number, seen?: any | null, available: any }> | null } | null };

export type ChangeAvailableDateYirMutationVariables = Exact<{
  userId: Scalars['ID'];
  year: Scalars['Int'];
  date: Scalars['Date'];
}>;


export type ChangeAvailableDateYirMutation = { __typename: 'Mutation', changeAvailableDateYearInReview?: { __typename: 'YearInReview', id: string, year: number, seen?: any | null, available: any } | null };

export type GetTeamHeatInfoQueryVariables = Exact<{
  property: Scalars['String'];
  type: UserSearchType;
}>;


export type GetTeamHeatInfoQuery = { __typename: 'Query', user?: { __typename: 'User', id: string, team?: { __typename: 'Team', id: string, availableBoosts: number, boosts: Array<{ __typename: 'TeamHeatBoost', type: CurrencyBoostType, expireTimestamp: any } | null>, teamHeat: { __typename: 'TeamHeat', id: string, currentScore: number, lastUpdateScore: number, lastUpdateScoreTimestamp?: any | null, maxHeatExpireTimestamp?: any | null, isMaxHeat: boolean }, teamMonthlyPass?: { __typename: 'TeamMonthlyPass', id: string, teamHeatIteration: number, availableTeamHeatMilestone: number } | null } | null, currentUserMonthlyPass: { __typename: 'UserMonthlyPass', id: string, claimedTeamHeatMilestone: Array<number> } } | null };

export type UpdateTeamHeatInfoMutationVariables = Exact<{
  input: TeamHeatUpdateInput;
}>;


export type UpdateTeamHeatInfoMutation = { __typename: 'Mutation', updateTeamHeat: { __typename: 'TeamHeatUpdatePayload', teamHeat: { __typename: 'TeamHeat', id: string, currentScore: number, lastUpdateScore: number, lastUpdateScoreTimestamp?: any | null, maxHeatExpireTimestamp?: any | null, isMaxHeat: boolean }, teamMonthlyPass: { __typename: 'TeamMonthlyPass', id: string, teamHeatIteration: number, availableTeamHeatMilestone: number } } };

export type UpdateTeamBoostsMutationVariables = Exact<{
  input: UpdateTeamBoostsInput;
}>;


export type UpdateTeamBoostsMutation = { __typename: 'Mutation', updateTeamBoosts: { __typename: 'UpdateTeamBoostsPayload', team: { __typename: 'Team', id: string, availableBoosts: number, boosts: Array<{ __typename: 'TeamHeatBoost', type: CurrencyBoostType, expireTimestamp: any } | null> } } };

export type ResetClaimedTeamHeatMilestonesMutationVariables = Exact<{
  input: ResetTeamHeatClaimedMilestonesInput;
}>;


export type ResetClaimedTeamHeatMilestonesMutation = { __typename: 'Mutation', resetClaimedTeamHeatMilestones: { __typename: 'ResetTeamHeatClaimedMilestonesPayload', userMonthlyPass: { __typename: 'UserMonthlyPass', id: string, claimedTeamHeatMilestone: Array<number> } } };

export type UserEmojiPacksQueryVariables = Exact<{
  property: Scalars['String'];
  type: UserSearchType;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type UserEmojiPacksQuery = { __typename: 'Query', user?: { __typename: 'User', id: string, emojiPacks: { __typename: 'UserEmojiPackPaginated', id: string, totalCount: number, hasMore: boolean, list: Array<{ __typename: 'UserEmojiPack', isActive: boolean, availability: Array<{ __typename: 'EmojiAvailabilityInfo', isAvailable: boolean, type: EmojiAvailabilityType }>, emojiPack: { __typename: 'EmojiPack', id: string, name: string, asset: string, layout: EmojiPackLayout, emojis: Array<{ __typename: 'Emoji', id: string, asset: string, name: string, utfCode: string }> } }> } } | null };

export type DeleteUserEmojiPackMutationVariables = Exact<{
  input: DeleteUserEmojiPackInput;
}>;


export type DeleteUserEmojiPackMutation = { __typename: 'Mutation', deleteUserEmojiPack: { __typename: 'UserEmojiPackCommonPayload', user: { __typename: 'User', id: string, emojiPacks: { __typename: 'UserEmojiPackPaginated', id: string, totalCount: number, hasMore: boolean, list: Array<{ __typename: 'UserEmojiPack', isActive: boolean, availability: Array<{ __typename: 'EmojiAvailabilityInfo', isAvailable: boolean, type: EmojiAvailabilityType }>, emojiPack: { __typename: 'EmojiPack', id: string, name: string, asset: string, layout: EmojiPackLayout, emojis: Array<{ __typename: 'Emoji', id: string, asset: string, name: string, utfCode: string }> } }> } } } };

export type UpdateUserEmojiPackMutationVariables = Exact<{
  input: UpdateUserEmojiPackInput;
}>;


export type UpdateUserEmojiPackMutation = { __typename: 'Mutation', updateUserEmojiPack: { __typename: 'UserEmojiPackCommonPayload', user: { __typename: 'User', id: string, emojiPacks: { __typename: 'UserEmojiPackPaginated', id: string, totalCount: number, hasMore: boolean, list: Array<{ __typename: 'UserEmojiPack', isActive: boolean, availability: Array<{ __typename: 'EmojiAvailabilityInfo', isAvailable: boolean, type: EmojiAvailabilityType }>, emojiPack: { __typename: 'EmojiPack', id: string, name: string, asset: string, layout: EmojiPackLayout, emojis: Array<{ __typename: 'Emoji', id: string, asset: string, name: string, utfCode: string }> } }> } } } };

export type AddUserEmojiPackMutationVariables = Exact<{
  input: AddUserEmojiPackInput;
}>;


export type AddUserEmojiPackMutation = { __typename: 'Mutation', addUserEmojiPack: { __typename: 'UserEmojiPackCommonPayload', user: { __typename: 'User', id: string, emojiPacks: { __typename: 'UserEmojiPackPaginated', id: string, totalCount: number, hasMore: boolean, list: Array<{ __typename: 'UserEmojiPack', isActive: boolean, availability: Array<{ __typename: 'EmojiAvailabilityInfo', isAvailable: boolean, type: EmojiAvailabilityType }>, emojiPack: { __typename: 'EmojiPack', id: string, name: string, asset: string, layout: EmojiPackLayout, emojis: Array<{ __typename: 'Emoji', id: string, asset: string, name: string, utfCode: string }> } }> } } } };

export type ResetEmojiPackTutorialMutationVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type ResetEmojiPackTutorialMutation = { __typename: 'Mutation', resetEmojiPackTutorial: { __typename: 'UserEmojiPackCommonPayload', user: { __typename: 'User', id: string, emojiPacks: { __typename: 'UserEmojiPackPaginated', id: string, totalCount: number, hasMore: boolean, list: Array<{ __typename: 'UserEmojiPack', isActive: boolean, availability: Array<{ __typename: 'EmojiAvailabilityInfo', isAvailable: boolean, type: EmojiAvailabilityType }>, emojiPack: { __typename: 'EmojiPack', id: string, name: string, asset: string, layout: EmojiPackLayout, emojis: Array<{ __typename: 'Emoji', id: string, asset: string, name: string, utfCode: string }> } }> } } } };

export type ResetDailyEmojisMutationVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type ResetDailyEmojisMutation = { __typename: 'Mutation', resetDailyEmojis: number };

export type GetUserExportsQueryVariables = Exact<{
  input: UserExportsInput;
}>;


export type GetUserExportsQuery = { __typename: 'Query', userExports: { __typename: 'UserExportsPayload', userExports: Array<{ __typename: 'UserExport', id: string, requested: any, processed?: any | null, status?: UserExportStatus | null, jobStatus?: UserExportJobStatus | null, jobStartedAt?: any | null, exportedAt?: any | null, fileExpiresAt?: any | null }> } };

export type GetSignedDownloadUrlQueryVariables = Exact<{
  input: GetSignedDownloadUrlInput;
}>;


export type GetSignedDownloadUrlQuery = { __typename: 'Query', getSignedDownloadUrl: { __typename: 'GetSignedDownloadUrlPayload', url: string } };

export type StartExportJobMutationVariables = Exact<{
  input: StartExportJobInput;
}>;


export type StartExportJobMutation = { __typename: 'Mutation', startExportJob: { __typename: 'StartExportJobPayload', userExport: { __typename: 'UserExport', id: string, requested: any, processed?: any | null, status?: UserExportStatus | null, jobStatus?: UserExportJobStatus | null, jobStartedAt?: any | null, exportedAt?: any | null, fileExpiresAt?: any | null } } };

export type CreateExportRequestMutationVariables = Exact<{
  input: CreateExportRequestInput;
}>;


export type CreateExportRequestMutation = { __typename: 'Mutation', createExportRequest: { __typename: 'CreateExportRequestPayload', userExport: { __typename: 'UserExport', id: string, requested: any, processed?: any | null, status?: UserExportStatus | null, jobStatus?: UserExportJobStatus | null, jobStartedAt?: any | null, exportedAt?: any | null, fileExpiresAt?: any | null } } };

export type ProcessExportRequestMutationVariables = Exact<{
  input: ProcessExportRequestInput;
}>;


export type ProcessExportRequestMutation = { __typename: 'Mutation', processExportRequest: { __typename: 'ProcessExportRequestPayload', userExport: { __typename: 'UserExport', id: string, requested: any, processed?: any | null, status?: UserExportStatus | null, jobStatus?: UserExportJobStatus | null, jobStartedAt?: any | null, exportedAt?: any | null, fileExpiresAt?: any | null } } };

export type DeleteUserCalendarMutationVariables = Exact<{
  calendarId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type DeleteUserCalendarMutation = { __typename: 'Mutation', deleteUserCalendar: { __typename: 'User', id: string, calendars: Array<{ __typename: 'PaidCalendar', id: string, name: string }> } };

export type GetMarathonEventMilestonesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetMarathonEventMilestonesQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', getMarathonEvent: { __typename: 'MarathonEventConfig', id: string, milestones: Array<{ __typename: 'MarathonMilestoneConfig', numberOfGuesses: number, type: MarathonMilestoneType }> } } };

export type GetCurrentUserMarathonEventQueryVariables = Exact<{
  property: Scalars['String'];
  type: UserSearchType;
}>;


export type GetCurrentUserMarathonEventQuery = { __typename: 'Query', user?: { __typename: 'User', id: string, userMarathonEvent?: { __typename: 'UserMarathonEvent', id: string, eventId: string, checkPoint: number, maxSongReached: number, currentRound?: { __typename: 'UserMarathonRound', id: string, state: number } | null, milestoneClaimed: Array<{ __typename: 'UserMarathonMilestone', index: number, isBasicClaimed: boolean, isPlusClaimed: boolean }> } | null } | null };

export type UpdateUserMarathonEventMutationVariables = Exact<{
  input: UpdateUserMarathonEventInput;
}>;


export type UpdateUserMarathonEventMutation = { __typename: 'Mutation', updateUserMarathonEvent: { __typename: 'UpdateUserMarathonEventPayload', userEvent: { __typename: 'UserMarathonEvent', id: string, eventId: string, checkPoint: number, maxSongReached: number, currentRound?: { __typename: 'UserMarathonRound', id: string, state: number } | null, milestoneClaimed: Array<{ __typename: 'UserMarathonMilestone', index: number, isBasicClaimed: boolean, isPlusClaimed: boolean }> } } };

export type ResetUserMarathonEventMutationVariables = Exact<{
  input: ResetUserMarathonEventInput;
}>;


export type ResetUserMarathonEventMutation = { __typename: 'Mutation', resetUserMarathonEvent: { __typename: 'ResetUserMarathonEventPayload', userEvent?: { __typename: 'UserMarathonEvent', id: string, eventId: string, checkPoint: number, maxSongReached: number, currentRound?: { __typename: 'UserMarathonRound', id: string, state: number } | null, milestoneClaimed: Array<{ __typename: 'UserMarathonMilestone', index: number, isBasicClaimed: boolean, isPlusClaimed: boolean }> } | null } };

export type GetUserMarathonAchievementsQueryVariables = Exact<{
  property: Scalars['String'];
  type: UserSearchType;
}>;


export type GetUserMarathonAchievementsQuery = { __typename: 'Query', user?: { __typename: 'User', id: string, achievementMissions?: { __typename: 'UserAchievementMissions', id: string, missions: Array<{ __typename: 'MissionProgress', id: string, progress: number, progressGoal: number, completedDate?: any | null, claimedDate?: any | null, claimedMultiplier?: number | null, mission: { __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null } }> } | null } | null };

export type UpdateUserMarathonAchievementProgressMutationVariables = Exact<{
  input: UpdateUmeAchievement;
}>;


export type UpdateUserMarathonAchievementProgressMutation = { __typename: 'Mutation', updateUserMarathonAchievementProgress: number };

export type AutocompleteSongQueryVariables = Exact<{
  input: HurdleAutoCompleteInput;
}>;


export type AutocompleteSongQuery = { __typename: 'Query', hurdleAutoComplete: { __typename: 'HurdleAutoCompletePayload', items: Array<{ __typename: 'SongItemSuggestion', id: string, title: string, artist: string, catalogItemId: string }> } };

export type GetNumberOfRecipientsQueryVariables = Exact<{
  filters: GiftFiltersInput;
}>;


export type GetNumberOfRecipientsQuery = { __typename: 'Query', getPotentialNumberOfRecipients: { __typename: 'AdminGiftPayload', count: number, metadataList: Array<string> } };

export type GetDraftGiftsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDraftGiftsQuery = { __typename: 'Query', getDraftGifts: Array<{ __typename: 'IapGiftDraft', id: string, created: any, sendDate?: any | null, sku: string, messageId?: string | null, recipientsCount?: number | null, sentRecipientsCount: number, deliveryStatus: string, totalBatches: number, pendingBatches: number, runningBatches: number, completedBatches: number, failedBatches: number, filters: { __typename: 'GiftFilters', appVersion?: string | null, platform?: string | null, region?: string | null, country?: string | null, age?: number | null, gender?: string | null, subTier?: UserSubscriptionTier | null, daysSinceInstall?: number | null, isSpender?: number | null, specificUsers?: Array<string> | null, daysSinceLastOnline?: number | null }, rewards: Array<{ __typename: 'IapGiftDraftReward', itemId: string, type: string, amount: number }> }> };

export type CreateGiftAdminMutationVariables = Exact<{
  filters: GiftFiltersInput;
  gifts: Array<LevelRewardInput> | LevelRewardInput;
  messageId?: InputMaybe<Scalars['String']>;
  sendDate?: InputMaybe<Scalars['Date']>;
  recipientsCount?: InputMaybe<Scalars['Int']>;
}>;


export type CreateGiftAdminMutation = { __typename: 'Mutation', createGiftAdmin: { __typename: 'IapGiftDraft', id: string, created: any, sendDate?: any | null, sku: string, messageId?: string | null, recipientsCount?: number | null, sentRecipientsCount: number, deliveryStatus: string, totalBatches: number, pendingBatches: number, runningBatches: number, completedBatches: number, failedBatches: number, filters: { __typename: 'GiftFilters', appVersion?: string | null, platform?: string | null, region?: string | null, country?: string | null, age?: number | null, gender?: string | null, subTier?: UserSubscriptionTier | null, daysSinceInstall?: number | null, isSpender?: number | null, specificUsers?: Array<string> | null, daysSinceLastOnline?: number | null }, rewards: Array<{ __typename: 'IapGiftDraftReward', itemId: string, type: string, amount: number }> } };

export type UpdateGiftAdminMutationVariables = Exact<{
  id: Scalars['ID'];
  filters: GiftFiltersInput;
  gifts: Array<LevelRewardInput> | LevelRewardInput;
  messageId?: InputMaybe<Scalars['String']>;
  sendDate?: InputMaybe<Scalars['Date']>;
  recipientsCount?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateGiftAdminMutation = { __typename: 'Mutation', updateGiftAdmin: { __typename: 'IapGiftDraft', id: string, created: any, sendDate?: any | null, sku: string, messageId?: string | null, recipientsCount?: number | null, sentRecipientsCount: number, deliveryStatus: string, totalBatches: number, pendingBatches: number, runningBatches: number, completedBatches: number, failedBatches: number, filters: { __typename: 'GiftFilters', appVersion?: string | null, platform?: string | null, region?: string | null, country?: string | null, age?: number | null, gender?: string | null, subTier?: UserSubscriptionTier | null, daysSinceInstall?: number | null, isSpender?: number | null, specificUsers?: Array<string> | null, daysSinceLastOnline?: number | null }, rewards: Array<{ __typename: 'IapGiftDraftReward', itemId: string, type: string, amount: number }> } };

export type RetryGiftAdminMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RetryGiftAdminMutation = { __typename: 'Mutation', retryGiftAdmin: { __typename: 'IapGiftDraft', id: string, created: any, sendDate?: any | null, sku: string, messageId?: string | null, recipientsCount?: number | null, sentRecipientsCount: number, deliveryStatus: string, totalBatches: number, pendingBatches: number, runningBatches: number, completedBatches: number, failedBatches: number, filters: { __typename: 'GiftFilters', appVersion?: string | null, platform?: string | null, region?: string | null, country?: string | null, age?: number | null, gender?: string | null, subTier?: UserSubscriptionTier | null, daysSinceInstall?: number | null, isSpender?: number | null, specificUsers?: Array<string> | null, daysSinceLastOnline?: number | null }, rewards: Array<{ __typename: 'IapGiftDraftReward', itemId: string, type: string, amount: number }> } };

export type RemoveDraftGiftAdminMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveDraftGiftAdminMutation = { __typename: 'Mutation', removeDraftGiftAdmin: { __typename: 'RemoveDraftGiftAdminPayload', isRemoved: boolean } };

export type GetAllMessageTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllMessageTemplatesQuery = { __typename: 'Query', getMessageTemplates: Array<{ __typename: 'MessageTemplate', id: string, message: string }> };

export type CreateMessageTemplateMutationVariables = Exact<{
  msg: Scalars['String'];
}>;


export type CreateMessageTemplateMutation = { __typename: 'Mutation', createMessageTemplate: Array<{ __typename: 'MessageTemplate', id: string, message: string }> };

export type EditMessageTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
  msg: Scalars['String'];
}>;


export type EditMessageTemplateMutation = { __typename: 'Mutation', editMessageTemplate: Array<{ __typename: 'MessageTemplate', id: string, message: string }> };

export type DeleteMessageTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteMessageTemplateMutation = { __typename: 'Mutation', deleteMessageTemplate: Array<{ __typename: 'MessageTemplate', id: string, message: string }> };

export type GetSubscriptionFeatureTogglesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubscriptionFeatureTogglesQuery = { __typename: 'Query', app: { __typename: 'App', id: string, autoRenewReminderPopupEnabled: boolean, sandboxSubscriptionSkuCheatEnabled: boolean, sandboxSubscriptionSkuCheatUserIds: Array<string> } };

export type UpdateSubscriptionFeatureTogglesMutationVariables = Exact<{
  autoRenewReminderPopupEnabled?: InputMaybe<Scalars['Boolean']>;
  sandboxSubscriptionSkuCheatEnabled?: InputMaybe<Scalars['Boolean']>;
  sandboxSubscriptionSkuCheatUserIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type UpdateSubscriptionFeatureTogglesMutation = { __typename: 'Mutation', updateAppFeatureToggles: { __typename: 'AppFeatureToggles', autoRenewReminderPopupEnabled: boolean, sandboxSubscriptionSkuCheatEnabled: boolean, sandboxSubscriptionSkuCheatUserIds: Array<string> } };

export type GetUnsupportedPopupConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnsupportedPopupConfigsQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', unsupportedPopupConfigs: Array<{ __typename: 'UnsupportedPopupConfig', id: string, key: string, name: string, enabled: boolean, place: PopupPlacement, targetSystemName: UnsupportedPopupTargetSystemName, popupType: UnsupportedPopupType, minimumDeviceVersion?: string | null, blockerReleaseVersion?: string | null, displayPolicy: UnsupportedPopupDisplayPolicy, titleTexts: any, bodyTexts: any }> } };

export type CreateUnsupportedPopupMutationVariables = Exact<{
  input: UnsupportedPopupConfigInput;
}>;


export type CreateUnsupportedPopupMutation = { __typename: 'Mutation', createUnsupportedPopupConfig: { __typename: 'UnsupportedPopupConfig', id: string, key: string, name: string, enabled: boolean, targetSystemName: UnsupportedPopupTargetSystemName, popupType: UnsupportedPopupType, minimumDeviceVersion?: string | null, blockerReleaseVersion?: string | null, displayPolicy: UnsupportedPopupDisplayPolicy, titleTexts: any, bodyTexts: any } };

export type UpdateUnsupportedPopupMutationVariables = Exact<{
  input: UpdateUnsupportedPopupConfigInput;
}>;


export type UpdateUnsupportedPopupMutation = { __typename: 'Mutation', updateUnsupportedPopupConfig: { __typename: 'UnsupportedPopupConfig', id: string, key: string, name: string, enabled: boolean, targetSystemName: UnsupportedPopupTargetSystemName, popupType: UnsupportedPopupType, minimumDeviceVersion?: string | null, blockerReleaseVersion?: string | null, displayPolicy: UnsupportedPopupDisplayPolicy, titleTexts: any, bodyTexts: any } };

export type DeleteUnsupportedPopupMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteUnsupportedPopupMutation = { __typename: 'Mutation', deleteUnsupportedPopupConfig: string };

export type SetLatestUpdateGiftMutationVariables = Exact<{
  eligibleIosVersions: Array<Scalars['Int']> | Scalars['Int'];
  eligibleAndroidVersions: Array<Scalars['Int']> | Scalars['Int'];
  betaIosVersions?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  betaAndroidVersions?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  gift1Type: Scalars['String'];
  gift1Amount: Scalars['Int'];
  gift2Type: Scalars['String'];
  gift2Amount: Scalars['Int'];
}>;


export type SetLatestUpdateGiftMutation = { __typename: 'Mutation', setLatestUpdateGift: { __typename: 'LatestUpdateGift', eligibleIosVersions: Array<number>, eligibleAndroidVersions: Array<number>, betaIosVersions: Array<number>, betaAndroidVersions: Array<number>, gift1Type: string, gift1Amount: number, gift2Type: string, gift2Amount: number, updatedAt: any } };

export type UpdateGiftHistoryQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateGiftHistoryQuery = { __typename: 'Query', updateGiftHistory: Array<{ __typename: 'UpdateGiftHistory', id: string, appId: string, eligibleIosVersions: Array<number>, eligibleAndroidVersions: Array<number>, betaIosVersions: Array<number>, betaAndroidVersions: Array<number>, gift1Type: string, gift1Amount: number, gift2Type: string, gift2Amount: number, createdAt: any }> };

export type UpdateUpdateGiftHistoryMutationVariables = Exact<{
  id: Scalars['ID'];
  eligibleIosVersions?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  eligibleAndroidVersions?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  betaIosVersions?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  betaAndroidVersions?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  gift1Type?: InputMaybe<Scalars['String']>;
  gift1Amount?: InputMaybe<Scalars['Int']>;
  gift2Type?: InputMaybe<Scalars['String']>;
  gift2Amount?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateUpdateGiftHistoryMutation = { __typename: 'Mutation', updateUpdateGiftHistory: { __typename: 'UpdateGiftHistory', id: string, eligibleIosVersions: Array<number>, eligibleAndroidVersions: Array<number>, betaIosVersions: Array<number>, betaAndroidVersions: Array<number>, gift1Type: string, gift1Amount: number, gift2Type: string, gift2Amount: number, createdAt: any } };

export type DeleteUpdateGiftHistoryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteUpdateGiftHistoryMutation = { __typename: 'Mutation', deleteUpdateGiftHistory: boolean };

export type GetAppVersionConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppVersionConfigsQuery = { __typename: 'Query', getAppVersionConfigs: Array<{ __typename: 'AppVersionConfig', version: string, platform: string, forceUpdateType: string, numericVersion: number }> };

export type CreateAppVersionConfigMutationVariables = Exact<{
  version: Scalars['String'];
  forceUpdateType: Scalars['String'];
  platform: Scalars['String'];
}>;


export type CreateAppVersionConfigMutation = { __typename: 'Mutation', createAppVersionConfig: Array<{ __typename: 'AppVersionConfig', version: string, platform: string, forceUpdateType: string, numericVersion: number }> };

export type DeleteAppVersionConfigMutationVariables = Exact<{
  version: Scalars['String'];
  platform: Scalars['String'];
}>;


export type DeleteAppVersionConfigMutation = { __typename: 'Mutation', deleteAppVersionConfig: Array<{ __typename: 'AppVersionConfig', version: string, platform: string, forceUpdateType: string, numericVersion: number }> };

export type UpdateAppVersionConfigMutationVariables = Exact<{
  version: Scalars['String'];
  forceUpdateType: Scalars['String'];
  platform: Scalars['String'];
}>;


export type UpdateAppVersionConfigMutation = { __typename: 'Mutation', updateAppVersionConfig: Array<{ __typename: 'AppVersionConfig', version: string, platform: string, forceUpdateType: string, numericVersion: number }> };

export type GetStickersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStickersQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', stickers: { __typename: 'StickerPaginated', list: Array<{ __typename: 'Sticker', id: string, name: string, liveOpsAvailability: ItemAvailability, asset: string, cost?: { __typename: 'CurrencyAccolade' } | { __typename: 'CurrencyBoost' } | { __typename: 'CurrencyCategoryFragment', id: string, amount: number, category: { __typename: 'ContentCategory', id: string } } | { __typename: 'CurrencyCategoryRandom' } | { __typename: 'CurrencyCoin', id: string, amount: number } | { __typename: 'CurrencyDiamond', id: string, amount: number } | { __typename: 'CurrencyFreeSpin' } | { __typename: 'CurrencyLiveEvent' } | { __typename: 'CurrencyLoyaltyPoints' } | { __typename: 'CurrencyMetaFragmentBronze' } | { __typename: 'CurrencyMetaFragmentGold' } | { __typename: 'CurrencyMetaFragmentSilver' } | { __typename: 'CurrencyShardBronze' } | { __typename: 'CurrencyShardGold' } | { __typename: 'CurrencyShardSilver' } | { __typename: 'CurrencySpecialEvent' } | { __typename: 'CurrencyStampCard' } | { __typename: 'CurrencySubscriptionDay' } | { __typename: 'CurrencyTournamentTicket' } | { __typename: 'CurrencyUnlimitedBoost' } | { __typename: 'CurrencyXP' } | null, nextLevelItems: Array<{ __typename: 'AppSkin', id: string, level: number, asset: string, cost?: { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | null } | { __typename: 'ProfileFrame', id: string, level: number, asset: string, cost?: { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | null } | { __typename: 'Sticker', id: string, level: number, asset: string, cost?: { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | null }> }> } } };

export type GetSkinsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSkinsQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', appskins: { __typename: 'AppSkinPaginated', list: Array<{ __typename: 'AppSkin', id: string, name: string, iconAsset?: string | null, iconPrimaryColor?: string | null, iconBackgroundColor?: string | null, liveOpsAvailability: ItemAvailability, asset: string, cost?: { __typename: 'CurrencyAccolade' } | { __typename: 'CurrencyBoost' } | { __typename: 'CurrencyCategoryFragment', id: string, amount: number, category: { __typename: 'ContentCategory', id: string } } | { __typename: 'CurrencyCategoryRandom' } | { __typename: 'CurrencyCoin', id: string, amount: number } | { __typename: 'CurrencyDiamond', id: string, amount: number } | { __typename: 'CurrencyFreeSpin' } | { __typename: 'CurrencyLiveEvent' } | { __typename: 'CurrencyLoyaltyPoints' } | { __typename: 'CurrencyMetaFragmentBronze' } | { __typename: 'CurrencyMetaFragmentGold' } | { __typename: 'CurrencyMetaFragmentSilver' } | { __typename: 'CurrencyShardBronze' } | { __typename: 'CurrencyShardGold' } | { __typename: 'CurrencyShardSilver' } | { __typename: 'CurrencySpecialEvent' } | { __typename: 'CurrencyStampCard' } | { __typename: 'CurrencySubscriptionDay' } | { __typename: 'CurrencyTournamentTicket' } | { __typename: 'CurrencyUnlimitedBoost' } | { __typename: 'CurrencyXP' } | null, nextLevelItems: Array<{ __typename: 'AppSkin', id: string, level: number, asset: string, cost?: { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | null } | { __typename: 'ProfileFrame', id: string, level: number, asset: string, cost?: { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | null } | { __typename: 'Sticker', id: string, level: number, asset: string, cost?: { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | null }> }> } } };

export type GetFramesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFramesQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', profileFrames: { __typename: 'ProfileFramePaginated', list: Array<{ __typename: 'ProfileFrame', id: string, name: string, liveOpsAvailability: ItemAvailability, asset: string, cost?: { __typename: 'CurrencyAccolade' } | { __typename: 'CurrencyBoost' } | { __typename: 'CurrencyCategoryFragment', id: string, amount: number, category: { __typename: 'ContentCategory', id: string } } | { __typename: 'CurrencyCategoryRandom' } | { __typename: 'CurrencyCoin', id: string, amount: number } | { __typename: 'CurrencyDiamond', id: string, amount: number } | { __typename: 'CurrencyFreeSpin' } | { __typename: 'CurrencyLiveEvent' } | { __typename: 'CurrencyLoyaltyPoints' } | { __typename: 'CurrencyMetaFragmentBronze' } | { __typename: 'CurrencyMetaFragmentGold' } | { __typename: 'CurrencyMetaFragmentSilver' } | { __typename: 'CurrencyShardBronze' } | { __typename: 'CurrencyShardGold' } | { __typename: 'CurrencyShardSilver' } | { __typename: 'CurrencySpecialEvent' } | { __typename: 'CurrencyStampCard' } | { __typename: 'CurrencySubscriptionDay' } | { __typename: 'CurrencyTournamentTicket' } | { __typename: 'CurrencyUnlimitedBoost' } | { __typename: 'CurrencyXP' } | null, nextLevelItems: Array<{ __typename: 'AppSkin', id: string, level: number, asset: string, cost?: { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | null } | { __typename: 'ProfileFrame', id: string, level: number, asset: string, cost?: { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | null } | { __typename: 'Sticker', id: string, level: number, asset: string, cost?: { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | null }> }> } } };

export type UpdateItemMutationVariables = Exact<{
  input: UpdateItemInput;
}>;


export type UpdateItemMutation = { __typename: 'Mutation', updateItem: { __typename: 'UpdateItemPayload', item: { __typename: 'AppSkin', id: string, name: string } | { __typename: 'ProfileFrame', id: string, name: string } | { __typename: 'Sticker', id: string, name: string } } };

export type CreateItemMutationVariables = Exact<{
  input: CreateItemInput;
}>;


export type CreateItemMutation = { __typename: 'Mutation', createItem: { __typename: 'CreateItemPayload', item: { __typename: 'AppSkin', id: string, name: string } | { __typename: 'ProfileFrame', id: string, name: string } | { __typename: 'Sticker', id: string, name: string } } };

export type UploadAssetMutationVariables = Exact<{
  input: UploadAssetInput;
}>;


export type UploadAssetMutation = { __typename: 'Mutation', uploadAsset: { __typename: 'UploadAssetPayload', item: { __typename: 'AppSkin', id: string, name: string, asset: string } | { __typename: 'ProfileFrame', id: string, name: string, asset: string } | { __typename: 'Sticker', id: string, name: string, asset: string } } };

export type UploadIconAssetMutationVariables = Exact<{
  input: UploadIconAssetInput;
}>;


export type UploadIconAssetMutation = { __typename: 'Mutation', uploadIconAsset: { __typename: 'UploadAssetPayload', item: { __typename: 'AppSkin', id: string, name: string, asset: string } | { __typename: 'ProfileFrame', id: string, name: string, asset: string } | { __typename: 'Sticker', id: string, name: string, asset: string } } };

export type UploadSheetMutationVariables = Exact<{
  input: UploadSheetInput;
}>;


export type UploadSheetMutation = { __typename: 'Mutation', uploadSheet: { __typename: 'UploadSheetPayload', message: string } };

export type GetMonthlyPassesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMonthlyPassesQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', id: string, monthlyPasses: { __typename: 'MonthlyPassPaginated', list: Array<{ __typename: 'MonthlyPass', id: string, monthId: string, month: number, year: number, levels: Array<{ __typename: 'LevelConfigMonthlyPass', level: number, xpToNextLevel: number, basicReward: { __typename: 'AppSkin', id: string } | { __typename: 'Badge', id: string } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string, name: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string } | { __typename: 'EmojiPack', id: string } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }, plusReward?: { __typename: 'AppSkin', id: string } | { __typename: 'Badge', id: string } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string, name: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string } | { __typename: 'EmojiPack', id: string } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string } | null }>, teamRankGroups: Array<{ __typename: 'LBRankGroup', id: string, minRank: number, maxRank: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge', id: string } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string, name: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string } | { __typename: 'EmojiPack', id: string } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }>, leaderboardRankGroups: Array<{ __typename: 'LBRankGroup', id: string, minRank: number, maxRank: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge', id: string } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string, name: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string } | { __typename: 'EmojiPack', id: string } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }>, teamHeatIterations: Array<{ __typename: 'TeamHeatIteration', milestonesReward: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge', id: string } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string, name: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string } | { __typename: 'EmojiPack', id: string } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> } | null>, missions?: { __typename: 'MonthlyPassMissions', id: string, dailyMissions: Array<{ __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null }>, monthlyMissions: Array<{ __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null }>, extraMissions: Array<{ __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null }>, teamMissions: Array<{ __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null }> } | null }> } } };

export type UpdateMonthlyPassMutationVariables = Exact<{
  input: UpdateMonthlyPassInput;
}>;


export type UpdateMonthlyPassMutation = { __typename: 'Mutation', updateMonthlyPass: { __typename: 'UpdatedMonthlyPassPayload', monthlyPass: { __typename: 'MonthlyPass', id: string, levels: Array<{ __typename: 'LevelConfigMonthlyPass', level: number }> } } };

export type InitMonthlyPassMissionsMutationVariables = Exact<{
  input: InitMonthlyPassMissionsInput;
}>;


export type InitMonthlyPassMissionsMutation = { __typename: 'Mutation', initMonthlyPassMissions: { __typename: 'MonthlyPassMissionsPayload', missions: { __typename: 'MonthlyPassMissions', id: string } } };

export type UpdateMonthlyPassMissionsMutationVariables = Exact<{
  input: UpdateMonthlyPassMissionsInput;
}>;


export type UpdateMonthlyPassMissionsMutation = { __typename: 'Mutation', updateMonthlyPassMissions: { __typename: 'MonthlyPassMissionsPayload', missions: { __typename: 'MonthlyPassMissions', id: string } } };

export type UpdateTeamHeatIterationMilestonesMutationVariables = Exact<{
  input: TeamHeatIterationInput;
}>;


export type UpdateTeamHeatIterationMilestonesMutation = { __typename: 'Mutation', updateTeamHeatIterationMilestones: { __typename: 'UpdateTeamHeatIterationMilestonesPayload', monthlyPass: { __typename: 'MonthlyPass', teamHeatIterations: Array<{ __typename: 'TeamHeatIteration', milestonesReward: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge', id: string } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string, name: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string } | { __typename: 'EmojiPack', id: string } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> } | null> } } };

export type ContentCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type ContentCategoriesQuery = { __typename: 'Query', app: { __typename: 'App', contentCategories: Array<{ __typename: 'ContentCategory', id: string, name: string, icon: string }> } };

export type QuizLiveShowPresetsQueryVariables = Exact<{ [key: string]: never; }>;


export type QuizLiveShowPresetsQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', quizLiveShowPresets: Array<{ __typename: 'QuizLiveShowPreset', id: string, description?: string | null }> } };

export type ContentPacksByCategoryQueryVariables = Exact<{
  category: Scalars['ID'];
  excludeExplicit: Scalars['Boolean'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type ContentPacksByCategoryQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', contentPacksByCategory?: Array<{ __typename: 'ContentPack', id: string, name: string }> | null } };

export type GetItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetItemsQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', stickers: { __typename: 'StickerPaginated', list: Array<{ __typename: 'Sticker', id: string, name: string, liveOpsAvailability: ItemAvailability }> }, appskins: { __typename: 'AppSkinPaginated', list: Array<{ __typename: 'AppSkin', id: string, name: string, liveOpsAvailability: ItemAvailability }> }, profileFrames: { __typename: 'ProfileFramePaginated', list: Array<{ __typename: 'ProfileFrame', id: string, name: string, liveOpsAvailability: ItemAvailability }> }, posters: Array<{ __typename: 'Poster', id: string, type: PosterType, name: string, currencyCost?: number | null, currencyType?: string | null, itemId?: string | null, asset?: string | null }> } };

export type CreateMonthlyPassMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateMonthlyPassMutation = { __typename: 'Mutation', createMonthlyPass: { __typename: 'UpdatedMonthlyPassPayload', monthlyPass: { __typename: 'MonthlyPass', id: string } } };

export type GetVanityItemQueryVariables = Exact<{
  property: Scalars['String'];
  type: SearchType;
}>;


export type GetVanityItemQuery = { __typename: 'Query', item?: { __typename: 'AppSkin', iconAsset?: string | null, iconPrimaryColor?: string | null, iconBackgroundColor?: string | null, id: string, name: string, asset: string, level: number, availability: ItemAvailability, cost?: { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | null } | { __typename: 'ProfileFrame', id: string, name: string, asset: string, level: number, availability: ItemAvailability, cost?: { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | null } | { __typename: 'Sticker', id: string, name: string, asset: string, level: number, availability: ItemAvailability, cost?: { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | null } | null };

export type GetBadgesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBadgesQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', badgeConfigs: { __typename: 'BadgeConfigPaginated', hasMore: boolean, totalCount: number, list: Array<{ __typename: 'BadgeConfig', id: string, type: BadgeType, name: string, unlockReq?: string | null, levelUpReq?: string | null, details: string }> } } };

export type CreateBadgeMutationVariables = Exact<{
  input: CreateBadgeInput;
}>;


export type CreateBadgeMutation = { __typename: 'Mutation', createBadge: { __typename: 'CreateBadgePayload', badge: { __typename: 'BadgeConfig', id: string, type: BadgeType, name: string, unlockReq?: string | null, levelUpReq?: string | null, details: string } } };

export type UpdateBadgeMutationVariables = Exact<{
  input: UpdateBadgeInput;
}>;


export type UpdateBadgeMutation = { __typename: 'Mutation', updateBadge: { __typename: 'UpdateBadgePayload', badge: { __typename: 'BadgeConfig', id: string, type: BadgeType, name: string, unlockReq?: string | null, levelUpReq?: string | null, details: string } } };

export type UploadBadgeAssetsMutationVariables = Exact<{
  input: UploadBadgeAssetInput;
}>;


export type UploadBadgeAssetsMutation = { __typename: 'Mutation', uploadBadgeAssets: { __typename: 'UploadBadgeAssetPayload', asset: string } };

export type DeleteBadgeMutationVariables = Exact<{
  input: RemoveBadgeInput;
}>;


export type DeleteBadgeMutation = { __typename: 'Mutation', removeBadge: { __typename: 'RemoveBadgePayload', badgeDeleted: string } };

export type GetSpecialBadgeUnlockAndLevelUpRequirementsConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSpecialBadgeUnlockAndLevelUpRequirementsConfigQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', badgeLevelUpReqConfig: Array<string>, badgeUnlockReqConfig: Array<string> } };

export type GetEmojiConfigsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetEmojiConfigsQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', emojisConfig: { __typename: 'EmojiConfigPaginated', hasMore: boolean, totalCount: number, list: Array<{ __typename: 'EmojiConfig', id: string, name: string }> } } };

export type GetEmojiPacksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmojiPacksQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', emojiPacks: { __typename: 'EmojiPackPaginated', hasMore: boolean, totalCount: number, list: Array<{ __typename: 'EmojiPack', id: string, name: string, asset: string, layout: EmojiPackLayout, isDraft: boolean, emojis: Array<{ __typename: 'Emoji', id: string, name: string, asset: string, utfCode: string, cost: { __typename: 'CurrencyDiamond', id: string, amount: number } }> }> } } };

export type CreateEmojiPackMutationVariables = Exact<{
  input: CreateEmojiPackInput;
}>;


export type CreateEmojiPackMutation = { __typename: 'Mutation', createEmojiPack: { __typename: 'CreateEmojiPackPayload', emojiPack: { __typename: 'EmojiPack', id: string, name: string, asset: string, layout: EmojiPackLayout, isDraft: boolean, emojis: Array<{ __typename: 'Emoji', id: string, name: string, asset: string, utfCode: string, cost: { __typename: 'CurrencyDiamond', id: string, amount: number } }> } } };

export type UpdateEmojiPackMutationVariables = Exact<{
  input: UpdateEmojiPackInput;
}>;


export type UpdateEmojiPackMutation = { __typename: 'Mutation', updateEmojiPack: { __typename: 'UpdateEmojiPackPayload', emojiPack: { __typename: 'EmojiPack', id: string, name: string, asset: string, layout: EmojiPackLayout, isDraft: boolean, emojis: Array<{ __typename: 'Emoji', id: string, name: string, asset: string, utfCode: string, cost: { __typename: 'CurrencyDiamond', id: string, amount: number } }> } } };

export type UploadEmojiPackAssetMutationVariables = Exact<{
  input: UploadEmojiPackAssetInput;
}>;


export type UploadEmojiPackAssetMutation = { __typename: 'Mutation', uploadEmojiPackAsset: { __typename: 'UploadEmojiPackAssetPayload', emojiPack: { __typename: 'EmojiPack', id: string, name: string, asset: string, layout: EmojiPackLayout, isDraft: boolean, emojis: Array<{ __typename: 'Emoji', id: string, name: string, asset: string, utfCode: string, cost: { __typename: 'CurrencyDiamond', id: string, amount: number } }> } } };

export type UploadBatchEmojiAssetMutationVariables = Exact<{
  input: UploadBatchEmojiAssetInput;
}>;


export type UploadBatchEmojiAssetMutation = { __typename: 'Mutation', uploadBatchEmojiAsset: { __typename: 'UploadBatchEmojiAssetPayload', assets: Array<string> } };

export type DeleteEmojiPackMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteEmojiPackMutation = { __typename: 'Mutation', deleteEmojiPack: string };

export type UploadEmojiFontMutationVariables = Exact<{
  input: UploadEmojisFontInput;
}>;


export type UploadEmojiFontMutation = { __typename: 'Mutation', uploadEmojisFont: { __typename: 'UploadEmojisFontPayload', asset: string } };

export type UpdateEmojiMutationVariables = Exact<{
  input: UpdateEmojiInput;
}>;


export type UpdateEmojiMutation = { __typename: 'Mutation', updateEmoji: { __typename: 'UpdateEmojiPayload', emoji: { __typename: 'Emoji', id: string, name: string, asset: string } } };

export type DeleteEmojiMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteEmojiMutation = { __typename: 'Mutation', deleteEmoji: string };

export type UploadEmojiAssetMutationVariables = Exact<{
  input: UploadEmojiAssetInput;
}>;


export type UploadEmojiAssetMutation = { __typename: 'Mutation', uploadEmojiAsset: { __typename: 'UploadEmojiAssetPayload', asset: string } };

export type EmojiFontInspectDataQueryVariables = Exact<{ [key: string]: never; }>;


export type EmojiFontInspectDataQuery = { __typename: 'Query', app: { __typename: 'App', id: string, emojiFontInspectData: Array<{ __typename: 'EmojiFontInspectData', versionInCache: string, version: string, updated: any, url: string }> } };

export type EmojiPacksLayoutAvailabilitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type EmojiPacksLayoutAvailabilitiesQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', emojiPacksLayoutAvailabilities: Array<{ __typename: 'EmojiPackLayoutInfo', type: EmojiPackLayout, availability: Array<EmojiAvailabilityType> }> } };

export type GetPostersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPostersQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', posters: Array<{ __typename: 'Poster', id: string, type: PosterType, name: string, currencyCost?: number | null, currencyType?: string | null, itemId?: string | null, asset?: string | null }> } };

export type CreatePosterMutationVariables = Exact<{
  input: CreatePosterInput;
}>;


export type CreatePosterMutation = { __typename: 'Mutation', createPoster: { __typename: 'Poster', id: string, type: PosterType, name: string, currencyCost?: number | null, currencyType?: string | null, itemId?: string | null, asset?: string | null } };

export type UpdatePosterMutationVariables = Exact<{
  input: UpdatePosterInput;
}>;


export type UpdatePosterMutation = { __typename: 'Mutation', updatePoster: { __typename: 'Poster', id: string, type: PosterType, name: string, currencyCost?: number | null, currencyType?: string | null, itemId?: string | null, asset?: string | null } };

export type UploadPosterAssetsMutationVariables = Exact<{
  input: UploadPosterAssetInput;
}>;


export type UploadPosterAssetsMutation = { __typename: 'Mutation', uploadPosterAssets: { __typename: 'Poster', id: string, type: PosterType, name: string, currencyCost?: number | null, currencyType?: string | null, itemId?: string | null, asset?: string | null } };

export type DeletePosterMutationVariables = Exact<{
  posterId: Scalars['ID'];
}>;


export type DeletePosterMutation = { __typename: 'Mutation', removePoster: { __typename: 'RemovePosterPayload', id: string } };

export type FlushRedisCacheMutationVariables = Exact<{
  input: FlushRedisCacheInput;
}>;


export type FlushRedisCacheMutation = { __typename: 'Mutation', flushRedisCache: { __typename: 'FlushRedisCachePayload', flushedEntities: number } };

export type GetAbTestsConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAbTestsConfigsQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', ABTestConfigs: Array<{ __typename: 'ABTestConfig', id: string, status: AbTestStatus, type: AbTestType, audience: AbTestAudienceType, defaultVariation?: string | null, description?: string | null, isNewAudienceOnly: boolean, isHardCoded: boolean, startDate: any, winnerVariation?: string | null, variationsWithPercentage: Array<{ __typename: 'ABTestVariation', name: string, percentage: number }> }> } };

export type CreateAbTestMutationVariables = Exact<{
  input: CreateAbTestInput;
}>;


export type CreateAbTestMutation = { __typename: 'Mutation', createABTest: { __typename: 'CreateABTestPayload', abTest: { __typename: 'ABTestConfig', id: string, status: AbTestStatus, type: AbTestType, audience: AbTestAudienceType, defaultVariation?: string | null, description?: string | null, isNewAudienceOnly: boolean, isHardCoded: boolean, startDate: any, winnerVariation?: string | null, variationsWithPercentage: Array<{ __typename: 'ABTestVariation', name: string, percentage: number }> } } };

export type UpdateAbTestMutationVariables = Exact<{
  input: UpdateAbTestInput;
}>;


export type UpdateAbTestMutation = { __typename: 'Mutation', updateABTest: { __typename: 'UpdateABTestPayload', abTest: { __typename: 'ABTestConfig', id: string, status: AbTestStatus, type: AbTestType, audience: AbTestAudienceType, defaultVariation?: string | null, description?: string | null, isNewAudienceOnly: boolean, isHardCoded: boolean, startDate: any, winnerVariation?: string | null, variationsWithPercentage: Array<{ __typename: 'ABTestVariation', name: string, percentage: number }> } } };

export type DeleteAbTestMutationVariables = Exact<{
  input: DeleteAbTestInput;
}>;


export type DeleteAbTestMutation = { __typename: 'Mutation', deleteABTest: { __typename: 'DeleteABTestPayload', testIdDeleted: string } };

export type GetLiveOpsChainedOfferEventConfigQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetLiveOpsChainedOfferEventConfigQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', chainedOfferEvent?: { __typename: 'ChainedOfferEventConfig', id: string, startDate: any, stopDate: any, status: ChainedOfferEventStatus, name: string, backgroundImage?: string | null, filterUserIds?: Array<string> | null, filterSubscriptionTier?: UserSubscriptionTier | null, filterUserMinCreationDate?: string | null, filterUserMaxCreationDate?: string | null, filterAppVersion?: string | null, filterUserLevel?: number | null, packs: Array<{ __typename: 'ChainedOfferPackConfig', cost?: number | null, sku?: string | null, claimType: ChainedOfferClaimType, rewards: Array<{ __typename: 'ChainedOfferPackRewardConfig', type: string, amount: number, itemId: string }> }> } | null } };

export type GetLiveOpsChainedOfferEventConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLiveOpsChainedOfferEventConfigsQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', chainedOfferEvents: Array<{ __typename: 'ChainedOfferEventConfig', id: string, startDate: any, stopDate: any, status: ChainedOfferEventStatus, name: string, backgroundImage?: string | null, filterUserIds?: Array<string> | null, filterSubscriptionTier?: UserSubscriptionTier | null, filterUserMinCreationDate?: string | null, filterUserMaxCreationDate?: string | null, filterAppVersion?: string | null, filterUserLevel?: number | null, packs: Array<{ __typename: 'ChainedOfferPackConfig', cost?: number | null, sku?: string | null, claimType: ChainedOfferClaimType, rewards: Array<{ __typename: 'ChainedOfferPackRewardConfig', type: string, amount: number, itemId: string }> }> }> } };

export type CreateChainedOfferEventMutationVariables = Exact<{
  input?: InputMaybe<CreateChainedOfferEventInput>;
}>;


export type CreateChainedOfferEventMutation = { __typename: 'Mutation', createChainedOfferEvent?: { __typename: 'CreateChainedOfferEventPayload', chainedOfferEvent: { __typename: 'ChainedOfferEventConfig', id: string, startDate: any, stopDate: any, status: ChainedOfferEventStatus, name: string, backgroundImage?: string | null, filterUserIds?: Array<string> | null, filterSubscriptionTier?: UserSubscriptionTier | null, filterUserMinCreationDate?: string | null, filterUserMaxCreationDate?: string | null, filterAppVersion?: string | null, filterUserLevel?: number | null, packs: Array<{ __typename: 'ChainedOfferPackConfig', cost?: number | null, sku?: string | null, claimType: ChainedOfferClaimType, rewards: Array<{ __typename: 'ChainedOfferPackRewardConfig', type: string, amount: number, itemId: string }> }> } } | null };

export type UpdateChainedOfferEventMutationVariables = Exact<{
  input?: InputMaybe<UpdateChainedOfferEventInput>;
}>;


export type UpdateChainedOfferEventMutation = { __typename: 'Mutation', updateChainedOfferEvent?: { __typename: 'UpdateChainedOfferEventPayload', chainedOfferEvent: { __typename: 'ChainedOfferEventConfig', id: string, startDate: any, stopDate: any, status: ChainedOfferEventStatus, name: string, backgroundImage?: string | null, filterUserIds?: Array<string> | null, filterSubscriptionTier?: UserSubscriptionTier | null, filterUserMinCreationDate?: string | null, filterUserMaxCreationDate?: string | null, filterAppVersion?: string | null, filterUserLevel?: number | null, packs: Array<{ __typename: 'ChainedOfferPackConfig', cost?: number | null, sku?: string | null, claimType: ChainedOfferClaimType, rewards: Array<{ __typename: 'ChainedOfferPackRewardConfig', type: string, amount: number, itemId: string }> }> } } | null };

export type DeleteChainedOfferEventMutationVariables = Exact<{
  input?: InputMaybe<DeleteChainedOfferEventInput>;
}>;


export type DeleteChainedOfferEventMutation = { __typename: 'Mutation', deleteChainedOfferEvent?: { __typename: 'DeleteChainedOfferEventPayload', deletedEventId: string } | null };

export type UploadChainedOfferEventAssetMutationVariables = Exact<{
  input?: InputMaybe<UploadChainedOfferEventAssetInput>;
}>;


export type UploadChainedOfferEventAssetMutation = { __typename: 'Mutation', uploadChainedOfferEventAsset: { __typename: 'ChainedOfferEventConfig', id: string, startDate: any, stopDate: any, status: ChainedOfferEventStatus, name: string, backgroundImage?: string | null, filterUserIds?: Array<string> | null, filterSubscriptionTier?: UserSubscriptionTier | null, filterUserMinCreationDate?: string | null, filterUserMaxCreationDate?: string | null, filterAppVersion?: string | null, filterUserLevel?: number | null, packs: Array<{ __typename: 'ChainedOfferPackConfig', cost?: number | null, sku?: string | null, claimType: ChainedOfferClaimType, rewards: Array<{ __typename: 'ChainedOfferPackRewardConfig', type: string, amount: number, itemId: string }> }> } };

export type CollectionsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type CollectionsQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', collections: { __typename: 'CollectionPaginated', totalCount: number, list: Array<{ __typename: 'Collection', id: string, name: string, type: CollectionType, categoryId?: string | null, asset?: string | null, isDraft: boolean, levels: Array<{ __typename: 'CollectionLevel', rewards?: Array<{ __typename: 'CollectionReward', type: string, amount?: number | null, itemId?: string | null }> | null, items?: Array<{ __typename: 'CollectionLevelItem', itemLevel: number, type: CollectionItemType, itemId: string }> | null }> }> } } };

export type UpdateCollectionMutationVariables = Exact<{
  input: UpdateCollectionInput;
}>;


export type UpdateCollectionMutation = { __typename: 'Mutation', updateCollection: { __typename: 'Collection', id: string, name: string, type: CollectionType, categoryId?: string | null, asset?: string | null, isDraft: boolean, levels: Array<{ __typename: 'CollectionLevel', rewards?: Array<{ __typename: 'CollectionReward', type: string, amount?: number | null, itemId?: string | null }> | null, items?: Array<{ __typename: 'CollectionLevelItem', itemLevel: number, type: CollectionItemType, itemId: string }> | null }> } };

export type CreateCollectionMutationVariables = Exact<{
  input: CreateCollectionInput;
}>;


export type CreateCollectionMutation = { __typename: 'Mutation', createCollection: { __typename: 'Collection', id: string, name: string, type: CollectionType, categoryId?: string | null, asset?: string | null, isDraft: boolean, levels: Array<{ __typename: 'CollectionLevel', rewards?: Array<{ __typename: 'CollectionReward', type: string, amount?: number | null, itemId?: string | null }> | null, items?: Array<{ __typename: 'CollectionLevelItem', itemLevel: number, type: CollectionItemType, itemId: string }> | null }> } };

export type RemoveCollectionMutationVariables = Exact<{
  collectionId: Scalars['ID'];
}>;


export type RemoveCollectionMutation = { __typename: 'Mutation', removeCollection: { __typename: 'RemoveCollectionPayload', id: string } };

export type UploadCollectionAssetsMutationVariables = Exact<{
  input: UploadCollectionAssetInput;
}>;


export type UploadCollectionAssetsMutation = { __typename: 'Mutation', uploadCollectionAssets: { __typename: 'Collection', id: string, name: string, type: CollectionType, categoryId?: string | null, asset?: string | null, isDraft: boolean, levels: Array<{ __typename: 'CollectionLevel', rewards?: Array<{ __typename: 'CollectionReward', type: string, amount?: number | null, itemId?: string | null }> | null, items?: Array<{ __typename: 'CollectionLevelItem', itemLevel: number, type: CollectionItemType, itemId: string }> | null }> } };

export type HurdleCalendarQueryVariables = Exact<{
  input: HurdleCalendarInput;
}>;


export type HurdleCalendarQuery = { __typename: 'Query', hurdleCalendar: { __typename: 'HurdleCalendarPayload', hurdleQuizzes: Array<{ __typename: 'HurdleQuiz', id: string, startDate: any, endDate: any, namespace: HurdleNamespace, categoryId: string, type: HurdleType, catalogItemId: string, question?: { __typename: 'HurdleQuestion', id: string, asset: string, offset: number, song?: { __typename: 'Song', id: string, displayTitle: string, displayArtist: string } | null } | null }> } };

export type HurdleQuizQueryVariables = Exact<{
  input: HurdleQuizInput;
}>;


export type HurdleQuizQuery = { __typename: 'Query', hurdleQuiz: { __typename: 'HurdleQuizPayload', hurdleQuiz?: { __typename: 'HurdleQuiz', id: string, startDate: any, endDate: any, namespace: HurdleNamespace, categoryId: string, type: HurdleType, catalogItemId: string, question?: { __typename: 'HurdleQuestion', id: string, asset: string, offset: number, song?: { __typename: 'Song', id: string, displayTitle: string, displayArtist: string } | null } | null } | null } };

export type HurdleCatalogItemQueryVariables = Exact<{
  input: HurdleCatalogItemInput;
}>;


export type HurdleCatalogItemQuery = { __typename: 'Query', hurdleCatalogItem: { __typename: 'HurdleCatalogItemPayload', catalogItem: { __typename: 'HurdleCatalogItem', id: string, categoryId?: string | null, excludeFromAutogeneration?: boolean | null, excludeFromCheck?: boolean | null, offset: number, addedAt: any, removed?: boolean | null, item: { __typename: 'HurdleSongItem', id: string, asset: string, song?: { __typename: 'Song', id: string, title: string, artist: string, picture?: string | null } | null } } } };

export type UpdateHurdleQuizMutationVariables = Exact<{
  input: UpdateHurdleQuizInput;
}>;


export type UpdateHurdleQuizMutation = { __typename: 'Mutation', updateHurdleQuiz: { __typename: 'UpdateHurdleQuizPayload', hurdleQuiz: { __typename: 'HurdleQuiz', id: string, startDate: any, endDate: any, namespace: HurdleNamespace, categoryId: string, type: HurdleType, catalogItemId: string, question?: { __typename: 'HurdleQuestion', id: string, asset: string, offset: number, song?: { __typename: 'Song', id: string, displayTitle: string, displayArtist: string } | null } | null } } };

export type GenerateHurdleQuizzesMutationVariables = Exact<{
  input: GenerateHurdleQuizzesInput;
}>;


export type GenerateHurdleQuizzesMutation = { __typename: 'Mutation', generateHurdleQuizzes: { __typename: 'GenerateHurdleQuizzesPayload', hurdleQuizzes: Array<{ __typename: 'HurdleQuiz', id: string, startDate: any, endDate: any, namespace: HurdleNamespace, categoryId: string, type: HurdleType, catalogItemId: string, question?: { __typename: 'HurdleQuestion', id: string, asset: string, offset: number, song?: { __typename: 'Song', id: string, displayTitle: string, displayArtist: string } | null } | null }> } };

export type ValidateHurdleQuizConfigQueryVariables = Exact<{
  input: ValidateHurdleQuizConfigInput;
}>;


export type ValidateHurdleQuizConfigQuery = { __typename: 'Query', validateHurdleQuizConfig?: { __typename: 'ValidateHurdleQuizConfigPayload', isValid: boolean, messages: Array<string> } | null };

export type LiveEventsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationParams>;
}>;


export type LiveEventsQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', liveEvents: { __typename: 'LiveEventPaginated', totalCount: number, hasMore: boolean, list: Array<{ __typename: 'LiveEvent', id: string, startDate: any, name: string }> } } };

export type LiveEventQueryVariables = Exact<{
  liveEventId: Scalars['ID'];
}>;


export type LiveEventQuery = { __typename: 'Query', liveEvent?: { __typename: 'LiveEvent', id: string, name: string, startDate: any, endDate: any, isDraft: boolean, filterUserIds: Array<string>, filterOnlyAdmin: boolean, filterVersion: number, contentPacks: Array<{ __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }>, shop: Array<{ __typename: 'LiveEventShopItemConfig', type: string, amount: number, itemId: string, cost: number, buyLimit: number }> } | null };

export type UpdateLiveEventMutationVariables = Exact<{
  input: UpdateLiveEventInput;
}>;


export type UpdateLiveEventMutation = { __typename: 'Mutation', updateLiveEvent: { __typename: 'LiveEventPayload', liveEvent: { __typename: 'LiveEvent', id: string, name: string, startDate: any, endDate: any, isDraft: boolean, filterUserIds: Array<string>, filterOnlyAdmin: boolean, filterVersion: number, contentPacks: Array<{ __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }>, shop: Array<{ __typename: 'LiveEventShopItemConfig', type: string, amount: number, itemId: string, cost: number, buyLimit: number }> } } };

export type UpdateLiveEventContentPacksMutationVariables = Exact<{
  input: UpdateLiveEventContentPacksInput;
}>;


export type UpdateLiveEventContentPacksMutation = { __typename: 'Mutation', updateLiveEventContentPacks: { __typename: 'LiveEventPayload', liveEvent: { __typename: 'LiveEvent', id: string, name: string, startDate: any, endDate: any, isDraft: boolean, filterUserIds: Array<string>, filterOnlyAdmin: boolean, filterVersion: number, contentPacks: Array<{ __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }>, shop: Array<{ __typename: 'LiveEventShopItemConfig', type: string, amount: number, itemId: string, cost: number, buyLimit: number }> } } };

export type CreateLiveEventMutationVariables = Exact<{
  input: CreateLiveEventInput;
}>;


export type CreateLiveEventMutation = { __typename: 'Mutation', createLiveEvent: { __typename: 'LiveEventPayload', liveEvent: { __typename: 'LiveEvent', id: string, name: string, startDate: any, endDate: any, isDraft: boolean, filterUserIds: Array<string>, filterOnlyAdmin: boolean, filterVersion: number, contentPacks: Array<{ __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }>, shop: Array<{ __typename: 'LiveEventShopItemConfig', type: string, amount: number, itemId: string, cost: number, buyLimit: number }> } } };

export type RemoveLiveEventMutationVariables = Exact<{
  input: RemoveLiveEventInput;
}>;


export type RemoveLiveEventMutation = { __typename: 'Mutation', removeLiveEvent: { __typename: 'RemoveLiveEventPayload', isRemoved: boolean } };

export type AddSpecialEventContentPackMutationVariables = Exact<{
  input: AddSpecialEventContentPackInput;
}>;


export type AddSpecialEventContentPackMutation = { __typename: 'Mutation', addSpecialEventContentPack: { __typename: 'AddSpecialEventContentPackPayload', specialEvent: { __typename: 'SpecialEvent', id: string, name: string }, contentPack: { __typename: 'ContentPack', id: string, name: string } } };

export type RemoveSpecialEventContentPackMutationVariables = Exact<{
  input: RemoveSpecialEventContentPackInput;
}>;


export type RemoveSpecialEventContentPackMutation = { __typename: 'Mutation', removeSpecialEventContentPack: { __typename: 'RemoveSpecialEventContentPackPayload', specialEvent: { __typename: 'SpecialEvent', id: string, name: string }, contentPack: { __typename: 'ContentPack', id: string, name: string } } };

export type UpdateLiveEventShopMutationVariables = Exact<{
  input: UpdateLiveEventShopInput;
}>;


export type UpdateLiveEventShopMutation = { __typename: 'Mutation', updateLiveEventShop: { __typename: 'LiveEventPayload', liveEvent: { __typename: 'LiveEvent', id: string, name: string, startDate: any, endDate: any, isDraft: boolean, filterUserIds: Array<string>, filterOnlyAdmin: boolean, filterVersion: number, contentPacks: Array<{ __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }>, shop: Array<{ __typename: 'LiveEventShopItemConfig', type: string, amount: number, itemId: string, cost: number, buyLimit: number }> } } };

export type QuizLiveShowsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationParams>;
}>;


export type QuizLiveShowsQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', quizLiveShows: { __typename: 'QuizLiveShowsPaginated', hasMore: boolean, totalCount: number, list: Array<{ __typename: 'QuizLiveShow', id: string, startDate: any, playerCount: number, lastUpdateDate: any, lastSchedule: { __typename: 'LiveShowLastSchedulePayload', isCurrentlyScheduled: boolean }, rounds: Array<{ __typename: 'QuizLiveShowRound', encryptedRoundAssetUrl: string, encryptedRoundAssetUrlV2?: string | null }> }> } } };

export type QuizLiveShowQueryVariables = Exact<{
  showId: Scalars['ID'];
}>;


export type QuizLiveShowQuery = { __typename: 'Query', quizLiveShow?: { __typename: 'QuizLiveShow', id: string, startDate: any, lastUpdateDate: any, playerCount: number, diamondPrize: number, category: { __typename: 'ContentCategory', id: string, name: string }, lastSchedule: { __typename: 'LiveShowLastSchedulePayload', isCurrentlyScheduled: boolean }, adminSpecialEvent?: { __typename: 'SpecialEvent', id: string, name: string, startDate: any, endDate: any } | null, extraConfig: { __typename: 'ExtraConfig', primaryColor?: string | null, secondaryColor?: string | null, secondaryDarkColor?: string | null, buttonColor?: string | null, contrastGradient1?: string | null, contrastGradient2?: string | null, headerImage?: string | null, characterImage?: string | null }, rounds: Array<{ __typename: 'QuizLiveShowRound', id: string, questionDuration: number, encryptedRoundAssetUrl: string, encryptedRoundAssetUrlV2?: string | null, contentPack: { __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }, liveOpsQuestions: Array<{ __typename: 'QuizQuestion', id: string, title: string, asset?: string | null, song?: { __typename: 'Song', id: string, title: string, artist: string, picture?: string | null } | null }> }> } | null };

export type UpsertQuizLiveShowMutationVariables = Exact<{
  input: UpsertQuizLiveShowInput;
}>;


export type UpsertQuizLiveShowMutation = { __typename: 'Mutation', upsertQuizLiveShow: { __typename: 'QuizLiveShow', id: string, startDate: any, lastUpdateDate: any, playerCount: number, diamondPrize: number, category: { __typename: 'ContentCategory', id: string, name: string }, lastSchedule: { __typename: 'LiveShowLastSchedulePayload', isCurrentlyScheduled: boolean }, adminSpecialEvent?: { __typename: 'SpecialEvent', id: string, name: string, startDate: any, endDate: any } | null, extraConfig: { __typename: 'ExtraConfig', primaryColor?: string | null, secondaryColor?: string | null, secondaryDarkColor?: string | null, buttonColor?: string | null, contrastGradient1?: string | null, contrastGradient2?: string | null, headerImage?: string | null, characterImage?: string | null }, rounds: Array<{ __typename: 'QuizLiveShowRound', id: string, questionDuration: number, encryptedRoundAssetUrl: string, encryptedRoundAssetUrlV2?: string | null, contentPack: { __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }, liveOpsQuestions: Array<{ __typename: 'QuizQuestion', id: string, title: string, asset?: string | null, song?: { __typename: 'Song', id: string, title: string, artist: string, picture?: string | null } | null }> }> } };

export type ResetQuizLiveShowRoundQuestionsMutationVariables = Exact<{
  input: ResetQuizLiveShowRoundQuestionsInput;
}>;


export type ResetQuizLiveShowRoundQuestionsMutation = { __typename: 'Mutation', resetQuizLiveShowRoundQuestions: { __typename: 'QuizLiveShow', id: string, startDate: any, lastUpdateDate: any, playerCount: number, diamondPrize: number, category: { __typename: 'ContentCategory', id: string, name: string }, lastSchedule: { __typename: 'LiveShowLastSchedulePayload', isCurrentlyScheduled: boolean }, adminSpecialEvent?: { __typename: 'SpecialEvent', id: string, name: string, startDate: any, endDate: any } | null, extraConfig: { __typename: 'ExtraConfig', primaryColor?: string | null, secondaryColor?: string | null, secondaryDarkColor?: string | null, buttonColor?: string | null, contrastGradient1?: string | null, contrastGradient2?: string | null, headerImage?: string | null, characterImage?: string | null }, rounds: Array<{ __typename: 'QuizLiveShowRound', id: string, questionDuration: number, encryptedRoundAssetUrl: string, encryptedRoundAssetUrlV2?: string | null, contentPack: { __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }, liveOpsQuestions: Array<{ __typename: 'QuizQuestion', id: string, title: string, asset?: string | null, song?: { __typename: 'Song', id: string, title: string, artist: string, picture?: string | null } | null }> }> } };

export type UploadLiveShowHeaderAssetMutationVariables = Exact<{
  input: UploadAssetInput;
}>;


export type UploadLiveShowHeaderAssetMutation = { __typename: 'Mutation', uploadLiveShowHeaderAsset: { __typename: 'QuizLiveShow', id: string, startDate: any, lastUpdateDate: any, playerCount: number, diamondPrize: number, category: { __typename: 'ContentCategory', id: string, name: string }, lastSchedule: { __typename: 'LiveShowLastSchedulePayload', isCurrentlyScheduled: boolean }, adminSpecialEvent?: { __typename: 'SpecialEvent', id: string, name: string, startDate: any, endDate: any } | null, extraConfig: { __typename: 'ExtraConfig', primaryColor?: string | null, secondaryColor?: string | null, secondaryDarkColor?: string | null, buttonColor?: string | null, contrastGradient1?: string | null, contrastGradient2?: string | null, headerImage?: string | null, characterImage?: string | null }, rounds: Array<{ __typename: 'QuizLiveShowRound', id: string, questionDuration: number, encryptedRoundAssetUrl: string, encryptedRoundAssetUrlV2?: string | null, contentPack: { __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }, liveOpsQuestions: Array<{ __typename: 'QuizQuestion', id: string, title: string, asset?: string | null, song?: { __typename: 'Song', id: string, title: string, artist: string, picture?: string | null } | null }> }> } };

export type UploadLiveShowCharacterAssetMutationVariables = Exact<{
  input: UploadAssetInput;
}>;


export type UploadLiveShowCharacterAssetMutation = { __typename: 'Mutation', uploadLiveShowCharacterAsset: { __typename: 'QuizLiveShow', id: string, startDate: any, lastUpdateDate: any, playerCount: number, diamondPrize: number, category: { __typename: 'ContentCategory', id: string, name: string }, lastSchedule: { __typename: 'LiveShowLastSchedulePayload', isCurrentlyScheduled: boolean }, adminSpecialEvent?: { __typename: 'SpecialEvent', id: string, name: string, startDate: any, endDate: any } | null, extraConfig: { __typename: 'ExtraConfig', primaryColor?: string | null, secondaryColor?: string | null, secondaryDarkColor?: string | null, buttonColor?: string | null, contrastGradient1?: string | null, contrastGradient2?: string | null, headerImage?: string | null, characterImage?: string | null }, rounds: Array<{ __typename: 'QuizLiveShowRound', id: string, questionDuration: number, encryptedRoundAssetUrl: string, encryptedRoundAssetUrlV2?: string | null, contentPack: { __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }, liveOpsQuestions: Array<{ __typename: 'QuizQuestion', id: string, title: string, asset?: string | null, song?: { __typename: 'Song', id: string, title: string, artist: string, picture?: string | null } | null }> }> } };

export type StopCurrentLiveShowMutationVariables = Exact<{ [key: string]: never; }>;


export type StopCurrentLiveShowMutation = { __typename: 'Mutation', stopCurrentLiveShow: { __typename: 'StopCurrentLiveShowPayload', isStopped: boolean } };

export type RemoveLiveShowMutationVariables = Exact<{
  input: RemoveLiveShowInput;
}>;


export type RemoveLiveShowMutation = { __typename: 'Mutation', removeLiveShow: { __typename: 'RemoveLiveShowPayload', isRemoved: boolean, isUnscheduled?: boolean | null } };

export type LiveShowLogsQueryVariables = Exact<{
  showId: Scalars['ID'];
  pagination?: InputMaybe<PaginationParams>;
}>;


export type LiveShowLogsQuery = { __typename: 'Query', analytics: { __typename: 'Analytics', liveShowLogs: { __typename: 'LiveShowLogsPaginated', totalCount: number, list: Array<{ __typename: 'LiveShowLog', timestamp: any, message: string, namespace: string, source: string, level: string, extraData: any }> } } };

export type RescheduleQuizLiveShowMutationVariables = Exact<{
  input: RescheduleQuizLiveShowInput;
}>;


export type RescheduleQuizLiveShowMutation = { __typename: 'Mutation', rescheduleQuizLiveShow: { __typename: 'QuizLiveShow', id: string, startDate: any, lastUpdateDate: any, playerCount: number, diamondPrize: number, category: { __typename: 'ContentCategory', id: string, name: string }, lastSchedule: { __typename: 'LiveShowLastSchedulePayload', isCurrentlyScheduled: boolean }, adminSpecialEvent?: { __typename: 'SpecialEvent', id: string, name: string, startDate: any, endDate: any } | null, extraConfig: { __typename: 'ExtraConfig', primaryColor?: string | null, secondaryColor?: string | null, secondaryDarkColor?: string | null, buttonColor?: string | null, contrastGradient1?: string | null, contrastGradient2?: string | null, headerImage?: string | null, characterImage?: string | null }, rounds: Array<{ __typename: 'QuizLiveShowRound', id: string, questionDuration: number, encryptedRoundAssetUrl: string, encryptedRoundAssetUrlV2?: string | null, contentPack: { __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }, liveOpsQuestions: Array<{ __typename: 'QuizQuestion', id: string, title: string, asset?: string | null, song?: { __typename: 'Song', id: string, title: string, artist: string, picture?: string | null } | null }> }> } };

export type ScheduleQuizLiveShowRoundEncryptionMutationVariables = Exact<{
  input: ScheduleQuizLiveShowRoundEncryptionInput;
}>;


export type ScheduleQuizLiveShowRoundEncryptionMutation = { __typename: 'Mutation', scheduleQuizLiveShowRoundEncryption: { __typename: 'QuizLiveShow', id: string, startDate: any, lastUpdateDate: any, playerCount: number, diamondPrize: number, category: { __typename: 'ContentCategory', id: string, name: string }, lastSchedule: { __typename: 'LiveShowLastSchedulePayload', isCurrentlyScheduled: boolean }, adminSpecialEvent?: { __typename: 'SpecialEvent', id: string, name: string, startDate: any, endDate: any } | null, extraConfig: { __typename: 'ExtraConfig', primaryColor?: string | null, secondaryColor?: string | null, secondaryDarkColor?: string | null, buttonColor?: string | null, contrastGradient1?: string | null, contrastGradient2?: string | null, headerImage?: string | null, characterImage?: string | null }, rounds: Array<{ __typename: 'QuizLiveShowRound', id: string, questionDuration: number, encryptedRoundAssetUrl: string, encryptedRoundAssetUrlV2?: string | null, contentPack: { __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }, liveOpsQuestions: Array<{ __typename: 'QuizQuestion', id: string, title: string, asset?: string | null, song?: { __typename: 'Song', id: string, title: string, artist: string, picture?: string | null } | null }> }> } };

export type CopyQuizLiveShowMutationVariables = Exact<{
  input: CopyQuizLiveShowInput;
}>;


export type CopyQuizLiveShowMutation = { __typename: 'Mutation', copyQuizLiveShow: { __typename: 'QuizLiveShow', id: string, startDate: any, lastUpdateDate: any, lastSchedule: { __typename: 'LiveShowLastSchedulePayload', isCurrentlyScheduled: boolean }, rounds: Array<{ __typename: 'QuizLiveShowRound', encryptedRoundAssetUrl: string, encryptedRoundAssetUrlV2?: string | null }> } };

export type UpdateQuizLiveShowContentPacksMutationVariables = Exact<{
  input: UpdateQuizLiveShowContentPacksInput;
}>;


export type UpdateQuizLiveShowContentPacksMutation = { __typename: 'Mutation', updateQuizLiveShowContentPacks: { __typename: 'QuizLiveShow', id: string } };

export type AddSpecialEventQuizLiveShowMutationVariables = Exact<{
  input: AddSpecialEventQuizLiveShowInput;
}>;


export type AddSpecialEventQuizLiveShowMutation = { __typename: 'Mutation', addSpecialEventQuizLiveShow: { __typename: 'AddSpecialEventQuizLiveShowPayload', specialEvent: { __typename: 'SpecialEvent', id: string, name: string }, quizLiveShow: { __typename: 'QuizLiveShow', id: string } } };

export type RemoveSpecialEventQuizLiveShowMutationVariables = Exact<{
  input: RemoveSpecialEventQuizLiveShowInput;
}>;


export type RemoveSpecialEventQuizLiveShowMutation = { __typename: 'Mutation', removeSpecialEventQuizLiveShow: { __typename: 'RemoveSpecialEventQuizLiveShowPayload', specialEvent: { __typename: 'SpecialEvent', id: string, name: string }, quizLiveShow: { __typename: 'QuizLiveShow', id: string } } };

export type GetLoyaltyCampaignAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLoyaltyCampaignAdminQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', id: string, loyaltyCampaignConfigs: Array<{ __typename: 'LoyaltyCampaignConfig', id: string, amount: number, updatedAt: any }>, loyaltyCampaignCards: Array<{ __typename: 'LoyaltyCampaignCard', id: string, kind: LoyaltyCampaignCardKind, name: string, groupId?: string | null, groupName?: string | null, groupDisplayOrder?: number | null, groupStartDate?: any | null, groupEndDate?: any | null, subgroupId?: string | null, subgroupName?: string | null, subgroupDisplayOrder?: number | null, subgroupStartDate?: any | null, subgroupEndDate?: any | null, itemDisplayOrder?: number | null, displayOrder: number, cost: number, itemBonusLoyaltyPoints?: number | null, maxClaims: number, created: any, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge', id: string, name: string } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string } | { __typename: 'EmojiPack', id: string } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster', id: string } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }> } };

export type GetLoyaltyCampaignSkuOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLoyaltyCampaignSkuOptionsQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', id: string, loyaltyCampaignSkuOptions: Array<string>, loyaltyCampaignOfferOptions: Array<{ __typename: 'LoyaltyCampaignOfferOption', id: string, label: string, priceUsd?: number | null, skus: Array<string> }>, loyaltyCampaignSkuPrices: Array<{ __typename: 'LoyaltyCampaignSkuPrice', sku: string, priceUsd: number }> } };

export type UpsertLoyaltyCampaignConfigMutationVariables = Exact<{
  id: Scalars['ID'];
  amount: Scalars['Int'];
}>;


export type UpsertLoyaltyCampaignConfigMutation = { __typename: 'Mutation', upsertLoyaltyCampaignConfig: { __typename: 'LoyaltyCampaignConfig', id: string, amount: number, updatedAt: any } };

export type DeleteLoyaltyCampaignConfigMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteLoyaltyCampaignConfigMutation = { __typename: 'Mutation', deleteLoyaltyCampaignConfig: boolean };

export type CreateLoyaltyCampaignCardMutationVariables = Exact<{
  kind: LoyaltyCampaignCardKind;
  name: Scalars['String'];
  groupId?: InputMaybe<Scalars['String']>;
  groupName?: InputMaybe<Scalars['String']>;
  groupDisplayOrder?: InputMaybe<Scalars['Int']>;
  groupStartDate?: InputMaybe<Scalars['Date']>;
  groupEndDate?: InputMaybe<Scalars['Date']>;
  subgroupId?: InputMaybe<Scalars['String']>;
  subgroupName?: InputMaybe<Scalars['String']>;
  subgroupDisplayOrder?: InputMaybe<Scalars['Int']>;
  subgroupStartDate?: InputMaybe<Scalars['Date']>;
  subgroupEndDate?: InputMaybe<Scalars['Date']>;
  itemDisplayOrder?: InputMaybe<Scalars['Int']>;
  cost: Scalars['Int'];
  itemBonusLoyaltyPoints?: InputMaybe<Scalars['Int']>;
  maxClaims: Scalars['Int'];
  rewards: Array<LevelRewardInput> | LevelRewardInput;
}>;


export type CreateLoyaltyCampaignCardMutation = { __typename: 'Mutation', createLoyaltyCampaignCard: { __typename: 'LoyaltyCampaignCard', id: string, kind: LoyaltyCampaignCardKind, name: string, groupId?: string | null, groupName?: string | null, groupDisplayOrder?: number | null, groupStartDate?: any | null, groupEndDate?: any | null, subgroupId?: string | null, subgroupName?: string | null, subgroupDisplayOrder?: number | null, subgroupStartDate?: any | null, subgroupEndDate?: any | null, itemDisplayOrder?: number | null, displayOrder: number, cost: number, itemBonusLoyaltyPoints?: number | null, maxClaims: number, created: any, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge', id: string, name: string } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string } | { __typename: 'EmojiPack', id: string } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster', id: string } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> } };

export type UpdateLoyaltyCampaignCardMutationVariables = Exact<{
  id: Scalars['ID'];
  kind?: InputMaybe<LoyaltyCampaignCardKind>;
  name?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
  groupName?: InputMaybe<Scalars['String']>;
  groupDisplayOrder?: InputMaybe<Scalars['Int']>;
  groupStartDate?: InputMaybe<Scalars['Date']>;
  groupEndDate?: InputMaybe<Scalars['Date']>;
  subgroupId?: InputMaybe<Scalars['String']>;
  subgroupName?: InputMaybe<Scalars['String']>;
  subgroupDisplayOrder?: InputMaybe<Scalars['Int']>;
  subgroupStartDate?: InputMaybe<Scalars['Date']>;
  subgroupEndDate?: InputMaybe<Scalars['Date']>;
  itemDisplayOrder?: InputMaybe<Scalars['Int']>;
  cost?: InputMaybe<Scalars['Int']>;
  itemBonusLoyaltyPoints?: InputMaybe<Scalars['Int']>;
  displayOrder?: InputMaybe<Scalars['Int']>;
  maxClaims?: InputMaybe<Scalars['Int']>;
  rewards?: InputMaybe<Array<LevelRewardInput> | LevelRewardInput>;
}>;


export type UpdateLoyaltyCampaignCardMutation = { __typename: 'Mutation', updateLoyaltyCampaignCard: { __typename: 'LoyaltyCampaignCard', id: string, kind: LoyaltyCampaignCardKind, name: string, groupId?: string | null, groupName?: string | null, groupDisplayOrder?: number | null, groupStartDate?: any | null, groupEndDate?: any | null, subgroupId?: string | null, subgroupName?: string | null, subgroupDisplayOrder?: number | null, subgroupStartDate?: any | null, subgroupEndDate?: any | null, itemDisplayOrder?: number | null, displayOrder: number, cost: number, itemBonusLoyaltyPoints?: number | null, maxClaims: number, created: any, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge', id: string, name: string } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number, unlimitedBoostType: CurrencyUnlimitedBoostType } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string } | { __typename: 'EmojiPack', id: string } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster', id: string } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> } };

export type DeleteLoyaltyCampaignCardMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteLoyaltyCampaignCardMutation = { __typename: 'Mutation', deleteLoyaltyCampaignCard: boolean };

export type UpdateLoyaltyCampaignGroupMutationVariables = Exact<{
  groupId: Scalars['String'];
  groupName: Scalars['String'];
  groupDisplayOrder?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['Date']>;
  endDate?: InputMaybe<Scalars['Date']>;
}>;


export type UpdateLoyaltyCampaignGroupMutation = { __typename: 'Mutation', updateLoyaltyCampaignGroup: boolean };

export type UpdateLoyaltyCampaignSubgroupMutationVariables = Exact<{
  groupId: Scalars['String'];
  subgroupId: Scalars['String'];
  subgroupName: Scalars['String'];
  subgroupDisplayOrder?: InputMaybe<Scalars['Int']>;
  subgroupStartDate?: InputMaybe<Scalars['Date']>;
  subgroupEndDate?: InputMaybe<Scalars['Date']>;
}>;


export type UpdateLoyaltyCampaignSubgroupMutation = { __typename: 'Mutation', updateLoyaltyCampaignSubgroup: boolean };

export type GetAllMarathonEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllMarathonEventsQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', getAllMarathonEvents: Array<{ __typename: 'MarathonEventConfig', id: string, name: string, startDate: any, stopDate: any, status: ChainedOfferEventStatus }> } };

export type GetMarathonEventQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetMarathonEventQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', getMarathonEvent: { __typename: 'MarathonEventConfig', id: string, name: string, startDate: any, stopDate: any, status: ChainedOfferEventStatus, category?: string | null, filterUserIds?: Array<string> | null, filterSubscriptionTier?: UserSubscriptionTier | null, filterUserMinCreationDate?: any | null, filterUserMaxCreationDate?: any | null, filterAppVersion?: string | null, filterUserLevel?: number | null, milestoneGroups: Array<{ __typename: 'MarathonMilestoneGroupConfig', unlockDate: any, stopDate: any, milestones: Array<{ __typename: 'MarathonMilestoneConfig', numberOfGuesses: number, type: MarathonMilestoneType, basicReward: { __typename: 'GenericLevelReward', type: LevelRewardInputType, amount: number, itemId?: string | null }, plusReward: { __typename: 'GenericLevelReward', type: LevelRewardInputType, amount: number, itemId?: string | null } }> }>, economy: { __typename: 'MarathonEconomyConfig', startPrice: number, revivePrice: number, freeStartsPlus: number, freeStartsBasic: number, freeRevivesPlus: number, freeRevivesBasic: number } } } };

export type CreateMarathonEventMutationVariables = Exact<{
  input: CreateMarathonEventInput;
}>;


export type CreateMarathonEventMutation = { __typename: 'Mutation', createMarathonEvent: { __typename: 'CreateMarathonEventPayload', event: { __typename: 'MarathonEventConfig', id: string, name: string, startDate: any, stopDate: any, status: ChainedOfferEventStatus, category?: string | null, filterUserIds?: Array<string> | null, filterSubscriptionTier?: UserSubscriptionTier | null, filterUserMinCreationDate?: any | null, filterUserMaxCreationDate?: any | null, filterAppVersion?: string | null, filterUserLevel?: number | null, milestoneGroups: Array<{ __typename: 'MarathonMilestoneGroupConfig', unlockDate: any, stopDate: any, milestones: Array<{ __typename: 'MarathonMilestoneConfig', numberOfGuesses: number, type: MarathonMilestoneType, basicReward: { __typename: 'GenericLevelReward', type: LevelRewardInputType, amount: number, itemId?: string | null }, plusReward: { __typename: 'GenericLevelReward', type: LevelRewardInputType, amount: number, itemId?: string | null } }> }>, economy: { __typename: 'MarathonEconomyConfig', startPrice: number, revivePrice: number, freeStartsPlus: number, freeStartsBasic: number, freeRevivesPlus: number, freeRevivesBasic: number } } } };

export type UpdateMarathonEventMutationVariables = Exact<{
  input: UpdateMarathonEventInput;
}>;


export type UpdateMarathonEventMutation = { __typename: 'Mutation', updateMarathonEvent: { __typename: 'UpdateMarathonEventPayload', event: { __typename: 'MarathonEventConfig', id: string, name: string, startDate: any, stopDate: any, status: ChainedOfferEventStatus, category?: string | null, filterUserIds?: Array<string> | null, filterSubscriptionTier?: UserSubscriptionTier | null, filterUserMinCreationDate?: any | null, filterUserMaxCreationDate?: any | null, filterAppVersion?: string | null, filterUserLevel?: number | null, milestoneGroups: Array<{ __typename: 'MarathonMilestoneGroupConfig', unlockDate: any, stopDate: any, milestones: Array<{ __typename: 'MarathonMilestoneConfig', numberOfGuesses: number, type: MarathonMilestoneType, basicReward: { __typename: 'GenericLevelReward', type: LevelRewardInputType, amount: number, itemId?: string | null }, plusReward: { __typename: 'GenericLevelReward', type: LevelRewardInputType, amount: number, itemId?: string | null } }> }>, economy: { __typename: 'MarathonEconomyConfig', startPrice: number, revivePrice: number, freeStartsPlus: number, freeStartsBasic: number, freeRevivesPlus: number, freeRevivesBasic: number } } } };

export type DeleteMarathonEventMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteMarathonEventMutation = { __typename: 'Mutation', deleteMarathonEvent: boolean };

export type GetAllMarathonMilestoneConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllMarathonMilestoneConfigsQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', getAllMarathonMilestoneConfigs: Array<{ __typename: 'MarathonMilestoneTemplate', id: string, name: string, milestones: Array<{ __typename: 'MarathonMilestoneConfig', numberOfGuesses: number, type: MarathonMilestoneType, basicReward: { __typename: 'GenericLevelReward', type: LevelRewardInputType, amount: number, itemId?: string | null }, plusReward: { __typename: 'GenericLevelReward', type: LevelRewardInputType, amount: number, itemId?: string | null } }> }> } };

export type CreateMMilestonesTemplateMutationVariables = Exact<{
  input: CreateMmTemplateInput;
}>;


export type CreateMMilestonesTemplateMutation = { __typename: 'Mutation', createMMilestonesTemplate?: { __typename: 'CreateMMTemplatePayload', template: { __typename: 'MarathonMilestoneTemplate', id: string, name: string, milestones: Array<{ __typename: 'MarathonMilestoneConfig', numberOfGuesses: number, type: MarathonMilestoneType, basicReward: { __typename: 'GenericLevelReward', type: LevelRewardInputType, amount: number, itemId?: string | null }, plusReward: { __typename: 'GenericLevelReward', type: LevelRewardInputType, amount: number, itemId?: string | null } }> } } | null };

export type UpdateMMilestonesTemplateMutationVariables = Exact<{
  input: UpdateMmTemplateInput;
}>;


export type UpdateMMilestonesTemplateMutation = { __typename: 'Mutation', updateMMilestonesTemplate?: { __typename: 'UpdateMMTemplatePayload', template: { __typename: 'MarathonMilestoneTemplate', id: string, name: string, milestones: Array<{ __typename: 'MarathonMilestoneConfig', numberOfGuesses: number, type: MarathonMilestoneType, basicReward: { __typename: 'GenericLevelReward', type: LevelRewardInputType, amount: number, itemId?: string | null }, plusReward: { __typename: 'GenericLevelReward', type: LevelRewardInputType, amount: number, itemId?: string | null } }> } } | null };

export type DeleteMMilestonesTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteMMilestonesTemplateMutation = { __typename: 'Mutation', deleteMMilestonesTemplate: boolean };

export type GetAllCategoriesForMarathonQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCategoriesForMarathonQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', getAllCategoriesForMarathon: Array<{ __typename: 'MarathonCategoryData', id: string, name: string, contentPacks: number, songs: number }> } };

export type ContentItemsQueryVariables = Exact<{
  songIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ContentItemsQuery = { __typename: 'Query', getSongSampleByIds: Array<{ __typename: 'SongSample', id: string, song: { __typename: 'Song', id: string, displayTitle: string, displayArtist: string, title: string, artist: string, picture?: string | null } } | null> };

export type GetCalendarsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCalendarsQuery = { __typename: 'Query', getCalendars: Array<{ __typename: 'PaidCalendar', id: string, name: string, skuId?: string | null, startDate: any, endDate: any, filterUserIds: Array<string>, filterVersion?: number | null, purchaseReward?: { __typename: 'PaidCalendarReward', type: string, amount: number, itemId?: string | null } | null, calendarItems: Array<{ __typename: 'PaidCalendarReward', type: string, amount: number, itemId?: string | null }> }> };

export type UpdateCalendarAdminMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  calendarItems: Array<LevelRewardInput> | LevelRewardInput;
  skuId: Scalars['String'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  purchaseReward?: InputMaybe<LevelRewardInput>;
  filterUserIds: Array<Scalars['ID']> | Scalars['ID'];
  filterVersion?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateCalendarAdminMutation = { __typename: 'Mutation', updateCalendarAdmin: { __typename: 'PaidCalendar', id: string, name: string, skuId?: string | null, startDate: any, endDate: any, filterUserIds: Array<string>, filterVersion?: number | null, purchaseReward?: { __typename: 'PaidCalendarReward', type: string, amount: number, itemId?: string | null } | null, calendarItems: Array<{ __typename: 'PaidCalendarReward', type: string, amount: number, itemId?: string | null }> } };

export type CreateCalendarAdminMutationVariables = Exact<{
  name: Scalars['String'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
}>;


export type CreateCalendarAdminMutation = { __typename: 'Mutation', createCalendarAdmin: { __typename: 'PaidCalendar', id: string, name: string, skuId?: string | null, startDate: any, endDate: any, filterUserIds: Array<string>, filterVersion?: number | null, purchaseReward?: { __typename: 'PaidCalendarReward', type: string, amount: number, itemId?: string | null } | null, calendarItems: Array<{ __typename: 'PaidCalendarReward', type: string, amount: number, itemId?: string | null }> } };

export type RemoveCalendarAdminMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveCalendarAdminMutation = { __typename: 'Mutation', removeCalendarAdmin: { __typename: 'RemoveCalendarAdminPayload', isRemoved: boolean } };

export type GetAppShopDiamondsSalesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppShopDiamondsSalesQuery = { __typename: 'Query', app: { __typename: 'App', shopDiamondsSales: Array<{ __typename: 'CurrencyDiamondPack', id: string, amount: number, sku: string, asset: string }> } };

export type GetAppShopBundlesSalesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppShopBundlesSalesQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', bundleSales: Array<{ __typename: 'CurrencyBundlePack', id: string, cost: number, sku: string, name: string }> } };

export type GetAppBundlesNamesAndTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppBundlesNamesAndTagsQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', bundleNames: Array<BundlePackName>, bundleTags: Array<BundlePackTag> } };

export type GetSubscriptionSaleOffersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubscriptionSaleOffersQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', initialSubscriptionOffers: Array<{ __typename: 'SubscriptionSaleConfig', id: string, discount: number, backgroundTheme?: string | null }> } };

export type GetAppCoinsSalesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppCoinsSalesQuery = { __typename: 'Query', app: { __typename: 'App', coinsSales: Array<{ __typename: 'CurrencyCoinPack', id: string, amount: number, asset: string, cost: { __typename: 'CurrencyDiamond', id: string, amount: number } }> } };

export type GetAppBoostsSalesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppBoostsSalesQuery = { __typename: 'Query', app: { __typename: 'App', boostsSales: Array<{ __typename: 'CurrencyBoostPack', id: string, amount: number, asset: string, boostType: CurrencyBoostType, cost: { __typename: 'CurrencyCoin', id: string, amount: number } }> } };

export type GetLiveOpsSaleEventConfigQueryVariables = Exact<{
  saleEventId: Scalars['ID'];
}>;


export type GetLiveOpsSaleEventConfigQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', saleEventConfig?: { __typename: 'SaleEventConfig', id: string, startDate: any, stopDate: any, priority: number, status: SaleEventStatus, name: string, isHardCoded: boolean, filterUserIds?: Array<string> | null, filterSubscriptionTier?: UserSubscriptionTier | null, filterUserMinCreationDate?: string | null, filterUserMaxCreationDate?: string | null, filterAppVersion?: string | null, filterUserLevel?: number | null, filterHadSub?: boolean | null, sales: Array<{ __typename: 'SaleConfig', id: string, startDate?: any | null, stopDate?: any | null, name?: string | null, targetedProductId?: string | null, saleProductId?: string | null, newPrice?: number | null, oldPrice?: number | null, offerPercentage?: number | null, tag: SaleTagType, ruleMaximumNumberOfClaim?: number | null, purchaseLimitType?: PurchaseLimitEnum | null }>, packs: Array<{ __typename: 'SaleBundleConfig', id: string, startDate?: any | null, stopDate?: any | null, name?: string | null, backgroundImage?: string | null, offerPercentage?: number | null, tag?: string | null, ruleMaximumNumberOfClaim?: number | null, purchaseLimitType?: PurchaseLimitEnum | null, displayTimer?: boolean | null, skuId?: string | null, items: Array<{ __typename: 'BundleItem', itemId?: string | null, type?: string | null, amount?: number | null }> }>, dailyItems: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }>, subscriptions: Array<{ __typename: 'SubscriptionSaleConfig', id: string, discount: number, backgroundTheme?: string | null }>, assetsConfig: { __typename: 'SaleEventAssetsConfig', backgroundImage?: string | null, characterImage?: string | null } } | null } };

export type GetLiveOpsSaleEventConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLiveOpsSaleEventConfigsQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', saleEventConfigs: Array<{ __typename: 'SaleEventConfig', id: string, startDate: any, stopDate: any, priority: number, status: SaleEventStatus, name: string, isHardCoded: boolean, filterUserIds?: Array<string> | null, filterSubscriptionTier?: UserSubscriptionTier | null, filterUserMinCreationDate?: string | null, filterUserMaxCreationDate?: string | null, filterAppVersion?: string | null, filterUserLevel?: number | null, filterHadSub?: boolean | null, sales: Array<{ __typename: 'SaleConfig', id: string, startDate?: any | null, stopDate?: any | null, name?: string | null, targetedProductId?: string | null, saleProductId?: string | null, newPrice?: number | null, oldPrice?: number | null, offerPercentage?: number | null, tag: SaleTagType, ruleMaximumNumberOfClaim?: number | null, purchaseLimitType?: PurchaseLimitEnum | null }>, packs: Array<{ __typename: 'SaleBundleConfig', id: string, startDate?: any | null, stopDate?: any | null, name?: string | null, backgroundImage?: string | null, offerPercentage?: number | null, tag?: string | null, ruleMaximumNumberOfClaim?: number | null, purchaseLimitType?: PurchaseLimitEnum | null, displayTimer?: boolean | null, skuId?: string | null, items: Array<{ __typename: 'BundleItem', itemId?: string | null, type?: string | null, amount?: number | null }> }>, dailyItems: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }>, subscriptions: Array<{ __typename: 'SubscriptionSaleConfig', id: string, discount: number, backgroundTheme?: string | null }>, assetsConfig: { __typename: 'SaleEventAssetsConfig', backgroundImage?: string | null, characterImage?: string | null } }> } };

export type CreateSaleEventMutationVariables = Exact<{
  input: CreateSaleEventInput;
}>;


export type CreateSaleEventMutation = { __typename: 'Mutation', createSaleEvent: { __typename: 'CreateSaleEventPayload', saleEvent: { __typename: 'SaleEventConfig', id: string, startDate: any, stopDate: any, priority: number, status: SaleEventStatus, name: string, isHardCoded: boolean, filterUserIds?: Array<string> | null, filterSubscriptionTier?: UserSubscriptionTier | null, filterUserMinCreationDate?: string | null, filterUserMaxCreationDate?: string | null, filterAppVersion?: string | null, filterUserLevel?: number | null, filterHadSub?: boolean | null, sales: Array<{ __typename: 'SaleConfig', id: string, startDate?: any | null, stopDate?: any | null, name?: string | null, targetedProductId?: string | null, saleProductId?: string | null, newPrice?: number | null, oldPrice?: number | null, offerPercentage?: number | null, tag: SaleTagType, ruleMaximumNumberOfClaim?: number | null, purchaseLimitType?: PurchaseLimitEnum | null }>, packs: Array<{ __typename: 'SaleBundleConfig', id: string, startDate?: any | null, stopDate?: any | null, name?: string | null, backgroundImage?: string | null, offerPercentage?: number | null, tag?: string | null, ruleMaximumNumberOfClaim?: number | null, purchaseLimitType?: PurchaseLimitEnum | null, displayTimer?: boolean | null, skuId?: string | null, items: Array<{ __typename: 'BundleItem', itemId?: string | null, type?: string | null, amount?: number | null }> }>, dailyItems: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }>, subscriptions: Array<{ __typename: 'SubscriptionSaleConfig', id: string, discount: number, backgroundTheme?: string | null }>, assetsConfig: { __typename: 'SaleEventAssetsConfig', backgroundImage?: string | null, characterImage?: string | null } } } };

export type UpdateSaleEventMutationVariables = Exact<{
  input: UpdateSaleEventInput;
}>;


export type UpdateSaleEventMutation = { __typename: 'Mutation', updateSaleEvent: { __typename: 'UpdateSaleEventPayload', saleEvent: { __typename: 'SaleEventConfig', id: string, startDate: any, stopDate: any, priority: number, status: SaleEventStatus, name: string, isHardCoded: boolean, filterUserIds?: Array<string> | null, filterSubscriptionTier?: UserSubscriptionTier | null, filterUserMinCreationDate?: string | null, filterUserMaxCreationDate?: string | null, filterAppVersion?: string | null, filterUserLevel?: number | null, filterHadSub?: boolean | null, sales: Array<{ __typename: 'SaleConfig', id: string, startDate?: any | null, stopDate?: any | null, name?: string | null, targetedProductId?: string | null, saleProductId?: string | null, newPrice?: number | null, oldPrice?: number | null, offerPercentage?: number | null, tag: SaleTagType, ruleMaximumNumberOfClaim?: number | null, purchaseLimitType?: PurchaseLimitEnum | null }>, packs: Array<{ __typename: 'SaleBundleConfig', id: string, startDate?: any | null, stopDate?: any | null, name?: string | null, backgroundImage?: string | null, offerPercentage?: number | null, tag?: string | null, ruleMaximumNumberOfClaim?: number | null, purchaseLimitType?: PurchaseLimitEnum | null, displayTimer?: boolean | null, skuId?: string | null, items: Array<{ __typename: 'BundleItem', itemId?: string | null, type?: string | null, amount?: number | null }> }>, dailyItems: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }>, subscriptions: Array<{ __typename: 'SubscriptionSaleConfig', id: string, discount: number, backgroundTheme?: string | null }>, assetsConfig: { __typename: 'SaleEventAssetsConfig', backgroundImage?: string | null, characterImage?: string | null } } } };

export type DeleteSaleEventMutationVariables = Exact<{
  input: DeleteSaleEventInput;
}>;


export type DeleteSaleEventMutation = { __typename: 'Mutation', deleteSaleEvent: { __typename: 'DeleteSaleEventPayload', saleEventIdDeleted: string } };

export type UploadSaleEventAssetMutationVariables = Exact<{
  input: UploadSaleEventAssetInput;
}>;


export type UploadSaleEventAssetMutation = { __typename: 'Mutation', uploadSaleEventAsset: { __typename: 'SaleEventPayload', saleEvent: { __typename: 'SaleEventConfig', id: string, startDate: any, stopDate: any, priority: number, status: SaleEventStatus, name: string, isHardCoded: boolean, filterUserIds?: Array<string> | null, filterSubscriptionTier?: UserSubscriptionTier | null, filterUserMinCreationDate?: string | null, filterUserMaxCreationDate?: string | null, filterAppVersion?: string | null, filterUserLevel?: number | null, filterHadSub?: boolean | null, sales: Array<{ __typename: 'SaleConfig', id: string, startDate?: any | null, stopDate?: any | null, name?: string | null, targetedProductId?: string | null, saleProductId?: string | null, newPrice?: number | null, oldPrice?: number | null, offerPercentage?: number | null, tag: SaleTagType, ruleMaximumNumberOfClaim?: number | null, purchaseLimitType?: PurchaseLimitEnum | null }>, packs: Array<{ __typename: 'SaleBundleConfig', id: string, startDate?: any | null, stopDate?: any | null, name?: string | null, backgroundImage?: string | null, offerPercentage?: number | null, tag?: string | null, ruleMaximumNumberOfClaim?: number | null, purchaseLimitType?: PurchaseLimitEnum | null, displayTimer?: boolean | null, skuId?: string | null, items: Array<{ __typename: 'BundleItem', itemId?: string | null, type?: string | null, amount?: number | null }> }>, dailyItems: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }>, subscriptions: Array<{ __typename: 'SubscriptionSaleConfig', id: string, discount: number, backgroundTheme?: string | null }>, assetsConfig: { __typename: 'SaleEventAssetsConfig', backgroundImage?: string | null, characterImage?: string | null } } } };

export type SpecialEventsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationParams>;
}>;


export type SpecialEventsQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', specialEvents: { __typename: 'SpecialEventPaginated', totalCount: number, hasMore: boolean, list: Array<{ __typename: 'SpecialEvent', id: string, startDate: any, name: string }> } } };

export type SpecialEventQueryVariables = Exact<{
  specialEventId: Scalars['ID'];
}>;


export type SpecialEventQuery = { __typename: 'Query', specialEvent?: { __typename: 'SpecialEvent', id: string, name: string, description: string, startDate: any, endDate: any, isDraft: boolean, configWarnings: Array<string>, assetsConfig: { __typename: 'SpecialEventAssetsConfig', primaryColor?: string | null, secondaryColor?: string | null, secondaryDarkColor?: string | null, buttonColor?: string | null, contrast?: string | null, contrastGradient1?: string | null, contrastGradient2?: string | null, headerImage?: string | null, backgroundImage?: string | null, icon?: string | null }, missions?: { __typename: 'SpecialEventMissions', id: string, sequentialMissions: Array<{ __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null }> } | null, tournaments: Array<{ __typename: 'Tournament', id: string, startDate: any }>, quizLiveShows: Array<{ __typename: 'QuizLiveShow', id: string, startDate: any }>, contentPacks: Array<{ __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }>, milestones: Array<{ __typename: 'SpecialEventMilestone', id: string, score: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string, name: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string, name: string } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }>, plusMilestones: Array<{ __typename: 'SpecialEventMilestone', id: string, score: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string, name: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string, name: string } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }>, rankGroups: Array<{ __typename: 'SpecialEventRankGroup', id: string, minRank: number, maxRank: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string, name: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string, name: string } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }> } | null };

export type UpdateSpecialEventMutationVariables = Exact<{
  input: UpdateSpecialEventInput;
}>;


export type UpdateSpecialEventMutation = { __typename: 'Mutation', updateSpecialEvent: { __typename: 'SpecialEventPayload', specialEvent: { __typename: 'SpecialEvent', id: string, name: string, description: string, startDate: any, endDate: any, isDraft: boolean, configWarnings: Array<string>, assetsConfig: { __typename: 'SpecialEventAssetsConfig', primaryColor?: string | null, secondaryColor?: string | null, secondaryDarkColor?: string | null, buttonColor?: string | null, contrast?: string | null, contrastGradient1?: string | null, contrastGradient2?: string | null, headerImage?: string | null, backgroundImage?: string | null, icon?: string | null }, missions?: { __typename: 'SpecialEventMissions', id: string, sequentialMissions: Array<{ __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null }> } | null, tournaments: Array<{ __typename: 'Tournament', id: string, startDate: any }>, quizLiveShows: Array<{ __typename: 'QuizLiveShow', id: string, startDate: any }>, contentPacks: Array<{ __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }>, milestones: Array<{ __typename: 'SpecialEventMilestone', id: string, score: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string, name: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string, name: string } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }>, plusMilestones: Array<{ __typename: 'SpecialEventMilestone', id: string, score: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string, name: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string, name: string } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }>, rankGroups: Array<{ __typename: 'SpecialEventRankGroup', id: string, minRank: number, maxRank: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string, name: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string, name: string } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }> } } };

export type UpdateSpecialEventAssetMutationVariables = Exact<{
  input: UploadSpecialEventAssetInput;
}>;


export type UpdateSpecialEventAssetMutation = { __typename: 'Mutation', uploadSpecialEventAsset: { __typename: 'SpecialEventPayload', specialEvent: { __typename: 'SpecialEvent', id: string, name: string, description: string, startDate: any, endDate: any, isDraft: boolean, configWarnings: Array<string>, assetsConfig: { __typename: 'SpecialEventAssetsConfig', primaryColor?: string | null, secondaryColor?: string | null, secondaryDarkColor?: string | null, buttonColor?: string | null, contrast?: string | null, contrastGradient1?: string | null, contrastGradient2?: string | null, headerImage?: string | null, backgroundImage?: string | null, icon?: string | null }, missions?: { __typename: 'SpecialEventMissions', id: string, sequentialMissions: Array<{ __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null }> } | null, tournaments: Array<{ __typename: 'Tournament', id: string, startDate: any }>, quizLiveShows: Array<{ __typename: 'QuizLiveShow', id: string, startDate: any }>, contentPacks: Array<{ __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }>, milestones: Array<{ __typename: 'SpecialEventMilestone', id: string, score: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string, name: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string, name: string } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }>, plusMilestones: Array<{ __typename: 'SpecialEventMilestone', id: string, score: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string, name: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string, name: string } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }>, rankGroups: Array<{ __typename: 'SpecialEventRankGroup', id: string, minRank: number, maxRank: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string, name: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string, name: string } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }> } } };

export type UpdateSpecialEventMilestonesMutationVariables = Exact<{
  input: UpdateSpecialEventMilestonesInput;
}>;


export type UpdateSpecialEventMilestonesMutation = { __typename: 'Mutation', updateSpecialEventMilestones: { __typename: 'SpecialEventPayload', specialEvent: { __typename: 'SpecialEvent', id: string, name: string, description: string, startDate: any, endDate: any, isDraft: boolean, configWarnings: Array<string>, assetsConfig: { __typename: 'SpecialEventAssetsConfig', primaryColor?: string | null, secondaryColor?: string | null, secondaryDarkColor?: string | null, buttonColor?: string | null, contrast?: string | null, contrastGradient1?: string | null, contrastGradient2?: string | null, headerImage?: string | null, backgroundImage?: string | null, icon?: string | null }, missions?: { __typename: 'SpecialEventMissions', id: string, sequentialMissions: Array<{ __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null }> } | null, tournaments: Array<{ __typename: 'Tournament', id: string, startDate: any }>, quizLiveShows: Array<{ __typename: 'QuizLiveShow', id: string, startDate: any }>, contentPacks: Array<{ __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }>, milestones: Array<{ __typename: 'SpecialEventMilestone', id: string, score: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string, name: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string, name: string } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }>, plusMilestones: Array<{ __typename: 'SpecialEventMilestone', id: string, score: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string, name: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string, name: string } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }>, rankGroups: Array<{ __typename: 'SpecialEventRankGroup', id: string, minRank: number, maxRank: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string, name: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string, name: string } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }> } } };

export type UpdateSpecialEventPlusMilestonesMutationVariables = Exact<{
  input: UpdateSpecialEventPlusMilestonesInput;
}>;


export type UpdateSpecialEventPlusMilestonesMutation = { __typename: 'Mutation', updateSpecialEventPlusMilestones: { __typename: 'SpecialEventPayload', specialEvent: { __typename: 'SpecialEvent', id: string, name: string, description: string, startDate: any, endDate: any, isDraft: boolean, configWarnings: Array<string>, assetsConfig: { __typename: 'SpecialEventAssetsConfig', primaryColor?: string | null, secondaryColor?: string | null, secondaryDarkColor?: string | null, buttonColor?: string | null, contrast?: string | null, contrastGradient1?: string | null, contrastGradient2?: string | null, headerImage?: string | null, backgroundImage?: string | null, icon?: string | null }, missions?: { __typename: 'SpecialEventMissions', id: string, sequentialMissions: Array<{ __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null }> } | null, tournaments: Array<{ __typename: 'Tournament', id: string, startDate: any }>, quizLiveShows: Array<{ __typename: 'QuizLiveShow', id: string, startDate: any }>, contentPacks: Array<{ __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }>, milestones: Array<{ __typename: 'SpecialEventMilestone', id: string, score: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string, name: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string, name: string } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }>, plusMilestones: Array<{ __typename: 'SpecialEventMilestone', id: string, score: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string, name: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string, name: string } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }>, rankGroups: Array<{ __typename: 'SpecialEventRankGroup', id: string, minRank: number, maxRank: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string, name: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string, name: string } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }> } } };

export type UpdateSpecialEventRankGroupsMutationVariables = Exact<{
  input: UpdateSpecialEventRankGroupsInput;
}>;


export type UpdateSpecialEventRankGroupsMutation = { __typename: 'Mutation', updateSpecialEventRankGroups: { __typename: 'SpecialEventPayload', specialEvent: { __typename: 'SpecialEvent', id: string, name: string, description: string, startDate: any, endDate: any, isDraft: boolean, configWarnings: Array<string>, assetsConfig: { __typename: 'SpecialEventAssetsConfig', primaryColor?: string | null, secondaryColor?: string | null, secondaryDarkColor?: string | null, buttonColor?: string | null, contrast?: string | null, contrastGradient1?: string | null, contrastGradient2?: string | null, headerImage?: string | null, backgroundImage?: string | null, icon?: string | null }, missions?: { __typename: 'SpecialEventMissions', id: string, sequentialMissions: Array<{ __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null }> } | null, tournaments: Array<{ __typename: 'Tournament', id: string, startDate: any }>, quizLiveShows: Array<{ __typename: 'QuizLiveShow', id: string, startDate: any }>, contentPacks: Array<{ __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }>, milestones: Array<{ __typename: 'SpecialEventMilestone', id: string, score: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string, name: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string, name: string } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }>, plusMilestones: Array<{ __typename: 'SpecialEventMilestone', id: string, score: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string, name: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string, name: string } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }>, rankGroups: Array<{ __typename: 'SpecialEventRankGroup', id: string, minRank: number, maxRank: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string, name: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string, name: string } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }> } } };

export type UpdateSpecialEventContentPacksMutationVariables = Exact<{
  input: UpdateSpecialEventContentPacksInput;
}>;


export type UpdateSpecialEventContentPacksMutation = { __typename: 'Mutation', updateSpecialEventContentPacks: { __typename: 'SpecialEventPayload', specialEvent: { __typename: 'SpecialEvent', id: string, name: string, description: string, startDate: any, endDate: any, isDraft: boolean, configWarnings: Array<string>, assetsConfig: { __typename: 'SpecialEventAssetsConfig', primaryColor?: string | null, secondaryColor?: string | null, secondaryDarkColor?: string | null, buttonColor?: string | null, contrast?: string | null, contrastGradient1?: string | null, contrastGradient2?: string | null, headerImage?: string | null, backgroundImage?: string | null, icon?: string | null }, missions?: { __typename: 'SpecialEventMissions', id: string, sequentialMissions: Array<{ __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null }> } | null, tournaments: Array<{ __typename: 'Tournament', id: string, startDate: any }>, quizLiveShows: Array<{ __typename: 'QuizLiveShow', id: string, startDate: any }>, contentPacks: Array<{ __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }>, milestones: Array<{ __typename: 'SpecialEventMilestone', id: string, score: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string, name: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string, name: string } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }>, plusMilestones: Array<{ __typename: 'SpecialEventMilestone', id: string, score: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string, name: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string, name: string } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }>, rankGroups: Array<{ __typename: 'SpecialEventRankGroup', id: string, minRank: number, maxRank: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string, name: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string, name: string } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }> } } };

export type CreateSpecialEventMutationVariables = Exact<{
  input: CreateSpecialEventInput;
}>;


export type CreateSpecialEventMutation = { __typename: 'Mutation', createSpecialEvent: { __typename: 'SpecialEventPayload', specialEvent: { __typename: 'SpecialEvent', id: string, name: string, description: string, startDate: any, endDate: any, isDraft: boolean, configWarnings: Array<string>, assetsConfig: { __typename: 'SpecialEventAssetsConfig', primaryColor?: string | null, secondaryColor?: string | null, secondaryDarkColor?: string | null, buttonColor?: string | null, contrast?: string | null, contrastGradient1?: string | null, contrastGradient2?: string | null, headerImage?: string | null, backgroundImage?: string | null, icon?: string | null }, missions?: { __typename: 'SpecialEventMissions', id: string, sequentialMissions: Array<{ __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null }> } | null, tournaments: Array<{ __typename: 'Tournament', id: string, startDate: any }>, quizLiveShows: Array<{ __typename: 'QuizLiveShow', id: string, startDate: any }>, contentPacks: Array<{ __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }>, milestones: Array<{ __typename: 'SpecialEventMilestone', id: string, score: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string, name: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string, name: string } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }>, plusMilestones: Array<{ __typename: 'SpecialEventMilestone', id: string, score: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string, name: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string, name: string } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }>, rankGroups: Array<{ __typename: 'SpecialEventRankGroup', id: string, minRank: number, maxRank: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward', contentPack: { __typename: 'ContentPack', id: string, name: string } } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji', id: string, name: string } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }> } } };

export type RemoveSpecialEventMutationVariables = Exact<{
  input: RemoveSpecialEventInput;
}>;


export type RemoveSpecialEventMutation = { __typename: 'Mutation', removeSpecialEvent: { __typename: 'RemoveSpecialEventPayload', isRemoved: boolean } };

export type InitSpecialEventMissionsMutationVariables = Exact<{
  input: InitSpecialEventMissionsInput;
}>;


export type InitSpecialEventMissionsMutation = { __typename: 'Mutation', initSpecialEventMissions: { __typename: 'SpecialEventMissionsPayload', missions: { __typename: 'SpecialEventMissions', id: string, sequentialMissions: Array<{ __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null }> } } };

export type UpdateSpecialEventMissionsMutationVariables = Exact<{
  input: UpdateSpecialEventMissionsInput;
}>;


export type UpdateSpecialEventMissionsMutation = { __typename: 'Mutation', updateSpecialEventMissions: { __typename: 'SpecialEventMissionsPayload', missions: { __typename: 'SpecialEventMissions', id: string, sequentialMissions: Array<{ __typename: 'Mission', id: string, start: any, end: any, requiredTier: UserSubscriptionTier, rewardAccolades?: number | null, rewardXp: number, rewardDiamonds?: number | null, rewardCoins?: number | null, tasks: Array<{ __typename: 'MissionTask', type: MissionTaskType, params: Array<{ __typename: 'MissionParamContentCategory', category: { __typename: 'ContentCategory', id: string } } | { __typename: 'MissionParamContentPack', contentPack: { __typename: 'ContentPack', id: string } } | { __typename: 'MissionParamFloat', floatValue: number } | { __typename: 'MissionParamHour24', intValue: number } | { __typename: 'MissionParamInt', intValue: number } | { __typename: 'MissionParamSong', variantIds: Array<string> } | { __typename: 'MissionParamString', stringValue: string } | { __typename: 'MissionParamType' }> }>, reward?: { __typename: 'AppSkin' } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff' } | { __typename: 'Poster' } | { __typename: 'ProfileFrame' } | { __typename: 'Sticker' } | null }> } } };

export type TeamShopQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<TeamShopFilter>;
}>;


export type TeamShopQuery = { __typename: 'Query', teamShop: { __typename: 'TeamShopPaginated', totalCount: number, hasMore: boolean, list: Array<{ __typename: 'TeamShopItem', id: string, startDate: any, endDate?: any | null, buyLimit?: number | null, buyLimitType?: TeamShopBuyLimitEnum | null, cost: number, discount?: number | null, reward: { __typename: 'TeamShopItemConfig', type: string, amount?: number | null, itemId?: string | null } }> } };

export type UpdateTeamShopItemMutationVariables = Exact<{
  itemId: Scalars['ID'];
  item: CreateUpdateTeamShopItemInput;
}>;


export type UpdateTeamShopItemMutation = { __typename: 'Mutation', updateTeamShopItem: { __typename: 'TeamShopPaginated', totalCount: number, hasMore: boolean, list: Array<{ __typename: 'TeamShopItem', id: string, startDate: any, endDate?: any | null, buyLimit?: number | null, buyLimitType?: TeamShopBuyLimitEnum | null, cost: number, discount?: number | null, reward: { __typename: 'TeamShopItemConfig', type: string, amount?: number | null, itemId?: string | null } }> } };

export type CreateTeamShopItemMutationVariables = Exact<{
  item: CreateUpdateTeamShopItemInput;
}>;


export type CreateTeamShopItemMutation = { __typename: 'Mutation', createTeamShopItem: { __typename: 'TeamShopPaginated', totalCount: number, hasMore: boolean, list: Array<{ __typename: 'TeamShopItem', id: string, startDate: any, endDate?: any | null, buyLimit?: number | null, buyLimitType?: TeamShopBuyLimitEnum | null, cost: number, discount?: number | null, reward: { __typename: 'TeamShopItemConfig', type: string, amount?: number | null, itemId?: string | null } }> } };

export type DeleteTeamShopItemMutationVariables = Exact<{
  itemId: Scalars['ID'];
}>;


export type DeleteTeamShopItemMutation = { __typename: 'Mutation', deleteTeamShopItem: { __typename: 'TeamShopPaginated', totalCount: number, hasMore: boolean, list: Array<{ __typename: 'TeamShopItem', id: string, startDate: any, endDate?: any | null, buyLimit?: number | null, buyLimitType?: TeamShopBuyLimitEnum | null, cost: number, discount?: number | null, reward: { __typename: 'TeamShopItemConfig', type: string, amount?: number | null, itemId?: string | null } }> } };

export type TournamentsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type TournamentsQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', tournaments: { __typename: 'TournamentPaginated', hasMore: boolean, totalCount: number, list: Array<{ __typename: 'Tournament', id: string, startDate: any }> } } };

export type TournamentQueryVariables = Exact<{
  tournamentId: Scalars['ID'];
}>;


export type TournamentQuery = { __typename: 'Query', tournament?: { __typename: 'Tournament', id: string, name: string, description: string, startDate: any, endDate: any, ticketCost: number, category: { __typename: 'ContentCategory', id: string }, assetsConfig: { __typename: 'TournamentAssetsConfig', primaryColor?: string | null, secondaryColor?: string | null, secondaryDarkColor?: string | null, buttonColor?: string | null, characterImage?: string | null, headerImage?: string | null, contrast?: string | null, contrastGradient1?: string | null, contrastGradient2?: string | null }, contentPacks: Array<{ __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }>, adminSpecialEvent?: { __typename: 'SpecialEvent', id: string, name: string, startDate: any, endDate: any } | null, milestones: Array<{ __typename: 'TournamentMilestone', id: string, score: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }>, rankGroups: Array<{ __typename: 'TournamentRankGroup', id: string, minRank: number, maxRank: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }> } | null };

export type UpdateTournamentMutationVariables = Exact<{
  input: UpdateTournamentInput;
}>;


export type UpdateTournamentMutation = { __typename: 'Mutation', updateTournament: { __typename: 'TournamentPayload', tournament: { __typename: 'Tournament', id: string, name: string, description: string, startDate: any, endDate: any, ticketCost: number, category: { __typename: 'ContentCategory', id: string }, assetsConfig: { __typename: 'TournamentAssetsConfig', primaryColor?: string | null, secondaryColor?: string | null, secondaryDarkColor?: string | null, buttonColor?: string | null, characterImage?: string | null, headerImage?: string | null, contrast?: string | null, contrastGradient1?: string | null, contrastGradient2?: string | null }, contentPacks: Array<{ __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }>, adminSpecialEvent?: { __typename: 'SpecialEvent', id: string, name: string, startDate: any, endDate: any } | null, milestones: Array<{ __typename: 'TournamentMilestone', id: string, score: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }>, rankGroups: Array<{ __typename: 'TournamentRankGroup', id: string, minRank: number, maxRank: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }> } } };

export type UpdateTournamentMilestonesMutationVariables = Exact<{
  input: UpdateTournamentMilestonesInput;
}>;


export type UpdateTournamentMilestonesMutation = { __typename: 'Mutation', updateTournamentMilestones: { __typename: 'TournamentPayload', tournament: { __typename: 'Tournament', id: string, name: string, description: string, startDate: any, endDate: any, ticketCost: number, category: { __typename: 'ContentCategory', id: string }, assetsConfig: { __typename: 'TournamentAssetsConfig', primaryColor?: string | null, secondaryColor?: string | null, secondaryDarkColor?: string | null, buttonColor?: string | null, characterImage?: string | null, headerImage?: string | null, contrast?: string | null, contrastGradient1?: string | null, contrastGradient2?: string | null }, contentPacks: Array<{ __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }>, adminSpecialEvent?: { __typename: 'SpecialEvent', id: string, name: string, startDate: any, endDate: any } | null, milestones: Array<{ __typename: 'TournamentMilestone', id: string, score: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }>, rankGroups: Array<{ __typename: 'TournamentRankGroup', id: string, minRank: number, maxRank: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }> } } };

export type UpdateTournamentRankGroupsMutationVariables = Exact<{
  input: UpdateTournamentRankGroupsInput;
}>;


export type UpdateTournamentRankGroupsMutation = { __typename: 'Mutation', updateTournamentRankGroups: { __typename: 'TournamentPayload', tournament: { __typename: 'Tournament', id: string, name: string, description: string, startDate: any, endDate: any, ticketCost: number, category: { __typename: 'ContentCategory', id: string }, assetsConfig: { __typename: 'TournamentAssetsConfig', primaryColor?: string | null, secondaryColor?: string | null, secondaryDarkColor?: string | null, buttonColor?: string | null, characterImage?: string | null, headerImage?: string | null, contrast?: string | null, contrastGradient1?: string | null, contrastGradient2?: string | null }, contentPacks: Array<{ __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }>, adminSpecialEvent?: { __typename: 'SpecialEvent', id: string, name: string, startDate: any, endDate: any } | null, milestones: Array<{ __typename: 'TournamentMilestone', id: string, score: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }>, rankGroups: Array<{ __typename: 'TournamentRankGroup', id: string, minRank: number, maxRank: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }> } } };

export type UpdateTournamentContentPacksMutationVariables = Exact<{
  input: UpdateTournamentContentPacksInput;
}>;


export type UpdateTournamentContentPacksMutation = { __typename: 'Mutation', updateTournamentContentPacks: { __typename: 'TournamentPayload', tournament: { __typename: 'Tournament', id: string, name: string, description: string, startDate: any, endDate: any, ticketCost: number, category: { __typename: 'ContentCategory', id: string }, assetsConfig: { __typename: 'TournamentAssetsConfig', primaryColor?: string | null, secondaryColor?: string | null, secondaryDarkColor?: string | null, buttonColor?: string | null, characterImage?: string | null, headerImage?: string | null, contrast?: string | null, contrastGradient1?: string | null, contrastGradient2?: string | null }, contentPacks: Array<{ __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }>, adminSpecialEvent?: { __typename: 'SpecialEvent', id: string, name: string, startDate: any, endDate: any } | null, milestones: Array<{ __typename: 'TournamentMilestone', id: string, score: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }>, rankGroups: Array<{ __typename: 'TournamentRankGroup', id: string, minRank: number, maxRank: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }> } } };

export type CopyTournamentMutationVariables = Exact<{
  input: CopyTournamentInput;
}>;


export type CopyTournamentMutation = { __typename: 'Mutation', copyTournament: { __typename: 'TournamentPayload', tournament: { __typename: 'Tournament', id: string, name: string, description: string, startDate: any, endDate: any, ticketCost: number, category: { __typename: 'ContentCategory', id: string }, assetsConfig: { __typename: 'TournamentAssetsConfig', primaryColor?: string | null, secondaryColor?: string | null, secondaryDarkColor?: string | null, buttonColor?: string | null, characterImage?: string | null, headerImage?: string | null, contrast?: string | null, contrastGradient1?: string | null, contrastGradient2?: string | null }, contentPacks: Array<{ __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }>, adminSpecialEvent?: { __typename: 'SpecialEvent', id: string, name: string, startDate: any, endDate: any } | null, milestones: Array<{ __typename: 'TournamentMilestone', id: string, score: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }>, rankGroups: Array<{ __typename: 'TournamentRankGroup', id: string, minRank: number, maxRank: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }> } } };

export type CreateTournamentMutationVariables = Exact<{
  input: CreateTournamentInput;
}>;


export type CreateTournamentMutation = { __typename: 'Mutation', createTournament: { __typename: 'TournamentPayload', tournament: { __typename: 'Tournament', id: string, name: string, description: string, startDate: any, endDate: any, ticketCost: number, category: { __typename: 'ContentCategory', id: string }, assetsConfig: { __typename: 'TournamentAssetsConfig', primaryColor?: string | null, secondaryColor?: string | null, secondaryDarkColor?: string | null, buttonColor?: string | null, characterImage?: string | null, headerImage?: string | null, contrast?: string | null, contrastGradient1?: string | null, contrastGradient2?: string | null }, contentPacks: Array<{ __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }>, adminSpecialEvent?: { __typename: 'SpecialEvent', id: string, name: string, startDate: any, endDate: any } | null, milestones: Array<{ __typename: 'TournamentMilestone', id: string, score: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }>, rankGroups: Array<{ __typename: 'TournamentRankGroup', id: string, minRank: number, maxRank: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }> } } };

export type RemoveTournamentMutationVariables = Exact<{
  input: RemoveTournamentInput;
}>;


export type RemoveTournamentMutation = { __typename: 'Mutation', removeTournament: { __typename: 'RemoveTournamentPayload', isRemoved: boolean } };

export type UploadTournamentHeaderAssetMutationVariables = Exact<{
  input: UploadAssetInput;
}>;


export type UploadTournamentHeaderAssetMutation = { __typename: 'Mutation', uploadTournamentHeaderAsset: { __typename: 'TournamentPayload', tournament: { __typename: 'Tournament', id: string, name: string, description: string, startDate: any, endDate: any, ticketCost: number, category: { __typename: 'ContentCategory', id: string }, assetsConfig: { __typename: 'TournamentAssetsConfig', primaryColor?: string | null, secondaryColor?: string | null, secondaryDarkColor?: string | null, buttonColor?: string | null, characterImage?: string | null, headerImage?: string | null, contrast?: string | null, contrastGradient1?: string | null, contrastGradient2?: string | null }, contentPacks: Array<{ __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }>, adminSpecialEvent?: { __typename: 'SpecialEvent', id: string, name: string, startDate: any, endDate: any } | null, milestones: Array<{ __typename: 'TournamentMilestone', id: string, score: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }>, rankGroups: Array<{ __typename: 'TournamentRankGroup', id: string, minRank: number, maxRank: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }> } } };

export type UploadTournamentCharacterAssetMutationVariables = Exact<{
  input: UploadAssetInput;
}>;


export type UploadTournamentCharacterAssetMutation = { __typename: 'Mutation', uploadTournamentCharacterAsset: { __typename: 'TournamentPayload', tournament: { __typename: 'Tournament', id: string, name: string, description: string, startDate: any, endDate: any, ticketCost: number, category: { __typename: 'ContentCategory', id: string }, assetsConfig: { __typename: 'TournamentAssetsConfig', primaryColor?: string | null, secondaryColor?: string | null, secondaryDarkColor?: string | null, buttonColor?: string | null, characterImage?: string | null, headerImage?: string | null, contrast?: string | null, contrastGradient1?: string | null, contrastGradient2?: string | null }, contentPacks: Array<{ __typename: 'ContentPack', id: string, name: string, popularity: number, explicitContentStatus?: ContentPackExplicitContentStatus | null }>, adminSpecialEvent?: { __typename: 'SpecialEvent', id: string, name: string, startDate: any, endDate: any } | null, milestones: Array<{ __typename: 'TournamentMilestone', id: string, score: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }>, rankGroups: Array<{ __typename: 'TournamentRankGroup', id: string, minRank: number, maxRank: number, rewards: Array<{ __typename: 'AppSkin', id: string } | { __typename: 'Badge' } | { __typename: 'ContentPackReward' } | { __typename: 'CurrencyAccolade', amount: number } | { __typename: 'CurrencyBoost', amount: number, boostType: CurrencyBoostType } | { __typename: 'CurrencyCategoryFragment', amount: number, category: { __typename: 'ContentCategory', id: string, icon: string, name: string } } | { __typename: 'CurrencyCategoryRandom', amount: number } | { __typename: 'CurrencyCoin', amount: number } | { __typename: 'CurrencyDiamond', amount: number } | { __typename: 'CurrencyFreeSpin', amount: number } | { __typename: 'CurrencyLiveEvent', amount: number } | { __typename: 'CurrencyLoyaltyPoints', amount: number } | { __typename: 'CurrencyMetaFragmentBronze', amount: number } | { __typename: 'CurrencyMetaFragmentGold', amount: number } | { __typename: 'CurrencyMetaFragmentSilver', amount: number } | { __typename: 'CurrencyShardBronze', amount: number } | { __typename: 'CurrencyShardGold', amount: number } | { __typename: 'CurrencyShardSilver', amount: number } | { __typename: 'CurrencySpecialEvent', amount: number } | { __typename: 'CurrencyStampCard', amount: number } | { __typename: 'CurrencySubscriptionDay', amount: number } | { __typename: 'CurrencyTournamentTicket', amount: number } | { __typename: 'CurrencyUnlimitedBoost', amount: number } | { __typename: 'CurrencyXP', amount: number } | { __typename: 'Emoji' } | { __typename: 'EmojiPack' } | { __typename: 'MonthlyBuff', multiplier: number, buffType?: MonthlyBuffType | null } | { __typename: 'Poster' } | { __typename: 'ProfileFrame', id: string } | { __typename: 'Sticker', id: string }> }> } } };

export type AddSpecialEventTournamentMutationVariables = Exact<{
  input: AddSpecialEventTournamentInput;
}>;


export type AddSpecialEventTournamentMutation = { __typename: 'Mutation', addSpecialEventTournament: { __typename: 'AddSpecialEventTournamentPayload', specialEvent: { __typename: 'SpecialEvent', id: string, name: string }, tournament: { __typename: 'Tournament', id: string, name: string } } };

export type RemoveSpecialEventTournamentMutationVariables = Exact<{
  input: RemoveSpecialEventTournamentInput;
}>;


export type RemoveSpecialEventTournamentMutation = { __typename: 'Mutation', removeSpecialEventTournament: { __typename: 'RemoveSpecialEventTournamentPayload', specialEvent: { __typename: 'SpecialEvent', id: string, name: string }, tournament: { __typename: 'Tournament', id: string, name: string } } };

export type GetAllWheelFortuneEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllWheelFortuneEventsQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', getAllWheelFortuneEvents: Array<{ __typename: 'WheelFortuneEventConfig', id: string, name: string, startDate: any, stopDate: any, status: ChainedOfferEventStatus }> } };

export type GetWheelFortuneEventQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetWheelFortuneEventQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', getWheelFortuneEvent: { __typename: 'WheelFortuneEventConfig', id: string, name: string, startDate: any, stopDate: any, status: ChainedOfferEventStatus, filterUserIds?: Array<string> | null, filterSubscriptionTier?: UserSubscriptionTier | null, filterUserMinCreationDate?: any | null, filterUserMaxCreationDate?: any | null, filterAppVersion?: string | null, filterUserLevel?: number | null, spinPrice: { __typename: 'GenericLevelReward', type: LevelRewardInputType, amount: number }, spinPricePlus: { __typename: 'GenericLevelReward', type: LevelRewardInputType, amount: number }, rewards: Array<{ __typename: 'WheelFortuneRewardConfig', weight: number, reward: { __typename: 'GenericLevelReward', type: LevelRewardInputType, amount: number, itemId?: string | null } }> } } };

export type CreateWheelFortuneEventMutationVariables = Exact<{
  input: CreateWfEventInput;
}>;


export type CreateWheelFortuneEventMutation = { __typename: 'Mutation', createWheelFortuneEvent: { __typename: 'CreateWFEventPayload', event: { __typename: 'WheelFortuneEventConfig', id: string, name: string, startDate: any, stopDate: any, status: ChainedOfferEventStatus, filterUserIds?: Array<string> | null, filterSubscriptionTier?: UserSubscriptionTier | null, filterUserMinCreationDate?: any | null, filterUserMaxCreationDate?: any | null, filterAppVersion?: string | null, filterUserLevel?: number | null, spinPrice: { __typename: 'GenericLevelReward', type: LevelRewardInputType, amount: number }, spinPricePlus: { __typename: 'GenericLevelReward', type: LevelRewardInputType, amount: number }, rewards: Array<{ __typename: 'WheelFortuneRewardConfig', weight: number, reward: { __typename: 'GenericLevelReward', type: LevelRewardInputType, amount: number, itemId?: string | null } }> } } };

export type UpdateWheelFortuneEventMutationVariables = Exact<{
  input: UpdateWfEventInput;
}>;


export type UpdateWheelFortuneEventMutation = { __typename: 'Mutation', updateWheelFortuneEvent: { __typename: 'UpdateWFEventPayload', event: { __typename: 'WheelFortuneEventConfig', id: string, name: string, startDate: any, stopDate: any, status: ChainedOfferEventStatus, filterUserIds?: Array<string> | null, filterSubscriptionTier?: UserSubscriptionTier | null, filterUserMinCreationDate?: any | null, filterUserMaxCreationDate?: any | null, filterAppVersion?: string | null, filterUserLevel?: number | null, spinPrice: { __typename: 'GenericLevelReward', type: LevelRewardInputType, amount: number }, spinPricePlus: { __typename: 'GenericLevelReward', type: LevelRewardInputType, amount: number }, rewards: Array<{ __typename: 'WheelFortuneRewardConfig', weight: number, reward: { __typename: 'GenericLevelReward', type: LevelRewardInputType, amount: number, itemId?: string | null } }> } } };

export type DeleteWheelFortuneEventMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteWheelFortuneEventMutation = { __typename: 'Mutation', deleteWheelFortuneEvent: boolean };

export type GetAllWheelFortuneRewardConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllWheelFortuneRewardConfigsQuery = { __typename: 'Query', liveOps: { __typename: 'LiveOps', getAllWheelFortuneRewardConfigs: Array<{ __typename: 'WheelFortuneRewardTemplate', id: string, name: string, rewards: Array<{ __typename: 'WheelFortuneRewardConfig', weight: number, reward: { __typename: 'GenericLevelReward', type: LevelRewardInputType, amount: number, itemId?: string | null } }> }> } };

export type CreateWfRewardTemplateMutationVariables = Exact<{
  input: CreateWfrTemplateInput;
}>;


export type CreateWfRewardTemplateMutation = { __typename: 'Mutation', createWFRewardTemplate?: { __typename: 'CreateWFRTemplatePayload', template: { __typename: 'WheelFortuneRewardTemplate', id: string, name: string, rewards: Array<{ __typename: 'WheelFortuneRewardConfig', weight: number, reward: { __typename: 'GenericLevelReward', type: LevelRewardInputType, amount: number, itemId?: string | null } }> } } | null };

export type UpdateWfRewardTemplateMutationVariables = Exact<{
  input: UpdateWfrTemplateInput;
}>;


export type UpdateWfRewardTemplateMutation = { __typename: 'Mutation', updateWFRewardTemplate?: { __typename: 'UpdateWFRTemplatePayload', template: { __typename: 'WheelFortuneRewardTemplate', id: string, name: string, rewards: Array<{ __typename: 'WheelFortuneRewardConfig', weight: number, reward: { __typename: 'GenericLevelReward', type: LevelRewardInputType, amount: number, itemId?: string | null } }> } } | null };

export type DeleteWfRewardTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteWfRewardTemplateMutation = { __typename: 'Mutation', deleteWFRewardTemplate: boolean };

export type SignInMutationVariables = Exact<{
  input: SignUpInput;
}>;


export type SignInMutation = { __typename: 'Mutation', signIn: { __typename: 'SignInPayload', authToken: string } };

export type SignUpMutationVariables = Exact<{
  input: SignUpInput;
}>;


export type SignUpMutation = { __typename: 'Mutation', signUp: { __typename: 'SignInPayload', authToken: string } };

export type PracticeQuizQueryVariables = Exact<{
  categoryIds: Array<Scalars['ID']> | Scalars['ID'];
  explicitContent?: InputMaybe<Scalars['Boolean']>;
}>;


export type PracticeQuizQuery = { __typename: 'Query', practiceQuiz: Array<{ __typename: 'PracticeQuiz', id: string, contentPack: { __typename: 'ContentPack', id: string }, questions: Array<{ __typename: 'QuizQuestion', id: string, correctChoiceIndex: number, song?: { __typename: 'Song', id: string } | null }> }> };

export type UpdateUserPictureMutationVariables = Exact<{
  input: UpdateUserPictureInput;
}>;


export type UpdateUserPictureMutation = { __typename: 'Mutation', updateUserPicture: { __typename: 'UpdateUserPayload', user?: { __typename: 'User', id: string, picture?: string | null } | null } };

export type GetDashboardDataQueryVariables = Exact<{
  sqlQueries: Array<AnalyticsDashboardQueriesInput> | AnalyticsDashboardQueriesInput;
}>;


export type GetDashboardDataQuery = { __typename: 'Query', analytics: { __typename: 'Analytics', id: string, dashboardQueries: Array<{ __typename: 'AnalyticsDashboardQueriesPayload', id: string, data?: Array<string> | null, error?: string | null, metadata?: string | null }> } };
